(function () {
  'use strict';
  angular
    .module('frontendapp',
    ['ui.bootstrap',
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'toastr',
      'LocalStorageModule',
      'satellizer',
      'sap.imageloader',
      'ngMap',
      'fox.scrollReveal',
      'angularSmoothscroll',
      'angular-loading-bar',
      'textAngular',
      'ngCsv',
      'chart.js',
      //'angularUtils.directives.uiBreadcrumbs',
      'ngFileUpload'

    ]);

})();

'use strict';
angular.module('frontendapp')
  .directive('voucherpicker', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinventoryform/widgets/voucherpicker.html',
      restrict: 'E',
      replace: true,
      scope: {
        register: '=',
        disabled: '=',
        targetField: '@'
      },
      rootScope: $rootScope,
      controller: function voucherpickerformController($uibModal, $scope, $rootScope, toastr,
                                                       $state, $auth, $location, $log, Upload,
                                                       UserService, localStorageService,
                                                       TablesService, $window, $modal) {

        console.log('voucherpicker register!', $scope.targetField);


        //console.log($scope.disabled, $scope.partner_id)

        //TO REFACTOR FOR IMPROVE TRANSFER POINT
        $rootScope.loadVoucherList = function (code) {
          var filters = {
            per_page: '10',
            filters: {
              vouchertype_id: {
                value: "9,10,11",
                operator: 'whereIn',
              },
              code: {
                value: code,
                operator: 'like'
              },
              partner_id: {
                value: $rootScope.voucher.selected.partner_id,
              }
            }
          };
          TablesService.filtrar('voucher', filters)
            .success(function (res) {
              console.log('loadCustomVoucher', res);
              $rootScope.voucherList = res.result.data;
              //$rootScope.voucher.selected.partner.voucher = res.result.data;
            });
        };

        //$rootScope.voucherSearch = "VENTA-MERQ-2";
        $rootScope.voucherSearch = "";

        $rootScope.setVoucher = function (voucher) {

          console.log('setVoucher!!!!',voucher);
          $rootScope.voucher.selected.stockorderhist = angular.copy(voucher.stockorderhist);
          $rootScope.voucher.selected.voucherline = angular.copy(voucher.voucherline);
          $rootScope.voucher.selected.voucher_related = angular.copy(voucher.id);
          $rootScope.voucher.actionType = 'store';
          if(voucher.vouchertype_id!=10){
            angular.forEach( $rootScope.voucher.selected.voucherline ,function(i){
              i.quantity_expected2= angular.copy(i.quantity);
              i.quantity=0;
            });
          }
          else{
            /*angular.forEach( $rootScope.voucher.selected.voucherline ,function(i){
              i.quantity=0;
            });*/
            TablesService.filtrar('productcombogroup', {
              filters: {
                product_id: {
                  value: voucher.voucherline[0].product_id,
                },
              }
            })
              .success(function (res) {
                if (res.status) {
                  $rootScope.voucher.selected.voucherline=[];
                  console.log('grupos rescatados', res);
                  $scope.retriveItems(res.result.data);
                  console.log('luego de cargar grupos', $rootScope.voucher.selected)
                }
              });
          }
          $rootScope.comboGroup=[];
          $scope.retriveItems = function (source) {
            var temp = [];
            //$rootScope.voucher.selected.voucherline = [];
            console.log('retriveItems 0',source);
            angular.forEach(source, function(g){
              var group = g.name;
              console.log('retriveItems group',g);
              $rootScope.comboGroup.push({
                group: g.name,
                min: g.min,
                max: g.max,
                currentTotal: 0,
                prevTotal: 0,
                nextTotal: 0,
              });
              //console.log('comboGroup', $rootScope.comboGroup);
              angular.forEach(g.productcomboitem, function(p){
                var group = g.name;
                p.product.group = g.name;
                p.product.min = g.min;
                p.product.max = g.max;
                //console.log('retriveItems 3',p.product);
                //$rootScope.addLineTemp(p.product);
                $rootScope.addLine(p.product);
                //$rootScope.addStock(p.stock[0]);
              })
            });
          };

          angular.forEach($rootScope.voucher.selected.stockorderhist, function (i) {
            if (i.stockadjustment.length > 0) {
              angular.forEach(i.stockadjustment, function (j) {
                console.log('stockadjustment j', j);
                j.temp = angular.copy(j.quantity_issued);
                j.quantity_issued = 0;
                if ($rootScope.verifyInList($rootScope.voucher.selected.stockorder.stockadjustment, j, 'batchcode')) {
                  console.log('insertando older', j);
                  $rootScope.voucher.selected.stockorder.stockadjustment.push(j);
                }
                angular.forEach($rootScope.voucher.selected.voucherline, function (k) {
                  //k.quantity_issued = 0;
                  k.older_issued = k.older_issued ? k.older_issued : 0;
                  $rootScope.calculateIssuedTotal(k);
                  if (k.product_id == j.product_id) {
                    k.older_issued += parseInt(j.temp);
                    $rootScope.calculateIssuedTotal(k);
                  }
                });

              });

            }
          });

          /* if(voucher.stockorder.length>0){
           $rootScope.voucher.selected.warehouse_id = voucher.stockorder[0].warehouse_id;
           $rootScope.voucher.selected.warehouse = voucher.stockorder[0].warehouse;
           }

           $rootScope.voucher.selected.stockorder = voucher.stockorder[voucher.stockorder.length-1];
           $rootScope.voucher.selected.stockorderhist = angular.copy(voucher.stockorder);
           $rootScope.setVoucherType($rootScope.voucher.selected.vouchertype_id);
           if (!$rootScope.voucher.selected.voucherline) {
           $rootScope.voucher.selected.voucherline = [];
           }
          */
          if ( !$rootScope.voucher.selected.stockorder ) {
            $rootScope.voucher.selected.stockorder = {
              stockadjustment: [],
              status: 0
            };
          }
        };
        $scope.setVoucherSearch = function (name) {
          $rootScope.voucherSearch = name;
        };

      }
    }
  })
;

'use strict';
angular.module('frontendapp')
  .directive('stockpicker', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinventoryform/widgets/stockpicker.html',
      restrict: 'E',
      replace: true,
      scope: {
        register: '=',
        warehouseId: '=',
        newLine: '=',
        newStock: '=',
        widgetType: '=',
        modelName: '@',
      },
      rootScope: $rootScope,
      controller: function stockpickerformController($uibModal, $scope, $rootScope, toastr, $timeout,
                                                     $state, $auth, $location, $log, Upload,
                                                     UserService, localStorageService,
                                                     TablesService, $window, $modal) {

        //console.log('stockpicker register!', $scope.register);
        //console.log('stockpicker warehouseId!', $scope.warehouseId);
        //console.log('stockpicker widgetType!', $scope.widgetType);
        //console.log('stockpicker register!!', $scope.register);
        //console.log('stockpicker newLine!!', $scope.newLine);
        //console.log('stockpicker newStock!!', $scope.newStock);

        //PRODUCTS PICKER
        $scope.register.isOpen = false;
        $rootScope.searched = '';
        //$rootScope.searched = '1118033005';
        $scope.showPicker = function (value) {
          console.log('showpicker', value);
          $scope.register.isOpen = value;
          if ($scope.register.isOpen == false) {
            $rootScope.searched = '';
          }
        };
        $scope.loadItems = function (value, onlyCode) {
          var params = {
            per_page: '25',
            page: '1',
            filters: {},
          };
          if (onlyCode == true) {
            params.filters.id = {
              operator: '=',
              value: value,
            }
          }
          else {
            params.filters.code = {
              operator: 'stockavaible',
              other: ['code', 'code_secondary'],
              value: value,
              //warehouse_id: $scope.warehouseId ? $scope.warehouseId : 1,
            };
            switch ($rootScope.voucher.selected.vouchertype_id) {
              case 9:
                params.filters.productcategory_id = {
                  operator: 'whereNotIn',
                  value: '4,5',
                };
                params.filters.productcategory = {
                  operator: 'has',
                  field: 'onsale',
                  value: 1,
                };
                break;
              case 10:
                params.filters.productcategory_id = {
                  operator: '=',
                  value: 4,
                };
                break;
              case 11:
                params.filters.productcategory_id = {
                  operator: '=',
                  value: 5,
                };
                break;
            }
          }
          console.log('solicitado', params);
          TablesService.filtrar('product', params)
            .success(function (res) {
              if (res.status) {
                $scope.register.isOpen = true;
                console.log('productos all response', res);
                console.log('productos extraidos', res.result);
                $scope.productItem = res.result.data;
                if(res.result.data.length == 1){
                  console.log('unico!!',res.result.data);
                  if( $scope.newStock ){
                    var first = $rootScope.getFirstEnabled(res.result.data[0], $scope.warehouseId);
                    if( first.length == 1  ){
                      $scope.addItem(res.result.data[0], first[0]);
                    }
                  }
                  else{
                    $scope.addItem(res.result.data[0]);
                  }
                }
              }
            });
        };

        $scope.setLevelGroup = function(){
          angular.forEach($rootScope.comboGroup,function (g){
            console.log('comboGroup',g);
            var temp = g;
            angular.forEach($rootScope.voucher.selected.voucherline, function(i){
              console.log('voucherline',i);
              if(temp != i.group){
                temp = i.group;
                i.isFirst = true;
              }
              else{
                i.isfirst = false;
              }
            });
          });
          console.log('----', $rootScope.voucher.selected.voucherline);
        };
        $scope.retriveItems = function (){
          var temp = [];
          //$rootScope.voucher.selected.voucherline = [];
          console.log('BU',$scope.BU);
          angular.forEach($scope.BU.product.productcombogroup, function(g){
            var group = g.name;
            console.log('retriveItems group',g);
            $rootScope.comboGroup.push(g.name);
            angular.forEach(g.productcomboitem, function(p){
              var group = g.name;
              p.product.group = g.name;
              p.product.min = g.min;
              p.product.max = g.max;
              console.log('retriveItems',p.product);
              $rootScope.addLine(p.product);
              //$rootScope.addStock(p.stock[0]);
            })
          });
          $rootScope[$scope.modelName].selected.voucherline.splice(0, 1);
          if($rootScope.voucher.actionType == 'store'){
            angular.forEach($rootScope[$scope.modelName].selected.voucherline, function(p){
              p.quantity = 0;
            });
          }
          $scope.setLevelGroup();
        };


        $scope.addItem = function (product, stock) {
          console.log('addItem',product, stock);
          $timeout(function(){
            $scope.showPicker(false);
          }, 500);
          if(stock){
            stock.product = angular.copy(product);
          }
          switch ($rootScope.voucher.selected.vouchertype_id) {
            case 4:
              var exit = [];
              console.log('STEP', product, stock);
              angular.forEach(product.stock, function (i) {
                if (i.warehouse_id == $rootScope.voucher.selected.warehouse_id) {
                  exit.push(i);
                }
              });
              $rootScope.addLine(product);
              if(stock){
                $rootScope.addStock(stock);
              }
              else{
                $rootScope.addStock(exit[0]);
              }
              break;
            case 6:
            case 9:
            case 11:
              var x = $rootScope.getCompleteStock(product, $rootScope.voucher.selected.warehouse_id);
              if (x > 0) {
                if ($scope.newLine) {
                  $rootScope.addLine(product);
                }
                if ($scope.newStock) {
                  if (stock){
                    console.log('addItem 1', stock);
                    $rootScope.addStock(stock);
                  }
                  else{
                    //logica para seleccionar primer item disponible sin
                    //seleccionar un lote
                    var first = $rootScope.getFirstEnabled(product, $scope.warehouseId);
                    if(first.length>0){
                      $rootScope.addStock(first[0]);
                    }
                  }
                }
              }
              else{
                toastr.warning('Stock insuficiente', 'Error');
              }
              break;
            default:
              if ($scope.newLine) {
                $rootScope.addLine(product);
              }
              if ($scope.newStock) {
                console.log('addItem 2', stock);
                $scope.showPicker(false);
                $rootScope.addStock(stock);

              }
              break;
          }
          $scope.showPicker(false);
          delete $rootScope.searched;
        };


      }
    }
  })
;

'use strict';
angular.module('frontendapp')
  .directive('partnerpicker', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinventoryform/widgets/partnerpicker.html',
      restrict: 'E',
      replace: true,
      scope: {
        register: '=',
        disabled: '=',
        targetField: '@'
      },
      rootScope: $rootScope,
      controller: function partnerpickerformController($uibModal, $scope, $rootScope, toastr,
                                                     $state, $auth, $location, $log, Upload,
                                                     UserService, localStorageService,
                                                     TablesService, $window, $modal) {

        console.log('partnerpicker register!', $scope.targetField);


        //console.log($scope.disabled, $scope.partner_id)
        switch($rootScope.currentModule){
          case 'purchases':
            $scope.partnerTypeLabel = 'Proveedor';
            break;
          case 'sales':
            //$scope.partnerTypeLabel = 'Cliente';
            //TO DO
            if($scope.targetField == 'partner_id'){
              $scope.partnerTypeLabel = 'Cliente' ;
            }
            else{
              $scope.partnerTypeLabel = 'Vendedor';
            }
            break;
        }
        $rootScope.loadPartners = function ( value , targetField) {
          console.log('ejecuta loadPartners', value, targetField );
         // $scope.status.isopen = true;
          switch ($rootScope.currentModule) {
            case 'purchases':
              $scope.partnerType = 3;
              break;
            case 'inventory':
              $scope.partnerType = 1;
              break;
            case 'sales':
              $scope.partnerType = targetField == 'partner_id'? 2 : 1;
              break;
          }
          var filters = {
            per_page: '10',
            page: '1',
            filters: {
              type: {
                operator: 'whereIn',
                value:  $scope.partnerType,
              },
              docid :{
                operator: 'orwhere',
                other: ['name'/*, 'phone'*/],
                value: value
              }
            }
          };
          TablesService.filtrar('partner', filters)
            .success(function (res) {
              console.log('loadPartners',res);
              if (res.status) {
                $rootScope.partnersSet = res.result.data;
              }
            });
        };

        $scope.setPartnerSearch = function(name){
          $rootScope.partnerSearch[$scope.targetField] = name;
        };
        $rootScope.$watch('voucher.selected.'+$scope.targetField,function(){
          if($scope.targetField == 'partner_id' && $rootScope.voucher.selected.partner){
            $rootScope.partnerSearch.partner_id = $rootScope.voucher.selected.partner.name;
          }

          if($scope.targetField == 'partner_related' && $rootScope.voucher.selected.partnerrelated){
            $rootScope.partnerSearch.partner_related = $rootScope.voucher.selected.partnerrelated.name;
          }

          //$rootScope.partnerSearch[$scope.targetField] ='cambiado';
        },true)

      }
    }
  })
;

/**
 * Created by DELL on 2/12/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uireadvoucher', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uireadvoucher/uireadvoucher.html',
      restrict: 'E',
      replace: true,
      scope: {
        level: '=',
        modelName: '@',
        modelParent: '@',
        operationType: '@',
      },
      rootScope: $rootScope,
      controller: function uireadvoucherformController($uibModal, $scope, $rootScope, toastr,
                                                         $state, $auth, $location, $log, Upload,
                                                         UserService, localStorageService,
                                                         TablesService, $window, $modal) {

        $scope.firstTime = true;
        console.log('uireadvoucher', $scope.level, $scope.modelName);

        $rootScope.paymentTitle = 'Entrega de productos';
        $rootScope.newCreditIndex = 'unsigned';
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

        $scope.bussinessRules = function (){
          switch ($rootScope.currentModule) {
            case 'purchases':
              $rootScope.paymentDetail = [
                {label: 'Proveedor', value: $rootScope.voucher.selected.partner.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Almacen', value: 'Almacen central'}
              ];
              break;
            case 'sales':
              $rootScope.paymentTypes = [
                {type:'cash'},
                {type:'card'},
                {type:'note'},
                {type:'transaction'}
              ];
              if(!$rootScope.voucher.selected.partner.partnercategory){
                $rootScope.voucher.selected.partner.partnercategory = {
                  name:'SN',
                  topcredit : 0
                }
              }
              if($rootScope.voucher.selected.partner.partnercategory){
                $scope.oldTopCredit = angular.copy( $rootScope.voucher.selected.partner.partnercategory.topcredit );
              }
              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope.voucher.selected.partner.name},
                {label: 'Categoría', value: $rootScope.voucher.selected.partner.partnercategory.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Saldo de crédito',
                  success: function (){return $rootScope.newCreditIndex != 'unsigned'},
                  value: $rootScope.voucher.selected.partner.partnercategory.topcredit},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Punto de venta', value: 'Sucursal Miraflores'}
              ];
              $rootScope[$scope.modelName].selected.vouchertransaction = [
                {
                  payment_type: 'cash',
                  payment_label: 'efectivo',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'card',
                  payment_label: 'tarjeta',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'note',
                  payment_label: 'cheque',
                  verification:true,
                  attachment : '',
                  currency: 'Bs.',
                  amount :0,
                  code: ''
                },
                {
                  payment_type: 'transaction',
                  payment_label: 'transfer.',
                  verification:true,
                  currency: 'Bs.',
                  amount : 0,
                  attachment : '',
                  code: ''
                },
              ];
              break;
            case 'inventory':
              $rootScope.paymentDetail = [
                {label: 'Encargado', value: $rootScope.currentUser.partner[0].name},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Almacen', value: 'Almacen central'}
              ];
              break;
          }
        };
        $scope.bussinessRules();

        //PRODUCTS PICKER
        $scope.batchPicker = false;
        $scope.loadProducts = function (field, value) {
          /*var filter = {
           filters: {
           /!*stock: {
           operator: 'has',
           /!*field:'current_stock',
           value:'bigger'*!/
           },*!/
           code :{
           //operator: 'like',
           operator: 'orwhere',
           other: ['code_secondary', 'description'],
           value: value
           }
           },
           per_page: '10'
           };*/
          var filters = {
            per_page: '50',
            page: '1',
            filters: {
              code :{
                //operator: 'like',
                operator: 'stockavaible',
                other: ['code','code_secondary'],
                value: value
              }
            },
          };
          if (value != '') {
            //console.log('solicitado', field, filters);
            TablesService.filtrar('product', filters)
              .success(function (res) {
                if (res.status) {
                  //console.log('productos extraidos',  res.result.data);
                  $scope.products = res.result.data;
                }
                //console.log('filtros actualizados', $rootScope.memVoucher)
              });
          }
          else {
            $scope.products = [];
          }

        };
        $scope.addProduct = function (item, stock) {
          if (!$rootScope.memVoucher.voucherline) {
            $rootScope.memVoucher.voucherline = [];
          }
          console.log('inertando', item, stock)
          /*if(item.stock.length >0){item.stock[0].quantity = 1;}*/
          var newProd = {
            product_id: item.id,
            product: item,
            value: 0,
            quantity: 1,
            quantity_expected: 1,
            quantity_issued: 1,
            stock: 0,
            status: 0,
            newitem: true,
            stockadjustment : []
          };
          $rootScope.addToList($rootScope.memVoucher.voucherline, newProd, 'product_id');
          $scope.setNewStockadjustment(item.id, (stock)?stock:item.stock[0]);
          $scope.products = [];
          $rootScope.searchCode = '';
          $scope.searchCode2 = '';
          $scope.batchPicker = false;
        };
        $scope.setNewStockadjustment = function(targetId, item){
          angular.forEach($rootScope.memVoucher.voucherline, function (value) {
            if(value.product_id == targetId){
              var temp = item;
              temp.product_id =  item.product_id;
              temp.stock_id =  item.id;
              temp.quantity =  1;
              temp.quantity_expected =  1;
              temp.quantity_issued =  1;
              temp.active =  true;
              $rootScope.addToList(value.stockadjustment, temp, 'stock_id');
            }
          })
        };

        $scope.pairingVoucherStock2 = function () {
          $scope.lastOrder = 0;
          angular.forEach($rootScope.memVoucher.voucherline, function (value, key) {
            value.stockadjustment = $scope.retriveStockAdjustments(value.product_id, $scope.lastOrder );
          })
        };
        $scope.retriveStockAdjustments = function (productId, orderId){
          var stockadjustments = [];
          if($rootScope.memVoucher.stockorder.length>0){
            angular.forEach($rootScope.memVoucher.stockorder[orderId].stockadjustment,
              function (item) {
                console.log('retriveStockAdjustments', item);
                if(item.product_id == productId){
                  item.active =  true;
                  stockadjustments.push(item);
                }
              });
          }

          return stockadjustments;
        };



        //selected product to show in contextual menu


        //CALCULATES TOTAL AMOUNTH
        /*$scope.globalTotal = 0;
        $scope.othersTotal = 0;
        $scope.calculateTotal3 = function (quantity, price, discount) {
          $scope.globalTotal = 0;
          angular.forEach($rootScope.memVoucher.voucherline, function (value, key) {
            //console.log('calculateTotal3',value, value[quantity], value[price])
            var sum = 0;
            var discount = 0;
            value[quantity] = Math.round(value[quantity]);
            if (value[quantity] > 0 && parseFloat(value[price])  > 0) {
              if(value.discount){
                discount =  (parseFloat(value[price]) * value.discount/100);
                //console.log('descuento calculado', discount)
              }
              value.sub =  value[quantity] * (parseFloat(value[price]) - discount);
              sum = value[quantity] * (parseFloat(value[price]) - discount) ;
            }
            if(value.stockadjustment.length == 1){
              value.stockadjustment[0].quantity = value[quantity];
            }
            angular.forEach(value.stockadjustment, function (item, itemkey) {
              //console.log(item, itemkey);
              item.quantity_issued = item.quantity;
              item.quantity_expected = item.quantity - item.quantity_issued ;
            });

            $scope.globalTotal += sum;
          });
          $rootScope.memVoucher.total = $scope.globalTotal + $scope.othersTotal;

        };
        $scope.calculateSubTotal3 = function (target, source) {
          var sub = 0;
          console.log('calculateSubTotal3',target, source);
          angular.forEach(target.stockadjustment, function (value, key) {
            if(!value.quantity){
              value.quantity = 0;
            }
            sub += value.quantity;
          });
          target.quantity = sub;
          $scope.calculateTotal3('quantity','value');
          return sub;
        };*/

        //STORES TRANSACTION
        $scope.updateRegister = function () {
          $rootScope.memVoucher = angular.copy($rootScope.memVoucher);
          console.log('UPDATE REGISTER', $rootScope[$scope.modelName])
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              console.log('simplificado', $rootScope.memVoucher, $rootScope[$scope.modelName].actionType);
              switch ($rootScope[$scope.modelName].actionType) {
                case 'store':
                  $rootScope[$scope.modelName].storeRow();
                  break;
                case 'update':
                  $rootScope[$scope.modelName].updateRow();
                  break;
                case 'delete':
                  $rootScope[$scope.modelName].deleteRow();
                  break;
              }
            });
        };

        //STOCK MOVEMENT DEFINITION
        $scope.checkGoodStock = function(item){
          var tot = 0;
          console.log('checkGoodStock', item);
          angular.forEach(item.stock, function(i){
            if(i.warehouse_id == $rootScope.voucher.selected.warehouse_id){
              tot += i.current_stock;
            }
          });
          /*if(tot>0){
           // console.log('checkGoodStock', tot, item);
           }*/
          return tot;
        };
        /*$scope.newTotalDelivery = function (cg){
          cg.newTotal = 0;
          angular.forEach(cg.product,function(i){
            cg.newTotal += i.quantity;
          })
        };*/
        $rootScope.memVoucher ={};
        $rootScope.loadTempVoucher = function (voucher){
          console.log('cargado', voucher)
          $rootScope.memVoucher = angular.copy(voucher);
          $scope.pairingVoucherStock2();
          if(voucher.stockorder.length>0){
            $rootScope.memVoucher.warehouse_id = voucher.stockorder[0].warehouse_id;
            $rootScope.memVoucher.warehouse = voucher.stockorder[0].warehouse;
          }
          console.log('LOADED memVoucher', $rootScope.memVoucher);
        };
        //CONTROL
        console.log($rootScope.tempVoucher);
        $rootScope.loadTempVoucher($rootScope.tempVoucher);
        $rootScope.$watch('tempVoucher', function () {
          console.log($rootScope.tempVoucher);
          $rootScope.loadTempVoucher($rootScope.tempVoucher);
        }, true);
        $scope.closeAndBack = function (){
          $rootScope.uiConf.switchView('prev')
        };

        $rootScope.printMem=function(){
          console.log('mem voucher', $rootScope.memVoucher);
          console.log('mem voucher', $rootScope.memVoucher.voucherline);
        }


      }
    }
  })
;

'use strict';
angular.module('frontendapp')
  .directive('uiselleragenda', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiselleragenda/uiselleragenda.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        modelParent: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
        level: '='
      },
      rootScope: $rootScope,

      controller: function uiselleragendaController($uibModal, $scope, $rootScope, toastr,
                                                    $state, $auth, $location, $log,
                                                    UserService, localStorageService,
                                                    TablesService, $window, $modal) {




        //////////////USEFULL VARS ///////////////



        $rootScope.years = [];
        for (var i = 0; i < 100; i++) {
          $rootScope.years.push(
            {
              id: String(2017 + i),
              label: 2017 + i
            }
          );
        }

        $rootScope.statusOptions = [
          {id: "1", label: $rootScope.switchText('No iniciado', 'Pending')},
          {id: "2", label: $rootScope.switchText('En proceso', 'In progress')},
          {id: "3", label: $rootScope.switchText('Detenido', 'Stoped')},
          {id: "4", label: $rootScope.switchText('Concluido', 'Finished')}
        ];

        $rootScope.weekDays = [
          {id: "1", label: 'Mo'},
          {id: "2", label: 'Tu'},
          {id: "3", label: 'We'},
          {id: "4", label: 'Th'},
          {id: "5", label: 'Fr'},
          {id: "6", label: 'Sa'},
          {id: "7", label: 'Su'}
        ];

        $rootScope.months = [
          {id: "1", label: "Enero"},
          {id: "2", label: "Febrero"},
          {id: "3", label: "Marzo"},
          {id: "4", label: "Abril"},
          {id: "5", label: "Mayo"},
          {id: "6", label: "Junio"},
          {id: "7", label: "Julio"},
          {id: "8", label: "Agosto"},
          {id: "9", label: "Septiembre"},
          {id: "10", label: "Octubre"},
          {id: "11", label: "Noviembre"},
          {id: "12", label: "Diciembre"}
        ];

        $rootScope.getDaysInMonth = function (gmonth, gyear) {
          ////console.log'procesing', gmonth, gyear)
          return new Date(gyear, gmonth, 0).getDate();
        };

        $rootScope.getDaysInyear = function (year) {
          return $rootScope.isLeapYear(year) ? 366 : 365;
        };

        $rootScope.isLeapYear = function (year) {
          return year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);
        };

        $rootScope.getWeekNumber = function (d) {
          // Copy date so don't modify original
          d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
          // Set to nearest Thursday: current date + 4 - current day number
          // Make Sunday's day number 7
          // d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
          // Get first day of year
          //var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
          var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 0));
          // Calculate full weeks to nearest Thursday
          var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1) / 7);
          // Return array of year and week number
          return weekNo;
        };

        $rootScope.calendarConstruct = function (fYear, fmonth) {
          $rootScope.calendar = {
            view: '1',
            weekFirst: 0,
            weekLast: 0,
            fYear:fYear,
            fMonth:fmonth
          };
          var baseItems = $rootScope.calendarGenDays(1, $rootScope.getDaysInMonth(fmonth, fYear) + 1, fYear, fmonth, false);
          var firstItem = baseItems[0];
          var lastItem = baseItems[baseItems.length - 1];
          var items = [];
          var extra1 = [];
          var extra2 = [];
          if (firstItem.weekday > 0) {
            extra1 = $rootScope.calendarGenDays(
              $rootScope.getDaysInMonth(firstItem.month - 1, firstItem.year) + 1 - firstItem.weekday, //to
              $rootScope.getDaysInMonth(firstItem.month - 1, firstItem.year) + 1, //from
              (lastItem.month == 1) ? parseInt(lastItem.year) - 1 : parseInt(lastItem.year),// year
              (lastItem.month == 1) ? 12 : parseInt(lastItem.month) - 1, // month
              true);
            items = items.concat(extra1);
          }
          items = items.concat(baseItems);
          if (lastItem.weekday != 6) {
            extra2 = $rootScope.calendarGenDays(
              1, //from
              1 - lastItem.weekday + 6, //to
              (lastItem.month == 12) ? parseInt(lastItem.year) + 1 : parseInt(lastItem.year), //year
              (lastItem.month == 12) ? parseInt(lastItem.month) : 1, //month
              true);
            items = items.concat(extra2);
          }
          $rootScope.calendar.items = items;
          $rootScope.calendar.weekFirst = $rootScope.calendar.items[0].weeknumber;
          $rootScope.calendar.weekLast = $rootScope.calendar.items[$rootScope.calendar.items.length - 1].weeknumber;

          console.log('vista calendario', $rootScope.calendar, fYear, fmonth, items);
        };

        $rootScope.calendarGenDays = function (from, to, year, month, extra) {
          //console.log'calendarGenDays', year, month)
          var temp = [];
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          for (var i = from; i < to; i++) {
            temp.push(
              {
                id: i,
                day: i,
                month: month,
                year: year,
                weekday: new Date(year, month - 1, i).getDay(),
                weekdaylabel: $rootScope.weekDays[new Date(year, month - 1, i).getDay()].label,
                date: new Date(year, month - 1, i),
                weeknumber: $rootScope.getWeekNumber(new Date(year, month - 1, i)),
                today: today.getTime() == new Date(year, month - 1, i).getTime(),
                extra: extra,
                data: {}
              }
            );
            if(today.getTime() == new Date(year, month - 1, i).getTime()){
              $rootScope.today = {
                id: i,
                day: i,
                month: month,
                year: year,
                weekday: new Date(year, month - 1, i).getDay(),
                weekdaylabel: $rootScope.weekDays[new Date(year, month - 1, i).getDay()].label,
                date: new Date(year, month - 1, i),
                weeknumber: $rootScope.getWeekNumber(new Date(year, month - 1, i)),
                today: today.getTime() == new Date(year, month - 1, i).getTime(),
                extra: extra,
                data: {}
              };
              console.log('$rootScope.today ',$rootScope.today )
            }
          }
          return temp;
        };

        $rootScope.stringToDate = function (value) {
          var event1 = value.split('-');
          var event2 = new Date(event1[0], event1[1] - 1, event1[2]);
          return event2
        };

        $rootScope.identifyTasks = function (dateEval) {
          var data = {
            events: [],
            stages: [],
            project: false
          };

          return data;

        };

        $rootScope.switchCalendarView = function (type, value) {
          var fmont = angular.copy($rootScope.calendar.fMonth);
          var fyear = angular.copy($rootScope.calendar.fYear);

         if(type == 'month'){
            if(value=='next' ){
              if($rootScope.calendar.fMonth < 12){
                fmont ++;
              }
              else{
                fmont = 1;
                fyear ++;
              }
            }
            if(value=='prev' ){
              if($rootScope.calendar.fMonth >1){
                fmont --;
              }
              else{
                fmont = 12;
                fyear --;
              }
            }
           $rootScope.year = fyear;
           $rootScope.month = fmont;
           $rootScope.calendarConstruct(fyear, fmont);
           $rootScope.getMonthSchedule(fyear, fmont);
          }
        };

        $rootScope.calendarConstruct($rootScope.year, $rootScope.month);


        ////////////////////////////////////////////////////////////////

        $rootScope.dayView = false;
        $rootScope.editDayView = false;

        $rootScope.checkInfo = function (day){
          var temp = day.year + "-" + (day.month < 10 ? "0" + day.month : day.month) + "-" + (day.day < 10 ? "0" + day.day : day.day);
          day.info = false;
          angular.forEach($rootScope.selleragenda.dataset.data, function(i){
            if(i.date == temp){
              day.info = true;
            }
          });
          return day.info;
        };

        $rootScope.getDaySchedule = function (day){
          var temp = day.year + "-" + (day.month < 10 ? "0" + day.month : day.month) + "-" + (day.day < 10 ? "0" + day.day : day.day);
          $rootScope.selleragenda.selected = {items : []};
          $rootScope.dayPicked = temp;
          angular.forEach($rootScope.selleragenda.dataset.data, function(i){
            console.log(i.date , temp);
            if(i.date == temp){
              $rootScope.selleragenda.selected.items.push(i);
            }
          });
          $rootScope.dayView = true;
          console.log('seleccionado',$rootScope.selleragenda.selected);
        };

        $rootScope.checkClient = function(partner){
          //var control = false;
          partner.picked = false;
          angular.forEach($rootScope.selleragenda.selected.items ,function(i){
            if( partner.id == i.partner_id  ){
              partner.picked = true;
              partner.status = i.status;
              partner.selleragenda = i;
            }
          });
          console.log('control 1',partner);
          return partner.picked;
        };

        $rootScope.reloadDaySchedule = function(){
          TablesService.filtrar('selleragenda', {
            filters: {
              date: {
                operator: 'like',
                value: $rootScope.dayPicked
              }
            }
          }).success(function (res) {
            console.log('selleragenda!!!!!',res);
            $rootScope.selleragenda.selected.items = res.result.data;
            angular.forEach($rootScope.sellerClients, function(i){
              $rootScope.checkClient(i);
            });
          });
        };
        $rootScope.addSchedule = function(client){
          var item = {
            partner_id: client.id,
            user_id:$rootScope.currentUser.id,
            date: $rootScope.dayPicked,
            status: 0,
            comment:'',
          };
          client.picked = true;
          TablesService.almacenar('selleragenda', item)
            .success(function (res) {
              console.log(res);
              $rootScope.reloadDaySchedule();
            })

        };

        $rootScope.removeSchedule = function (client) {
          client.picked = false;
          TablesService.eliminar('selleragenda',
            client.selleragenda.id, client.selleragenda)
            .success(function (res) {
              console.log(res);
              $rootScope.reloadDaySchedule();
            });
        };
        $rootScope.markSchedule = function (client) {
          console.log('client',client);
          if(client.status == 0){
            client.status = 1;
            client.selleragenda.status = 1;
          }
          else{
            client.status = 0;
            client.selleragenda.status = 0;
          }

          TablesService.actualizar('selleragenda',
            client.selleragenda.id, client.selleragenda)
            .success(function (res) {
              console.log(res);
              $rootScope.reloadDaySchedule();
            })
        };
        $rootScope.commentSchedule = function (client) {
          TablesService.actualizar('selleragenda',
            client.selleragenda.id, client.selleragenda)
            .success(function (res) {
              console.log(res);
              $rootScope.reloadDaySchedule();
            })
        };

        $rootScope.getMonthSchedule = function(year, month){
          var filters = {
            filters: {
              user_id: {
                operator: 'like',
                value: $rootScope.currentUser.id
              },
              date: {
                operator: 'like',
                value: year + "-" + (month < 10 ? "0" + month : month)
              }
            }
          };

          TablesService.filtrar('selleragenda', filters)
            .success(function (res) {
              console.log('selleragenda!!!!!',res);
              $rootScope.selleragenda.dataset = res.result;
            });
        };

        $rootScope.getSellerClients = function(){
          var filters = {
            filters: {
              created_by: {
                operator: 'like',
                value: $rootScope.currentUser.id
              },
              type: {
                operator: 'like',
                value: 2
              },
            }
          };
          console.log('filtros enviados', filters);
          TablesService.filtrar('partner', filters)
            .success(function (res) {
              console.log('partners!!!!!',res);
              $rootScope.sellerClients = res.result.data;
            });
        };

        $rootScope.getSellerClients();

        $rootScope.setPartnertask = function(partner, state){
          $rootScope.globalPartner = angular.copy(partner);
          $rootScope.stateGo(state,{lan:$rootScope.language});
          console.log('$rootScope.globalPartner ',$rootScope.globalPartner );
        };

        $rootScope.selectPartner = function(partner){
          $rootScope.infoMenu = true;
          $rootScope.selleragenda.selected.partner = partner;
        }



      }
    }
  });

'use strict';
angular.module('frontendapp')
  .directive('uiselector', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiselector/uiselector.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        modelParent: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
        level: '='
      },
      rootScope: $rootScope,

      controller: function uiselectorController($uibModal, $scope, $rootScope, toastr,
                                            $state, $auth, $location, $log,
                                            UserService, localStorageService,
                                            TablesService, $window, $modal) {


       

       

      }
    }
  });

/** Created by DELL on 12/12/2018.
 */

'use strict';
angular.module('frontendapp')
  .directive('uipiker', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uipiker/uipiker.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        modelParent: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
        level: '='
      },
      rootScope: $rootScope,

      controller: function uipikerController($uibModal, $scope, $rootScope, toastr,
                                            $state, $auth, $location, $log,
                                            UserService, localStorageService,
                                            TablesService, $window, $modal) {


        $scope.itemsList = [];

        switch($scope.modelName){
          case 'voucher':
            console.log('uipiker',$scope.modelName,$rootScope[$scope.modelName].selected);
            break;
          case 'productcombogroup':
            console.log('uipiker',$scope.modelName,$rootScope[$scope.modelName].selected);
            $scope.temp = angular.copy($rootScope[$scope.modelName].selected.productcomboitem);
            angular.forEach($scope.temp, function (i){
              $scope.itemsList.push(i.product);
            });
            break;
          case 'productgroup':
            console.log('uipiker',$scope.modelName,$rootScope[$scope.modelName].selected);
            $scope.temp = angular.copy($rootScope[$scope.modelName].selected.productgroupitem);
            angular.forEach($scope.temp, function (i){
              i.product = {
                id:i.product_id
              };
              $scope.itemsList.push(i.product);
            });
            break;
        }
        $scope.itemsListBU = angular.copy($scope.itemsList);

        $scope.$watch('itemsList', function(){
          console.log('lista actual', $scope.itemsList);
        });

        $scope.saveSelection=function (){
          switch($scope.modelName){
            case 'voucher':
              angular.forEach($scope.itemsList, function (item){
                console.log('agregando a voucher',item)
                $rootScope.addLine (item);
              });
              $rootScope.uiConf.switchView('prev');
              break;
            case 'productcombogroup':
              var list = [];
              angular.forEach($scope.itemsList, function (l){
                var l = {
                  productcombogroup_id : $rootScope.productcombogroup.selected.id,
                  product_id : l.id
                };
                list.push(l);
              });
              console.log('actual!!!!', $rootScope.productcombogroup.selected.productcomboitem);
              var params = {
                list: list,
                id: $rootScope.productcombogroup.selected.id
              };
              console.log('enviando!!!!', params);
              TablesService.storemany('productcomboitem',params)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if(res.status){
                    toastr.success('Registro almacenado', 'Exito');
                    $rootScope.uiConf.switchView('prev', {}, true);
                  }
                  else{
                    toastr.warning('Registro no almacenado', 'Error'  );
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error'  );
                });
              break;
            case 'productgroup':
              var list = [];
              angular.forEach($scope.itemsList, function (l){
                var l = {
                  productgroup_id : $rootScope.productgroup.selected.id,
                  product_id : l.id
                };
                list.push(l);
              });
              console.log('actual!!!!', $rootScope.productgroup.selected.productgroupitem);
              var params = {
                list: list,
                id: $rootScope.productgroup.selected.id
              };
              console.log('enviando!!!!', params);
              TablesService.storemany('productgroupitem',params)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if(res.status){
                    toastr.success('Registro almacenado', 'Exito');
                    $rootScope.uiConf.switchView('prev', {}, true);
                  }
                  else{
                    toastr.warning('Registro no almacenado', 'Error'  );
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error'  );
                });
              break;
          }

          /*if($scope.modelName != 'voucher' ){
            var list = [];
            angular.forEach($scope.itemsList, function (l){
              var l = {
                productcombogroup_id : $rootScope.productcombogroup.selected.id,
                product_id : l.id
              };
              list.push(l);
            });
            console.log('actual!!!!', $rootScope.productcombogroup.selected.productcomboitem);
            var params = {
              list: list,
              id: $rootScope.productcombogroup.selected.id
            };
            console.log('enviando!!!!', params);
            TablesService.storemany('productcomboitem',params)
              .success(function (res) {
                console.log('Salida almacenar', res);
                if(res.status){
                  toastr.success('Registro almacenado', 'Exito');
                  $rootScope.uiConf.switchView('prev', {}, true);
                }
                else{
                  toastr.warning('Registro no almacenado', 'Error'  );
                }
              })
              .error(function (res) {
                console.log('ERROR salida almacenar', res);
                toastr.warning('Registro no almacenado', 'Error'  );
              })
          }
          else{
            /!*$rootScope[$scope.modelName].itemsList= angular.copy($scope.itemsList);
            $rootScope.productsPiked =  angular.copy($scope.itemsList);*!/
            angular.forEach($scope.itemsList, function (item){
              console.log('agregando a voucher',item)
              $rootScope.addLine (item);
            });
            $rootScope.uiConf.switchView('prev');
            //$rootScope[$scope.modelName].resetRegister();
          }*/
        };

        //paginacion

        $rootScope.calculateStock = function (items){
          var total = 0;
          if(items){
            angular.forEach(items, function (item){
              if(item.current_stock){
                total += parseInt(item.current_stock);
              }
            }) ;
          }
          return total;
        };

        /////////////////////////////////
        /////////////////////////////////
        /////////////////////////////////
        console.log('PIKERFORM',  $rootScope[$scope.modelName]);
        //paginacion
        $scope.changePage = function ( value) {
          switch(value) {
            case 'increase':
              $scope.pikerFilter.page++;
              break;
            case 'decrease':
              $scope.pikerFilter.page--;
              break;
            default:
              $scope.pikerFilter.page = value;
              break;
          }
          $scope.loadItem();
        };
        $scope.changePerPage = function () {
          console.log('changePerPage',$scope.filters);
          $scope.pikerFilter.page=1;
          $scope.pikerFilter.per_page = parseInt(angular.copy( $scope.pikerFilter.page)) ;
          $scope.loadItem();
        };
        $scope.pikerFilter = {
          per_page:25,
          page:1,
          filters: {
            code:{
              value:'',
              operator:'like'
            },
            code_secondary:{
              value:'',
              operator:'like'
            },
            description:{
              value:'',
              operator:'like'
            }
          }
        };
        switch ($scope.modelName) {
          case 'productcombogroup':
          case 'voucher':
            $scope.pikerFilter.filters.productcategory_id = {
              value: '4',
              operator: '<>'
            };
            break;
        }

        $scope.loadItem = function () {
          if($scope.modelName=='voucher'){
            /*$scope.pikerFilter.filters.code = {
              operator: 'stockavaible',
              other: ['code', 'code_secondary'],
              value: value,
              warehouse_id: $scope.warehouseId ? $scope.warehouseId : 1,
            };*/
            switch ($rootScope.currentModule) {
              case 'purchases':
                break;
              case 'inventory':
                $scope.pikerFilter.filters.code = {
                  operator: 'stockavaible',
                  other: ['code', 'code_secondary'],
                  warehouse_id: $rootScope.voucher.selected.warehouse_id
                };
                break;
              case 'sales':
                $scope.pikerFilter.filters.code.operator =  'stockavaible';
                $scope.pikerFilter.filters.code.other = '';
                $scope.pikerFilter.filters.code.warehouse_id = '';
                /*params.filters.code = {
                  operator: 'stockavaible',
                  other: ['code', 'code_secondary'],
                  value: value,
                  //warehouse_id: $scope.warehouseId ? $scope.warehouseId : 1,
                };*/
                break;
            }
            console.log('solicitado products for voucher', $scope.pikerFilter);
          }
          TablesService.filtrar('product',  $scope.pikerFilter )
            .success(function (res) {
              if (res.status) {
                console.log('product extraidos', res.result);
                $scope.productData = res.result;
                $scope.productItem = res.result.data;
              }
            });
        };

        //$scope.loadItem();

        $scope.loadProductlines = function (){
          TablesService.filtrar('productline',  {
            per_page:1000000
          })
            .success(function (res) {
              if (res.status) {
                console.log('productline extraidos', res.result.data);

                $scope.productLine = res.result.data;
              }
            });
        };

        $scope.loadProductlines ();

        $scope.loadProductfamily = function (){
          TablesService.filtrar('productfamily',  {
            per_page:1000000
          })
            .success(function (res) {
              if (res.status) {
                console.log('productfamily extraidos', res.result.data);
                $scope.productfamily = res.result.data;
              }
            });
        };

        $scope.loadProductfamily ();

        $scope.loadProductbrand = function (){
          TablesService.filtrar('productbrand',  {
            per_page:1000000
          })
            .success(function (res) {
              if (res.status) {
                console.log('productbrand extraidos', res.result.data);
                $scope.productbrand = res.result.data;
              }
            });
        };

        $scope.loadProductbrand ();

        $scope.loadProductcategory = function (){
          TablesService.filtrar('productcategory',  {
            per_page:1000000
          })
            .success(function (res) {
              if (res.status) {
                console.log('productcategory extraidos', res.result.data);
                $scope.productcategory = res.result.data;
              }
            });
        };

        $scope.loadProductcategory ();

        $scope.setWarehouse = function (id){
          $scope.warehouseId = id;
        };

        $scope.getWarehouse = function (){
          var control = false;
          angular.forEach($scope.warehouseList,function (w){
            if(w.id==id && !control){
              $scope.warehouse = w;
              control = true;
            }
          });
          return $scope.warehouse;
        };

        $scope.loadWitems = function (){
          TablesService.filtrar('warehouse', params)
            .success(function (res) {
              if (res.status) {
                console.log('warehouse extraidos', res.result.data);
                $scope.warehouseList = res.result.data;
              }
            });
        };

        $scope.validateAddtolist = function(register){
          console.log('validateaddtolist',$scope.modelName , register);
          if($scope.modelName == 'voucher'){
            switch($rootScope.currentState ){
              case 'sales-point':
                var total = 0;
                if (register.stock) {
                  angular.forEach(register.stock, function (item) {
                    if (item.current_stock && $rootScope.voucher.selected.warehouse_id == item.warehouse_id) {
                      total += parseInt(item.current_stock);
                    }
                  });
                }
                if (total) {
                  $rootScope.addToList($scope.itemsList, register, 'id', true);
                }
              case 'transfer-point':
              case 'purchase-point':
                   break;
              case 'sales-debts':
              case 'purchases-debts':
                 break;
              case 'sales-delivery-point':
                break;
              default:
                break;
            }
          }
          else{
            $rootScope.addToList($scope.itemsList , register, 'id', true);
          }
        }

      }
    }
  });


/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uipaymentold', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uipaymentold/uipaymentold.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uipaymentoldController($uibModal, $scope, $rootScope, toastr,
                                               $state, $auth, $location, $log,
                                               UserService, localStorageService,
                                               TablesService, $window, $modal) {



        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {
          console.log('REFRESH desde uipaymentold');
          $rootScope.calculateBalance();
        }, true);

        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

        $rootScope.newPay = function () {
          $scope.emptyPay = {
            voucher_id: $rootScope.voucher.selected.id,
            partner_id: $rootScope.voucher.selected.partner_id,
            type: '',
            payment_type: '',
            comment: '',
            amount: 0,
            balance: 0,
            debit: 0,
          };
          var temp = angular.copy($scope.emptyPay);
          $rootScope.voucher.selected.vouchertransaction.push(temp)
          console.log('CREA NUEVO PAGO!!!')
        };

        $rootScope.calculateBalance = function () {
          /*var last = $rootScope.voucher.selected.vouchertransaction.length-1;
           var pay = angular.copy($rootScope.voucher.selected.vouchertransaction[last]);
           console.log('calculando...' , $rootScope.voucher.selected.vouchertransaction);
           if($rootScope.voucher.selected.vouchertransaction.length==0){
           pay.debit = angular.copy($rootScope.voucher.selected.total);
           }
           else{
           pay.debit = angular.copy($scope.nextDebit);
           }
           pay.balance = pay.debit - pay.amount;
           pay.nextDebit = pay.amount - pay.debit;
           console.log(pay);
           $scope.nextDebit = angular.copy(pay.balance);
           $rootScope.voucher.selected.subtotal = 0;
           $rootScope.blockPay=false;
           console.log('calculando... last ', pay);*/
          if (!$rootScope.voucher.selected.vouchertransaction) {
            $rootScope.voucher.selected.vouchertransaction = [];
            $rootScope.newPay();
          }
          console.log('calculando...', $rootScope.voucher.selected.vouchertransaction);
          $rootScope.blockPay=false;
          /////////////////DDD
          /////////////////DDD
          /////////////////DDD
          angular.forEach($rootScope.voucher.selected.vouchertransaction, function (value, key) {
            $rootScope.voucher.selected.subtotal = 0;
            console.log('calculando...', key);
            if (key == 0) {
              value.debit = angular.copy($rootScope.voucher.selected.total);
              $scope.nextDebit = angular.copy(value.balance);
            }
            else {
              value.debit = angular.copy($scope.nextDebit)
            }

            if(value.cash ){
              if(value.cash > value.debit ){
                value.amount =  value.cash - value.debit ;
              }
              else{
                value.amount = value.cash;
              }
            }

            value.balance = value.debit - value.amount;
            $scope.nextDebit = angular.copy(value.balance);
            console.log('calculando...', value);


            //////ultimo saldo
            $rootScope.voucher.selected.balance = angular.copy(value.balance);

            if( $rootScope.voucher.selected.balance < 0){
              $rootScope.voucher.selected.balance = 0;
            }

            //CONTROL
            if (value.amount <= 0) {
              console.log('XXXXX1');
              $rootScope.blockPay = true;
            }
            //CONTROL
            if (value.payment_type == '') {
              console.log('XXXXX2');
              $rootScope.blockPay = true;
            }
          });
          console.log('calculando...', $rootScope.voucher.selected.vouchertransaction);

          //CONTROL
          if ($rootScope.voucher.selected.balance < 0) {
            console.log('XXXXX3');
            $rootScope.blockPay = true;
          }

        };

        $scope.remove = function ($index) {
          $rootScope.voucher.selected.vouchertransaction.splice($index, 1);
          $rootScope.calculateBalance();
        };

        /*if(!$rootScope[$scope.modelName].selected.vouchertransaction){
         $rootScope.voucher.selected.vouchertransaction=[];
         $rootScope.newPay();
         }*/

        $rootScope.calculateBalance();

        $scope.resetPay = function () {
          $rootScope.voucher.selected.vouchertransaction = [];
          $rootScope.newPay();
          $rootScope.calculateBalance();
        };

        //STORES TRANSACTION
        $scope.updateRegister = function () {

          $rootScope[$scope.modelName].selected = angular.copy($rootScope[$scope.modelName].selected);
          console.log('UPDATE REGISTER', $rootScope[$scope.modelName])
          $scope.control = false;
          if ($rootScope[$scope.modelName].selected.voucherline.length > 0 && $rootScope[$scope.modelName].selected.partner.docid != '') {
            $scope.control = true;
          }
          else {
            toastr.warning('Complete los campos', 'Error');
          }
          if ($scope.control) {
            UserService.actualizarToken()
              .success(function (tok) {
                $rootScope.asignarVarSession('token', tok);
                console.log('simplificado', $rootScope[$scope.modelName].selected, $rootScope[$scope.modelName].actionType);
                switch ($rootScope[$scope.modelName].actionType) {
                  case 'store':
                    $rootScope[$scope.modelName].storeRow();
                    break;
                  case 'update':
                    $rootScope[$scope.modelName].updateRow();
                    break;
                  case 'delete':
                    $rootScope[$scope.modelName].deleteRow();
                    break;
                }
              });
          }
        };


      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uipayment', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
        level: '=',
      },
      rootScope: $rootScope,
      controller: function uipaymentController($uibModal, $scope, $rootScope, toastr,
                                               $state, $auth, $location, $log,
                                               UserService, localStorageService,
                                               TablesService, $window, $modal) {

        console.log('DIRECTIVE uipayment');
        $rootScope.paymentTitle = 'Forma de pago';
        $rootScope.creditIndex = -1;
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        $scope.getWName = function () {
          var exit = '';
          angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w) {
            if ($rootScope.voucher.selected.warehouse_id == w.id) {
              exit = w.name;
            }
          });
          return exit;
        };
        $scope.getWName2 = function () {
          var exit = '';
          angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w) {
            if ($rootScope.voucher.selected.warehouse_id2 == w.id) {
              exit = w.name;
            }
          });
          return exit;
        };
        $scope.currentCR = $rootScope.getCurrentUserCashregister(false) ;

        console.log('$scope.currentCR',$scope.currentCR);

        $rootScope.paymentTypes = [
          {
            id: 1,
            type: 'cash',
            label: 'Efectivo Bs.',
            currency: 'Bs.',
            times: 1,
            hidden: function () {
              if ($rootScope.currentModule == 'sales' && $rootScope.currentState!= 'sales-mobile-point') {
                return false;
              }
              else {
                return true;
              }
            }
          },
          {
            id: 2,
            type: 'cash',
            label: 'Efectivo USD',
            currency: 'USD',
            times: 1,
            hidden: function () {
              if ($rootScope.currentModule == 'sales' && $rootScope.currentState!= 'sales-mobile-point') {
                return false;
              }
              else {
                return true;
              }
            }
          },
          {
            id: 3,
            type: 'card',
            label: 'Tarjeta',
            currency: 'Bs.',
            times: 1,
            hidden: function () {
              if ($rootScope.currentModule == 'sales' && $rootScope.currentState!= 'sales-mobile-point') {
                return false;
              }
              else {
                return true;
              }
            }
          },
          {
            id: 4,
            type: 'other',
            label: 'Transfer',
            verification: true,
            currency: 'Bs.',
            times: 2,
            hidden: function () {
              if ( $rootScope.currentState!= 'sales-mobile-point') {
                return false;
              }
              else {
                return true;
              }
            }
          },
          {
            id: 5,
            type: 'credit',
            label: 'Crédito',
            currency: 'Bs.',
            times: 1,
            hidden: function () {
              return true;
            }
          }
        ];
        //PAYMENT CONTROL
        $scope.validateNewPay = function () {
          angular.forEach($rootScope.paymentTypes, function (p) {
            p.count = 0;
            angular.forEach($rootScope.voucher.selected.vouchertransaction,
              function (t) {
                if (t.payment_type == p.type && t.currency == p.currency) {
                  p.count++;
                }
              });
            (p.count >= p.times || $rootScope.voucher.selected.balance <= 0) ? p.enable = false : p.enable = true;
          });
        };

        console.log('TIPO VOUCHER DESDE PAYMENT', $rootScope.voucher.selected.invoice_type);
        if($rootScope.voucher.selected.invoice_type == 4){

          $scope.partnerTarget = 'partnerrelated';
        }
        else{
          $scope.partnerTarget = 'partner';
        }

        console.log('PARTNERTARGET',$scope.partnerTarget);
        $rootScope.newPay = function (value, currency, verification, label) {
          console.log('newPay', value, currency, verification);
          $scope.emptyPay = {
            voucher_id: $rootScope.voucher.selected.id,
            partner_id: $rootScope.voucher.selected[$scope.partnerTarget].id,
            cashregister_id :($scope.currentCR)?$scope.currentCR.id:null,
            type: '',
            payment_type: value,
            payment_label: label,
            currency: currency ? currency : $rootScope.globalParams.currency,
            verification: '',
            comment: '',
            amount: 0,
            amount_issued: 0,
            amount_bs: 0,
            amount_usd: 0,
            amount_excedent: 0,
            current_exchange: $rootScope.globalParams.TcUSD,
            balance: 0,
            debit: 0,
          };
          if($rootScope.currentModule == 'sales'){
            $scope.emptyPay.cashregister_id = $rootScope.currentUser.cashregisteruser[0].cashregister.id;
          }
          if (verification === true) {
            $scope.emptyPay.verification = true;
            $scope.emptyPay.attachment = true;
          }
          $rootScope.voucher.selected.vouchertransaction.push($scope.emptyPay);
          $rootScope.creditIndex = $rootScope.getCreditindex();
          if ($rootScope.creditIndex >= 0) {
            $rootScope.voucher.selected.vouchertransaction[$rootScope.creditIndex].amount = angular.copy($rootScope.voucher.selected.balance);
            $rootScope.calculateBalance($rootScope.voucher.selected.vouchertransaction[$rootScope.creditIndex]);
            if ($rootScope.currentModule == 'sales') {
              $rootScope.voucher.selected[$scope.partnerTarget].creditavailable -= $rootScope.voucher.selected.vouchertransaction[$rootScope.creditIndex].amount;
              console.log('credit actualizado',  $rootScope.voucher.selected[$scope.partnerTarget].creditavailable );
              angular.forEach($rootScope.paymentDetail, function (value) {
                if (value.label == 'Saldo de crédito') {
                  console.log('credit actualizado 2');
                  value.value = $rootScope.voucher.selected[$scope.partnerTarget].creditavailable;
                }
              });
            }
          }
        };
        $rootScope.undoCredit = function () {
          $rootScope.voucher.selected.vouchertransaction.splice($rootScope.getCreditindex(), 1);
          $rootScope.creditIndex = $rootScope.getCreditindex();
          if ($rootScope.currentModule == 'sales') {
            console.log('$scope.oldTopCredit',$scope.oldTopCredit);
            $rootScope.voucher.selected[$scope.partnerTarget].creditavailable = angular.copy($scope.oldTopCredit);
            angular.forEach($rootScope.paymentDetail, function (value) {
              if (value.label == 'Saldo de crédito') {
                value.value = angular.copy($scope.oldTopCredit);
              }
            });
          }
          $scope.resetPay();
        };
        $rootScope.getCreditindex = function () {
          var exit = -1;
          angular.forEach($rootScope.voucher.selected.vouchertransaction, function (value, key) {
            if (value.payment_type == 'credit') {
              exit = key;
            }
          });
          return exit;
        };
        $scope.resetPay = function () {
          $scope.bussinessRules();
        };
        $rootScope.countTotalAmount = function(){
          var count = 0;
          var temp = angular.copy($rootScope.voucher.selected.vouchertransaction);
          angular.forEach(temp, function (value) {
            count += value.amount;
          });
          return count;
        };
        $rootScope.calculateBalance = function (tr) {
          $rootScope.voucher.selected.totalAmount = 0;
          $rootScope.voucher.selected.positiveBalance = 0;
          //Exchange, stores transaction
          if (tr.currency != $rootScope.globalParams.currency) {
            tr.amount_usd = angular.copy(tr.amounthOther);
            tr.amount = $rootScope.exchangeAmount( tr.amounthOther, 'TcUSD');
          }
          else{
            tr.amount_bs = angular.copy(tr.amount);
          }

          //Calculate total debt
          $rootScope.voucher.selected.totalDebt = $rootScope.voucher.selected.total - $rootScope.countTotalAmount() ;
          //Real import
          tr.amount_issued = angular.copy(tr.amount);
          //Excedent
          if ($rootScope.voucher.selected.totalDebt < 0) {
            if(tr.payment_type == 'cash'){
              //console.log('amount_excedente identificado',$rootScope.voucher.selected.totalDebt);
              tr.amount_excedent = angular.copy($rootScope.voucher.selected.totalDebt * -1);
              tr.amount = tr.amount_issued - tr.amount_excedent;
              if (tr.currency != $rootScope.globalParams.currency) {
                tr.amount_bs = tr.amount_excedent * -1;
              }
              else{
                tr.amount_bs = tr.amount_issued - tr.amount_excedent;
              }
              //console.log('recalculado', tr.amount_issued, tr.amount_excedent, tr.amount);
              $rootScope.voucher.selected.positiveBalance = angular.copy($rootScope.voucher.selected.totalDebt * -1);
            }
            //fuerza pagos en bolivianos
            else{
              tr.amount =  tr.amount + $rootScope.voucher.selected.totalDebt;
              tr.amount_issued = angular.copy(tr.amount);
              tr.amount_bs = angular.copy(tr.amount);
              //console.log('reajuste 1', $rootScope.voucher.selected.totalDebt , tr.amount);
              toastr.warning('Monto invalido', 'Reajuste efectuado');
            }
          }
          //Totals
          var totalAmount = parseFloat($rootScope.countTotalAmount());
          var totalAmount2 = parseFloat(totalAmount.toFixed(2));
          $rootScope.voucher.selected.totalAmount = totalAmount2;
          var balance = parseFloat($rootScope.voucher.selected.total - $rootScope.voucher.selected.totalAmount);
          var balance2 = parseFloat(balance.toFixed(2));
          $rootScope.voucher.selected.balance = balance2;
         // $rootScope.voucher.selected.balance = $rootScope.voucher.selected.total - $rootScope.voucher.selected.totalAmount;
          //console.log('totalAmount', $rootScope.voucher.selected.totalAmount);
          //console.log('balance', $rootScope.voucher.selected.balance);
          //console.log('positive balance', $rootScope.voucher.selected.positiveBalance);
        };


        $scope.oldTopCredit = angular.copy($rootScope.voucher.selected[$scope.partnerTarget].creditavailable);
        ///////////// MODEL ESTRUCTURE //////////////
        $scope.bussinessRules = function () {
          //UI header
          $rootScope.creditIndex = -1;
          TablesService.filtrar('accountbank',{per_page:1000})
            .success(function(res){
              $rootScope.bankaccounts = res.result.data;
            });
          switch ($rootScope.currentModule) {
            case 'purchases':
              /*if (!$rootScope.voucher.selected.partner.partnercategory) {
                $rootScope.voucher.selected.partner.partnercategory = {
                  name: 'SN',
                  topcredit: 0
                }
              }
              if ($rootScope.voucher.selected.partner.partnercategory) {
                $scope.oldTopCredit = angular.copy($rootScope.voucher.selected.partner.creditavailable);
              }*/
              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope.voucher.selected.partner.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Fecha / Hora', value: $rootScope.dateNow + ' / ' + $rootScope.timeNow},
                {
                  label: 'Almacen destino',
                  value: $scope.getWName2()
                }
              ];
              $rootScope[$scope.modelName].selected.vouchertransaction = [];
              break;
            case 'sales':
              if (!$rootScope.voucher.selected[$scope.partnerTarget].partnercategory) {
                $rootScope.voucher.selected[$scope.partnerTarget].partnercategory = {
                  name: 'SN',
                  topcredit: 0
                }
              }
              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope.voucher.selected[$scope.partnerTarget].name},
                {label: 'Categoría', value: $rootScope.voucher.selected[$scope.partnerTarget].partnercategory.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected[$scope.partnerTarget].docid},
                {
                  label: 'Saldo de crédito',
                  success: function () {
                    return $rootScope.creditIndex >= 0
                  },
                  value: $scope.oldTopCredit
                },
                {label: 'Fecha / Hora', value: $rootScope.dateNow + ' / ' + $rootScope.timeNow},
                {
                  label: 'Punto de venta',
                  value: function(){
                    if($rootScope.access(['super-admin'])){
                      return $scope.getWName();
                    }
                    else{
                      return $scope.currentCR.warehouse.name
                      //return $rootScope.getCurrentUserWarehouse(true).name;
                    }
                  }()
                },
                /* $scope.getWName() */
                {
                  label: 'Caja',
                  value: function(){
                    return $scope.currentCR.name;
                  }()
                }
              ];
              $rootScope[$scope.modelName].selected.vouchertransaction = [];
              break;
          }
          //starter voucher status
          $rootScope.voucher.selected.totalAmount = 0;
          $rootScope.voucher.selected.positiveBalance = 0;
          $rootScope.voucher.selected.balance = $rootScope.voucher.selected.total;

        };
        $scope.bussinessRules();
        $rootScope.$watch($scope.modelName + '.selected', function () {
          console.log('SELECTED',   $rootScope.voucher.selected);
          $scope.validateNewPay();
        }, true);

        //STORES TRANSACTION
        $rootScope.saveVoucher = function () {
          $rootScope.blockPay = true;
          $rootScope.blockPage = true;
          $rootScope.blockPageLoading = true;
          console.log('UPDATE REGISTER', $rootScope.voucher);
          UserService.actualizarToken().success(function (tok) {
            $rootScope.asignarVarSession('token', tok);
            console.log('simplificado', $rootScope.voucher.selected, $rootScope.voucher.actionType);
            switch ($rootScope.voucher.actionType) {
              case 'store':
                TablesService.almacenar('voucher', $rootScope.voucher.selected)
                  .success(function (res) {
                    console.log('Salida almacenar', res);
                    if (res.status) {
                      $rootScope.voucher.selected.id = res.result.id;
                      toastr.success('Registro almacenado', 'Exito');
                      $rootScope.blockPage = true;
                      $rootScope.blockPageLoading=false;
                      $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;
                      //$rootScope.reloadUI();
                    }
                    else {
                      toastr.warning('Registro no almacenado', 'Error');
                    }
                  })
                  .error(function (res) {
                    console.log('ERROR salida almacenar', res);
                    toastr.warning('Registro no almacenado', 'Error');
                  });
                break;
              case 'update':
                TablesService.actualizar('voucher', $rootScope.voucher.selected.id, $rootScope.voucher.selected)
                  .success(function (res) {
                    console.log('Salida actualizar', res);
                    if (res.status) {
                      toastr.success('Registro actualizado', 'Exito');
                      /*$rootScope.blockPage = true;
                      $rootScope.blockPageLoading=false;
                      $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;*/
                      //$rootScope.reloadUI()

                      $rootScope.blockPage=true;
                      $rootScope.blockPageLoading=false;
                      $rootScope.blockPageLink="es/printtransaction/"+res.newTransaction[0].id ;
                    }
                    else {
                      toastr.warning('Registro no actualizado', 'Error');
                    }
                  })
                  .error(function (res) {
                    console.log('ERROR salida actualizar', res);
                    toastr.warning('Registro no actualizado', 'Error');
                  });
                break;
              case 'delete':
                //$rootScope.voucher.deleteRow();
                break;
            }
          });
        };


      }
    }
  });

'use strict';
angular.module('frontendapp')
  .directive('uiinventoryform', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinventoryform/uiinventoryform.html',
      restrict: 'E',
      replace: true,
      scope: {
        level: '=',
        modelName: '@',
        modelParent: '@',
        operationType: '@',
        customProperties:'='
      },
      rootScope: $rootScope,
      controller: function uiinventoryformformController($uibModal, $scope, $rootScope, toastr,
                                                         $state, $auth, $location, $log, Upload, $timeout,
                                                         UserService, localStorageService,
                                                         TablesService, $window, $modal) {

        console.log('UIINVENTORY', $scope.level, $scope.modelName, $scope.customProperties);


        $scope.tableTemplate = ($scope.customProperties && $scope.customProperties.template) ? $scope.customProperties.template : $rootScope.currentModule;

        console.log('tableTemplate',$scope.tableTemplate);
        //STORES TRANSACTION
        $rootScope.executeVoucherForm = function (){
          console.log(
            'executeVoucherForm',
            $rootScope.voucher.actionType,
            $rootScope.voucher.selected.newStockorder);
          if($rootScope.voucher.actionType == 'store' && $rootScope.voucher.selected.newStockorder ){
              switch ($rootScope.voucher.selected.vouchertype_id) {
                case 9:
                case 11:
                  $rootScope.reconcileDelivery(true);
                      break;
                default:
                  $rootScope.reconcileDelivery(false);
                  break;
              }
            }
          console.log('ESTADO PREVIO 0',$rootScope.voucher.selected);
          console.log('ESTADO PREVIO 1',$rootScope.voucher.selected.stockorder);
          switch($rootScope.nextStep){
            case 'uipayment':
              $rootScope.uiConf.switchView('next', {actionType:'store',component:'uipayment', model:'voucher'}, false);
              break;
            case 'uiinventorycheck':
              $rootScope.uiConf.switchView('next', {actionType:'store',component:'uiinventorycheck', model:'voucher'}, false);
                  break;
            case 'uicombo':
              $rootScope.uiConf.switchView('next', {actionType:'store',component:'uicombo', model:'voucher'}, false);
                  break;
            case 'uideliveryprog':
              $rootScope.uiConf.switchView('next', {actionType:'store',component:'uideliveryprog', model:'voucher'}, false);
                  break;
            case 'stockadjust':
              $rootScope.saveVoucher2();
                  break;
            default:
              $rootScope.saveVoucher();
              break;
          }
        };

        //RELOAD UI BEFORE SAVE VOUCHER
        $rootScope.reloadUI = function (){
          location.reload();
        };

        //STOCK ORDER STATUS
        $rootScope.reconcileDelivery = function ( fill ){
          console.log('reconcileDelivery', fill);
          if ($rootScope.voucher.selected.warehouse_id) {
            $rootScope.voucher.selected.stockorder.warehouse_id = $rootScope.voucher.selected.warehouse_id;
          }
          if ($rootScope.voucher.selected.warehouse_id2) {
            $rootScope.voucher.selected.stockorder.warehouse_id2 = $rootScope.voucher.selected.warehouse_id2;
          }
          if (fill) {
            $rootScope.voucher.selected.stockorder.status = 1;
            angular.forEach($rootScope.voucher.selected.stockorder.stockadjustment, function (item) {
              item.quantity_issued = item.quantity;
            })
          }
        };

        //USEFULL FOR OTHER DIRECTIVES
        $rootScope.createProductIndex = function (source){
          $rootScope.productIndex = [];
          angular.forEach(source, function (v){
              angular.forEach(v.voucherline, function (vl){
                if($rootScope.verifyInList ( $rootScope.productIndex, vl.product, 'id')) {
                  vl.product.total = vl.quantity;
                  $rootScope.productIndex.push(vl.product);
                }
                else{
                  angular.forEach($rootScope.productIndex,function(item){
                    if(item.id == vl.id){
                      item.total =  item.total + vl.quantity;
                    }
                  });
                }
              });
          });



          console.log('productIndex', $rootScope.productIndex)
        };

        //PURCHASES
        $scope.remove = function ($index) {
          //TEMPORAL FIX
          if($rootScope.voucher.selected.stockorder){
            var tempIndex = angular.copy($rootScope.voucher.selected.voucherline[$index].product_id);
            console.log('tempIndex',tempIndex);
            angular.forEach($rootScope.voucher.selected.stockorder.stockadjustment, function(value, key){
              if(value.product_id == tempIndex){
                console.log('match tempIndex', value.product_id, key);
                $rootScope.voucher.selected.stockorder.stockadjustment.splice(key, 1);
              }
            });
          }
          $rootScope.voucher.selected.voucherline.splice($index, 1);
        };
        $scope.starterValue = function (register, target, value){
          if($rootScope.voucher.actionType == 'store'){
            register[target] = parseFloat(value);
          }
          register[target] = parseFloat(register[target]);
        };

        //MULTIPLE SELECTION OF PRODUCTS
        $rootScope.openPickerCustom = function () {
          //console.log('openPicker', model, customSettings);
          $rootScope.uiConf.switchView('next',
            {
              actionType:$rootScope.voucher.actionType,
              component:'uipiker',
              model:'voucher'
            }, false
          );
        };
        $rootScope.blockPikerCustom = function(){
          var hide = true;
          switch ($rootScope.currentModule) {
            case 'purchases':
              break;
            case 'inventory':
              break;
            case 'sales':
              if($rootScope.voucher.selected.warehouse_id){
                hide = false;
              }
              break;
          }
          return hide;
        };

        //PARTNER PICKER
        $rootScope.partnerSearch = {
          partner_id : "",
          partner_related : ""
        };
        $rootScope.resetPartner = function (targetField) {

          if(targetField == 'partner_id'){
            delete $rootScope.voucher.selected.partner ;
            $rootScope.voucher.selected.partner_id = "";
            $rootScope.voucher.selected.partnername = "";
            $rootScope.partnerSearch.partner_id = "";

          }
          if(targetField == 'partner_related'){
            delete $rootScope.voucher.selected.partnerrelated ;
            $rootScope.voucher.selected.partner_related = "";
            $rootScope.voucher.selected.partnername2 = "";
            $rootScope.partnerSearch.partner_related = "";

          }
          /*if ( $rootScope.currentState =='sales-mobile-point' || $rootScope.currentState =='sales-mobile-requests' ){
            $rootScope.voucher.selected.partner_related = "";
            $rootScope.partnerSearch = {
              partner_related : ""
            };
          }
          else{
            $rootScope.voucher.selected.partner_id = "";
            $rootScope.partnerSearch = {
              partner_id : "",
            };
          }*/
          console.log('partner actualizado', $rootScope.voucher.selected);
        };
        $rootScope.setPartner = function (value, targetField) {
          console.log('recarga desde setPartner', value);
          var pfield = targetField ? targetField : 'partner_id';
          if(pfield == 'partner_id'){
            $rootScope.voucher.selected.partner = value;
            $rootScope.voucher.selected.partnername = value.name;
            $rootScope.infoMenu = true;
            $rootScope.tab = 2;
            console.log('setPartner', $rootScope.voucher.selected.partner);
          }
          else{
            $rootScope.voucher.selected.partnerrelated = value;
            $rootScope.voucher.selected.partnername2 = value.name;
            console.log('setPartner', $rootScope.voucher.selected.partnerrelated);
          }
          $rootScope.voucher.selected[pfield] = value.id;

        };
        $scope.firstTime = true;
        $scope.enableSync = function () {
          $scope.firstTime = false;
        };
        $rootScope.newPartner = function () {
          var params = {
            component: 'uidefaultform',
            model: 'partner',
            refresh: false,
            actionType: 'store',
            customProperties: {
              type: {
                disabled: true,
                label:'Tipo',
                resolve: {
                  default: function (model) {
                    var exit;
                    switch ($rootScope.currentModule){
                      case 'purchases':
                        exit = 3;
                        break;
                      case 'sales':
                        exit = 2;
                        break;
                    }
                    return exit;
                  },
                }
              },
              partnercategory_id:{
                hide: ($rootScope.currentModule!='sales')
              },
              user_id: {
                hide: true
              },
              clientdiscount:{
                hide: ($rootScope.currentModule!='sales')
              },
              partnercontact: {
                hide: ($rootScope.currentModule!='sales')
              },
              latitud: {
                hide: false
              },
              longitud: {
                hide: false
              }
            }
          };
          $rootScope.uiConf.switchView('next', params, true);
          $scope.enableSync();
        };
        $rootScope.$watch('partner_old', function () {
          console.log('partner old watch');
          if (!$scope.firstTime) {
            console.log('partner old watch', $rootScope.partner_old.selected);
           // $rootScope.uiConf.currentLevel = 0;
           var id = angular.copy($rootScope.partner_old.selected.id);
            TablesService.filtrar('partner', {
              selected:id
            })
            .success(function (res) {
              console.log('loadPartners',res);
              if (res.status) {
                $rootScope.uiConf.switchView('prev');
                console.log('partner old picked', res);
                $rootScope.setPartner(res.selected);
                $rootScope.voucher.properties.partner_id.items = res.result.data;
              }
            });
            console.log('REFRESH with partner_old' , $rootScope.voucher.selected.partner);
          }
        });

        //VOUCHER TYPE RULES
        $rootScope.setVoucherType = function (id){
          switch(id){
            case 4:
            case 5:
            case 6:
            case 10:
            case 11:
              $rootScope.refreshVoucher();
                  break;
            default:
                  break;
          }

          if($rootScope.voucher.properties.vouchertype_id){
            console.log('asignando', id, $rootScope.voucher.properties.vouchertype_id.items);
            angular.forEach($rootScope.voucher.properties.vouchertype_id.items, function (item){
              if(id == item.id ){
                console.log('asignando tipvoucher',item);
                $rootScope.voucher.selected.vouchertype_id = item.id;
                $rootScope.voucher.selected.vouchertypeLabel = item.label;
                $rootScope.voucher.selected.newStockorder = item.newStockorder;
                $rootScope.voucher.selected.newTransaction = item.newTransaction;
                $rootScope.nextStep = item.component?item.component:'none';
              }
            });
          }
          //$rootScope.refreshVoucher();
        };


        //PROGRAM DELIVERY IN SALES MOBILE POINT
        $rootScope.programDelivery= function (){
          if($rootScope.voucher.selected.programmed_delivery=='1'){
            $rootScope.voucher.properties.programmed_at.hide=false;
            $rootScope.voucher.properties.programmed_time.hide=false;
            $rootScope.voucher.properties.programmed_type.hide=false;
          }
          else{
            $rootScope.voucher.properties.programmed_at.hide=true;
            $rootScope.voucher.properties.programmed_time.hide=true;
            $rootScope.voucher.properties.programmed_type.hide=true;
            $rootScope.voucher.selected.programmed_at='';
            $rootScope.voucher.selected.programmed_time='';
            $rootScope.voucher.selected.programmed_type='';
          }

        };


        //REFRESH VOUCHER OR CREATE NEW
        $rootScope.refreshVoucher=function(){
          $rootScope.voucher.selected.voucher_related = "";
          $rootScope.voucher.selected.voucherline = [];
          $rootScope.voucher.selected.warehouse_id2 = null;
          $rootScope.voucher.selected.stockorder = {
              stockadjustment: [],
              status: 0,
              type:true
            };
        };

        //INIT FUNCTION
        $scope.setBusinessLogic = function () {
          $rootScope.setPartner($rootScope.currentUser.partner[0],'partner_related');
          switch ($rootScope.currentModule) {
            case 'purchases':
              $rootScope.setVoucherType(3);
              break;
            case 'inventory':
              $rootScope.setVoucherType(6);
              $rootScope.setPartner($rootScope.currentUser.partner[0]);
              //$rootScope.loadCustomVoucher();
              break;
            case 'sales':
              console.log('heeyyyyyy sales',$rootScope.currentState );
              if($rootScope.currentState == 'sales-mobile-point'){
                $rootScope.setVoucherType(9);
                $rootScope.voucher.selected.programmed_delivery = '1';
                $rootScope.programDelivery();
                //$rootScope.setPartner($rootScope.currentUser.partner[0]);
                var filters = {
                  per_page: '1',
                  page: '1',
                  filters: {
                    id:{
                      value: $rootScope.currentUser.partner[0].id
                    }
                  },
                };
                TablesService.filtrar('partner', filters)
                  .success(function (res) {
                    if (res.status) {
                      console.log('partnerrelated refersh', res);
                      $rootScope.voucher.selected.partnerrelated = res.result.data[0];
                    }
                  });
              }
              if($rootScope.currentState == 'sales-mobile-requests'){
                $rootScope.setVoucherType(7);
                //$rootScope.setPartner($rootScope.currentUser.partner[0]);
              }
              if($rootScope.currentState == 'sales-point'){
                $rootScope.setVoucherType(9);
                $rootScope.voucher.selected.cashregister_id = $rootScope.currentUser.cashregisteruser[0].cashregister_id;
              }
              break;
          }
        };
        $scope.checkGoodStock = function(item){
          var tot = 0;
          //console.log('checkGoodStock', item);
          angular.forEach(item.stock, function(i){
            if(i.warehouse_id == $rootScope.voucher.selected.warehouse_id){
              tot += i.current_stock;
            }
          });
          return tot;
        };
        $rootScope.controlDeliveryProg = function(item, totalStock){
          if(item.quantity>totalStock){
            item.quantity = totalStock;
            toastr.warning('Stock insuficiente', 'Error');
          }
        };
        //CONTROL
        $rootScope.$watch('voucher.selected', function () {
          //console.log('REFRESH selected', $rootScope.voucher.selected);
          if($rootScope.currentState == 'sales-mobile-point'){
            $rootScope.voucher.selected.newTransaction = true;
            $rootScope.voucher.selected.vouchertransaction = [{
              voucher_id: $rootScope.voucher.selected.id,
              partner_id: $rootScope.voucher.selected.partner_related,
              cashregister_id :$rootScope.getCurrentUserCashregister(false).id ,
              type: '',
              payment_type: 'credit',
              payment_label: 'Crédito',
              currency:  'Bs.',
              verification: '',
              comment: '',
              amount: $rootScope.voucher.selected.total,
              amount_issued: 0,
              amount_bs: 0,
              amount_usd: 0,
              amount_excedent: 0,
              current_exchange: $rootScope.globalParams.TcUSD,
              balance: 0,
              debit: 0,
            }];
            if($rootScope.voucher.selected.programmed_delivery=='1' && $rootScope.voucher.selected.vouchertype_id == 10){
              $rootScope.nextStep = "uideliveryprog";
            }
            else{
              $rootScope.nextStep = "";
            }
          }
          $rootScope.uiinvBlock= false;
          if(!$rootScope.voucher.selected.partner_id){
            console.log('bloqueo 1');
            $rootScope.uiinvBlock = true;
          }
          if($rootScope.voucher.selected.voucherline){
            if($rootScope.voucher.selected.voucherline.length == 0){
              console.log('bloqueo 2');
              $rootScope.uiinvBlock = true;
            }
            var total = 0;
            angular.forEach($rootScope.voucher.selected.voucherline, function (i) {
              total += i.quantity;
            });
            if(total == 0){
              console.log('bloqueo 2.1');
              $rootScope.uiinvBlock = true;
            }
          }
          if ($rootScope.voucher.selected.stockorder) {

            if ($rootScope.voucher.selected.vouchertype_id == 9 || $rootScope.voucher.selected.vouchertype_id == 11) {

            }
          }
          if(($rootScope.voucher.selected.vouchertype_id == 5 || $rootScope.voucher.selected.vouchertype_id == 6) && $rootScope.voucher.selected.warehouse_id2 == null){
            console.log('bloqueo 3');
            $rootScope.uiinvBlock = true;
          }

          if(($rootScope.voucher.selected.invoice_type == '1' || $rootScope.voucher.selected.invoice_type == '2') && !$rootScope.voucher.selected.invoice_autorization ){
            console.log('bloqueo 4');
            $rootScope.uiinvBlock = true;
          }

          if($rootScope.currentState == 'sales-mobile-point' && $rootScope.voucher.selected.partnerrelated.creditavailable < $rootScope.voucher.selected.total ){
            console.log('bloqueo 5');
            toastr.warning('Monto invalido', 'Crédito insuficiente');
            $rootScope.uiinvBlock = true;
          }

          if($rootScope.currentState == 'sales-point' ||
            $rootScope.currentState == 'sales-mobile-point' ||
            $rootScope.currentState == 'sales-mobile-requests' ){
            $rootScope.searchDiscount();
          }
          //console.log('bloqueo', $rootScope.uiinvBlock)
        }, true);
        $rootScope.$watch('voucher.selected.partner_id', function () {
          if($rootScope.currentState == 'sales-point' ||
            $rootScope.currentState == 'sales-mobile-point' ||
            $rootScope.currentState == 'sales-mobile-requests' ){
            $rootScope.searchDiscount();
          }

        });
        //CUSTOMIZATION
        $rootScope.$watch('voucher.ready', function () {
          if($rootScope.globalPartner){
            switch ($rootScope.currentState) {
              case 'sales-debts':
                TablesService.filtrar('voucher', {
                  filters: {
                    credit_amount: {value: 1, operator: '>'},
                    vouchertype_id: {value: 9},
                    partner_id: {value: $rootScope.globalPartner.id}
                  }
                }).success(function (res) {
                  if (res.status) {
                    $rootScope.voucher.dataset = res.result;
                  }
                });
                break;
              case 'sales-mobile-point':
                TablesService.filtrar('partner', {
                  filters: {
                    id: {value: $rootScope.globalPartner.id}
                  }
                }).success(function (res) {
                  if (res.status) {
                    $rootScope.setPartner(res.result.data[0]);
                  }
                });
                break;
            }
          }

          $rootScope.voucher.picked = '';

          if (!$rootScope.voucher.selected.voucherline) {
            $rootScope.voucher.selected.voucherline = [];
          }

          if (!$rootScope.voucher.selected.stockorder) {
            $rootScope.voucher.selected.stockorder = {
              stockadjustment: [],
              type:true
            };
          }

          //TO DELETE
          if($rootScope.voucher.extraConf){
            $scope.vouchertype = $rootScope.voucher.extraConf.vouchertype;
          }

          $scope.setBusinessLogic();

          //TO DELETE
          /*$timeout(function () {
            var filters = {
              per_page: '1',
              page: '1',
              selected:188,
            };
            TablesService.filtrar('partner', filters)
              .success(function (res) {
                console.log('auto load partner',res);
                $rootScope.setPartner(res.selected);
              });
          }, 500);*/
          //TO DELETE

        }, true);

      }
    }
  })
;

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uiinvoicestock', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinvoice/uiinvoicestock.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
        level: '=',
      },
      rootScope: $rootScope,

      controller: function uiinvoicestockController($uibModal, $scope, $rootScope, toastr,
                                                    $state, $auth, $location, $log,
                                                    UserService, localStorageService,
                                                    TablesService, $window, $modal) {



        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {
          //console.log('REFRESH desde uiinvoice');
          if ($rootScope.voucher.selected.partner.partnercategory.topcredit < $rootScope.voucher.selected.balance) {
            if ($rootScope.newCreditIndex != 'unsigned') {
              $scope.remove($rootScope.newCreditIndex);
            }
          }

        }, true);

        if ($rootScope.voucher.selected.partner.partnercategory) {
          $scope.oldTopCredit = angular.copy($rootScope.voucher.selected.partner.partnercategory.topcredit);
        }

        $rootScope.printDiv = function (divName) {
          window.print();
        };

        $scope.getWName = function () {
          var exit = '';
          angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w) {
            if ($rootScope.voucher.selected.warehouse_id == w.id) {
              exit = w.name;
            }
          })
          return exit;
        };

        TablesService.filtrar('warehouse', {selected: $rootScope.voucher.selected.warehouse_id})
          .success(function (res) {
            console.log('///////////', res);
            $scope.w1 = '';
            $scope.w2 = '';
            angular.forEach(res.result.data, function (w) {
              if (w.id == $rootScope.stockOrderSelected.warehouse_id) {
                $scope.w1 = w.name;
              }
              if (w.id == $rootScope.stockOrderSelected.warehouse_id2) {
                $scope.w2 = w.name;
              }
            });
            $rootScope.voucher.selected.warehouse = res.selected;
            $rootScope.paymentDetail = [
              {label: 'Cliente', value: $rootScope.voucher.selected.partner.name},
              {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid}, /*
               ,*/
              /*{label: 'Saldo de crédito',
               success: function (){return $rootScope.newCreditIndex != 'unsigned'},*/
              /*   value: $rootScope.voucher.selected.partner.partnercategory.topcredit},*/
              {label: 'Fecha / Hora', value: $rootScope.dateNow + ' / ' + $rootScope.timeNow},
              /*{label: 'Punto de venta',
               value: $scope.getWName()
               },*/
            ];
            if ($scope.w1 != '') {
              $rootScope.paymentDetail.push({label: 'Almacen salida', value: $scope.w1})
            }
            if ($scope.w2 != '') {
              $rootScope.paymentDetail.push({label: 'Almacen entrada', value: $scope.w2})
            }

          });
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

        console.log('stockOrderSelected', $rootScope.voucher.selected);
        console.log('stockOrderSelected', $rootScope.stockOrderSelected);
        $scope.closeAndBack = function () {
          $rootScope.uiConf.switchView('prev')
        };
      }
    }

  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uiinvoice', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinvoice/uiinvoice.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
        level: '=',
      },
      rootScope: $rootScope,

      controller: function uiinvoiceController($uibModal, $scope, $rootScope, toastr,
                                               $state, $auth, $location, $log,
                                               UserService, localStorageService,
                                               TablesService, $window, $modal) {


        console.log('DIRECTIVA uiinvoice');
        $rootScope.printDiv = function (divName) {
          window.print();
        };
        $scope.loadW = function () {
          TablesService.filtrar('warehouse', {per_page:10000})
            .success(function (res) {
              $scope.wareList = res.result.data;
              console.log('loadW',$scope.wareList ,  res);
            });
        };
        $scope.loadV = function (value) {
          TablesService.filtrar('voucher', {selected: value})
            .success(function (res) {
              console.log('voucher', res);
            });
        };
        $scope.loadW();
        $scope.getWName = function (id) {
          var exit = '';
          console.log('consultando', $scope.wareList);
          angular.forEach($scope.wareList, function (w) {
            //console.log('getWName', w);
            if (id == w.id) {
              exit = w.name;
            }
          });
          //console.log('getWName', exit, id);
          return exit;
        };
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        $scope.tPrint = 'Impreso el : ' + $rootScope.dateNow + ' / ' + $rootScope.timeNow;
        $scope.uPrint = 'Impreso por : ' + $rootScope.currentUser.firstname + ' '+ $rootScope.currentUser.lastname;
        $rootScope.$watch($scope.modelName + '.selected', function () {
          console.log('CARGADO',$rootScope[$scope.modelName].selected);
          console.log('paymentDetail');
          if ($scope.modelName == 'voucher') {
            $rootScope.voucher.selected.transactionExcedent = 0;
            angular.forEach($rootScope.voucher.selected.vouchertransaction,function (i) {
              if(i.original_payment == 1){
                $rootScope.voucher.selected.transactionExcedent += parseFloat(i.amount_excedent) ;
              }
            });
            console.log('voucher!!!',$rootScope.voucher.selected);
            //var vt =
            switch (parseInt($rootScope.voucher.selected.vouchertype_id)) {
              case 2:
              case 3:
                $rootScope.paymentDetail = [
                  {label: 'Proveedor', value: $rootScope.voucher.selected.partner.name},
                  {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                  {
                    label: 'Almacen entrada',
                    value: function () {
                      return ($rootScope.voucher.selected.warehouse2) ? $rootScope.voucher.selected.warehouse2.name : 'NA';
                    }()
                  },
                  {label: 'Código', value: $rootScope.voucher.selected.code},
                  {label: 'Fecha / Hora', value: ($rootScope[$scope.modelName].selected.created_at)?$rootScope[$scope.modelName].selected.created_at:""},
                  {label: 'Registrado por', value: ($rootScope[$scope.modelName].selected.creator)?$rootScope[$scope.modelName].selected.creator.username:""},
                  //{label: 'Comentarios', value: ($rootScope[$scope.modelName].selected.comments)?$rootScope[$scope.modelName].selected.comments:""},
                ];
                break;
              case 4:
              case 5:
              case 6:
                $rootScope.paymentDetail = [
                  {
                    label: 'Emitido por', value: $rootScope.voucher.selected.partner.name
                  },
                  {
                    label: 'Almacen salida',
                    value: function () {
                      return ($rootScope.voucher.selected.warehouse) ? $rootScope.voucher.selected.warehouse.name : 'NA';
                    }()
                  },
                  {
                    label: 'Almacen entrada',
                    value: function () {
                      return ($rootScope.voucher.selected.warehouse2) ? $rootScope.voucher.selected.warehouse2.name : 'NA';
                    }()
                  },
                  {label: 'Código', value: $rootScope.voucher.selected.code},
                  {label: 'Fecha / Hora', value: ($rootScope[$scope.modelName].selected.created_at)?$rootScope[$scope.modelName].selected.created_at:""},
                  {label: 'Registrado por', value: ($rootScope[$scope.modelName].selected.creator)?$rootScope[$scope.modelName].selected.creator.username:""},
                  //{label: 'Comentarios', value: ($rootScope[$scope.modelName].selected.comments)?$rootScope[$scope.modelName].selected.comments:""},
                ];
                break;
              case 7:
              case 8:
              case 9:
              case 10:
              case 11:
                $rootScope.paymentDetail = [
                  {
                    label: 'Nombre', value: $rootScope.voucher.selected.partner.name
                  },
                  {
                    label: 'NIT/CI.',
                    value: $rootScope.voucher.selected.partner.docid
                  },
                  {
                    label: 'Código',
                    value:  $rootScope.voucher.selected.code
                  },
                  {
                    label: 'Punto de venta',
                    value: function(){
                      var exit = ($rootScope.voucher.selected.warehouse)?$rootScope.voucher.selected.warehouse.name:'NA';
                      return exit;
                    }()
                  },
                  {label: 'Fecha / Hora', value: ($rootScope[$scope.modelName].selected.created_at)?$rootScope[$scope.modelName].selected.created_at:""},
                  {label: 'Registrado por', value: ($rootScope[$scope.modelName].selected.creator)?$rootScope[$scope.modelName].selected.creator.username:""},
                  //{label: 'Comentarios', value: ($rootScope[$scope.modelName].selected.comments)?$rootScope[$scope.modelName].selected.comments:""},
                ];
                if($rootScope[$scope.modelName].selected.invoice_type==4){
                  $rootScope.paymentDetail.push(
                    {
                      label: 'Vendedor', value: $rootScope.voucher.selected.partnerrelated.name
                    },
                    {
                      label: 'Tipo de venta', value: 'Venta de promotor'
                    }
                  )
                }
                break;
              default:
                break;
            }
          }
          if ($scope.modelName == 'stockorder') {
            console.log('stockorder!!!',$rootScope[$scope.modelName].selected);
            if($rootScope[$scope.modelName].selected){

              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope[$scope.modelName].selected.voucher.partner.name},
                {label: 'NIT/CI', value: $rootScope[$scope.modelName].selected.voucher.partner.docid},
                {label: 'Almacen salida', value: ($rootScope[$scope.modelName].selected.warehouse)?$rootScope[$scope.modelName].selected.warehouse.name:'' },
                {label: 'Almacen entrada', value: ($rootScope[$scope.modelName].selected.warehouse2)?$rootScope[$scope.modelName].selected.warehouse2.name:'' },
                {label: 'Código ajuste', value: $rootScope[$scope.modelName].selected.operationcode},
                {label: 'Comprobante', value: $rootScope[$scope.modelName].selected.voucher.code},
                {label: 'Fecha / Hora', value: ($rootScope[$scope.modelName].selected.created_at)?$rootScope[$scope.modelName].selected.created_at:""},
                {label: 'Registrado por', value: ($rootScope[$scope.modelName].selected.creator)?$rootScope[$scope.modelName].selected.creator.username:""},
                {label: 'Comentarios', value: ($rootScope[$scope.modelName].selected.comments)?$rootScope[$scope.modelName].selected.comments:""},
              ];
              if($rootScope[$scope.modelName].selected.voucher.vouchertype_id==10){
                console.log('COMBO MATCH', $rootScope[$scope.modelName].selected.voucher.voucherline);
                $rootScope.paymentDetail.push(
                  {
                    label: 'Combo',
                    value: $rootScope[$scope.modelName].selected.voucher.voucherline[0].product.code + ' ' +
                    $rootScope[$scope.modelName].selected.voucher.voucherline[0].product.code_secondary
                  }
                )
              }
            }
          }
          if ($scope.modelName == 'vouchertransaction') {
            switch ($rootScope[$scope.modelName].selected.voucher.vouchertype_id) {
              case 2:
              case 3:
                $rootScope.paymentDetail = [
                  {label: 'Proveedor', value: $rootScope[$scope.modelName].selected.partner.name},
                  {label: 'NIT/CI', value: $rootScope[$scope.modelName].selected.partner.docid},
                  {label: 'Código transacción', value: $rootScope[$scope.modelName].selected.id},
                  {label: 'Comprobante', value: $rootScope[$scope.modelName].selected.voucher.code},
                ];  break;
              case 4:
              case 5:
              case 6:
                $rootScope.paymentDetail = [
                  {label: 'Encargado', value: $rootScope[$scope.modelName].selected.partner.name},
                  {label: 'Código transacción', value: $rootScope[$scope.modelName].selected.id},
                  {label: 'Comprobante', value: $rootScope[$scope.modelName].selected.voucher.code},
                ];
                break;
              case 7:
              case 8:
              case 9:
              case 10:
              case 11:
                $rootScope.paymentDetail = [
                  {label: 'Cliente', value: $rootScope[$scope.modelName].selected.partner.name},
                  {label: 'NIT/CI', value: $rootScope[$scope.modelName].selected.partner.docid},
                  {label: 'Punto de venta', value: $rootScope[$scope.modelName].selected.voucher.warehouse.name},
                  {label: 'Caja', value: $rootScope[$scope.modelName].selected.cashregister.name},
                  {label: 'Código transacción', value: $rootScope[$scope.modelName].selected.id},
                  {label: 'Comprobante', value: $rootScope[$scope.modelName].selected.voucher.code},
                ];
                 if($rootScope[$scope.modelName].selected.voucher.vouchertype_id==10){
                    console.log('COMBO MATCH', $rootScope[$scope.modelName].selected.voucher.voucherline);
                    $rootScope.paymentDetail.push(
                      {
                        label: 'Combo',
                        value: $rootScope[$scope.modelName].selected.voucher.voucherline[0].product.code + ' ' +
                        $rootScope[$scope.modelName].selected.voucher.voucherline[0].product.code_secondary
                      }
                    )
                  }
                break;
              default:
                break;
            }

          //  console.log('vouchertransaction!!!',$rootScope[$scope.modelName].selected);
            /*
            switch ($rootScope[$scope.modelName].selected.voucher.vouchertype_id) {
              case 2:
              case 3:
                $rootScope.paymentDetail = [
                  {label: 'Proveedor', value: $rootScope[$scope.modelName].selected.partner.name},
                  {label: 'NIT/CI', value: $rootScope[$scope.modelName].selected.partner.docid},
                  {label: 'Código transacción', value: $rootScope[$scope.modelName].selected.id},
                  {label: 'Comprobante', value: $rootScope[$scope.modelName].selected.voucher.code},
                 //// {label: 'Fecha / Hora', value: ($rootScope[$scope.modelName].selected.created_at)?$rootScope[$scope.modelName].selected.created_at:""},
                ];  break;
              case 4:
              case 5:
              case 6:
                $rootScope.paymentDetail = [
                  {label: 'Encargado', value: $rootScope[$scope.modelName].selected.partner.name},
                  {label: 'Código transacción', value: $rootScope[$scope.modelName].selected.id},
                  {label: 'Comprobante', value: $rootScope[$scope.modelName].selected.voucher.code},
                 // {label: 'Fecha / Hora', value: ($rootScope[$scope.modelName].selected.created_at)?$rootScope[$scope.modelName].selected.created_at:""},
                ];
                break;
              case 7:
              case 8:
              case 9:
              case 10:
              case 11:
                $rootScope.paymentDetail = [
                  {label: 'Cliente', value: $rootScope[$scope.modelName].selected.partner.name},
                  {label: 'NIT/CI', value: $rootScope[$scope.modelName].selected.partner.docid},
                  {label: 'Punto de venta', value: $rootScope[$scope.modelName].selected.voucher.warehouse.name},
                  {label: 'Caja', value: $rootScope[$scope.modelName].selected.cashregister.name},
                  {label: 'Código transacción', value: $rootScope[$scope.modelName].selected.id},
                  {label: 'Comprobante', value: $rootScope[$scope.modelName].selected.voucher.code},
                 // {label: 'Fecha / Hora', value: ($rootScope[$scope.modelName].selected.created_at)?$rootScope[$scope.modelName].selected.created_at:""},
                ];
                break;
              default:
                break;
            }
            */

          }
          if ($scope.modelName == 'cashregisterlog') {
            $rootScope.paymentDetail = [
              {label: 'Caja', value: $rootScope[$scope.modelName].selected.cashregister.name},
              {label: 'Transacciones por', value:  $rootScope.transalatePayment($rootScope.paymentType)},
              {label: 'Fecha conciliación', value: $rootScope[$scope.modelName].selected.last_verification},
            ];
          }
        }, true);

      }
    }

  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uiinventorycheck', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinventorycheck/uiinventorycheck.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uiinventorycheckController($uibModal, $scope, $rootScope, toastr,
                                                      $state, $auth, $location, $log,
                                                      UserService, localStorageService,
                                                      TablesService, $window, $modal) {


        console.log('DIRECTIVA uiinventorycheck');
        $rootScope.blockUiForm = false;
        $rootScope.paymentTitle = 'Transferencia de productos';
        $rootScope.newCreditIndex = 'unsigned';
        $rootScope.voucher.selected.stockorder.type = true;
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

        if ($rootScope.voucher.actionType == 'update') {
          console.log('regla resetada');
          console.log('stockorderhist', $rootScope.voucher.selected.stockorderhist);
          if (!$rootScope.voucher.selected.stockorder) {

          }
          var last =$rootScope.voucher.selected.stockorderhist.length-1;
          $rootScope.voucher.selected.stockorder = {
            stockadjustment: [],
            warehouse_id: ($rootScope.voucher.selected.warehouse_id)?$rootScope.voucher.selected.warehouse_id:null,
            warehouse_id2: ($rootScope.voucher.selected.warehouse_id2)?$rootScope.voucher.selected.warehouse_id2:null,
            status: 0
          };
          //$rootScope.verifyInList = function (target, item, fieldcontrol)
          if ($rootScope.voucher.selected.stockorderhist && $rootScope.voucher.selected.stockorderhist.length > 0) {
            console.log(0, $rootScope.voucher.selected.stockorderhist);
            angular.forEach($rootScope.voucher.selected.stockorderhist, function (i) {
              /* if($rootScope.verifyInList (i, item, fieldcontrol);)*/
              console.log(0.5);
              if (i.stockadjustment.length > 0) {
                console.log(1);
                angular.forEach(i.stockadjustment, function (j) {
                  console.log('stockadjustment j', j);
                  j.temp = angular.copy(j.quantity_issued);
                  j.quantity_issued = 0;
                  if ($rootScope.verifyInList($rootScope.voucher.selected.stockorderhist.stockadjustment, j, 'batchcode')) {
                    console.log('insertando older', j);
                    $rootScope.voucher.selected.stockorder.stockadjustment.push(j);
                  }
                  angular.forEach($rootScope.voucher.selected.voucherline, function (k) {
                    //k.quantity_issued = 0;
                    k.older_issued = k.older_issued ? k.older_issued : 0;
                    $rootScope.calculateIssuedTotal(k);
                    if (k.product_id == j.product_id) {
                      //console.log(2);
                      //console.log('older');
                      /*k.older_issued.push(j.temp);
                      k.older_issued = k.older_issued?k.older_issued:0;*/
                      k.older_issued += parseInt(j.temp);
                      $rootScope.calculateIssuedTotal(k);
                    }
                  });

                });

              }
            });

            //$rootScope.verifyInList (target, item, fieldcontrol);
          }
          $rootScope.voucher.selected.newStockorder = true;
        }


        $scope.bussinessRules = function () {
          switch ($rootScope.currentModule) {
            case 'purchases':
              break;
            case 'sales':
              $rootScope.transferDetail = [
                {label: 'Encargado', value: $rootScope.currentUser.partner[0].name},
                {label: 'Fecha / Hora', value: $rootScope.dateNow + ' / ' + $rootScope.timeNow},
                {label: 'Almacen', value: 'Almacen central'}
              ];
              break;
            case 'inventory':
              $rootScope.transferDetail = [
                {label: 'Encargado', value: $rootScope.currentUser.partner[0].name},
                {label: 'Fecha / Hora', value: $rootScope.dateNow + ' / ' + $rootScope.timeNow},
              ];
              if ($rootScope.voucher.selected.warehouse_id) {
                $rootScope.transferDetail.push(
                  {
                    label: 'Almacen Ori.',
                    value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id)
                  }
                )
              }
              if ($rootScope.voucher.selected.warehouse_id2) {
                $rootScope.transferDetail.push(
                  {
                    label: 'Almacen Des.',
                    value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id2)
                  }
                )
              }
              break;
          }
        };

        $scope.bussinessRules();

        $scope.remove = function ($index,register) {
          console.log($rootScope.voucher.selected.stockorder.stockadjustment, $index);
          $rootScope.voucher.selected.stockorder.stockadjustment.splice($index, 1);
          //$root.calculateIssuedTotal(register,st)
          var list = $rootScope.getSubitems(register);
          angular.forEach(list, function(st){
            $rootScope.calculateIssuedTotal(register,st)
          });
        };

        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {
          console.log('selected', $rootScope.voucher.selected)
        }, true);
        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch('voucher.selected.stockorder', function () {
          console.log('voucher.selected.stockorde', $rootScope.voucher.selected)
        }, true);



      }
    }
  });

/**
 * Created by DELL on 1/12/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uideliveryprog', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uideliveryprog/uideliveryprog.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uideliveryprogController($uibModal, $scope, $rootScope, toastr,
                                             $state, $auth, $location, $log, $timeout,
                                             UserService, localStorageService,
                                             TablesService, $window, $modal) {


        //$scope.BU = angular.copy($rootScope.voucher.selected.voucherline[0]);

        console.log('uideliveryprog !!!!');
        if($rootScope.voucher.selected.voucherline[0].stockissued){
          $rootScope.comboGroup = angular.copy($rootScope.voucher.selected.voucherline[0].stockissued.groups);
        }
        else{
          var filters = {
            per_page: '100',
            page: '1',
            filters: {
              product_id:{
                value: $rootScope.voucher.selected.voucherline[0].product_id
              }
            },
          };
          TablesService.filtrar('productcombogroup', filters)
            .success(function (res) {
              if (res.status) {
                console.log('datos para carga de items', res);
                $rootScope.voucher.selected.voucherline[0].stockissued = {
                  groups :res.result.data
                };
                angular.forEach($rootScope.voucher.selected.voucherline[0].stockissued.groups, function(cg){
                  cg.product = [];
                  angular.forEach(cg.productcomboitem,function(comboitem){
                    cg.product.push(
                      {
                        product_id: comboitem.product_id,
                        product: {
                          code: comboitem.product.code,
                          code_secondary: comboitem.product.code_secondary,
                          description: comboitem.product.description,
                          stock: comboitem.product.stock
                        },
                        stockissued: 0
                      }
                    )
                  });
                  delete cg.productcomboitem;
                  cg.totalExpected= $rootScope.voucher.selected.voucherline[0].quantity * cg.min;
                  cg.totalIssued = 0;
                  cg.totalBalance= ($rootScope.voucher.selected.voucherline[0].quantity * cg.min) - 0;
                  cg.newTotal = 0
                });
                console.log('voucherline[0]', $rootScope.voucher.selected.voucherline[0]);
              }
            });
        }

        $rootScope.voucher.selected.voucherlineTemp2 = [];

        $rootScope.$watch('comboGroup', function(){
          console.log('cambio comboGroup',$rootScope.comboGroup)
        });

        //TO CREATE VISUAL WARNINGS
        $scope.checkGoodStock = function(item){
          var tot = 0;
          //console.log('checkGoodStock', item);
          angular.forEach(item.stock, function(i){
            if(i.warehouse_id == $rootScope.voucher.selected.warehouse_id){
              tot += i.current_stock;
            }
          });
          return tot;
        };
        $scope.newTotalDelivery = function (cg, item, totalStock){
          console.log('cg',cg, 'item',item, 'totalstock',totalStock);
          $rootScope.voucher.selected.voucherlineTemp2 = [];
          cg.newTotal = 0;
          if(item.quantity > totalStock){
            item.quantity = totalStock;
            toastr.warning('Stock insuficiente', 'Error');
          }
          angular.forEach($rootScope.voucher.selected.voucherline[0].stockissued.groups, function(group){
            angular.forEach(group.product,function(i){
              if(i.quantity){
                group.newTotal += i.quantity;
                console.log('sumando', group.newTotal, i.quantity);
                i.value = 0;
                if(i.quantity>0){
                  $rootScope.voucher.selected.voucherlineTemp2.push(i);
                }
              }
            })
          });
          /*angular.forEach(cg.product,function(i){
            if(i.quantity){
              cg.newTotal += i.quantity;
              console.log('sumando', cg.newTotal, i.quantity);
              i.value = 0;
              if(i.quantity>0){
                $rootScope.voucher.selected.voucherlineTemp2.push(i);
              }
            }
          })*/
        };


        //UI TITLES AND TIME STAMP
        $rootScope.paymentTitle = 'Transferencia de productos';
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        $rootScope.getWarehousename = function(id){
          var exit = '';
          if($rootScope.voucher.properties.warehouse_id.items){
            angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w){
              if (w.id == id ){
                exit = w.name;
              }
            });
          }
          return exit;
        };
        $scope.comboQuantity =  $rootScope.voucher.selected.voucherline[0].quantity;
        //BUSINESS
        $scope.bussinessRules = function (){
          switch ($rootScope.currentModule) {
            case 'sales':
              $rootScope.transferDetail = [
                {
                  label: 'Fecha / Hora',
                  value: $rootScope.dateNow+' / '+$rootScope.timeNow
                },
                {
                  label: 'Almacen',
                  value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id)},
                {
                  label: 'Combo',
                  value: $rootScope.voucher.selected.voucherline[0].product.code + ' ' + $rootScope.voucher.selected.voucherline[0].product.code_secondary
                }
              ];
              break;
          }
          //$rootScope.voucher.selected.stockorder.type = true;
        };
        $scope.bussinessRules();
        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {
         // console.log('selected from uideliveryprog', $rootScope.voucher.selected)
        }, true);
        $rootScope.$watch($scope.modelName + '.selected.voucherlineTemp2', function () {

        }, true);
        $rootScope.saveVoucher4 = function () {
          console.log('UPDATE REGISTER', $rootScope.voucher);
          console.log('voucherlineTemp2', $rootScope.voucher.selected.voucherlineTemp2);
          $rootScope.blockPage = true;
          $rootScope.blockPageLoading = true;
          console.log('CASO PROGRAMACION');
          $scope.voucherSelected = angular.copy($rootScope.voucher.selected);
          if($rootScope.currentState == 'sales-mobile-requests'){
            $scope.voucherSelected.voucherline = angular.copy( $rootScope.voucher.selected.voucherlineTemp2);
          }
          console.log('voucherline actualizada', $scope.voucherSelected);
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              console.log('simplificado', $scope.voucherSelected, $rootScope.voucher.actionType);
              TablesService.almacenar($scope.modelName, $scope.voucherSelected)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if (res.status) {
                    $rootScope[res.modelName].selected.id = res.result.id;
                    toastr.success('Registro almacenado', 'Exito');
                    $rootScope.blockPage = true;
                    $rootScope.blockPageLoading = false;
                    $rootScope.blockPageLink = "es/print/" + res.result.id;
                  }
                  else {
                    toastr.warning('Registro no almacenado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error');
                });
            });
        };


      }
    }
  });


'use strict';
angular.module('frontendapp')
  .directive('uidefaultform', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uidefaultform/uidefaultform.html',
      restrict: 'E',
      replace: true,
      scope: {
        level: '=',
        modelName: '@',
        modelParent: '@',
      },
      rootScope: $rootScope,
      controller: function uidefaultformController ($uibModal, $scope, $rootScope, toastr,
                                                    $state, $auth, $location, $log, Upload,
                                                    UserService, localStorageService,
                                                    TablesService, $window, $modal) {




        //=================DB interactions===================
        $scope.updateRegister = function () {
          console.log('UPDATE REGISTER', $rootScope[$scope.modelName])
          if($scope.checkAllValidations()){
            UserService.actualizarToken()
              .success(function (tok) {
                $rootScope.asignarVarSession('token', tok);
                switch ($rootScope[$scope.modelName].actionType){
                  case 'update':
                    $rootScope[$scope.modelName].updateRow();
                    break;
                  case 'store':
                    $rootScope[$scope.modelName].storeRow();
                    break;
                  case 'delete':
                    $rootScope[$scope.modelName].deleteRow();
                    break;
                }
              });
          }
        };

        //=======================VALIDATION RULES=====================

        //text-angular
        $scope.loadToolBar = function (mode) {
          var toolbarConfig = angular.copy(mode);
          switch (mode) {
            case 'basics':
              toolbarConfig = [
                ['bold', 'italics', 'underline', 'strikeThrough'],
                ['ul', 'ol'],
                ['undo', 'redo', 'clear'],
                ['html'],
                ['wordcount', 'charcount']
              ];
              break;
            case 'complete':
              toolbarConfig = [
                ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
                ['bold', 'italics', 'underline', 'strikeThrough'],
                ['ul', 'ol'],
                ['undo', 'redo', 'clear'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
                ['html'],
                ['insertRelation', 'localfiles', 'insertImage', 'insertLink', 'insertVideo'],
                ['wordcount', 'charcount']
              ];
              break;
          }
          return toolbarConfig;
        };
        //text transformations
        $scope.dateToSpanishFormat = function (dateString) {
          var x = new Date(dateString);
          var y = x.toDateString();
          y = y.replace("Mon", "Lun");
          y = y.replace("Tue", "Mar");
          y = y.replace("Wed", "Mié");
          y = y.replace("Thu", "Jue");
          y = y.replace("Fri", "Vie");
          y = y.replace("Sat", "Sáb");
          y = y.replace("Sun", "Dom");
          y = y.replace("Jan", "Enero");
          y = y.replace("Feb", "Febrero");
          y = y.replace("Mar", "Marzo");
          y = y.replace("Apr", "Abril");
          y = y.replace("May", "Mayo");
          y = y.replace("Jun", "Junio");
          y = y.replace("Jul", "Julio");
          y = y.replace("Aug", "Agosto");
          y = y.replace("Sep", "Septiembre");
          y = y.replace("Oct", "Octubre");
          y = y.replace("Nov", "Noviembre");
          y = y.replace("Dec", "Diciembre");
          var z = y.split(" ");
          return (z[2] + ' de ' + z[1] + ' de ' + z[3]);
        };
        $scope.numberToMonth = function (dateString) {
          var y = '' + dateString;
          y = y.replace("1", "Enero");
          y = y.replace("2", "Febrero");
          y = y.replace("3", "Marzo");
          y = y.replace("4", "Abril");
          y = y.replace("5", "Mayo");
          y = y.replace("6", "Junio");
          y = y.replace("7", "Julio");
          y = y.replace("8", "Agosto");
          y = y.replace("9", "Septiembre");
          y = y.replace("10", "Octubre");
          y = y.replace("11", "Noviembre");
          y = y.replace("12", "Diciembre");
          return y;
        };

        //maps
        $rootScope.pos = function () {
          $scope.p = this.getPosition();
          console.log('pos',  $scope.p);
          $rootScope[$scope.modelName].selected.latitud = $scope.p.lat();
          $rootScope[$scope.modelName].selected.longitud = $scope.p.lng();
        };
        //ui-switch
        $scope.uiSwitch = function (value){
          var x = angular.copy($rootScope[$scope.modelName].selected[value] )
          if( x || x == 1 || x == '1'){
            $rootScope[$scope.modelName].selected[value] = 0;
          }
          if(!x || x == 0 || x == '0'){
            $rootScope[$scope.modelName].selected[value] =1;
          }
        };
        //passwords

        $scope.validatePassword = function (id1, id2) {
          var pass2 = document.getElementById(id1).value;
          var pass1 = document.getElementById(id2).value;
          /*if(pass1.length < 6 ){
           document.getElementById(id2).setCustomValidity("Se requieren mínimo 6 caracteres");
           }*/
          if (pass1 != pass2)
            document.getElementById(id2).setCustomValidity("Las contraseñas no coinciden");
          else
            document.getElementById(id2).setCustomValidity('');
        };
        $scope.passGeneratorReady = false;
        $scope.passGenerator = function ( len ) {
          var length = (len)?(len):(10);
          var string = "abcdefghijklmnopqrstuvwxyz"; //to upper
          var numeric = '0123456789';
          var punctuation = '!@#$%^&*()_+~`|}{[]\:;?><,./-=';
          var password = "";
          var character = "";
          var crunch = true;
          while( password.length<length ) {
            var entity1 = Math.ceil(string.length * Math.random()*Math.random());
            var entity2 = Math.ceil(numeric.length * Math.random()*Math.random());
            var entity3 = Math.ceil(punctuation.length * Math.random()*Math.random());
            var hold = string.charAt( entity1 );
            var hold = (entity1%2==0)?(hold.toUpperCase()):(hold);
            character += hold;
            character += numeric.charAt( entity2 );
            character += punctuation.charAt( entity3 );
            password = character;
          }

          //$rootScope[$scope.modelName].selected.password = password;
          //$scope.copyField = password;
          //$scope.passGeneratorReady = true;
          //return password;
        };
        //datepicker

        $scope.options = {
          customClass: getDayClass,
          minDate: new Date(),
          showWeeks: true
        };
        $scope.toggleMin = function () {
          $scope.options.minDate = $scope.options.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.setDate = function (year, month, day) {
          $scope.dt = new Date(year, month, day);
        };
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date(tomorrow);
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        $scope.events = [
          {
            date: tomorrow,
            status: 'full'
          },
          {
            date: afterTomorrow,
            status: 'partially'
          }
        ];
        function getDayClass(data) {
          var date = data.date,
            mode = data.mode;
          if (mode === 'day') {
            var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

            for (var i = 0; i < $scope.events.length; i++) {
              var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

              if (dayToCheck === currentDay) {
                return $scope.events[i].status;
              }
            }
          }
          return '';
        }
        //required fields
        $scope.checkAllValidations = function(){
          var exit = true;
          return true;
        };


      }
    }
  })
;

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uifilters', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uifilters/uifilters.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        customTemplate:'@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uifiltersController($uibModal, $scope, $rootScope, toastr,
                                                      $state, $auth, $location, $log,
                                                      UserService, localStorageService,
                                                      TablesService, $window, $modal) {

        if(!$scope.customTemplate){
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uifilters/templates/default.html'
        }
        else{
          $scope.currentTemplate = $scope.customTemplate;
        }

        /*$rootScope[$scope.modelName].filters = angular.copy($rootScope[$scope.modelName].filters);*/
        $rootScope[$scope.modelName].filters2 = angular.copy($rootScope[$scope.modelName].filters);

        //console.log('CARGA FILTROS!!!!!', $rootScope[$scope.modelName], $rootScope[$scope.modelName].filters);

        $scope.loadAcItems = function(model, key, operator, value){
          console.log('ejecuta loadAcItems',model, key, operator, value)
          var filters = {
            per_page: '1000000',
            page: '1',
            filters : {},
            order: [{
              field: 'id',
              direction: 'asc'
            }]
          };
          filters.filters[key]= {
            operator: operator,
            value: value
          };
          if(value==''){
            $scope.search();
          }
          //var targetModel = model?model:$scope.modelName;
          //console.log('recarga datos con ',model, filters)

          TablesService.filtrar(model, filters)
            .success(function (res) {
              if (res.status) {
                console.log('datos para carga de items',res);
                $rootScope[$scope.modelName].filters.filters[key].items = res.result.data;
              }
            });
        };

        $scope.pickItem = function(key, value){
          console.log('recarga desde pickItem',key, value);
          $rootScope[$scope.modelName].filters.filters[key].value = value;
          $rootScope[$scope.modelName].filters.filters[key][key+'_open']=false;
          $scope.search();
        };

        $scope.search=function(){
          console.log('recarga desde search',  $rootScope[$scope.modelName].filters.filters);
          //$rootScope[$scope.modelName].filters.filters = angular.copy($rootScope[$scope.modelName].filters.filters);

          TablesService.filtrar($scope.modelName, $rootScope[$scope.modelName].filters)
            .success(function (res) {
              console.log('ORIGINAL RESPONSE',res);
              console.log('ORIGINAL MODEL', $rootScope[res.modelName]);
              if (res.status) {
                $rootScope[res.modelName].dataset = res.result;
                $rootScope[res.modelName].globalStatics = res.globalStatics;
              }
            });
         // $rootScope[$scope.modelName].loadModel();
        };

        $scope.resetFilters = function (){
          $rootScope.reloadUI();
          /*$rootScope[$scope.modelName].filters = $rootScope[$scope.modelName].filters2;
         // $scope.stock.filters = $scope.stBackup;
          $scope.search();*/
        }

        $scope.loadItems = function (filterTarget, model, key, operator, value, other) {
          console.log('loadItems',model, key, operator, value, other);

          switch ($rootScope.currentModule) {
            case 'purchases':
              $scope.partnerType = 3;
              break;
            case 'inventory':
              $scope.partnerType = 1;
              break;
            case 'sales':
              if(filterTarget == 'partner_id'){
                $scope.partnerType = 2;
              }
              if(filterTarget == 'partner_related'){
                $scope.partnerType = 1;
              }
              break;
          }
          var filters = {
            per_page: '10',
            page: '1',
            filters: {
              type: {
                operator: 'whereIn',
                value:  $scope.partnerType,
              },
              docid :{
                operator: 'orwhere',
                other: ['name'/*, 'phone'*/],
                value: value
              }
            }
          };
          console.log('Antes de enviar',model,  filters);
          TablesService.filtrar(model, filters)
            .success(function (res) {
              if (res.status) {
                console.log('datos para carga de items', res);
                $rootScope[$scope.modelName].filters.filters[filterTarget].items = res.result.data;
              }
            });
        };



        $scope.loadFilterList = function (filterTarget, model, key, operator, value) {
          console.log('loadList',model, key, operator, value);

          var filters = {
            per_page: '25',
            page: '1',
            filters: {},
          };
          filters.filters[key] = {
            operator: operator,
            value: value,
            other: (operator=='orwhere')?['code_secondary','description']:null
          };
          console.log('Antes de enviar',model,  filters);
          TablesService.filtrar(model, filters)
            .success(function (res) {
              if (res.status) {
                console.log('datos para carga de items', res);
                $rootScope[$scope.modelName].filters.filters[filterTarget].items = res.result.data;
              }
            });
        };
        $scope.pick = function(key, value, dato){
          console.log('recarga desde pickItem',key, value, dato);
          $rootScope[$scope.modelName].filters.filters[key].value = value.id;
          $rootScope[$scope.modelName].filters.filters[key].value2 =
            (value[dato.itemsLabel]!="")?value[dato.itemsLabel]:value[dato.itemsLabel2];
          $scope.search();
        };

        $scope.countItems = function(obj){
          if(obj){
            var exit = Object.keys(obj).length?Object.keys(obj).length:0;
            return exit;
          }

        }

        ///////////////////////////////////////

       /* $scope.stock = {
          filters: [
            {
              isopen:    false,
              search:    '',
              model:    'productfamily',
              field:    'productfamily_id',
              label:    'Familia',
              searchIn: 'name',
            },
            {
              isopen:    false,
              search:    '',
              model:    'productbrand',
              field:    'productbrand_id',
              label:    'Marca',
              searchIn: 'name',
            },
            {
              isopen:    false,
              search:    '',
              model:    'productline',
              field:    'productline_id',
              label:    'Linea',
              searchIn: 'name',
            }
          ],
          setFilter: function (sf, item) {
            console.log('setFilter', sf, item);
            /!*$rootScope.stock.filters.filters.product = {
              operator: "has",
              value: parseInt(item.id),
              field: sf.field
            };*!/
            console.log('recarga desde search',  $rootScope[$scope.modelName].filters.filters);
            $rootScope[$scope.modelName].filters.filters = angular.copy($rootScope[$scope.modelName].filters.filters);

            if(!$rootScope[$scope.modelName].filters.filters.product){
              $rootScope[$scope.modelName].filters.filters.product = {
                operator: "hasGroup",
                value: [],
                field: sf.field
              };
            }
            var temp = {
              field: sf.field,
              value: item.id
            };
            var exit = true;
            angular.forEach($rootScope[$scope.modelName].filters.filters.product.value, function (v) {
              if (v.field == sf.field) {
                v.value = item.id;
                exit = false;
              }
            });
            if(exit ===true){
              $rootScope[$scope.modelName].filters.filters.product.value.push(temp);
            }
            sf.search = '';
            sf.label = item[sf.searchIn];

            $rootScope.stockR = angular.copy($rootScope.stock.filters.filters);
            console.log('$rootScope.stock', $rootScope.stock.filters.filters);
            $rootScope[$scope.modelName].loadModel();
          },
          loadData: function(f){
            var params = {
              per_page:10,
              filters : {
                name:{
                  operator:'like',
                  value: f.search
                }
              }
            };
            TablesService.filtrar(f.model, params)
              .success(function (res) {
                if (res.status) {
                  console.log('datos para carga de items', res);
                  f.data = res.result.data;
                }
              });
          }
        };

        $scope.stBackup = angular.copy($scope.stock.filters);
        $rootScope.stockR = angular.copy($rootScope.stock.filters.filters);
*/

        $scope.setFilter = function (sf, item, dato, key) {
          console.log('setFilter', sf, item, dato, key);

          if (!$rootScope[$scope.modelName].filters.filters.product) {
            $rootScope[$scope.modelName].filters.filters.product = {
              operator: "hasGroup",
              value: [],
              field: sf.field
            };
          }
          var temp = {
            field: sf.field,
            value: item.id
          };
          var exit = true;
          angular.forEach($rootScope[$scope.modelName].filters.filters.product.value, function (v) {
            if (v.field == sf.field) {
              v.value = item.id;
              exit = false;
            }
          });
          if (exit === true) {
            $rootScope[$scope.modelName].filters.filters.product.value.push(temp);
          }
          sf.search = '';
          sf.label = item[sf.searchIn];
          console.log('$rootScope.stock', $rootScope[$scope.modelName].filters.filters);
          $scope.search();
        };

        $scope.loadData = function(f){
          console.log('loadData',f);
          /*var params = {
            per_page:10,
            filters : {
              name:{
                operator:'like',
                value: f.search
              }
            }
          };*/
          var params = {
            per_page:10,
            filters : {}
          };
          params.filters[(f.searchIn)?f.searchIn:'name']={
            operator:(f.operator)?f.operator:'like',
            value:f.search
          };
          if (f.filters){
            var ftemp = JSON.parse(f.filters);
            angular.forEach(ftemp, function (i,k){
                console.log('f.filters',k,i);
                params.filters[k]=i;
            })
          }
          console.log('before loadData',f.model, params);
          TablesService.filtrar(f.model, params)
            .success(function (res) {
              if (res.status) {
                console.log('datos para carga de items', res);
                f.data = res.result.data;
              }
            });
        }

        $scope.stockReport = function (){
          //console.log('stockReport',$rootScope.stockR);
          var exit = '?';
          angular.forEach($rootScope[$scope.modelName].filters.filters, function(v, k){
            if (exit != '?') {
              exit += '&';
            }
            if(v.operator=='hasGroup'){
              angular.forEach(v.value, function(v2, k2){
                if (exit != '?') {
                  exit += '&';
                }
                exit += v2.field+'='+ ((v2.value)?v2.value:'null');
              });
           /*   exit += v.field+'='+ v.value;*/
            }
            else{
              exit += k+'='+  ((v.value)?v.value:'null');
            }

            //console.log(k,v);
          });
          //console.log('exit', exit);
          return exit;
        }




      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uidebt', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uidebt/uidebt.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uidebtController($uibModal, $scope, $rootScope, toastr,
                                                      $state, $auth, $location, $log,
                                                      UserService, localStorageService,
                                                      TablesService, $window, $modal) {



        $rootScope.paymentTitle = 'Transferencia de productos';
        $rootScope.newCreditIndex = 'unsigned';
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();


        $rootScope.getWarehousename = function(id){
          var control = false;
          var exit = '';
          console.log('getWarehousename',$rootScope.voucher.properties.warehouse_id.items, id);
          if($rootScope.voucher.properties.warehouse_id.items){
            angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w){
              if (w.id == id && !control){
                control = true;
                exit = w.name;
              }
            });
          }

          return exit;
        };



        $scope.bussinessRules = function (){
          switch ($rootScope.currentModule) {
            case 'purchases':
              break;
            case 'sales':$
              $rootScope.transferDetail = [
                {label: 'Encargado', value: $rootScope.currentUser.partner[0].name},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Almacen', value: 'Almacen central'}
              ];
              break;
            case 'inventory':
              $rootScope.transferDetail = [
                {label: 'Encargado', value: $rootScope.currentUser.partner[0].name},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
              ];
              if($rootScope.voucher.selected.warehouse_id){
                $rootScope.transferDetail.push(
                  {
                    label: 'Almacen Ori.',
                    value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id)
                  }
                )
              }
              if($rootScope.voucher.selected.warehouse_id2){
                $rootScope.transferDetail.push(
                  {
                    label: 'Almacen Des.',
                    value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id2)
                  }
                )
              }
              break;
          }
        };
        $scope.bussinessRules();



        $scope.remove = function ($index) {
          $rootScope.voucher.selected.vouchertransaction.splice($index, 1);
          $rootScope.calculateBalance();
          $rootScope.newCreditIndex = 'unsigned';
        };

        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {

        }, true);

        $rootScope.saveVoucher2 = function () {
          /* $rootScope.voucher.selected =
           angular.copy($rootScope.voucher.selected);*/
          console.log('UPDATE REGISTER', $rootScope.voucher);
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              console.log('simplificado', $rootScope.voucher.selected, $rootScope.voucher.actionType);
              switch ($rootScope.voucher.actionType) {
                case 'store':
                  TablesService.almacenar($scope.modelName,$rootScope.voucher.selected)
                    .success(function (res) {
                      console.log('Salida almacenar', res);
                      if(res.status){
                        $rootScope[res.modelName].selected.id = res.result.id;
                        toastr.success('Registro almacenado', 'Exito');
                      }
                      else{
                        toastr.warning('Registro no almacenado', 'Error'  );
                      }
                    })
                    .error(function (res) {
                      console.log('ERROR salida almacenar', res);
                      toastr.warning('Registro no almacenado', 'Error'  );
                    });
                  break;
                case 'update':
                  TablesService.actualizar($scope.modelName, $rootScope.voucher.selected.id, $rootScope.voucher.selected)
                    .success(function (res) {
                      console.log('Salida actualizar', res);
                      if (res.status) {
                        toastr.success('Registro actualizado', 'Exito');
                      }
                      else {
                        toastr.warning('Registro no actualizado', 'Error');
                      }
                    })
                    .error(function (res) {
                      console.log('ERROR salida actualizar', res);
                      toastr.warning('Registro no actualizado', 'Error');
                    });
                  break;
                case 'delete':
                  $rootScope.voucher.deleteRow();
                  break;
              }
            });
        };




      }
    }
  });

/**
 * Created by DELL on 1/12/2018.
 */
/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uicombo_old', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicombo/uicombo.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uicomboController($uibModal, $scope, $rootScope, toastr,
                                                      $state, $auth, $location, $log,
                                                      UserService, localStorageService,
                                                      TablesService, $window, $modal) {



        $rootScope.paymentTitle = 'Entrega de combos';
        $rootScope.newCreditIndex = 'unsigned';
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

        $scope.bussinessRules = function (){
          switch ($rootScope.currentModule) {
            case 'purchases':

              break;
            case 'sales':
              $rootScope.paymentTypes = [
                {type:'cash'},
                {type:'card'},
                {type:'note'},
                {type:'transaction'}
              ];
              if(!$rootScope.voucher.selected.partner.partnercategory){
                $rootScope.voucher.selected.partner.partnercategory = {
                  name:'SN',
                  topcredit : 0
                }
              }
              if($rootScope.voucher.selected.partner.partnercategory){
                $scope.oldTopCredit = angular.copy( $rootScope.voucher.selected.partner.partnercategory.topcredit );
              }
              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope.voucher.selected.partner.name},
                {label: 'Categoría', value: $rootScope.voucher.selected.partner.partnercategory.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Saldo de crédito',
                  success: function (){return $rootScope.newCreditIndex != 'unsigned'},
                  value: $rootScope.voucher.selected.partner.partnercategory.topcredit},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Punto de venta', value: 'Sucursal Miraflores'}
              ];
              $rootScope[$scope.modelName].selected.vouchertransaction = [
                {
                  payment_type: 'cash',
                  payment_label: 'efectivo',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'card',
                  payment_label: 'tarjeta',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'note',
                  payment_label: 'cheque',
                  verification:true,
                  attachment : '',
                  currency: 'Bs.',
                  amount :0,
                  code: ''
                },
                {
                  payment_type: 'transaction',
                  payment_label: 'transfer.',
                  verification:true,
                  currency: 'Bs.',
                  amount : 0,
                  attachment : '',
                  code: ''
                },
              ];
              break;
            case 'inventory':

              break;
          }
        };
        $scope.bussinessRules();

        $scope.remove = function ($index) {
          $rootScope.voucher.selected.vouchertransaction.splice($index, 1);
          $rootScope.calculateBalance();
          $rootScope.newCreditIndex = 'unsigned';
        };

        $scope.resetPay = function () {
          $scope.bussinessRules();
        };


        //PRODUCTS PICKER
        $scope.batchPicker = false;
        $scope.loadProducts = function (field, value) {
          /*var filter = {
           filters: {
           /!*stock: {
           operator: 'has',
           /!*field:'current_stock',
           value:'bigger'*!/
           },*!/
           code :{
           //operator: 'like',
           operator: 'orwhere',
           other: ['code_secondary', 'description'],
           value: value
           }
           },
           per_page: '10'
           };*/
          var filters = {
            per_page: '50',
            page: '1',
            filters: {
              code :{
                //operator: 'like',
                operator: 'stockavaible',
                other: ['code','code_secondary'],
                value: value
              }
            },
          };
          if (value != '') {
            //console.log('solicitado', field, filters);
            TablesService.filtrar('product', filters)
              .success(function (res) {
                if (res.status) {
                  console.log('productos extraidos',  res.result.data);
                  $scope.products = res.result.data;
                }
                //console.log('filtros actualizados', $rootScope[$scope.modelName].selected)
              });
          }
          else {
            $scope.products = [];
          }

        };
        $scope.addProduct = function (item, stock) {
          if (!$rootScope[$scope.modelName].selected.voucherline) {
            $rootScope[$scope.modelName].selected.voucherline = [];
          }
          console.log('inertando', item, stock)
          /*if(item.stock.length >0){item.stock[0].quantity = 1;}*/
          var newProd = {
            product_id: item.id,
            combogroup: item.combogroup,
            combogroupMax: item.combogroupMax,
            combogroupMin: item.combogroupMin,
            itemMin: item.itemMin,
            itemMax: item.itemMax,
            product: item,
            value: 0,
            quantity: 0,
            quantity_expected: 0,
            quantity_issued: 0,
            stock: 0,
            status: 0,
            newitem: true,
            stockadjustment : []
          };
          $rootScope.addToList($rootScope[$scope.modelName].selected.voucherline, newProd, 'product_id');
          $scope.setNewStockadjustment(item.id, (stock)?stock:item.stock[0]);
          $scope.products = [];
          $rootScope.searchCode = '';
          $scope.searchCode2 = '';
          $scope.batchPicker = false;
        };
        $scope.setNewStockadjustment = function(targetId, item){
          angular.forEach($rootScope[$scope.modelName].selected.voucherline, function (value) {
            if(value.product_id == targetId){
              var temp = item;
              temp.product_id =  item.product_id;
              temp.stock_id =  item.id;
              temp.quantity =  0;
              temp.quantity_expected =  0;
              temp.quantity_issued =  0;
              temp.active =  true;
              console.log('inserta stockadjustment', temp);
              $rootScope.addToList(value.stockadjustment, temp, 'stock_id');
            }
          })
        };

        $scope.pairingVoucherStock = function () {
          $scope.lastOrder = 0;
          angular.forEach($rootScope[$scope.modelName].selected.voucherline, function (value, key) {
            value.stockadjustment = $scope.retriveStockAdjustments(value.product_id, $scope.lastOrder );
          })
        };
        $scope.retriveStockAdjustments = function (productId, orderId){
          var stockadjustments = [];
          angular.forEach($rootScope[$scope.modelName].selected.stockorder[orderId].stockadjustment,
            function (item) {
              console.log('retriveStockAdjustments', item);
              if(item.product_id == productId){
                stockadjustments.push(item);
              }
            });
          return stockadjustments;
        };


        $scope.markLine = function (register){
          $scope.groupCounter = [];
          if(!register.active){
            if($scope.groupCounter[register.combogroup.id]){
              $scope.groupCounter[register.combogroup.id]++;
            }
            else{
              $scope.groupCounter[register.combogroup.id]=1;
            }
            register.active = true;
            register.quantity = register.itemMin;
            register.totalQuantity = 0;
            register.totalExpected = 0;
            angular.forEach(register.stockadjustment , function (item2){
              item2.quantity = 0;
              item2.quantity_issued =0;
              item2.quantity_expected =0;
            });
            $scope.calculateSubTotal2(register);
          }
          else{
            register.active = false;
            register.quantity = 0;
            register.totalQuantity = 0;
            register.totalExpected = 0;
            angular.forEach(register.stockadjustment , function (item2){
              item2.quantity = 0;
              item2.quantity_issued =0;
              item2.quantity_expected =0;
            })
          }
          angular.forEach($rootScope[$scope.modelName].selected.voucherline , function (item){
            if(register.product_id != item.product_id && item.active){
              $scope.groupCounter[item.combogroup.id] ++;
              if($scope.groupCounter[item.combogroup.id] > item.combogroupMax){
                item.active = false;
                item.quantity = 0;
                item.totalQuantity = 0;
                item.totalExpected = 0;
                angular.forEach(item.stockadjustment , function (item2){
                  item2.quantity = 0;
                  item2.quantity_issued = 0;
                  item2.quantity_expected = 0;
                })
              }
            }
          });
        };

        $scope.isFirst = function(id){
          var temp = false;
          angular.forEach($rootScope[$scope.modelName].selected.voucherline , function (i, key){
            if(i.combogroup.id == id){
              if(!temp){
                i.isFirst = true;
                temp = true;
              }
              else{
                i.isFirst = false;
              }
            }
          });
        };




        $scope.calculateSubTotal2 = function (item) {
          var sub = 0;
          var sub2 = 0;
          console.log('calculateSubTotal2',item);
          angular.forEach(item.stockadjustment, function (value) {
            value.quantity_expected = value.quantity - value.quantity_issued;
            sub += value.quantity;
            sub2 += value.quantity_issued;
            console.log('item', value);
          });
          item.totalQuantity = sub2 ;
          item.totalExpected = item.quantity - sub2;
          console.log('calculateSubTotal2 end',item);
          return sub;
        };


        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {
          //  console.log('selected',$rootScope[$scope.modelName].selected)
        }, true);
        $scope.closeAndBack = function (){
          $rootScope[$scope.modelName].selected.voucherline = angular.copy($rootScope[$scope.modelName].selected.voucherlineOld);
          $rootScope.uiConf.switchView('prev')
        };
        $rootScope[$scope.modelName].selected.voucherlineOld = angular.copy($rootScope[$scope.modelName].selected.voucherline);
        $rootScope[$scope.modelName].selected.voucherline = [];
        $rootScope[$scope.modelName].selected.comments = "Entrega de productos "+ $rootScope[$scope.modelName].selected.voucherlineOld[0].product.description;
           angular.forEach($rootScope[$scope.modelName].selected.voucherlineOld[0].product.productcombogroup, function(g, gk){
          console.log('ingresa lvl 0');
          angular.forEach(g.productcomboitem, function(i, ik){
            //i.product.combogroupName = g.name;
            i.product.combogroup = angular.copy(g);
            i.product.combogroupMax = g.max;
            i.product.combogroupMin = g.min;
            i.product.itemMax = i.max_units;
            i.product.itemMin = i.min_units;
            console.log('ingresa lvl 1',i.product);
            $scope.addProduct(i.product);
          });
        });

        //STORES TRANSACTION
        $scope.updateRegister = function () {

          console.log('UI INVENTORYCHECK UPDATE REGISTER', $rootScope[$scope.modelName])
          $scope.control = false;
          if ($rootScope[$scope.modelName].selected.voucherline.length > 0 && $rootScope[$scope.modelName].selected.partner.docid != '') {
            $scope.control = true;
          }
          else {
            toastr.warning('Complete los campos', 'Error');
          }
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              console.log('simplificado', $rootScope[$scope.modelName].selected, $rootScope[$scope.modelName].actionType);
              switch ($rootScope[$scope.modelName].actionType) {
                case 'store':
                  $rootScope[$scope.modelName].storeRow();
                  break;
                case 'update':
                  $rootScope[$scope.modelName].updateRow();
                  break;
                case 'delete':
                  $rootScope[$scope.modelName].deleteRow();
                  break;
              }
            });

        };


      }
    }
  });

/**
 * Created by DELL on 1/12/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uicombo', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicombo/uicombo.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uicomboController($uibModal, $scope, $rootScope, toastr,
                                                      $state, $auth, $location, $log, $timeout,
                                                      UserService, localStorageService,
                                                      TablesService, $window, $modal) {


        //$scope.BU = angular.copy($rootScope.voucher.selected.voucherline[0]);

        $rootScope.comboGroup = [];
        /*$scope.setLevelGroup = function(){
          angular.forEach($rootScope.comboGroup,function (g){
            console.log('comboGroup',g);
            var temp = g.group;
            angular.forEach($rootScope.voucher.selected.voucherline, function(i){
              console.log('voucherline',i);
              if(temp != i.group){
                temp = i.group;
                i.isFirst = true;
              }
              else{
                i.isfirst = false;
              }
            });
          });
          console.log('----', $rootScope.voucher.selected.voucherline);
        };*/
        $rootScope.voucher.selected.voucherlineTemp = [];
        $rootScope.addLineTemp = function (item) {
          //console.log('insertando voucherline temp', item);
          var newLine = {
            product_id: item.id,
            product: item,
            group: (item.group)?item.group:'',
            min: (item.min)?item.min:'',
            max: (item.max)?item.max:'',
            value: 0,
            quantity: 0,
            quantity_expected: 0,
            quantity_issued: 0,
            stock: 0,
            status: 0,
            stockadjustment: []
          };
          //console.log('newLine',newLine);
          $rootScope.addToList($rootScope.voucher.selected.voucherlineTemp, newLine, 'product_id');
          console.log('salida voucherline', $rootScope.voucher.selected);
        };

        $scope.retriveItems = function (source) {
          var temp = [];
          //$rootScope.voucher.selected.voucherline = [];
          console.log('retriveItems 0',source);
          angular.forEach(source, function(g){
            var group = g.name;
            console.log('retriveItems group',g);
            $rootScope.comboGroup.push({
              group: g.name,
              min: g.min,
              max: g.max,
              currentTotal: 0,
              prevTotal: 0,
              nextTotal: 0,
            });
            //console.log('comboGroup', $rootScope.comboGroup);
            angular.forEach(g.productcomboitem, function(p){
              var group = g.name;
              p.product.group = g.name;
              p.product.min = g.min;
              p.product.max = g.max;
              //console.log('retriveItems 3',p.product);
              $rootScope.addLineTemp(p.product);
              //$rootScope.addStock(p.stock[0]);
            })
          });
          $rootScope.stockorderOld = angular.copy($rootScope.voucher.selected.stockorder);
          if ($rootScope.voucher.actionType == 'update') {
            console.log('regla resetada');
            $rootScope.voucher.selected.stockorderhist = angular.copy($rootScope.stockorderOld);
            $rootScope.voucher.selected.stockorder = {
              stockadjustment: [],
              status: 0,
              type : true
            };
            if ($rootScope.voucher.selected.stockorderhist && $rootScope.voucher.selected.stockorderhist.length > 0) {
              console.log('step 0');
              angular.forEach($rootScope.voucher.selected.stockorderhist, function (i) {
                console.log('step 1');
                if (i.stockadjustment.length > 0) {
                  console.log('step 2');
                  angular.forEach(i.stockadjustment, function (j) {
                    j.temp = angular.copy(j.quantity_issued);
                    j.quantity_issued = 0;
                    if ($rootScope.verifyInList($rootScope.voucher.selected.stockorder.stockadjustment, j, 'stock_id')) {
                      console.log('insertando older', j);
                      $rootScope.voucher.selected.stockorder.stockadjustment.push(j);
                    }
                    angular.forEach($rootScope.voucher.selected.voucherlineTemp, function (k) {
                      //k.quantity_issued = 0;
                      console.log('step 3', k.product_id , j.product_id);
                      k.older_issued = k.older_issued ? k.older_issued : 0;
                      //$rootScope.calculateIssuedTotal(k);
                      if (k.product_id == j.product_id) {
                        console.log('step 4');

                        /*k.older_issued.push(j.temp);
                         k.older_issued = k.older_issued?k.older_issued:0;*/
                        k.older_issued += parseInt(j.temp);
                        //$rootScope.calculateIssuedTotal(k);
                        console.log('older', k.older_issued, k);
                      }
                    });

                  });

                }
              });

              //$rootScope.verifyInList (target, item, fieldcontrol);
            }
            $rootScope.voucher.selected.newStockorder = true;
            $rootScope.calculateComboTotals();
          }
        };

        $rootScope.$watch('comboGroup', function(){
          console.log('cambio comboGroup',$rootScope.comboGroup)
        });

        //calculate combo totals
        $rootScope.calculateComboTotals = function () {
          angular.forEach($rootScope.comboGroup, function (g) {
            console.log('comboGroup', g);
            g.currentTotal = 0;
            g.prevTotal = 0;
            g.nextTotal = 0;
            angular.forEach($rootScope.voucher.selected.voucherlineTemp, function (target) {
                if (g.group == target.group) {
                  angular.forEach($rootScope.getSubitems(target), function(i){
                      console.log('getSubitems', i);
                      //g.currentTotal += i.quantity_issued;
                      g.currentTotal += (($rootScope.voucher.selected.stockorder.type==false)?i.quantity_issued*-1:i.quantity_issued) ;
                  });
                  if(target.older_issued){
                    //console.log('reajustado',  target.older_issued);
                    g.prevTotal += parseInt(target.older_issued);
                    console.log('reajustado',  g.prevTotal, target.older_issued);
                    // target.quantity_expected = target.quantity - target.quantity_issued  - target.older_issued;
                  }
                  else{
                   // target.quantity_expected = target.quantity - target.quantity_issued ;
                  }
                }

              });
            g.currentTotal +=   g.prevTotal;
            g.nextTotal = g.prevTotal + g.nextTotal;
          });
        };
        //TO CREATE VISUAL WARNINGS
        $scope.checkGoodStock = function(item){
          var tot = 0;
          angular.forEach(item.stock, function(i){
            if(i.warehouse_id == $rootScope.voucher.selected.warehouse_id){
              tot += i.current_stock;
            }
          });
          if(tot>0){
           // console.log('checkGoodStock', tot, item);
          }
          return tot;

        };

        $rootScope.getOlderIssued = function (id) {
          var t = 0;
          angular.forEach($rootScope.voucher.selected.voucherlineTemp, function (target) {
           // console.log('test',target.product_id, id, id == target.product_id)
            if (id == target.product_id) {
              t += parseInt(target.older_issued);
            }
          });
          return t;
        };

        //UI TITLES AND TIME STAMP
        $rootScope.paymentTitle = 'Transferencia de productos';
        $rootScope.newCreditIndex = 'unsigned';
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        $rootScope.getWarehousename = function(id){
          var exit = '';
          if($rootScope.voucher.properties.warehouse_id.items){
            angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w){
              if (w.id == id ){
                exit = w.name;
              }
            });
          }
          return exit;
        };


        ///INITAL FUNCTION
        if($rootScope.voucher.selected.voucherline.length == 1){
          console.log('event 1');
          console.log('selected to search', $rootScope.voucher.selected.voucherline);
          TablesService.filtrar('productcombogroup', {
            filters: {
              product_id: {
                value: $rootScope.voucher.selected.voucherline[0].product_id,
              },
            },
            orderBy:{
                field:'id',
                direction:'asc'
              }
          })
            .success(function (res) {
              if (res.status) {
                console.log('grupos rescatados', res);
                //$scope.BU.product.productcombogroup = res.data;
                $scope.retriveItems(res.result.data);
                console.log('luego de cargar grupos', $rootScope.voucher.selected)
              }
            });
        }

        $scope.comboQuantity =  $rootScope.voucher.selected.voucherline[0].quantity;
        //BUSINESS
        $scope.bussinessRules = function (){
          switch ($rootScope.currentModule) {
            case 'purchases':
              break;
            case 'sales':
              $rootScope.transferDetail = [
                //{label: 'Encargado', value: ($rootScope.currentUser.partner.length>0)?$rootScope.currentUser.partner[0].name:''},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Almacen', value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id)},
                {
                  label: 'Combo',
                  value: $rootScope.voucher.selected.voucherline[0].product.code + ' ' + $rootScope.voucher.selected.voucherline[0].product.code_secondary
                }
              ];
              break;
            case 'inventory':
              $rootScope.transferDetail = [
                {label: 'Encargado', value: $rootScope.currentUser.partner[0].name},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
              ];
              if($rootScope.voucher.selected.warehouse_id){
                $rootScope.transferDetail.push(
                  {
                    label: 'Almacen Ori.',
                    value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id)
                  }
                )
              }
              if($rootScope.voucher.selected.warehouse_id2){
                $rootScope.transferDetail.push(
                  {
                    label: 'Almacen Des.',
                    value: $rootScope.getWarehousename($rootScope.voucher.selected.warehouse_id2)
                  }
                )
              }
              break;
          }
          $timeout(function() {
            $rootScope.voucher.selected.stockorder.type = true;
          }, 1000);

        };
        $scope.bussinessRules();

        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {
          console.log('selected from uicombo', $rootScope.voucher.selected)
        }, true);


       /* $rootScope.getOlderIssued = function (id) {
          var t = 0;
          angular.forEach($rootScope.voucher.selected.voucherlineTemp, function (target) {
            console.log('test',target.product_id, id, id == target.product_id)
            if (id == target.product_id) {
              t += parseInt(target.older_issued);
            }
          });
          return t;
        };*/
        $rootScope.$watch($scope.modelName + '.selected.voucherlineTemp', function () {
          console.log('final voucherlineTemp', $rootScope.voucher.selected.voucherlineTemp)
         // $root.voucher.selected.voucherlineTemp
        //$root.getSubitems(register)
         /* angular.forEach($rootScope.voucher.selected.voucherlineTemp, function(i){
            angular.forEach($rootScope.getSubitems(i), function(j){
              j.older_issued =  j.older_issued?:0;
              if (j.id == target.product_id) {
                j.older_issued += target.older_issued;
              }
            })
          })*/
        }, true);

        $rootScope.saveVoucher3 = function () {
          /* $rootScope.voucher.selected =
           angular.copy($rootScope.voucher.selected);*/
          console.log('UPDATE REGISTER', $rootScope.voucher);
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              console.log('simplificado', $rootScope.voucher.selected, $rootScope.voucher.actionType);
              switch ($rootScope.voucher.actionType) {
                case 'store':
                  TablesService.almacenar($scope.modelName,$rootScope.voucher.selected)
                    .success(function (res) {
                      console.log('Salida almacenar', res);
                      if(res.status){
                        $rootScope[res.modelName].selected.id = res.result.id;
                        toastr.success('Registro almacenado', 'Exito');
                        $rootScope.blockPage=true;
                        $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;
                      }
                      else{
                        toastr.warning('Registro no almacenado', 'Error'  );
                      }
                    })
                    .error(function (res) {
                      console.log('ERROR salida almacenar', res);
                      toastr.warning('Registro no almacenado', 'Error'  );
                    });
                  break;
                case 'update':
                  TablesService.actualizar($scope.modelName, $rootScope.voucher.selected.id, $rootScope.voucher.selected)
                    .success(function (res) {
                      console.log('Salida actualizar', res);
                      if (res.status) {
                        toastr.success('Registro actualizado', 'Exito');
                        $rootScope.blockPage=true;
                        $rootScope.blockPageLoading=false;
                        $rootScope.blockPageLink="es/printstockorder/"+res.newStockOrder.stockorder.id ;
                      }
                      else {
                        toastr.warning('Registro no actualizado', 'Error');
                      }
                    })
                    .error(function (res) {
                      console.log('ERROR salida actualizar', res);
                      toastr.warning('Registro no actualizado', 'Error');
                    });
                  break;
                case 'delete':
                  $rootScope.voucher.deleteRow();
                  break;
              }
            });
        };


      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uicontextualmenu', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicontextualmenu/uicontextualmenu.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        customTemplate:'@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uicontextualmenuController($uibModal, $scope, $rootScope, toastr,
                                                $state, $auth, $location, $log,
                                                UserService, localStorageService,
                                                TablesService, $window, $modal) {

        if(!$scope.customTemplate){
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/default.html'
        }
        else{
          $scope.currentTemplate = $scope.customTemplate;
        }

        if($scope.modelName == 'selleragenda'){
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/selleragenda.html';
        }

        if($scope.modelName == 'cashregisterlog' || ($scope.modelName == 'cashregister' && $rootScope.currentState == 'sales-cash-concilation')){
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/cashregister-log.html';
        }

        if($scope.modelName == 'voucher'){
          switch($rootScope.currentState ){
            case 'sales-point':
            case 'transfer-point':
            case 'sales-mobile-requests':
            case 'sales-mobile-point':
            case 'purchase-point':
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-creation.html';
              break;
            case 'sales-debts':
            case 'sales-transactions':
            case 'purchases-debts':
            case 'purchases-transactions':
            case 'pend-cashregister':
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-transaction.html';
              break;
                  //inventory
            case 'pend-purchases-incomes':
            case 'pend-transfer-incomes':
            case 'op-purchases-incomes':
            case 'op-transfer':
            case 'op-transfer-request':
                  //sales
            case 'sales-delivery-point-7':
            case 'sales-delivery-point':
            case 'sales-delivery-point-10':
            case 'sales-delivery-point-11':
            /*
            case 'hist-sales':
            case 'hist-rent':
            case 'hist-consignation':
            */
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-stockorder.html';
              break;
            default:
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-readall.html';
                  break;
          }
          var filters = {
            per_page: '10',
            filters: {
              id: {
                value: "9,10,11",
                operator: 'whereIn',
              },
            }
          };
          TablesService.filtrar('vouchertype', filters)
            .success(function (res) {
              console.log('load vouchertype', res);
              $rootScope.vouchercat = res.result.data;

              //TO DELETE
              /*$scope.switchClevel('next');
              $scope.loadVouchers ($rootScope.vouchercat[1]);*/
              //TO DELETE
            });

        }



        $scope.modelParent =  $scope.modelName;
        ///////////// MODEL ESTRUCTURE //////////////

        $rootScope.$watch( $scope.modelName+'.selected', function () {
          //console.log('REFRESH selected desde context', $rootScope[$scope.modelName].selected);

        }, true);

        $scope.clevel = 1;
        $rootScope.tabl2 = 1;
        $rootScope.tab = 1;

        $scope.switchClevel = function (value){
          switch (value){
            case 'next':
              $scope.clevel ++;
              break;
            case 'prev':
              $scope.clevel --;
                  break;
            default:
              $scope.clevel = value;
              break;
          }
        };
        $scope.setVoucherFilter= function (item, properties){
          $scope.voucherFilter = item.id;
          $scope.voucherLabel = item.label2;
          $scope.voucherRules = angular.copy(item);
          console.log(
            'setVoucherFilter',
            item,
            $scope.voucherFilter,
            $scope.voucherLabel,
            $scope.voucherRules
          );
          $scope.checkItems = function (){
            var exit = false;
            angular.forEach($rootScope[$scope.modelName].selected.partner.voucher, function (i){
              //console.log(i.vouchertype_id,$scope.voucherFilter );
              if(i.vouchertype_id == $scope.voucherFilter && !exit){
                exit = true;
              }
            });
            return exit;
          };
          console.log('vouchers loadad', $rootScope[$scope.modelName].selected.partner.voucher)
        }

        ////////////////////////////
        ////////////////////////////
        ////////////////////////////
        ////////////////////////////
        $scope.voucherSearch = '';
        $scope.loadVouchers= function (item,voucherSearch){
          if (item) {
            $scope.voucherFilter = item.id;
            $scope.voucherLabel = item.name;
          }
          var filters = {
            per_page: '10',
            productIndex:true,
            filters: {
              vouchertype_id: {
                value: $scope.voucherFilter
              },
              partner_id: {
                value: $rootScope.voucher.selected.partner_id,
              },
              code: {
                value: voucherSearch ,
                operator: 'like'
              }
            }
          };
          TablesService.filtrar('voucher', filters)
            .success(function (res) {
              console.log('loadCustomVoucher', res);
              $rootScope.voucherList = res.result;
              $rootScope.productIndex = res.statics.productIndex;

              //TO DELETE
              /*$rootScope.readTempVoucher($rootScope.voucherList.data[0]);*/
              //TO DELETE


            });
        }



      }
    }
  });

'use strict';
angular.module('frontendapp')
  .directive('uicrudgridsmall', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicrudgrid/uicrudgridsmall.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
      },
      rootScope: $rootScope,

      controller: function uicrudgridsmallController($uibModal, $scope, $rootScope, toastr,
                                            $state, $auth, $location, $log,
                                            UserService, localStorageService,
                                            TablesService, $window, $modal) {



        $scope.level = 0;
        $scope.modelParent =  $scope.modelName;
        ///////////// MODEL ESTRUCTURE ///////////////


        $scope.filters = {
          per_page: "10",
          page:1
        };
        //paginacion
        $scope.changePage = function ( value) {
          switch(value) {
            case 'increase':
              $scope.filters.page++;
              break;
            case 'decrease':
              $scope.filters.page--;
              break;
            default:
              $scope.filters.page = value;
              break;
          }
          $rootScope[$scope.modelName].filters.page = angular.copy($scope.filters.page);
          $rootScope[$scope.modelName].loadModel();
        };
        $scope.changePerPage = function () {
          console.log('changePerPage',$scope.filters);
          $rootScope[$scope.modelName].filters.page=1;
          $rootScope[$scope.modelName].filters.per_page = parseInt(angular.copy($scope.filters.per_page)) ;
          $rootScope[$scope.modelName].loadModel();
        };
        //ordenamiento de columnas
        $scope.sortCount = 0;
        $scope.propertyName = '';
        $scope.sortBy = function (propertyName) {
          $scope.propertyName = propertyName;
          $scope.sortCount++;
          $scope.dir = '';
          switch($scope.sortCount){
            case 1:
              $scope.dir='desc';
              $rootScope[$scope.modelName].filters.orderBy ={field:$scope.propertyName, direction: $scope.dir};
                  break;
            case 2:
              $scope.dir='asc';
              $rootScope[$scope.modelName].filters.orderBy ={field:$scope.propertyName, direction: $scope.dir};
                  break;
            default:
              $scope.sortCount = 0;
              $scope.propertyName = '';
              delete $rootScope[$scope.modelName].filters.orderBy;
                  break;
          }
          console.log('orderby!!!!!!!!!', $rootScope[$scope.modelName].filters);
          $rootScope[$scope.modelName].loadModel();
          /*$scope.sortCount++;
          $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
          $scope.propertyName = propertyName;
          if ($scope.sortCount == 3) {
            $scope.sortCount = 0;
            $scope.propertyName = '';
            delete $scope.filters.orden;
          }
          else {
            if ($scope.reverse) {
              var dir = 'desc'
            }
            else {
              var dir = 'asc'
            }
            $scope.filters.orden = [{
              campo: propertyName,
              direccion: dir
            }]
          }
          $scope.reloadData();*/
        };




      }
    }
  });

'use strict';
angular.module('frontendapp')
  .directive('uicrudgrid', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicrudgrid/crudgrid.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
      },
      rootScope: $rootScope,

      controller: function uicrudgridController($uibModal, $scope, $rootScope, toastr,
                                            $state, $auth, $location, $log,
                                            UserService, localStorageService,
                                            TablesService, $window, $modal) {



        $scope.level = 0;
        $scope.modelParent =  $scope.modelName;
        ///////////// MODEL ESTRUCTURE ///////////////


        $scope.filters = {
          per_page: "10",
          page:1
        };
        //paginacion
        $scope.changePage = function ( value) {
          switch(value) {
            case 'increase':
              $scope.filters.page++;
              break;
            case 'decrease':
              $scope.filters.page--;
              break;
            default:
              $scope.filters.page = value;
              break;
          }
          $rootScope[$scope.modelName].filters.page = angular.copy($scope.filters.page);
          $rootScope[$scope.modelName].loadModel();
        };
        $scope.changePerPage = function () {
          console.log('changePerPage',$scope.filters);
          $rootScope[$scope.modelName].filters.page=1;
          $rootScope[$scope.modelName].filters.per_page = parseInt(angular.copy($scope.filters.per_page)) ;
          $rootScope[$scope.modelName].loadModel();
        };
        //ordenamiento de columnas
        $scope.sortCount = 0;
        $scope.propertyName = '';
        $scope.sortBy = function (propertyName) {
          $scope.propertyName = propertyName;
          $scope.sortCount++;
          $scope.dir = '';
          switch($scope.sortCount){
            case 1:
              $scope.dir='desc';
              $rootScope[$scope.modelName].filters.orderBy ={field:$scope.propertyName, direction: $scope.dir};
                  break;
            case 2:
              $scope.dir='asc';
              $rootScope[$scope.modelName].filters.orderBy ={field:$scope.propertyName, direction: $scope.dir};
                  break;
            default:
              $scope.sortCount = 0;
              $scope.propertyName = '';
              delete $rootScope[$scope.modelName].filters.orderBy;
                  break;
          }
          console.log('orderby!!!!!!!!!', $rootScope[$scope.modelName].filters);
          $rootScope[$scope.modelName].loadModel();
          /*$scope.sortCount++;
          $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
          $scope.propertyName = propertyName;
          if ($scope.sortCount == 3) {
            $scope.sortCount = 0;
            $scope.propertyName = '';
            delete $scope.filters.orden;
          }
          else {
            if ($scope.reverse) {
              var dir = 'desc'
            }
            else {
              var dir = 'asc'
            }
            $scope.filters.orden = [{
              campo: propertyName,
              direccion: dir
            }]
          }
          $scope.reloadData();*/
        };




      }
    }
  });

/**
 * Created by DELL on 13/12/2018. uicashregister
 */
'use strict';
angular.module('frontendapp')
  .directive('uicashregister', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicashregister/uicashregister.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        modelParent: '@',
        crudTitle: '@',
        level: '='
      },
      rootScope: $rootScope,

      controller: function uicashregisterController($uibModal, $scope, $rootScope, toastr,
                                                    $state, $auth, $location, $log,
                                                    UserService, localStorageService,
                                                    TablesService, $window, $modal) {
        $rootScope.infoMenu = true;
        $rootScope.tab = 1;
        $rootScope.currencyCuts = [

          {
            cut: 200.00,
            currency: {bs: true, usd: false},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 100.00,
            currency: {bs: true, usd: true},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 50.00,
            currency: {bs: true, usd: true},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 20.00,
            currency: {bs: true, usd: true},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 10.00,
            currency: {bs: true, usd: true},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 5.00,
            currency: {bs: true, usd: true},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 2.00,
            currency: {bs: true, usd: true},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 1.00,
            currency: {bs: true, usd: false},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 0.50,  isFraction:true,
            currency: {bs: true, usd: false},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 0.20,  isFraction:true, label:'20 ctvs.',
            currency: {bs: true, usd: false},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },
          {
            cut: 0.10,  isFraction:true,
            currency: {bs: true, usd: false},
            amount: {bs: 0, usd: 0},
            value: {bs: 0, usd: 0}
          },

        ];
        $rootScope.$watch($scope.modelName + '.ready', function () {
          /*if (!$rootScope[$scope.modelName].selected) {
           $scope.getCurrentStatus(1);
           $rootScope[$scope.modelName].selected = $rootScope[$scope.modelName].dataset.data[0];
           $rootScope[$scope.modelName].selected.totalConciliate = 0;
           }*/
          /* $scope.calculateTotalConciliate();*/
          $rootScope.currencyCuts[11] = {
            cut: 'Pagos con tarjeta',
            notMultiply: true,
            currency: {bs: true, usd: false},
            amount: {bs: parseFloat($rootScope[$scope.modelName].selected.card_amount), usd: 0},
            value: {bs: parseFloat($rootScope[$scope.modelName].selected.card_amount), usd: 0}
          };
          $rootScope.currencyCuts[12] = {
            cut: 'Transferencias',
            notMultiply: true,
            currency: {bs: true, usd: false},
            amount: {bs: parseFloat($rootScope[$scope.modelName].selected.other_amount), usd: 0},
            value: {bs: 0, usd: 0}
          };
          $rootScope.currencyCuts[13] = {
            cut: 'Pagos a crédito',
            notMultiply: true,
            currency: {bs: true, usd: false},
            amount: {bs: parseFloat($rootScope[$scope.modelName].selected.credit_amount), usd: 0},
            value: {bs: 0, usd: 0}
          };
          /*var filtersCL = {
            filters:{
              cashregister_id :{
                value: $rootScope[$scope.modelName].selected.id
              },
              status :{
                value: '0',
                operator: '='
              }
            }
          };
          TablesService.filtrar('cashregisterlog',filtersCL)
            .success(function (res) {
              console.log('actual cashregisterlog', res);
              $rootScope[$scope.modelName].selected.currentCL = res.result.data[0].id;
              $rootScope[$scope.modelName].selected.vouchertransaction = res.result.data[0].vouchertransaction;
            });*/

          $rootScope[$scope.modelName].selected.currentCL = $rootScope[$scope.modelName].selected.currentlog.id;
          $rootScope[$scope.modelName].selected.vouchertransaction = $rootScope[$scope.modelName].selected.currentlog.vouchertransaction;
          //currentlog


        });

        $rootScope.nextUSD = 0;
        $rootScope.nextBs = 0;

        $rootScope.$watch('currencyCuts', function () {
          console.log('currencyCuts');
          $rootScope.getTotAmount();
        }, true);
        $rootScope.getTotAmount = function () {
          $rootScope[$scope.modelName].selected.balance = 0;
          $rootScope[$scope.modelName].selected.cash_reconcilied_bs = 0;
          $rootScope[$scope.modelName].selected.cash_reconcilied_usd = 0;
          angular.forEach($rootScope.currencyCuts, function (ct) {
            if (!ct.notMultiply) {
              ct.value.bs = ct.cut * ct.amount.bs;
              ct.value.usd = ct.cut * ct.amount.usd;
              $rootScope[$scope.modelName].selected.cash_reconcilied_bs += ct.value.bs;
              $rootScope[$scope.modelName].selected.cash_reconcilied_usd += ct.value.usd;
            }
            else {
              ct.value.bs = ct.amount.bs;
              ct.value.usd = ct.amount.usd;
              if (ct.cut == 'Pagos con tarjeta') {
                // $rootScope[$scope.modelName].selected.card_amount = angular.copy(parseFloat($rootScope[$scope.modelName].selected.card_amount));
                $rootScope[$scope.modelName].selected.card_reconcilied = ct.value.bs;
              }
              if (ct.cut == 'Transferencias') {
                //  $rootScope[$scope.modelName].selected.card_amount = angular.sellcopy(parseFloat($rootScope[$scope.modelName].selected.other_amount));
                $rootScope[$scope.modelName].selected.other_reconcilied = ct.value.bs;
              }
              if (ct.cut == 'Pagos a crédito') {
                // $rootScope[$scope.modelName].selected.card_amount = angular.copy(parseFloat($rootScope[$scope.modelName].selected.credit_amount));
                $rootScope[$scope.modelName].selected.credit_reconcilied = ct.value.bs;
              }
            }
            $rootScope[$scope.modelName].selected.cash_reconcilied_bs =  Math.round(($rootScope[$scope.modelName].selected.cash_reconcilied_bs)*100)/100;

          });
          $rootScope[$scope.modelName].selected.balance =  $rootScope[$scope.modelName].selected.cash_reconcilied_bs +
            $rootScope[$scope.modelName].selected.cash_reconcilied_usd+
            $rootScope[$scope.modelName].selected.card_reconcilied+
            $rootScope[$scope.modelName].selected.other_reconcilied;
          console.log('cash_reconcilied_bs', $rootScope[$scope.modelName].selected.cash_reconcilied_bs);
          console.log('cash_reconcilied_usd', $rootScope[$scope.modelName].selected.cash_reconcilied_usd);
        };
        $rootScope.getTotAmount();

        $rootScope.summatory=function(items){
          var exit = 0;
          angular.forEach(items, function(i){
            exit += parseFloat(i);
          });
          return exit;
        };
        $rootScope.limitAmount=function(target, limit){
          if($rootScope[target] > limit){
            $rootScope[target] = limit;
            console.log('Monto invalido', $rootScope[target]);
            toastr.warning('Monto invalido', 'Error');
          }
        };

        $scope.updateCashregister = function(){
          TablesService.actualizar('cashregister', $rootScope[$scope.modelName].selected.id,
            {
              'initial_amount_bs': $rootScope.nextInitAmountBs,
              'initial_amount_usd': $rootScope.nextInitAmountUsd,
              'cash_amount_bs': 0,
              'cash_amount_usd': 0,
              'card_amount': 0,
              'other_amount': 0,
              'credit_amount': 0,
              'last_verification': $rootScope.dateNow,
            })
            .success(function (res) {
              console.log('Salida actualizar cashregister', res);
              if (res.status) {
                toastr.success($rootScope.currentUser.cashregisteruser[0].cashregister.name + 'restaurada', 'Exito');
                //$rootScope[res.modelName].resetRegister(true);
                $rootScope.blockPageLoading =  false;
                if($scope.spv.voucher_id){
                  $rootScope.blockPageLink="es/print/"+$scope.spv.voucher_id;
                }

              }
              else {
                toastr.warning($rootScope.currentUser.cashregisteruser[0].cashregister.name + 'no restaurada', 'Error');
              }
            })
            .error(function (res) {
              console.log('ERROR salida actualizar', res);
              toastr.warning('Registro no actualizado', 'Error');
            });
        };

        $scope.saveCashregisterlog = function(){
          TablesService.actualizar('cashregisterlog', 'last',$scope.spv)
            .success(function (res) {
              console.log('Salida almacenar cashregisterlog', res);
              if (res.status) {
                toastr.success('cashregisterlog almacenado', 'Exito');
                //$rootScope[res.modelName].resetRegister(true);
                //$scope.updateCashregister();
                $scope.cl = {
                  /* 'warehouse_id',*/
                  'cashregister_id': $rootScope[$scope.modelName].selected.id,
                  /*'user_id',
                   'voucher_id',*/
                  'balance': 0,
                  'initial_amount_bs': 0,
                  'initial_amount_usd': 0,
                  'cash_amount_bs': $rootScope[$scope.modelName].selected.cash_amount_bs,
                  'cash_amount_usd': $rootScope[$scope.modelName].selected.cash_amount_usd,
                  'card_amount': $rootScope[$scope.modelName].selected.card_amount,
                  'other_amount': $rootScope[$scope.modelName].selected.other_amount,
                  'credit_amount': $rootScope[$scope.modelName].selected.credit_amount,
                  'cash_reconcilied_bs': 0,
                  'cash_reconcilied_usd': 0,
                  'card_reconcilied': 0,
                  'other_reconcilied':  0,
                  'credit_reconcilied': 0,
                  'status': 0,
                  'comment': '',
                  'last_verification': $rootScope.dateNow,
                };
                TablesService.almacenar('cashregisterlog', $scope.cl)
                  .success(function (res) {
                    console.log('Salida almacenar cashregisterlog', res);
                    if (res.status) {
                      toastr.success('cashregisterlog nuevo almacenado', 'Exito');
                      //$rootScope[res.modelName].resetRegister(true);
                      $scope.updateCashregister();
                    }
                    else {
                      toastr.warning('Registro no actualizado', 'Error');
                    }
                  })
                  .error(function (res) {
                    console.log('ERROR salida actualizar', res);
                    toastr.warning('Registro no actualizado', 'Error');
                  });
              }
              else {
                toastr.warning('Registro no actualizado', 'Error');
              }
            })
            .error(function (res) {
              console.log('ERROR salida actualizar', res);
              toastr.warning('Registro no actualizado', 'Error');
            });

        };

        $scope.saveConcilied = function () {
          $rootScope.blockPage = true;
          $rootScope.blockPageLoading = true;
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              console.log('simplificado', $rootScope[$scope.modelName].selected, $rootScope[$scope.modelName].actionType);
              var d = new Date();
              $rootScope.dateNow = d.getFullYear() + '-' + parseInt(d.getMonth() + 1) + '-' + d.getDate();
              $rootScope[$scope.modelName].selected.concilied = $rootScope.dateNow;
              $scope.spv = {
                /* 'warehouse_id',*/
                'cashregister_id': $rootScope[$scope.modelName].selected.id,
                /*'user_id',
                 'voucher_id',*/
                'balance': 0,
                'initial_amount_bs': $rootScope[$scope.modelName].selected.initial_amount_bs,
                'initial_amount_usd': $rootScope[$scope.modelName].selected.initial_amount_usd,
                'cash_amount_bs': $rootScope[$scope.modelName].selected.cash_amount_bs,
                'cash_amount_usd': $rootScope[$scope.modelName].selected.cash_amount_usd,
                'card_amount': $rootScope[$scope.modelName].selected.card_amount,
                'other_amount': $rootScope[$scope.modelName].selected.other_amount,
                'credit_amount': $rootScope[$scope.modelName].selected.credit_amount,
                'cash_reconcilied_bs': $rootScope[$scope.modelName].selected.cash_reconcilied_bs,
                'cash_reconcilied_usd': $rootScope[$scope.modelName].selected.cash_reconcilied_usd,
                'card_reconcilied': $rootScope[$scope.modelName].selected.card_reconcilied,
                'other_reconcilied': $rootScope[$scope.modelName].selected.other_reconcilied,
                'credit_reconcilied': $rootScope[$scope.modelName].selected.credit_reconcilied,
                'status': 1,
                'comment': $rootScope[$scope.modelName].selected.comment,
                'comment_cash': $rootScope[$scope.modelName].selected.comment_cash,
                'comment_card': $rootScope[$scope.modelName].selected.comment_card,
                'comment_other': $rootScope[$scope.modelName].selected.comment_other,
                'comment_credit': $rootScope[$scope.modelName].selected.comment_credit,
                'last_verification': $rootScope.dateNow,
              };
              $rootScope.transferAmount = 0;
              $rootScope.transferAmount = ($rootScope.nextUSD * $rootScope.globalParams.TcUSD) + $rootScope.nextBs;
              $rootScope.nextInitAmountBs  = $rootScope[$scope.modelName].selected.cash_reconcilied_bs - $rootScope.nextBs;
              $rootScope.nextInitAmountUsd = $rootScope[$scope.modelName].selected.cash_reconcilied_usd - $rootScope.nextUSD ;

              if($rootScope.transferAmount == 0){
                $scope.saveCashregisterlog();
              }
              else{
                TablesService.almacenar('voucher', {
                  'vouchertype_id':1,
                  'partner_id':$rootScope.currentUser.partner[0].id,
                  'code':'',
                  'status':0,
                  'comments':$rootScope[$scope.modelName].selected.comment,
                  'total':  $rootScope.transferAmount,
                  'credit_amount':'',
                  'transport_amount':0,
                  'other_amount':0,
                  'warehouse_id':$rootScope.currentUser.cashregisteruser[0].cashregister.warehouse_id,
                  'warehouse_id2':'',
                })
                  .success(function (res) {
                    console.log('Salida almacenar voucher', res);
                    if (res.status) {
                      toastr.success('Voucher almacenado', 'Exito');
                      //$rootScope[res.modelName].resetRegister(true);
                      $scope.spv.voucher_id = res.result.id;
                      $scope.saveCashregisterlog();
                    }
                    else {
                      toastr.warning('Registro no actualizado', 'Error');
                    }
                  })
                  .error(function (res) {
                    console.log('ERROR salida actualizar', res);
                    toastr.warning('Registro no actualizado', 'Error');
                  });
              }



            });
        }


      }
    }
  });


/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uibuilder', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/uibuilder.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
        /////////////////////
        uiCrudTitle: '@',
        uiFirstLevel: '='
      },
      rootScope: $rootScope,

      controller: function uibuilderController($uibModal, $scope, $rootScope, toastr,
                                            $state, $auth, $location, $log, $timeout,
                                            UserService, localStorageService,
                                            TablesService,Upload, $window, $modal) {
        //CUSTOMIZE MODEL PROPERTIES FROM FRONTEND
        $rootScope.customizeProperty = function (target, property) {
          //console.log('CUSTOM', target,property );
          if(target){
            for (var j in property) {
              //console.log('CUSTOM LEV 0', j)
              if (typeof property[j] == 'object') {
                if(j && !target[j]){
                  target[j]={};
                }
                for (var k in property[j]) {
                  //console.log('CUSTOM LEV 2',target[j],  k)
                  target[j][k] = property[j][k];
                }
              }
              else {
                //console.log('CUSTOM LEV 1', j)
                target[j] = property[j];
              }
            }
          }

        };

        /////////// MODEL CONSTRUCTOR  //////////////
        $rootScope.modelConstruct = function (params) {
          console.log('modelConstruct',params)
          $rootScope[params.modelAs?params.modelAs:params.model] = {
            accessDenied: false,
            refresh: (params.refresh!=null)?params.refresh:true,
            label: params.label,
            model: params.model,
            parentModel: params.parentModel,
            childModel: params.childModel,
            customComponent: params.customComponent,
            referenceField: '',
            //customRelations: params.customRelations ? params.customRelations : null,
            customProperties: params.customProperties ? params.customProperties : null,
            properties: {},
            customFilters: params.customFilters ? params.customFilters : null,
            filters: { filters:{}},
            dataset: {},
            selected: {},
            operations: params.operations ? params.operations : {},
            customOperations: params.customOperations ? params.customOperations : {},
            actionType: params.actionType ? params.actionType : null,
            newSelected: function () {
              this.selected = {};
              //console.log('new!!');
              for (var j in this.properties) {
                if(this.properties[j].default){

                  if( this.properties[j].type=='json' ){
                    this.selected[j] = JSON.parse(this.properties[j].default);
                  }
                  else{
                    this.selected[j]= this.properties[j].default;

                  }
                }else{
                  this.selected[j] = '';
                }
                if(j == this.parentModel+'_id'){
                  //console.log('DETECTA DEPENDENCIA', j);
                  this.selected[j]= $rootScope[this.parentModel].selected.id;
                  this.properties[j].disabled=true;
                }
              }
              this.resolveMethodsOf();
            },
            resetRegister: function (close) {
              $rootScope[this.model+'_old']=angular.copy(this);
              console.log('resetRegister' ,close, $rootScope[this.model+'_old']);
              if(close){
                console.log('alter 1');
                $rootScope.uiConf.switchView('prev', {}, this.refresh);
              }
              else{
                console.log('alter 2');
                this.selected = angular.copy(this.selectedBackup);
                //this.resolveMethodsOf();
              }
              console.log('ejecuta reseteo',this);
            },
            loadModel: function () {
              if (this.customFilters) {
                this.filters = this.customFilters;
                //console.log('agrega filtros personalizados')
              }
              //console.log('SOLICITA:', this.model, this.filters);
              console.log('LOADING MODEL', this);
              TablesService.filtrar(this.model, this.filters)
                .success(function (res) {
                  console.log("========CRUD CONSOLE===========");
                  console.log('ORIGINAL RESPONSE', res);
                  console.log('ORIGINAL MODEL', $rootScope[res.modelName]);
                  if (res.status) {
                    $rootScope[res.modelName].dataset = res.result;
                    $rootScope[res.modelName].globalStatics = res.globalStatics;
                    $rootScope[res.modelName].reload = false;
                    $rootScope[res.modelName].operations = res.options;
                    $rootScope[res.modelName].properties = res.modelProperties;
                    $rootScope[res.modelName].selected = res.selected;
                    $rootScope[res.modelName].referenceField = res.referenceField;
                    $rootScope[res.modelName].extraConf = res.extraConf;
                    $scope.referenceField = res.referenceField;

                    if($rootScope[res.modelName].customProperties){
                      $rootScope.customizeProperty($rootScope[res.modelName].properties, $rootScope[res.modelName].customProperties);
                    }
                    if ($rootScope[res.modelName].selected) {
                      $rootScope[res.modelName].resolveMethodsOf();
                      $rootScope[res.modelName].selectedBackup = angular.copy($rootScope[res.modelName].selected);
                    }
                    if ($rootScope[res.modelName].customFilters) {
                      //customize or overwrite filters
                      $rootScope.customizeProperty($rootScope[res.modelName].filters.filters,res.filterSet);
                    }
                    else{
                      //creates filters set
                      $rootScope[res.modelName].filters.filters = {};
                      $rootScope[res.modelName].filters.filters = res.filterSet;
                    }
                    if ($rootScope[res.modelName].customOperations && Object.keys($rootScope[res.modelName].customOperations).length>0) {
                      //customize or overwrite filters
                      console.log('customOperations', $rootScope[res.modelName].customOperations, ' = ', Object.keys($rootScope[res.modelName].customOperations).length);
                      $rootScope[res.modelName].operations = angular.copy($rootScope[res.modelName].customOperations);
                     /* $rootScope.customizeProperty($rootScope[res.modelName].operations);*/
                    }
                    if ($rootScope[res.modelName].actionType == 'store' && !$rootScope[res.modelName].selected) {
                      $rootScope[res.modelName].newSelected();
                    }
                    $rootScope[res.modelName].ready = true;
                  /*  if(res.modelName == 'voucher' && $rootScope.globalPartner){
                      switch ($rootScope.currentState) {
                        case 'sales-point':
                          TablesService.filtrar(
                            'partner',
                            {
                              filters: {
                                id: {
                                  value: $rootScope.globalPartner.id
                                }
                              }
                            }
                          )
                            .success(function (res) {
                              if (res.status) {
                                $rootScope.voucher.selected = {
                                  partner: res.result.data[0],
                                  partner_id: res.result.data[0].id,
                                  voucherline: [],
                                }
                              }
                            });
                          console.log('uiinventoryform global');
                          break;
                        case 'sales-debts':
                          TablesService.filtrar('voucher', {
                            filters: {
                              credit_amount: {
                                value: 1,
                                operator: '>'
                              },
                              vouchertype_id: {
                                value: 9,
                              },
                              partner_id: {
                                value: $rootScope.globalPartner.id,
                              }
                            }
                          })
                            .success(function (res) {
                              if (res.status) {
                                $rootScope.voucher.dataset = res.result;
                              }
                            });
                          console.log('grid global');
                          break;
                      }
                    }*/
                  }
                  console.log('ESTRUCTURA DE CRUD', $rootScope[res.modelName]);
                });
            },
            getFilesToUpload: function (){
              var fileslist = {fields:[]};
              var properties = this.properties;
              var selected = this.selected;
              angular.forEach(properties, function (value, key) {
                if (value.type== 'file' && typeof selected[key+'_file'] == 'object'){
                  fileslist[key] = selected[key+'_file'];
                  fileslist.fields.push(key);
                }
              }) ;
              this.fileslist = fileslist;
            },
            uploadFiles: function () {
              Upload.upload({
                url: $rootScope.api + '/api/' + this.model + '/upload/' + this.selected.id,
                data: this.fileslist
              }).then(function (response) {
                console.log('upload 1', response);
                var result = response.data;
                if (result.response) {
                  toastr.success('Registro almacenado', 'Exito');
                  $rootScope[result.modelName].resetRegister(true);
                } else {
                  toastr.success('Registro almacenado', 'Exito');
                }
              }, function (response) {
                console.log('upload 2', response)
                if (response.status > 0) {
                  toastr.warning(response.status + ': ' + response.data, 'Error');
                  $scope.errorMsg = response.status + ': ' + response.data;
                }
              }, function (evt) {
                console.log('upload 3', evt)
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
              });

            },
            storeMany: function (items){
              TablesService.storemany(this.model,items)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if(res.status){
                    toastr.success('Registro almacenado', 'Exito');
                    $rootScope.uiConf.switchView('prev', {}, true);
                  }
                  else{
                    toastr.warning('Registro no almacenado', 'Error'  );
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error'  );
                });
            },
            storeRow: function (){
              console.log('ingresa en store');
              this.getFilesToUpload();
              TablesService.almacenar(this.model, this.selected)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if(res.status){
                    $rootScope[res.modelName].selected.id = res.result.id;
                    if ($rootScope[res.modelName].fileslist.fields.length > 0) {
                      $rootScope[res.modelName].uploadFiles();
                      toastr.info('Cargando archivos', 'En proceso');
                    }
                    else {
                      toastr.success('Registro almacenado', 'Exito');
                      $rootScope[res.modelName].resetRegister($rootScope[res.modelName].refresh);
                    }
                  }
                  else{
                    toastr.warning('Registro no almacenado', 'Error'  );
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error'  );
                });
            },
            updateRow: function () {
              this.getFilesToUpload();
              console.log('ingresa en update enviando', this.selected);
              TablesService.actualizar(this.model, this.selected.id, this.selected)
                .success(function (res) {
                  console.log('Salida actualizar', res);
                  if (res.status) {
                    if ($rootScope[res.modelName].fileslist.fields.length > 0) {
                      $rootScope[res.modelName].uploadFiles();
                      toastr.info('Cargando archivos', 'En proceso');
                    }
                    else {
                      toastr.success('Registro actualizado', 'Exito');
                      $rootScope[res.modelName].resetRegister(true);
                    }
                  }
                  else {
                    toastr.warning('Registro no actualizado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida actualizar', res);
                  toastr.warning('Registro no actualizado', 'Error');
                });
            },
            deleteRow: function (){
              console.log('ingresa en delete');
              TablesService.eliminar(this.model, this.selected.id, this.selected)
                .success(function (res) {
                  console.log('Salida eliminar', res);
                  if(res.status){
                    toastr.success('Registro eliminado', 'Exito'  );
                    $rootScope[res.modelName].resetRegister(true);
                  }
                  else{
                    toastr.warning('Registro no eliminado'+((res.message)?', '+res.message:''), 'Error'  );
                  }
                })
                .error(function (res){
                  console.log('ERROR salida eliminar', res);
                  toastr.warning('Registro no eliminado', 'Error'  );
                });
            },
            resolveMethodsOf: function () {
              //console.log('inicia resolve', this);
              for (var property in this.properties) {
                for (var j in this.properties[property].resolve) {
                  //console.log('rresuelve', j );
                  this.properties[property][j] = this.resolve( this.properties[property].resolve[j]);
                  //console.log('resolve!!!!', j);
                }
                if (this.properties[property].type=='innerCrud' && this.selected && this.actionType!='store'){
                  console.log('say hello!!! selected',this.selected[property]);
                  console.log('say hello!!! properties',this.properties[property] );
                  this.prepareInnerCrud(this.selected[property],this.properties[property]);
                }
              }
            },
            resolve: function (functionInjected) {
              return functionInjected(this);
            },
            //NOT COMPLETE
            prepareInnerCrud: function (source, properties) {
              properties.items = [];
              if (properties.hasLevels) {
                properties.items = source;
              }
              else {
                if(source.length>0){
                  properties.items.push(source);
                }
              }
              if(properties.items.length>0){
                angular.forEach(properties.items, function (subitem) {
                  subitem.referenceField = $rootScope.getVarFromString(subitem, properties.itemsLabel)
                });
                console.log('innercruditems', properties.items)
              }

            }
          };
          $rootScope[params.modelAs?params.modelAs:params.model].loadModel(); // MODEL BUILDER
        };

        /////////// UI CONFIGURATION  //////////////
        $rootScope.uiConf =  {
          currentLevel: 0,
          level: [],
          setNewLevel: function (params, autoload) {
            //console.log('PARAMS EVALUATED', params)
            var control = false; // if control is true doesnt create a new level
            if(this.level[this.currentLevel]){
              control = (this.level[this.currentLevel].component == params.component && this.level[this.currentLevel].model == params.model);
            }
            if(control=== false){
              this.level.push(params);
              if (autoload) {
                $rootScope.modelConstruct(params);
              }
              this.currentLevel = this.level.lastIndexOf(params);
              //console.log('NEW LEVEL UICONF', $rootScope.uiConf)
            }
          },
          destroyCurrentLevel: function (autoload) {
            var index = this.level.indexOf(this.level[this.currentLevel]);
            if(index>0){
              if (index > -1) {
                this.level.splice(index, 1);
              }
              this.currentLevel--;
              if (autoload) {
                $rootScope[this.level[this.currentLevel].model].loadModel();
              }
            }
          },
          switchView: function (option, params, autoload) {
            switch (option) {
              case 'next':
                this.setNewLevel(params, autoload);
                break;
              case 'prev':
                this.destroyCurrentLevel(autoload);
                break;
              case 'new':
                this.setNewLevel(params, true);
                break;
              default:
                break;
            }
            //console.log('UICONF OBJECT', $rootScope.uiConf)
          },
        };

        /////////// CRUD BUILDER'S TRIGGER //////////////
        $rootScope.uiConf.switchView('new', $scope.uiFirstLevel, true);

        $rootScope.getProp = function(property){
          var keepGoing = true;
          angular.forEach(property, function(value, key){
            if(keepGoing) {
              if (typeof value != 'object'){
                keepGoing = false;
                return value;
              }
            }
          });
        };

        //SET SELECTED ATRIBUTE TO CURRENT MODEL
        $rootScope.chooseRegister = function (modelName, selected, actionType, reload, component) {
          console.log('SELECCIONA', modelName, selected, actionType, reload,component);
          $rootScope[modelName].selected = selected;
          $rootScope[modelName].actionType = actionType;
          $rootScope[modelName].resolveMethodsOf();
          //customFilters
          if ($rootScope[modelName].customFilters) {
            if ($rootScope[modelName].customFilters.relations && $rootScope[modelName].customFilters.relations == 'onSelect') {
              TablesService.find(modelName, selected.id, {})
                .success(function (res) {
                  console.log("===================");
                  console.log('FIND MODEL RESPONSE', res);
                  if (res.status) {
                    $rootScope[modelName].selected = res.result;
                  }
                })
            }
          }
          if (actionType == 'store') {
            $rootScope[modelName].newSelected();
            console.log('NEW SELECTED ATRIBUTE', $rootScope[modelName].selected)
          }
          if (actionType == 'read' ){
            $rootScope.showInfoMenu(true);
          }
          if (actionType != 'read') {
            $rootScope[modelName].selectedBackup = angular.copy(selected);
            $rootScope[modelName].filters.selected = angular.copy(selected.id);
            var params = {
              component: component?component:'uidefaultform',
              model: modelName,
              actionType: $rootScope[modelName].actionType,
              filters: $rootScope[modelName].filters
            };
            //console.log('params before new level', params);
            $rootScope.uiConf.switchView('next', params, reload);
          }
          console.log('modelo actual', $rootScope[modelName])
        };

        //creates new inner crud
        $rootScope.setInnerCrud = function (modelName, selected, actionType, parentModel) {
          console.log('ingresa:', modelName, selected, actionType);
          console.log('seleccionado inner crud', selected);
          var params = {
            component: 'uidefaultform',
            model: modelName,
            parentModel: parentModel,
            actionType: actionType,
            customFilters: {
              selected: (selected) ? angular.copy(selected.id) : null
            }
          };
          $rootScope.uiConf.switchView('new', params, true);
        };

        //get reference field in a relation
        $rootScope.getVarFromString = function (target, searched) {
          var exit = '';
          var levels = searched.split('.');
          switch (levels.length){
            case 1:
              exit = target[levels[0]];
              break;
            case 2:
              exit = target[levels[0]][levels[1]];
              break;
            case 3:
              exit = target[levels[0]][levels[1]][levels[2]];
              break;
            case 4:
              exit = target[levels[0]][levels[1]][levels[2]][levels[3]];
              break;
          }
          /*console.log('BUSCANDO', target);
           console.log('searched', searched);
           console.log('levels', levels);
           console.log('MAPPEADO', exit, levels.length)*/
          return exit;
        };

        //operations to add objects in a list
        $rootScope.verifyInList = function (target, item, fieldcontrol) {
          var exit = true;
          angular.forEach(target, function (value, key) {
            if (value[fieldcontrol] == item[fieldcontrol]) {
              exit = false;
            }
          });
          return exit;
        };

        $rootScope.addToList = function (list, item, fieldcontrol, autoremove) {
          if ($rootScope.verifyInList(list, item, fieldcontrol)) {
            list.push(item);
          }
          else{

            if(autoremove){
              var tempIndex = list.indexOf(item);
              //list.splice(tempIndex, 1);
              var control = false;
              angular.forEach(list, function(i, key){
                if(!control && item[fieldcontrol] == i[fieldcontrol]){
                  tempIndex = key;
                  control = true;
                  console.log('tempIndex',tempIndex)
                }
              });
              list.splice(tempIndex, 1);
            }
            else{
              toastr.warning('Registro duplicado', 'Error');
              console.log('error', list);
            }
          }
          console.log('lista actualizada', list);
        };

        //Change view title, when changeTitle change
        $rootScope.$watch('changeTitle', function(){
          if ($rootScope.changeTitle){
            $scope.uiCrudTitle = $rootScope.changeTitle;
          }
        });

        //Load cutom model to list
        $rootScope.loadItemList = function (target, model){
          TablesService.filtrar(model, {per_page:100000})
            .success(function (res) {
              if (res.status) {
                console.log('lista cargada',res);
                target.items = res.result.data;
              }
            });
        };

        //Reload UI
        $rootScope.reloadUI = function (){
          location.reload();
        };

        $rootScope.compareDates = function (){
          var d = new Date();
          d.setDate(d.getDate()-14);
          var t1 = new Date($rootScope.voucher.selected.created_at);
          /*console.log('compareDates',t1);
          console.log('compareDates',d );*/
          if(t1 < d && !$rootScope.access(['super-admin']) ){
            return true;
          }
          else{
            return false;
          }
        };

        ///////////////////////////////////////////////////
        //////////////CUSTOMIZATION GUIBDENTAL/////////////
        ///////////////////////////////////////////////////
        ////////PRODUCTS, SALES, TRANSFER, PURCHASE////////
        ///////////////////////////////////////////////////
        ///////////////// DIRECTIVES  /////////////////////
        //Trigguer multiple products picker
        $rootScope.openPicker = function (model, customSettings, warehouse) {
          console.log('openPicker', model, customSettings);
          $rootScope.uiConf.switchView('next',
            {
              actionType:'update',
              component:'uipiker',
              model:model
            }, false
          );
          /*$rootScope.uiConf.switchView('new',  {
           actionType:'store',
           component:'uipiker',
           model:model
           }, true);*/
        };
        //Trigger payments directive
        $rootScope.setDebt = function (){
          $rootScope.voucher.actionType = 'update';
          $rootScope.voucher.selected.newTransaction = true;
          $rootScope.voucher.selected.voucherTotal = angular.copy($rootScope.voucher.selected.total);
          $rootScope.voucher.selected.total = $rootScope.voucher.selected.credit_amount;
        };
        $rootScope.openPayment = function (){
          $rootScope.uiConf.switchView('next', {actionType:'store',component:'uipayment', model:'voucher'}, false);
        };
        //Trigguer stock order directive
        $rootScope.setStockorder = function (value){
          $rootScope.stockOrderSelected = angular.copy(value);
        };
        $rootScope.openStockview = function () {
          $rootScope.voucher.actionType = 'update';

          $rootScope.uiConf.switchView('next', {
            actionType: 'update',
            component: 'uiinventorycheck',
            model: 'voucher'
          }, false);
        };
        //trigguer combo view directive
        $rootScope.openComboview = function () {
          $rootScope.voucher.actionType = 'update';
          $rootScope.uiConf.switchView('next', {
            actionType: 'update',
            component: 'uicombo',
            model: 'voucher'
          }, false);
        };
        ///////////////GLOBAL FUNCTIONS///////////////////
        //READ AND LOAD VOUCHERS
        $rootScope.readTempVoucher = function (voucher){
          $rootScope.uiConf.switchView('next', {actionType:'store',component:'uireadvoucher', model:'voucher'}, false);
          $rootScope.tempVoucher = angular.copy(voucher);
        };
        $rootScope.loadVoucher = function (voucher, actionType){
          $scope.partnerB = angular.copy(voucher.partner);
          $scope.partner_idB = angular.copy(voucher.partner_id);
          $rootScope.voucher.selected = angular.copy(voucher);
          $rootScope.voucher.actionType = actionType;
          if(voucher.stockorder.length>0){
            $rootScope.voucher.selected.warehouse_id = voucher.stockorder[0].warehouse_id;
            $rootScope.voucher.selected.warehouse = voucher.stockorder[0].warehouse;
          }
          $rootScope.voucher.selected.partner =   $scope.partnerB;
          $rootScope.voucher.selected.partner_id = $scope.partner_idB;

          $rootScope.voucher.selected.stockorder = voucher.stockorder[voucher.stockorder.length-1];
          $rootScope.voucher.selected.stockorderhist = angular.copy(voucher.stockorder);
          $rootScope.setVoucherType($rootScope.voucher.selected.vouchertype_id);
          if (!$rootScope.voucher.selected.voucherline) {
            $rootScope.voucher.selected.voucherline = [];
          }
          if (!$rootScope.voucher.selected.stockorder) {
            $rootScope.voucher.selected.stockorder = {
              stockadjustment: [],
              status: 0
            };
          }
        };
        $rootScope.copyVoucherLines = function(voucher){
          $rootScope.voucher.selected.voucherline = [];
          $rootScope.voucher.selected.stockorder = null;
          angular.forEach(voucher.voucherline, function(i){
            console.log('loading', i , i.product);
            var x = $rootScope.getCompleteStock(i.product, $rootScope.voucher.selected.warehouse_id);
            console.log('total stock', x);
            if (x >= i.quantity) {

            }
            else{
              i.blocked = true;
              //toastr.warning('Stock insuficiente: '+i.product.description, 'No se puede cargar');
            }
            i.quantity_original = angular.copy(i.quantity);
            i.note = 'Cant. Original: '+ angular.copy(i.quantity);
            i.quantity = 0;
            $rootScope.voucher.selected.voucherline.push(i);
          });
          $rootScope.voucher.selected.vouchertypeSource =   voucher.vouchertype_id;
          $rootScope.voucher.selected.partner =   voucher.partner;
          $rootScope.voucher.selected.partner_id = voucher.partner_id;
          $rootScope.voucher.selected.partnerrelated =  voucher.partnerrelated;
          $rootScope.voucher.selected.partner_related = voucher.partner_related;
        };
        $rootScope.setVoucherRelated = function (voucher){
          $rootScope.voucher.selected.voucher_related = voucher.id;
          if(voucher.vouchertype_id == 10){
            $rootScope.nextStep = 'uideliveryprog';
          }
        };
        //PRODUCTS PICKER
        $rootScope.addLine = function (item) {
          console.log('insertando voucherline', item);
          var newLine = {
            product_id: item.id,
            product: item,
            group: (item.group)?item.group:'',
            min: (item.min)?item.min:'',
            max: (item.max)?item.max:'',
            value: 0,
            quantity: 0,
            quantity_expected: 0,
            quantity_issued: 0,
            stock: 0,
            status: 0,
            stockadjustment: []
          };
          console.log('newLine',newLine);
          $rootScope.addToList($rootScope.voucher.selected.voucherline, newLine, 'product_id');
          console.log('salida voucherline', $rootScope.voucher.selected);
        };
        $rootScope.addMany = function(itemsList){
          angular.forEach(itemsList, function (item) {
            $rootScope.addLine(item);
            var first = $rootScope.getFirstEnabled(item, $rootScope.voucher.selected.warehouse_id);
            //$rootScope.addStock(first);
            if(first.length>0){
              $rootScope.addStock(first[0]);
            }

          });
        };
        $rootScope.addStock = function (stock) {
          console.log('insertando stockadjustment 0', stock);
          stock.stock_id = stock.id;
          stock.quantity = 0;
          stock.quantity_expected = 0;
          stock.quantity_issued = 0;
          stock.active = true;
          console.log('insertando stockadjustment 1', stock);
          $rootScope.addToList(
            $rootScope.voucher.selected.stockorder.stockadjustment,
            stock,
            'stock_id'
          );
          console.log('insertando stockadjustment 2', stock);
          console.log('salida stockadjustment', $rootScope.voucher.selected);
        };
        $rootScope.newStockBatch = function (product){
          console.log('insertando stockadjustment', product);
          var stock = {};
          stock.product_id = product.id;
          stock.warehouse_id = $rootScope.voucher.selected.warehouse_id2;
          stock.quantity = 0;
          stock.quantity_expected = 0;
          stock.quantity_issued = 0;
          stock.batchcode =  '';
          stock.isNew = true;
          stock.active = true;
          console.log('temporal',$rootScope.voucher.selected);
          $rootScope.voucher.selected.stockorder.stockadjustment.push(stock);
        };
        $rootScope.getFirstEnabled = function (items, warehouseId) {
          var exit = [];
          angular.forEach(items.stock, function (i){
            if(i.warehouse_id == warehouseId && i.current_stock > 0){
              exit.push(i);
            }
          });
          return exit;
        };
        //PRODUCT PICKER TO SHOW ON UICONTEXTUAL MENU
        $rootScope.setPicked = function(id){
          console.log('setPicked',id);
          //picked = product.id
          $rootScope.voucher.picked=id;
          $rootScope.infoMenu = true;
          $timeout(function () {
            $rootScope.tab = 3;
          }, 200);
          $rootScope.tab = 3;
        };
        //CALCULATES TOTAL AMOUNTH
        $rootScope.globalTotal = 0;
        $rootScope.othersTotal = 0;
        $rootScope.calculateTotal = function (quantity, price, discount) {
          $rootScope.globalTotal = 0;
          angular.forEach($rootScope.voucher.selected.voucherline, function (value, key) {
            //console.log('calculateTotal',value, value[quantity], value[price])
            var sum = 0;
            var discount = 0;
            value.quantity = value.quantity ? value.quantity : 0;
            value[quantity] = Math.round(value[quantity]);
            if (parseFloat(value[quantity]) > 0 && parseFloat(value[price])  > 0) {
              console.log('modificando', value.discount);
              if(value.discount){
                discount = (parseFloat(value[price]) * parseFloat(value.discount/100));
                //console.log('descuento calculado', discount)
                discount = discount.toFixed(2);
              }
              sum = parseFloat(value[quantity]) * (parseFloat(value[price]) - discount) ;
              value.sub = parseFloat(value[quantity]) * (parseFloat(value[price]) - discount);
              value.sub = value.sub.toFixed(2);
            }
            $rootScope.globalTotal += sum;
          });
          $rootScope.globalTotal = $rootScope.globalTotal.toFixed(2);
          var globalTotal = parseFloat($rootScope.globalTotal + $rootScope.othersTotal);
          var globalTotal2 = parseFloat(globalTotal.toFixed(2));
          $rootScope.voucher.selected.total = globalTotal2;

        };
        $rootScope.calculateSubTotal = function (target) {
          var sub = 0;
          console.log('calculateSubTotal',target);
          angular.forEach($rootScope.getSubitems(target), function (value, key) {
            console.log('line', value);
            if(!value.quantity){
              value.quantity = 0;
            }
            console.log('0',parseInt(value.quantity) , parseInt(value.current_stock))
            if(parseInt(value.quantity) > parseInt(value.current_stock)){
              value.quantity = parseInt(value.current_stock);
              value.limitHelp = parseInt(value.current_stock);
              toastr.warning('Límite excedido', 'Advertencia');
            }
            sub += parseInt(value.quantity);
          });
          target.quantity = sub;
          $rootScope.calculateTotal('quantity','value');
          return sub;
        };
        $rootScope.calculateIssuedTotal = function (target) {
          var sub = 0;
          console.log('calculateIssuedTotal',target);
          angular.forEach($rootScope.getSubitems(target), function (value, key) {
            console.log('line',value);
            if(!value.quantity_issued){
              value.quantity_issued = 0;
            }
            if(value.quantity_issued > 0 && $rootScope.voucher.selected.stockorder.type==true){
            //if(value.quantity_issued > 0){
              console.log('case 1', value);
              if ($rootScope.voucher.selected.warehouse_id){
                var check1 = 0;
                if(value.product.stock){
                  angular.forEach(value.product.stock, function (st) {
                    console.log('st',st,  $rootScope.voucher.selected.warehouse_id, value.batchcode);
                    if (st.warehouse_id == $rootScope.voucher.selected.warehouse_id && st.batchcode == value.batchcode) {
                      check1 = st.current_stock;

                    }
                  });
                }
                if( value.quantity_issued > check1 ){
                  value.quantity_issued = check1;
                  toastr.warning('Límite excedido', 'Advertencia');
                }
              }
            }
            else{
              if ($rootScope.voucher.selected.warehouse_id2){
                console.log('case 2');
                var check2 = 0;
                angular.forEach(value.product.stock, function(st){
                  if(st.warehouse_id == $rootScope.voucher.selected.warehouse_id2 && st.batchcode == value.batchcode){
                    check2 = st.current_stock;
                  }
                });
                if( (value.quantity_issued) > check2 ){
                  value.quantity_issued = check2 ;
                  toastr.warning('Límite excedido', 'Advertencia');
                }
              }
            }

            sub += value.quantity_issued;
          });
          target.quantity_issued = sub;
          target.quantity = target.quantity ? target.quantity : 0;

          if(target.older_issued){
            console.log('reajustado',  target.quantity , target.quantity_issued  , target.older_issued);
            //target.quantity_expected = target.quantity - target.quantity_issued  - target.older_issued;
            target.quantity_expected = target.quantity - (($rootScope.voucher.selected.stockorder.type==false)?target.quantity_issued*-1:target.quantity_issued)  - target.older_issued;
          }
          else{
            //target.quantity_expected = target.quantity - target.quantity_issued ;
            target.quantity_expected = target.quantity - (($rootScope.voucher.selected.stockorder.type==false)?target.quantity_issued*-1:target.quantity_issued)  ;
          }

          //$rootScope.calculateTotal('quantity','value');
          return sub;
        };
        $rootScope.calculateOthersTotal = function () {
          $rootScope.othersTotal = 0;
          if ($rootScope.voucher.selected.other_amount) {
            $rootScope.othersTotal += $rootScope.voucher.selected.other_amount;
          }
          if ($rootScope.voucher.selected.transport_amount) {
            $rootScope.othersTotal += $rootScope.voucher.selected.transport_amount;
          }
          $rootScope.othersTotal = parseFloat($rootScope.othersTotal.toFixed(2));
          $rootScope.voucher.selected.othersTotal = $rootScope.othersTotal;
          var total = parseFloat($rootScope.globalTotal + $rootScope.othersTotal);
          var total2 = parseFloat(total.toFixed(2));
          $rootScope.voucher.selected.total = total2;
        };
        $rootScope.searchDiscount = function(){
          if($rootScope.voucher.selected.voucherline && $rootScope.currentModule == 'sales'){
            angular.forEach($rootScope.voucher.selected.voucherline, function(value){
              value.discount = 0;
              angular.forEach(value.product.productgroup,function(p){
                if($rootScope.voucher.selected.partner){
                  if($rootScope.voucher.selected.partner.partnerdiscount){
                    console.log('Descuentos partner', $rootScope.voucher.selected.partner.partnerdiscount);
                    angular.forEach($rootScope.voucher.selected.partner.partnerdiscount ,function (i){
                      if (p.id == i.productgroup_id) {
                        value.discount = i.discount;
                      }
                    });
                  }
                }
              });
            });
            $rootScope.calculateTotal('quantity','value');
          }
        };
        $rootScope.getCompleteStock = function(product, warehouse_id){
          var total = 0;
          //console.log('getCompleteStock', product, warehouse_id),
          if(product.stock){
            if(warehouse_id){
              angular.forEach(product.stock, function(p){
                if(p.warehouse_id == warehouse_id){
                  total += parseInt(p.current_stock);
                }
              });
            }
            else{
              angular.forEach(product.stock, function(p){
                total += parseInt(p.current_stock);
              });
            }
          }

          return total;
        };
        $rootScope.getStockItem = function(items, id, field){
          var exit = 'no asignado';
          angular.forEach(items.stock, function(s){
            if(s.id == id){
              exit= s[field];
            }
          });
          return exit;
        };
        $rootScope.getSubitems = function (item){
          console.log('buscando subitems', item);
          var list = [];
          angular.forEach($rootScope.voucher.selected.stockorder.stockadjustment, function(st){
            //console.log('st',st)
            if(st.product_id == item.product_id){
              list.push(st)
            }
          });
          console.log('subitems',list);
          return list;
        };
        $rootScope.getStockSum = function(items) {
          return items
            .map(function(x) { return x.current_stock; })
            .reduce(function(a, b) { return a + b; });
        };
        $rootScope.getWarehousename = function(id){
          var control = false;
          var exit = '';
          //console.log('getWarehousename',$rootScope.voucher.properties.warehouse_id.items, id);
          if($rootScope.voucher.properties.warehouse_id.items){
            angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w){
              if (w.id == id && !control){
                control = true;
                exit = w.name;
              }
            });
          }
          return exit;
        };
        $rootScope.getUnitcost = function (item,warehouse_id){
          var exit = 0;
          console.log('getUnitcost',item,warehouse_id);
          angular.forEach(item.unitcosts, function(i){
            if(warehouse_id == i.warehouse_id){
              exit = i.unit_cost;
            }
          });
          console.log('getUnitcost',exit);
          return exit;
        };
        $rootScope.getCurrentkardex = function (item,warehouse_id){
          var exit = 0;
          console.log('getCurrentkardex',item,warehouse_id);
          angular.forEach(item.unitcosts, function(i){
            if(warehouse_id == i.warehouse_id){
              exit = i;
            }
          });
          console.log('getCurrentkardex',exit);
          return exit;
        };
        $rootScope.checkGoodStock = function(item){
          var tot = 0;
          angular.forEach(item.stock, function(i){
            if(i.warehouse_id == $rootScope.voucher.selected.warehouse_id){
              tot += i.current_stock;
            }
          });
          return tot;
        };
        $rootScope.fillVoucherline = function(register,st){
          console.log('fillVoucherline',register,st);
          if(st.quantity_issued > st.current_stock && $rootScope.voucher.selected.stockorder.type == true){
            st.quantity_issued  = st.current_stock;
            toastr.warning('Stock insuficiente', 'Error');
          }
          angular.forEach($rootScope.voucher.selected.voucherline,function(i){
            i.quantity = 0;
            angular.forEach($rootScope.voucher.selected.stockorder.stockadjustment,function(j){
              if(i.product_id == j.product_id){
                i.quantity += j.quantity_issued;
              }
            });
          });
          $rootScope.calculateIssuedTotal(register,st);
        };
        //Watchers
        $rootScope.$watch( 'voucher.ready', function () {
          if($rootScope.globalPartner){
            switch ($rootScope.currentState) {
              case 'sales-debts':
                TablesService.filtrar('voucher', {
                  filters: {
                    credit_amount: {
                      value: 1,
                      operator: '>'
                    },
                    vouchertype_id: {
                      value: 9,
                    },
                    partner_id: {
                      value: $rootScope.globalPartner.id,
                    }
                  }
                })
                  .success(function (res) {
                    if (res.status) {
                      $rootScope.voucher.dataset = res.result;
                    }
                  });
                console.log('grid global');
                break;
            }
          }
        });
        ///////////////////////////////////////////////////
        //////////////CUSTOMIZATION GUIBDENTAL/////////////
        ///////////////////////////////////////////////////


        //creates new inner crud
        $rootScope.setSelector = function (modelName, selected, actionType, parentModel) {
          console.log('ingresa:', modelName, selected, actionType);
          console.log('seleccionado inner crud', selected);
          var params = {
            component: 'uiselector',
            model: modelName,
            parentModel: parentModel,
            actionType: actionType,

          };
          $rootScope.uiConf.switchView('new', params, true);
        };

      }
    }
  });

'use strict';
/**
 * Created by FER-PC-WIN10 on 25/05/2016.
 */
angular.module('frontendapp')
  .directive('uiBreadcrumbs', ['$interpolate', '$state','$rootScope', function ($interpolate, $state, $rootScope) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/scripts/directives/uiBreadcrumbs/uiBreadcrumbs.tpl.html',
      //templateUrl: 'app/views/directives/crud/crud.html',
      scope: {
        displaynameProperty: '@',
        fakeLabelParent: '=',
        abstractProxyProperty: '@?'
      },
      link: function (scope) {
        $rootScope.$watch('crudTitle', function() {
          scope.titulo = $rootScope.crudTitle;
        });
        //console.log('!!!!!!!!!',$rootScope.api)
        scope.breadcrumbs = [];
        if ($state.$current.name !== '') {
          updateBreadcrumbsArray();
        }
        scope.currentModule = $rootScope.currentModule;
        scope.$on('$stateChangeSuccess', function () {
          updateBreadcrumbsArray();
          scope.titulo = $rootScope.crudTitle;
          scope.currentModule = $rootScope.currentModule;
          //$rootScope.currentSec
        });
        /**
         * Start with the current state and traverse up the path to build the
         * array of breadcrumbs that can be used in an ng-repeat in the template.
         */
        function updateBreadcrumbsArray() {
          var workingState;
          var displayName;
          var breadcrumbs = [];
          var currentState = $state.$current;
          while (currentState && currentState.name !== '') {
            workingState = getWorkingState(currentState);
            if (workingState) {
              displayName = getDisplayName(workingState);
              if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                var size = currentState.name.split('.');
                var discard = [ 'select', 'password', 'view', 'review'];
                if($state.$current.name == currentState.name && ((size.length > 1 && discard.indexOf(size[1]) >= 0))){
                  console.log('final!!! 2', currentState.name)
                  displayName = displayName + scope.titulo;
                }
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                breadcrumbs.push({
                  displayName: displayName,
                  route: workingState.name
                });
              }
            }
            currentState = currentState.parent;
          }
          breadcrumbs.reverse();
          scope.breadcrumbs = breadcrumbs;
        }

        /**
         * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
         * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
         * set it to `false` which means this breadcrumb level will be skipped entirely.
         * @param currentState
         * @returns {*}
         */
        function getWorkingState(currentState) {
          var proxyStateName;
          var workingState = currentState;
          if (currentState.abstract === true) {
            if (typeof scope.abstractProxyProperty !== 'undefined') {
              proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
              if (proxyStateName) {
                workingState = angular.copy($state.get(proxyStateName));
                if (workingState) {
                  workingState.locals = currentState.locals;
                }
              } else {
                workingState = false;
              }
            } else {
              workingState = false;
            }
          }
          return workingState;
        }

        /**
         * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
         * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
         * properties on the state config object, by using the usual {{ }} syntax.
         * @param currentState
         * @returns {*}
         */
        function getDisplayName(currentState) {
          var interpolationContext;
          var propertyReference;
          var displayName;
          if (!scope.displaynameProperty) {
            // if the displayname-property attribute was not specified, default to the state's name
            return currentState.name;
          }
          propertyReference = getObjectValue(scope.displaynameProperty, currentState);
          if (propertyReference === false) {
            return false;
          } else if (typeof propertyReference === 'undefined') {
            return currentState.name;
          } else {
            // use the $interpolate service to handle any bindings in the propertyReference string.
            interpolationContext = (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState;
            displayName = $interpolate(propertyReference)(interpolationContext);
            return displayName;
          }
        }

        /**
         * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
         * value found at that path.
         *
         * @param objectPath
         * @param context
         * @returns {*}
         */
        function getObjectValue(objectPath, context) {
          var i;
          var propertyArray = objectPath.split('.');
          var propertyReference = context;
          for (i = 0; i < propertyArray.length; i++) {
            if (angular.isDefined(propertyReference[propertyArray[i]])) {
              propertyReference = propertyReference[propertyArray[i]];
            } else {
              // if the specified property was not found, default to the state's name
              return undefined;
            }
          }
          return propertyReference;
        }

        /**
         * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
         * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
         * @param state
         * @param breadcrumbs
         * @returns {boolean}
         */
        function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
          var i;
          var alreadyUsed = false;
          for (i = 0; i < breadcrumbs.length; i++) {
            if (breadcrumbs[i].route === state.name) {
              alreadyUsed = true;
            }
          }
          return alreadyUsed;
        }
      }
    };
  }]);

'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */

angular.module('frontendapp')
  .directive('mydatepicker', function () {
    return {
      templateUrl: 'app/scripts/directives/datepicker/datepicker.html',
      restrict: "E",
      scope: {
        ngModel: "=",
        ngChange: "=",
        ngSubmit: "=",
        ngRequired: "=",
        dateOptions: "=",
        opened: "=",
        pl: "@",
        format:"@"
      },
      link: function ($scope, element, attrs) {
        $scope.open = function (event) {
          event.preventDefault();
          event.stopPropagation();
          $scope.opened = true;
        };
        //console.log('datepicker',$scope.dateRequired);
        //$scope.format = 'yyyy/MM/dd';
        $scope.clear = function () {
          $scope.ngModel = null;
        };
      },

      controller: function uicomboController($uibModal, $scope, $rootScope) {
        $scope.$watch('ngModel',function(){
          if($scope.ngSubmit && $scope.ngModel != null){
            $scope.older = angular.copy($scope.ngModel);
            $scope.$parent[$scope.ngSubmit]();
          }
        },true);
      }

    }
  });

'use strict';
angular.module('frontendapp')
  .directive('appcontextmenu', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/appcontextmenu/appcontextmenu.html',
      restrict: 'E',
      replace: true,
      scope: {
        menuItems: '=',
        menuTitle: '@',
        menuDepth: '@',
        menuClass: '@',
      },
      rootScope: $rootScope,
      controller: function ($scope, $rootScope, $state, $auth, $location,
                            $log, UserService, localStorageService,
                            TablesService, $window, $modal) {


        $scope.infoMenu = $rootScope.infoMenu;

        $scope.showInfoMenu = function () {
          $rootScope.showInfoMenu()
        };

        $scope.stateGo = function (state, params) {
          $state.go(state, params);
        };

        $scope.currentState = $rootScope.currentState;

        $rootScope.$on('$stateChangeSuccess',
          function (event, toState) {
            $scope.currentState = $rootScope.currentState;
          });

        $rootScope.$watch('currentModule',function(){
          //$scope.currentModule = $rootScope.currentModule
        });

        $rootScope.$watch('infoMenu',function(){
          $scope.infoMenu = $rootScope.infoMenu;
        });



      }

      //////END CONTROLLER ////////
    }
  });

'use strict';
angular.module('frontendapp')
  .directive('appmenu', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/appmenu/appmenu.html',
      restrict: 'E',
      replace: true,
      scope: {
        menuItems: '=',
        menuTitle: '@',
        menuDepth: '@',
        menuClass: '@',
      },
      rootScope: $rootScope,
      controller: function ($scope, $rootScope, $state, $auth, $location,
                            $log, UserService, localStorageService,
                            TablesService, $window, $modal) {

        $scope.appMenu = false;

        $scope.showAppMenu = function (value) {
          console.log('infoMenu');
          $scope.appMenu = value?value:!$scope.appMenu;
        };

        $scope.stateGo = function (state, params) {
          $state.go(state, params);
        };

        $scope.initAppMenu = function(){
          $scope.currentLevel = 0;
          $scope.menuLevels = [];
          for (var i = 0 ; i < parseInt($scope.menuDepth); i++){
            $scope.menuLevels.push($scope.menuItems);
          }
        };

        $scope.initAppMenu();

        $scope.currentState = $rootScope.currentState;

        $rootScope.$on('$stateChangeSuccess',
          function (event, toState) {
            $scope.currentState = $rootScope.currentState;
            //$scope.showAppMenu(false);
            $scope.appMenu = false;
          });

        $rootScope.$watch('currentModule',function(){
          // console.log('deteca cambio');
          $scope.menuItems = $rootScope.appMenuItems[$rootScope.currentModule];
          $scope.initAppMenu();
        });

        $scope.selectItems=function(data, index, name ){
          console.log(index, data)
          $scope.menuLevels[index+1] = data.items;
          $scope.currentLevel ++;
        };

        $scope.showParent = function(){
          $scope.currentLevel--;
        };

        $scope.userPopover = {
          templateUrl: 'userPopover.html',
        };

        $scope.appPopover = {
          templateUrl: 'appPopover.html',
        };

        $scope.logout = function(){
          $rootScope.logout();
        };

        $scope.switchModule = function(value){
          $rootScope.switchModule(value);
        };

      }

      //////END CONTROLLER ////////
    }
  });

'use strict';
angular
  .module('frontendapp')
  .factory('UserService', function ($http, $rootScope) {
    return {
      actualizarToken: function () {
        return $http.get($rootScope.api + '/api/authenticate/refresh?token=' + $rootScope.tk);
      },
      owneraccount: function () {
        var params = {
          'token': $rootScope.tk
        };
        return $http.post($rootScope.api + '/api/authenticate/owneraccount', params);
      },
      updateclientprofile: function (params) {
        params.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/authenticate/updateaccount', params);
      },
      usercp: function (params) {
        params.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/authenticate/newpassword', params);
      },
      usernotification: function (params) {
        params.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/authenticate/usernotification', params);
      },
      forgotpassword: function (params) {
        return $http.post($rootScope.api + '/api/authenticate/forgotpassword', params);
      },
      checklink: function (params) {
        return $http.post($rootScope.api + '/api/authenticate/chekforgotlink', params);
      },
      resetforgotten: function (params) {
        return $http.post($rootScope.api + '/api/authenticate/resetpassword', params);
      }


    };
  });

'use strict';
angular
  .module('frontendapp')
  .factory('TablesService', function ($http, $rootScope) {
    return {
      listar: function (tabla) {
        var params = [];
        //params['lan'] = 'en';
        return $http.get($rootScope.api + '/api/' + tabla, params);
      },
      filtrar: function (tabla, params) {
        console.log('getdata params',tabla,  params);
        params['token'] = $rootScope.tk;
        params.currentState = $rootScope.currentState;
        return $http.post($rootScope.api + '/api/' + tabla + '/getdata', params);
      },
      find: function (tabla, id, params) {
        console.log('find params',tabla, id,  params);
        params['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/find/' + id, params);
      },
      contactar: function (params) {
        params['lan'] = $rootScope.language != undefined ? $rootScope.language : 'en';
        return $http.post($rootScope.api + '/api/formcontacto/almacenar', params);
      },
      estructura: function (tabla) {
        return $http.get($rootScope.api + '/api/' + tabla + '/estructura');
      },
      almacenar: function (tabla, parametros) {
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/store', parametros);
      },
      storemany: function (tabla, parametros) {
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/storemany', parametros);
      },
      actualizar: function (tabla, id, parametros) {
        parametros['token'] = $rootScope.tk;
        console.log('BEFORE',tabla, parametros);
        return $http.post($rootScope.api + '/api/' + tabla + '/update/' + id, parametros);
      },
      cargar: function (tabla, id, parametros) {
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/upload/' + id, parametros);
      },
      eliminar: function (tabla, id, parametros) {
        if (parametros == null) {
          parametros = {};
        }
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/delete/' + id, parametros);
      },
      visualizar: function (tabla, id) {
        var params = {
          'token': $rootScope.tk,
          'lan': $rootScope.language != undefined ? $rootScope.language : 'en'
        };
        return $http.get($rootScope.api + '/api/' + tabla + '/visualizar/' + id, params);
      },

      generate: function (parametros) {
        // parametros['token'] = $rootScope.tk;
        //////console.log('PRAMETROS', parametros)
        return $http.post($rootScope.api + '/api/facts/generate', parametros);
      },
      getTable: function (parametros) {
        return $http.post($rootScope.api + '/api/core/gettable', parametros);
      },
      getTableColumns: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/core/gettablecolumns', parametros);
      },
      corebuild: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/core/build', parametros);
      },
      notifications: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/not', parametros);
      },
    };
  });

/**
 * Created by FER-PC-WIN10 on 03/05/2016.
 */
(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('renderHtml', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.renderHtml);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    });
})();

/* -----------------------------------------------
 /* Author : Vincent Garreau  - vincentgarreau.com
 /* MIT license: http://opensource.org/licenses/MIT
 /* Demo / Generator : vincentgarreau.com/particles.js
 /* GitHub : github.com/VincentGarreau/particles.js
 /* How to use? : Check the GitHub README
 /* v2.0.0
 /* ----------------------------------------------- */
function hexToRgb(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(a, function (e, a, t, i) {
    return a + a + t + t + i + i
  });
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16)} : null
}
function clamp(e, a, t) {
  return Math.min(Math.max(e, a), t)
}
function isInArray(e, a) {
  return a.indexOf(e) > -1
}
var pJS = function (e, a) {
  var t = document.querySelector("#" + e + " > .particles-js-canvas-el");
  this.pJS = {
    canvas: {el: t, w: t.offsetWidth, h: t.offsetHeight},
    particles: {
      number: {value: 400, density: {enable: !0, value_area: 800}},
      color: {value: "#fff"},
      shape: {
        type: "circle",
        stroke: {width: 0, color: "#ff0000"},
        polygon: {nb_sides: 5},
        image: {src: "", width: 100, height: 100}
      },
      opacity: {value: 1, random: !1, anim: {enable: !1, speed: 2, opacity_min: 0, sync: !1}},
      size: {value: 20, random: !1, anim: {enable: !1, speed: 20, size_min: 0, sync: !1}},
      line_linked: {enable: !0, distance: 100, color: "#fff", opacity: 1, width: 1},
      move: {
        enable: !0,
        speed: 2,
        direction: "none",
        random: !1,
        straight: !1,
        out_mode: "out",
        bounce: !1,
        attract: {enable: !1, rotateX: 3e3, rotateY: 3e3}
      },
      array: []
    },
    interactivity: {
      detect_on: "canvas",
      events: {onhover: {enable: !0, mode: "grab"}, onclick: {enable: !0, mode: "push"}, resize: !0},
      modes: {
        grab: {distance: 100, line_linked: {opacity: 1}},
        bubble: {distance: 200, size: 80, duration: .4},
        repulse: {distance: 200, duration: .4},
        push: {particles_nb: 4},
        remove: {particles_nb: 2}
      },
      mouse: {}
    },
    retina_detect: !1,
    fn: {interact: {}, modes: {}, vendors: {}},
    tmp: {}
  };
  var i = this.pJS;
  a && Object.deepExtend(i, a), i.tmp.obj = {
    size_value: i.particles.size.value,
    size_anim_speed: i.particles.size.anim.speed,
    move_speed: i.particles.move.speed,
    line_linked_distance: i.particles.line_linked.distance,
    line_linked_width: i.particles.line_linked.width,
    mode_grab_distance: i.interactivity.modes.grab.distance,
    mode_bubble_distance: i.interactivity.modes.bubble.distance,
    mode_bubble_size: i.interactivity.modes.bubble.size,
    mode_repulse_distance: i.interactivity.modes.repulse.distance
  }, i.fn.retinaInit = function () {
    i.retina_detect && window.devicePixelRatio > 1 ? (i.canvas.pxratio = window.devicePixelRatio, i.tmp.retina = !0) : (i.canvas.pxratio = 1, i.tmp.retina = !1), i.canvas.w = i.canvas.el.offsetWidth * i.canvas.pxratio, i.canvas.h = i.canvas.el.offsetHeight * i.canvas.pxratio, i.particles.size.value = i.tmp.obj.size_value * i.canvas.pxratio, i.particles.size.anim.speed = i.tmp.obj.size_anim_speed * i.canvas.pxratio, i.particles.move.speed = i.tmp.obj.move_speed * i.canvas.pxratio, i.particles.line_linked.distance = i.tmp.obj.line_linked_distance * i.canvas.pxratio, i.interactivity.modes.grab.distance = i.tmp.obj.mode_grab_distance * i.canvas.pxratio, i.interactivity.modes.bubble.distance = i.tmp.obj.mode_bubble_distance * i.canvas.pxratio, i.particles.line_linked.width = i.tmp.obj.line_linked_width * i.canvas.pxratio, i.interactivity.modes.bubble.size = i.tmp.obj.mode_bubble_size * i.canvas.pxratio, i.interactivity.modes.repulse.distance = i.tmp.obj.mode_repulse_distance * i.canvas.pxratio
  }, i.fn.canvasInit = function () {
    i.canvas.ctx = i.canvas.el.getContext("2d")
  }, i.fn.canvasSize = function () {
    i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i && i.interactivity.events.resize && window.addEventListener("resize", function () {
      i.canvas.w = i.canvas.el.offsetWidth, i.canvas.h = i.canvas.el.offsetHeight, i.tmp.retina && (i.canvas.w *= i.canvas.pxratio, i.canvas.h *= i.canvas.pxratio), i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i.particles.move.enable || (i.fn.particlesEmpty(), i.fn.particlesCreate(), i.fn.particlesDraw(), i.fn.vendors.densityAutoParticles()), i.fn.vendors.densityAutoParticles()
    })
  }, i.fn.canvasPaint = function () {
    i.canvas.ctx.fillRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.canvasClear = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.particle = function (e, a, t) {
    if (this.radius = (i.particles.size.random ? Math.random() : 1) * i.particles.size.value, i.particles.size.anim.enable && (this.size_status = !1, this.vs = i.particles.size.anim.speed / 100, i.particles.size.anim.sync || (this.vs = this.vs * Math.random())), this.x = t ? t.x : Math.random() * i.canvas.w, this.y = t ? t.y : Math.random() * i.canvas.h, this.x > i.canvas.w - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), this.y > i.canvas.h - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), i.particles.move.bounce && i.fn.vendors.checkOverlap(this, t), this.color = {}, "object" == typeof e.value)if (e.value instanceof Array) {
      var s = e.value[Math.floor(Math.random() * i.particles.color.value.length)];
      this.color.rgb = hexToRgb(s)
    } else void 0 != e.value.r && void 0 != e.value.g && void 0 != e.value.b && (this.color.rgb = {
      r: e.value.r,
      g: e.value.g,
      b: e.value.b
    }), void 0 != e.value.h && void 0 != e.value.s && void 0 != e.value.l && (this.color.hsl = {
      h: e.value.h,
      s: e.value.s,
      l: e.value.l
    }); else"random" == e.value ? this.color.rgb = {
      r: Math.floor(256 * Math.random()) + 0,
      g: Math.floor(256 * Math.random()) + 0,
      b: Math.floor(256 * Math.random()) + 0
    } : "string" == typeof e.value && (this.color = e, this.color.rgb = hexToRgb(this.color.value));
    this.opacity = (i.particles.opacity.random ? Math.random() : 1) * i.particles.opacity.value, i.particles.opacity.anim.enable && (this.opacity_status = !1, this.vo = i.particles.opacity.anim.speed / 100, i.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
    var n = {};
    switch (i.particles.move.direction) {
      case"top":
        n = {x: 0, y: -1};
        break;
      case"top-right":
        n = {x: .5, y: -.5};
        break;
      case"right":
        n = {x: 1, y: -0};
        break;
      case"bottom-right":
        n = {x: .5, y: .5};
        break;
      case"bottom":
        n = {x: 0, y: 1};
        break;
      case"bottom-left":
        n = {x: -.5, y: 1};
        break;
      case"left":
        n = {x: -1, y: 0};
        break;
      case"top-left":
        n = {x: -.5, y: -.5};
        break;
      default:
        n = {x: 0, y: 0}
    }
    i.particles.move.straight ? (this.vx = n.x, this.vy = n.y, i.particles.move.random && (this.vx = this.vx * Math.random(), this.vy = this.vy * Math.random())) : (this.vx = n.x + Math.random() - .5, this.vy = n.y + Math.random() - .5), this.vx_i = this.vx, this.vy_i = this.vy;
    var r = i.particles.shape.type;
    if ("object" == typeof r) {
      if (r instanceof Array) {
        var c = r[Math.floor(Math.random() * r.length)];
        this.shape = c
      }
    } else this.shape = r;
    if ("image" == this.shape) {
      var o = i.particles.shape;
      this.img = {
        src: o.image.src,
        ratio: o.image.width / o.image.height
      }, this.img.ratio || (this.img.ratio = 1), "svg" == i.tmp.img_type && void 0 != i.tmp.source_svg && (i.fn.vendors.createSvgImg(this), i.tmp.pushing && (this.img.loaded = !1))
    }
  }, i.fn.particle.prototype.draw = function () {
    function e() {
      i.canvas.ctx.drawImage(r, a.x - t, a.y - t, 2 * t, 2 * t / a.img.ratio)
    }

    var a = this;
    if (void 0 != a.radius_bubble)var t = a.radius_bubble; else var t = a.radius;
    if (void 0 != a.opacity_bubble)var s = a.opacity_bubble; else var s = a.opacity;
    if (a.color.rgb)var n = "rgba(" + a.color.rgb.r + "," + a.color.rgb.g + "," + a.color.rgb.b + "," + s + ")"; else var n = "hsla(" + a.color.hsl.h + "," + a.color.hsl.s + "%," + a.color.hsl.l + "%," + s + ")";
    switch (i.canvas.ctx.fillStyle = n, i.canvas.ctx.beginPath(), a.shape) {
      case"circle":
        i.canvas.ctx.arc(a.x, a.y, t, 0, 2 * Math.PI, !1);
        break;
      case"edge":
        i.canvas.ctx.rect(a.x - t, a.y - t, 2 * t, 2 * t);
        break;
      case"triangle":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t, a.y + t / 1.66, 2 * t, 3, 2);
        break;
      case"polygon":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t / (i.particles.shape.polygon.nb_sides / 3.5), a.y - t / .76, 2.66 * t / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 1);
        break;
      case"star":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - 2 * t / (i.particles.shape.polygon.nb_sides / 4), a.y - t / 1.52, 2 * t * 2.66 / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 2);
        break;
      case"image":
        if ("svg" == i.tmp.img_type)var r = a.img.obj; else var r = i.tmp.img_obj;
        r && e()
    }
    i.canvas.ctx.closePath(), i.particles.shape.stroke.width > 0 && (i.canvas.ctx.strokeStyle = i.particles.shape.stroke.color, i.canvas.ctx.lineWidth = i.particles.shape.stroke.width, i.canvas.ctx.stroke()), i.canvas.ctx.fill()
  }, i.fn.particlesCreate = function () {
    for (var e = 0; e < i.particles.number.value; e++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value))
  }, i.fn.particlesUpdate = function () {
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      if (i.particles.move.enable) {
        var t = i.particles.move.speed / 2;
        a.x += a.vx * t, a.y += a.vy * t
      }
      if (i.particles.opacity.anim.enable && (1 == a.opacity_status ? (a.opacity >= i.particles.opacity.value && (a.opacity_status = !1), a.opacity += a.vo) : (a.opacity <= i.particles.opacity.anim.opacity_min && (a.opacity_status = !0), a.opacity -= a.vo), a.opacity < 0 && (a.opacity = 0)), i.particles.size.anim.enable && (1 == a.size_status ? (a.radius >= i.particles.size.value && (a.size_status = !1), a.radius += a.vs) : (a.radius <= i.particles.size.anim.size_min && (a.size_status = !0), a.radius -= a.vs), a.radius < 0 && (a.radius = 0)), "bounce" == i.particles.move.out_mode)var s = {
        x_left: a.radius,
        x_right: i.canvas.w,
        y_top: a.radius,
        y_bottom: i.canvas.h
      }; else var s = {
        x_left: -a.radius,
        x_right: i.canvas.w + a.radius,
        y_top: -a.radius,
        y_bottom: i.canvas.h + a.radius
      };
      switch (a.x - a.radius > i.canvas.w ? (a.x = s.x_left, a.y = Math.random() * i.canvas.h) : a.x + a.radius < 0 && (a.x = s.x_right, a.y = Math.random() * i.canvas.h), a.y - a.radius > i.canvas.h ? (a.y = s.y_top, a.x = Math.random() * i.canvas.w) : a.y + a.radius < 0 && (a.y = s.y_bottom, a.x = Math.random() * i.canvas.w), i.particles.move.out_mode) {
        case"bounce":
          a.x + a.radius > i.canvas.w ? a.vx = -a.vx : a.x - a.radius < 0 && (a.vx = -a.vx), a.y + a.radius > i.canvas.h ? a.vy = -a.vy : a.y - a.radius < 0 && (a.vy = -a.vy)
      }
      if (isInArray("grab", i.interactivity.events.onhover.mode) && i.fn.modes.grabParticle(a), (isInArray("bubble", i.interactivity.events.onhover.mode) || isInArray("bubble", i.interactivity.events.onclick.mode)) && i.fn.modes.bubbleParticle(a), (isInArray("repulse", i.interactivity.events.onhover.mode) || isInArray("repulse", i.interactivity.events.onclick.mode)) && i.fn.modes.repulseParticle(a), i.particles.line_linked.enable || i.particles.move.attract.enable)for (var n = e + 1; n < i.particles.array.length; n++) {
        var r = i.particles.array[n];
        i.particles.line_linked.enable && i.fn.interact.linkParticles(a, r), i.particles.move.attract.enable && i.fn.interact.attractParticles(a, r), i.particles.move.bounce && i.fn.interact.bounceParticles(a, r)
      }
    }
  }, i.fn.particlesDraw = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h), i.fn.particlesUpdate();
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      a.draw()
    }
  }, i.fn.particlesEmpty = function () {
    i.particles.array = []
  }, i.fn.particlesRefresh = function () {
    cancelRequestAnimFrame(i.fn.checkAnimFrame), cancelRequestAnimFrame(i.fn.drawAnimFrame), i.tmp.source_svg = void 0, i.tmp.img_obj = void 0, i.tmp.count_svg = 0, i.fn.particlesEmpty(), i.fn.canvasClear(), i.fn.vendors.start()
  }, i.fn.interact.linkParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = i.particles.line_linked.opacity - n / (1 / i.particles.line_linked.opacity) / i.particles.line_linked.distance;
      if (r > 0) {
        var c = i.particles.line_linked.color_rgb_line;
        i.canvas.ctx.strokeStyle = "rgba(" + c.r + "," + c.g + "," + c.b + "," + r + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(a.x, a.y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
      }
    }
  }, i.fn.interact.attractParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = t / (1e3 * i.particles.move.attract.rotateX), c = s / (1e3 * i.particles.move.attract.rotateY);
      e.vx -= r, e.vy -= c, a.vx += r, a.vy += c
    }
  }, i.fn.interact.bounceParticles = function (e, a) {
    var t = e.x - a.x, i = e.y - a.y, s = Math.sqrt(t * t + i * i), n = e.radius + a.radius;
    n >= s && (e.vx = -e.vx, e.vy = -e.vy, a.vx = -a.vx, a.vy = -a.vy)
  }, i.fn.modes.pushParticles = function (e, a) {
    i.tmp.pushing = !0;
    for (var t = 0; e > t; t++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value, {
      x: a ? a.pos_x : Math.random() * i.canvas.w,
      y: a ? a.pos_y : Math.random() * i.canvas.h
    })), t == e - 1 && (i.particles.move.enable || i.fn.particlesDraw(), i.tmp.pushing = !1)
  }, i.fn.modes.removeParticles = function (e) {
    i.particles.array.splice(0, e), i.particles.move.enable || i.fn.particlesDraw()
  }, i.fn.modes.bubbleParticle = function (e) {
    function a() {
      e.opacity_bubble = e.opacity, e.radius_bubble = e.radius
    }

    function t(a, t, s, n, c) {
      if (a != t)if (i.tmp.bubble_duration_end) {
        if (void 0 != s) {
          var o = n - p * (n - a) / i.interactivity.modes.bubble.duration, l = a - o;
          d = a + l, "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else if (r <= i.interactivity.modes.bubble.distance) {
        if (void 0 != s)var v = s; else var v = n;
        if (v != a) {
          var d = n - p * (n - a) / i.interactivity.modes.bubble.duration;
          "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else"size" == c && (e.radius_bubble = void 0), "opacity" == c && (e.opacity_bubble = void 0)
    }

    if (i.interactivity.events.onhover.enable && isInArray("bubble", i.interactivity.events.onhover.mode)) {
      var s = e.x - i.interactivity.mouse.pos_x, n = e.y - i.interactivity.mouse.pos_y, r = Math.sqrt(s * s + n * n), c = 1 - r / i.interactivity.modes.bubble.distance;
      if (r <= i.interactivity.modes.bubble.distance) {
        if (c >= 0 && "mousemove" == i.interactivity.status) {
          if (i.interactivity.modes.bubble.size != i.particles.size.value)if (i.interactivity.modes.bubble.size > i.particles.size.value) {
            var o = e.radius + i.interactivity.modes.bubble.size * c;
            o >= 0 && (e.radius_bubble = o)
          } else {
            var l = e.radius - i.interactivity.modes.bubble.size, o = e.radius - l * c;
            o > 0 ? e.radius_bubble = o : e.radius_bubble = 0
          }
          if (i.interactivity.modes.bubble.opacity != i.particles.opacity.value)if (i.interactivity.modes.bubble.opacity > i.particles.opacity.value) {
            var v = i.interactivity.modes.bubble.opacity * c;
            v > e.opacity && v <= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          } else {
            var v = e.opacity - (i.particles.opacity.value - i.interactivity.modes.bubble.opacity) * c;
            v < e.opacity && v >= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          }
        }
      } else a();
      "mouseleave" == i.interactivity.status && a()
    } else if (i.interactivity.events.onclick.enable && isInArray("bubble", i.interactivity.events.onclick.mode)) {
      if (i.tmp.bubble_clicking) {
        var s = e.x - i.interactivity.mouse.click_pos_x, n = e.y - i.interactivity.mouse.click_pos_y, r = Math.sqrt(s * s + n * n), p = ((new Date).getTime() - i.interactivity.mouse.click_time) / 1e3;
        p > i.interactivity.modes.bubble.duration && (i.tmp.bubble_duration_end = !0), p > 2 * i.interactivity.modes.bubble.duration && (i.tmp.bubble_clicking = !1, i.tmp.bubble_duration_end = !1)
      }
      i.tmp.bubble_clicking && (t(i.interactivity.modes.bubble.size, i.particles.size.value, e.radius_bubble, e.radius, "size"), t(i.interactivity.modes.bubble.opacity, i.particles.opacity.value, e.opacity_bubble, e.opacity, "opacity"))
    }
  }, i.fn.modes.repulseParticle = function (e) {
    function a() {
      var a = Math.atan2(d, p);
      if (e.vx = u * Math.cos(a), e.vy = u * Math.sin(a), "bounce" == i.particles.move.out_mode) {
        var t = {x: e.x + e.vx, y: e.y + e.vy};
        t.x + e.radius > i.canvas.w ? e.vx = -e.vx : t.x - e.radius < 0 && (e.vx = -e.vx), t.y + e.radius > i.canvas.h ? e.vy = -e.vy : t.y - e.radius < 0 && (e.vy = -e.vy)
      }
    }

    if (i.interactivity.events.onhover.enable && isInArray("repulse", i.interactivity.events.onhover.mode) && "mousemove" == i.interactivity.status) {
      var t = e.x - i.interactivity.mouse.pos_x, s = e.y - i.interactivity.mouse.pos_y, n = Math.sqrt(t * t + s * s), r = {
        x: t / n,
        y: s / n
      }, c = i.interactivity.modes.repulse.distance, o = 100, l = clamp(1 / c * (-1 * Math.pow(n / c, 2) + 1) * c * o, 0, 50), v = {
        x: e.x + r.x * l,
        y: e.y + r.y * l
      };
      "bounce" == i.particles.move.out_mode ? (v.x - e.radius > 0 && v.x + e.radius < i.canvas.w && (e.x = v.x), v.y - e.radius > 0 && v.y + e.radius < i.canvas.h && (e.y = v.y)) : (e.x = v.x, e.y = v.y)
    } else if (i.interactivity.events.onclick.enable && isInArray("repulse", i.interactivity.events.onclick.mode))if (i.tmp.repulse_finish || (i.tmp.repulse_count++, i.tmp.repulse_count == i.particles.array.length && (i.tmp.repulse_finish = !0)), i.tmp.repulse_clicking) {
      var c = Math.pow(i.interactivity.modes.repulse.distance / 6, 3), p = i.interactivity.mouse.click_pos_x - e.x, d = i.interactivity.mouse.click_pos_y - e.y, m = p * p + d * d, u = -c / m * 1;
      c >= m && a()
    } else 0 == i.tmp.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i)
  }, i.fn.modes.grabParticle = function (e) {
    if (i.interactivity.events.onhover.enable && "mousemove" == i.interactivity.status) {
      var a = e.x - i.interactivity.mouse.pos_x, t = e.y - i.interactivity.mouse.pos_y, s = Math.sqrt(a * a + t * t);
      if (s <= i.interactivity.modes.grab.distance) {
        var n = i.interactivity.modes.grab.line_linked.opacity - s / (1 / i.interactivity.modes.grab.line_linked.opacity) / i.interactivity.modes.grab.distance;
        if (n > 0) {
          var r = i.particles.line_linked.color_rgb_line;
          i.canvas.ctx.strokeStyle = "rgba(" + r.r + "," + r.g + "," + r.b + "," + n + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(i.interactivity.mouse.pos_x, i.interactivity.mouse.pos_y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
        }
      }
    }
  }, i.fn.vendors.eventsListeners = function () {
    "window" == i.interactivity.detect_on ? i.interactivity.el = window : i.interactivity.el = i.canvas.el, (i.interactivity.events.onhover.enable || i.interactivity.events.onclick.enable) && (i.interactivity.el.addEventListener("mousemove", function (e) {
      if (i.interactivity.el == window)var a = e.clientX, t = e.clientY; else var a = e.offsetX || e.clientX, t = e.offsetY || e.clientY;
      i.interactivity.mouse.pos_x = a, i.interactivity.mouse.pos_y = t, i.tmp.retina && (i.interactivity.mouse.pos_x *= i.canvas.pxratio, i.interactivity.mouse.pos_y *= i.canvas.pxratio), i.interactivity.status = "mousemove"
    }), i.interactivity.el.addEventListener("mouseleave", function (e) {
      i.interactivity.mouse.pos_x = null, i.interactivity.mouse.pos_y = null, i.interactivity.status = "mouseleave"
    })), i.interactivity.events.onclick.enable && i.interactivity.el.addEventListener("click", function () {
      if (i.interactivity.mouse.click_pos_x = i.interactivity.mouse.pos_x, i.interactivity.mouse.click_pos_y = i.interactivity.mouse.pos_y, i.interactivity.mouse.click_time = (new Date).getTime(), i.interactivity.events.onclick.enable)switch (i.interactivity.events.onclick.mode) {
        case"push":
          i.particles.move.enable ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : 1 == i.interactivity.modes.push.particles_nb ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : i.interactivity.modes.push.particles_nb > 1 && i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb);
          break;
        case"remove":
          i.fn.modes.removeParticles(i.interactivity.modes.remove.particles_nb);
          break;
        case"bubble":
          i.tmp.bubble_clicking = !0;
          break;
        case"repulse":
          i.tmp.repulse_clicking = !0, i.tmp.repulse_count = 0, i.tmp.repulse_finish = !1, setTimeout(function () {
            i.tmp.repulse_clicking = !1
          }, 1e3 * i.interactivity.modes.repulse.duration)
      }
    })
  }, i.fn.vendors.densityAutoParticles = function () {
    if (i.particles.number.density.enable) {
      var e = i.canvas.el.width * i.canvas.el.height / 1e3;
      i.tmp.retina && (e /= 2 * i.canvas.pxratio);
      var a = e * i.particles.number.value / i.particles.number.density.value_area, t = i.particles.array.length - a;
      0 > t ? i.fn.modes.pushParticles(Math.abs(t)) : i.fn.modes.removeParticles(t)
    }
  }, i.fn.vendors.checkOverlap = function (e, a) {
    for (var t = 0; t < i.particles.array.length; t++) {
      var s = i.particles.array[t], n = e.x - s.x, r = e.y - s.y, c = Math.sqrt(n * n + r * r);
      c <= e.radius + s.radius && (e.x = a ? a.x : Math.random() * i.canvas.w, e.y = a ? a.y : Math.random() * i.canvas.h, i.fn.vendors.checkOverlap(e))
    }
  }, i.fn.vendors.createSvgImg = function (e) {
    var a = i.tmp.source_svg, t = /#([0-9A-F]{3,6})/gi, s = a.replace(t, function (a, t, i, s) {
      if (e.color.rgb)var n = "rgba(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.opacity + ")"; else var n = "hsla(" + e.color.hsl.h + "," + e.color.hsl.s + "%," + e.color.hsl.l + "%," + e.opacity + ")";
      return n
    }), n = new Blob([s], {type: "image/svg+xml;charset=utf-8"}), r = window.URL || window.webkitURL || window, c = r.createObjectURL(n), o = new Image;
    o.addEventListener("load", function () {
      e.img.obj = o, e.img.loaded = !0, r.revokeObjectURL(c), i.tmp.count_svg++
    }), o.src = c
  }, i.fn.vendors.destroypJS = function () {
    cancelAnimationFrame(i.fn.drawAnimFrame), t.remove(), pJSDom = null
  }, i.fn.vendors.drawShape = function (e, a, t, i, s, n) {
    var r = s * n, c = s / n, o = 180 * (c - 2) / c, l = Math.PI - Math.PI * o / 180;
    e.save(), e.beginPath(), e.translate(a, t), e.moveTo(0, 0);
    for (var v = 0; r > v; v++)e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
    e.fill(), e.restore()
  }, i.fn.vendors.exportImg = function () {
    window.open(i.canvas.el.toDataURL("image/png"), "_blank")
  }, i.fn.vendors.loadImg = function (e) {
    if (i.tmp.img_error = void 0, "" != i.particles.shape.image.src)if ("svg" == e) {
      var a = new XMLHttpRequest;
      a.open("GET", i.particles.shape.image.src), a.onreadystatechange = function (e) {
        4 == a.readyState && (200 == a.status ? (i.tmp.source_svg = e.currentTarget.response, i.fn.vendors.checkBeforeDraw()) : (console.log("Error pJS - Image not found"), i.tmp.img_error = !0))
      }, a.send()
    } else {
      var t = new Image;
      t.addEventListener("load", function () {
        i.tmp.img_obj = t, i.fn.vendors.checkBeforeDraw()
      }), t.src = i.particles.shape.image.src
    } else console.log("Error pJS - No image.src"), i.tmp.img_error = !0
  }, i.fn.vendors.draw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type ? i.tmp.count_svg >= i.particles.number.value ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : void 0 != i.tmp.img_obj ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame))
  }, i.fn.vendors.checkBeforeDraw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type && void 0 == i.tmp.source_svg ? i.tmp.checkAnimFrame = requestAnimFrame(check) : (cancelRequestAnimFrame(i.tmp.checkAnimFrame), i.tmp.img_error || (i.fn.vendors.init(), i.fn.vendors.draw())) : (i.fn.vendors.init(), i.fn.vendors.draw())
  }, i.fn.vendors.init = function () {
    i.fn.retinaInit(), i.fn.canvasInit(), i.fn.canvasSize(), i.fn.canvasPaint(), i.fn.particlesCreate(), i.fn.vendors.densityAutoParticles(), i.particles.line_linked.color_rgb_line = hexToRgb(i.particles.line_linked.color)
  }, i.fn.vendors.start = function () {
    isInArray("image", i.particles.shape.type) ? (i.tmp.img_type = i.particles.shape.image.src.substr(i.particles.shape.image.src.length - 3), i.fn.vendors.loadImg(i.tmp.img_type)) : i.fn.vendors.checkBeforeDraw()
  }, i.fn.vendors.eventsListeners(), i.fn.vendors.start()
};
Object.deepExtend = function (e, a) {
  for (var t in a)a[t] && a[t].constructor && a[t].constructor === Object ? (e[t] = e[t] || {}, arguments.callee(e[t], a[t])) : e[t] = a[t];
  return e
}, window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
      window.setTimeout(e, 1e3 / 60)
    }
}(), window.cancelRequestAnimFrame = function () {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout
}(), window.pJSDom = [], window.particlesJS = function (e, a) {
  "string" != typeof e && (a = e, e = "particles-js"), e || (e = "particles-js");
  var t = document.getElementById(e), i = "particles-js-canvas-el", s = t.getElementsByClassName(i);
  if (s.length)for (; s.length > 0;)t.removeChild(s[0]);
  var n = document.createElement("canvas");
  n.className = i, n.style.width = "100%", n.style.height = "100%";
  var r = document.getElementById(e).appendChild(n);
  null != r && pJSDom.push(new pJS(e, a))
}, window.particlesJS.load = function (e, a, t) {
  var i = new XMLHttpRequest;
  i.open("GET", a), i.onreadystatechange = function (a) {
    if (4 == i.readyState)if (200 == i.status) {
      var s = JSON.parse(a.currentTarget.response);
      window.particlesJS(e, s), t && t()
    } else console.log("Error pJS - XMLHttpRequest status: " + i.status), console.log("Error pJS - File config not found")
  }, i.send()
};
/**
 * Created by DELL on 18/7/2018.
 */

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            element.css({maxHeight: $(window).height()});
          }).resize();
        }
      };
    })
    .directive('contextheight', function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {

            $timeout(function () {
              /*var evt = $window.document.createEvent('UIEvents');
              evt.initUIEvent('resize', true, false, $window, 0);
              $window.dispatchEvent(evt);*/
              console.log( element.parent().height());
              var parent =  element.parent().height() - 130;
              element.css({height: parent});
              element.css({maxHeight: parent});
              element.css({overflowX: 'hidden'});
              element.css({overflowY: 'scroll'});
              angular.element(window).resize(function () {
                $timeout(function() {
                }, 30);
              });
            }, 1000);
          }).resize();
        }
      };
    })
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          classitem : '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            $timeout(function () {
              var x = document.getElementsByClassName(scope.classitem);
              var arrayTemp = [];
              var temp = 0;
              for (var i = 0; i < x.length; i++){
                //console.log(x[i].offsetHeight)
                if(temp < x[i].offsetHeight){
                  temp = x[i].offsetHeight;
                }
              }
              //console.log('maximo',  temp);
              element.css({minHeight: temp});


            }, 1000);
          }).resize();
        }
      };
    })
    .directive('modalheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            element.css({minHeight: customHeight });
            element.css({maxHeight: customHeight });
          }).resize();
        }
      };
    })
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            //console.log(element, scope.minus, scope.plus, scope.equal, customHeight, '!!!!!');
            element.css({minHeight: customHeight });
          }).resize();
        }
      };
    })
    .directive('uiHeigth', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            //console.log(element, scope.minus, scope.plus, scope.equal, customHeight, '!!!!!');
            element.css({minHeight: customHeight });
            element.css({maxHeight: customHeight });
          }).resize();
        }
      };
    })

    .directive('switch', function(){
      return {
        restrict: 'AE'
        , replace: true
        , transclude: true
        , template: function(element, attrs) {
          var html = '';
          html += '<span';
          html +=   ' class="switch' + (attrs.class ? ' ' + attrs.class : '') + '"';
          html +=   attrs.ngModel ? ' ng-click="' + attrs.disabled + ' ? ' + attrs.ngModel + ' : ' + attrs.ngModel + '=!' + attrs.ngModel + (attrs.ngChange ? '; ' + attrs.ngChange + '()"' : '"') : '';
          html +=   ' ng-class="{ checked:' + attrs.ngModel + ', disabled:' + attrs.disabled + ' }"';
          html +=   '>';
          html +=   '<small></small>';
          html +=   '<input type="checkbox"';
          html +=     attrs.id ? ' id="' + attrs.id + '"' : '';
          html +=     attrs.name ? ' name="' + attrs.name + '"' : '';
          html +=     attrs.ngModel ? ' ng-model="' + attrs.ngModel + '"' : '';
          html +=     ' style="display:none" />';
          html +=     '<span class="switch-text">'; /*adding new container for switch text*/
          html +=     attrs.on ? '<span class="on">'+attrs.on+'</span>' : ''; /*switch text on value set by user in directive html markup*/
          html +=     attrs.off ? '<span class="off">'+attrs.off + '</span>' : ' ';  /*switch text off value set by user in directive html markup*/
          html += '</span>';
          return html;
        }
      }
    });


})();

/**
 *
 * Color picker
 * Author: Stefan Petre www.eyecon.ro
 *
 * Dual licensed under the MIT and GPL licenses
 *
 */

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('colorpicker', function ($compile) {
      return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/views/directives/colorpicker.html',
        link: function (scope, element) {
          console.log('ejecuta ccolor picker')

          var
            ids = {},
            inAction,
            charMin = 65,
            visible,
            defaults = {
              eventName: 'click',
              onShow: function () {
              },
              onBeforeShow: function () {
              },
              onHide: function () {
              },
              onChange: function () {
              },
              onSubmit: function () {
              },
              color: 'ff0000',
              livePreview: true,
              flat: false
            },
            fillRGBFields = function (hsb, cal) {
              var rgb = HSBToRGB(hsb);
              $(cal).data('colorpicker').fields
                .eq(1).val(rgb.r).end()
                .eq(2).val(rgb.g).end()
                .eq(3).val(rgb.b).end();
            },
            fillHSBFields = function (hsb, cal) {
              $(cal).data('colorpicker').fields
                .eq(4).val(hsb.h).end()
                .eq(5).val(hsb.s).end()
                .eq(6).val(hsb.b).end();
            },
            fillHexFields = function (hsb, cal) {
              $(cal).data('colorpicker').fields
                .eq(0).val(HSBToHex(hsb)).end();
            },
            setSelector = function (hsb, cal) {
              $(cal).data('colorpicker').selector.css('backgroundColor', '#' + HSBToHex({h: hsb.h, s: 100, b: 100}));
              $(cal).data('colorpicker').selectorIndic.css({
                left: parseInt(150 * hsb.s / 100, 10),
                top: parseInt(150 * (100 - hsb.b) / 100, 10)
              });
            },
            setHue = function (hsb, cal) {
              $(cal).data('colorpicker').hue.css('top', parseInt(150 - 150 * hsb.h / 360, 10));
            },
            setCurrentColor = function (hsb, cal) {
              $(cal).data('colorpicker').currentColor.css('backgroundColor', '#' + HSBToHex(hsb));
            },
            setNewColor = function (hsb, cal) {
              $(cal).data('colorpicker').newColor.css('backgroundColor', '#' + HSBToHex(hsb));
            },
            keyDown = function (ev) {
              var pressedKey = ev.charCode || ev.keyCode || -1;
              if ((pressedKey > charMin && pressedKey <= 90) || pressedKey == 32) {
                return false;
              }
              var cal = $(this).parent().parent();
              if (cal.data('colorpicker').livePreview === true) {
                change.apply(this);
              }
            },
            change = function (ev) {
              var cal = $(this).parent().parent(), col;
              if (this.parentNode.className.indexOf('_hex') > 0) {
                cal.data('colorpicker').color = col = HexToHSB(fixHex(this.value));
              } else if (this.parentNode.className.indexOf('_hsb') > 0) {
                cal.data('colorpicker').color = col = fixHSB({
                  h: parseInt(cal.data('colorpicker').fields.eq(4).val(), 10),
                  s: parseInt(cal.data('colorpicker').fields.eq(5).val(), 10),
                  b: parseInt(cal.data('colorpicker').fields.eq(6).val(), 10)
                });
              } else {
                cal.data('colorpicker').color = col = RGBToHSB(fixRGB({
                  r: parseInt(cal.data('colorpicker').fields.eq(1).val(), 10),
                  g: parseInt(cal.data('colorpicker').fields.eq(2).val(), 10),
                  b: parseInt(cal.data('colorpicker').fields.eq(3).val(), 10)
                }));
              }
              if (ev) {
                fillRGBFields(col, cal.get(0));
                fillHexFields(col, cal.get(0));
                fillHSBFields(col, cal.get(0));
              }
              setSelector(col, cal.get(0));
              setHue(col, cal.get(0));
              setNewColor(col, cal.get(0));
              cal.data('colorpicker').onChange.apply(cal, [col, HSBToHex(col), HSBToRGB(col)]);
            },
            blur = function (ev) {
              var cal = $(this).parent().parent();
              cal.data('colorpicker').fields.parent().removeClass('colorpicker_focus');
            },
            focus = function () {
              charMin = this.parentNode.className.indexOf('_hex') > 0 ? 70 : 65;
              $(this).parent().parent().data('colorpicker').fields.parent().removeClass('colorpicker_focus');
              $(this).parent().addClass('colorpicker_focus');
            },
            downIncrement = function (ev) {
              var field = $(this).parent().find('input').focus();
              var current = {
                el: $(this).parent().addClass('colorpicker_slider'),
                max: this.parentNode.className.indexOf('_hsb_h') > 0 ? 360 : (this.parentNode.className.indexOf('_hsb') > 0 ? 100 : 255),
                y: ev.pageY,
                field: field,
                val: parseInt(field.val(), 10),
                preview: $(this).parent().parent().data('colorpicker').livePreview
              };
              $(document).bind('mouseup', current, upIncrement);
              $(document).bind('mousemove', current, moveIncrement);
            },
            moveIncrement = function (ev) {
              ev.data.field.val(Math.max(0, Math.min(ev.data.max, parseInt(ev.data.val + ev.pageY - ev.data.y, 10))));
              if (ev.data.preview) {
                change.apply(ev.data.field.get(0), [true]);
              }
              return false;
            },
            upIncrement = function (ev) {
              change.apply(ev.data.field.get(0), [true]);
              ev.data.el.removeClass('colorpicker_slider').find('input').focus();
              $(document).unbind('mouseup', upIncrement);
              $(document).unbind('mousemove', moveIncrement);
              return false;
            },
            downHue = function (ev) {
              var current = {
                cal: $(this).parent(),
                y: $(this).offset().top
              };
              current.preview = current.cal.data('colorpicker').livePreview;
              $(document).bind('mouseup', current, upHue);
              $(document).bind('mousemove', current, moveHue);
            },
            moveHue = function (ev) {
              change.apply(
                ev.data.cal.data('colorpicker')
                  .fields
                  .eq(4)
                  .val(parseInt(360 * (150 - Math.max(0, Math.min(150, (ev.pageY - ev.data.y)))) / 150, 10))
                  .get(0),
                [ev.data.preview]
              );
              return false;
            },
            upHue = function (ev) {
              fillRGBFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              fillHexFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              $(document).unbind('mouseup', upHue);
              $(document).unbind('mousemove', moveHue);
              return false;
            },
            downSelector = function (ev) {
              var current = {
                cal: $(this).parent(),
                pos: $(this).offset()
              };
              current.preview = current.cal.data('colorpicker').livePreview;
              $(document).bind('mouseup', current, upSelector);
              $(document).bind('mousemove', current, moveSelector);
            },
            moveSelector = function (ev) {
              change.apply(
                ev.data.cal.data('colorpicker')
                  .fields
                  .eq(6)
                  .val(parseInt(100 * (150 - Math.max(0, Math.min(150, (ev.pageY - ev.data.pos.top)))) / 150, 10))
                  .end()
                  .eq(5)
                  .val(parseInt(100 * (Math.max(0, Math.min(150, (ev.pageX - ev.data.pos.left)))) / 150, 10))
                  .get(0),
                [ev.data.preview]
              );
              return false;
            },
            upSelector = function (ev) {
              fillRGBFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              fillHexFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              $(document).unbind('mouseup', upSelector);
              $(document).unbind('mousemove', moveSelector);
              return false;
            },
            enterSubmit = function (ev) {
              $(this).addClass('colorpicker_focus');
            },
            leaveSubmit = function (ev) {
              $(this).removeClass('colorpicker_focus');
            },
            clickSubmit = function (ev) {
              var cal = $(this).parent();
              var col = cal.data('colorpicker').color;
              cal.data('colorpicker').origColor = col;
              setCurrentColor(col, cal.get(0));
              cal.data('colorpicker').onSubmit(col, HSBToHex(col), HSBToRGB(col), cal.data('colorpicker').el);
            },
            show = function (ev) {
              var cal = $('#' + $(this).data('colorpickerId'));
              cal.data('colorpicker').onBeforeShow.apply(this, [cal.get(0)]);
              var pos = $(this).offset();
              var viewPort = getViewport();
              var top = pos.top + this.offsetHeight;
              var left = pos.left;
              if (top + 176 > viewPort.t + viewPort.h) {
                top -= this.offsetHeight + 176;
              }
              if (left + 356 > viewPort.l + viewPort.w) {
                left -= 356;
              }
              cal.css({left: left + 'px', top: top + 'px'});
              if (cal.data('colorpicker').onShow.apply(this, [cal.get(0)]) != false) {
                cal.show();
              }
              $(document).bind('mousedown', {cal: cal}, hide);
              return false;
            },
            hide = function (ev) {
              if (!isChildOf(ev.data.cal.get(0), ev.target, ev.data.cal.get(0))) {
                if (ev.data.cal.data('colorpicker').onHide.apply(this, [ev.data.cal.get(0)]) != false) {
                  ev.data.cal.hide();
                }
                $(document).unbind('mousedown', hide);
              }
            },
            isChildOf = function (parentEl, el, container) {
              if (parentEl == el) {
                return true;
              }
              if (parentEl.contains) {
                return parentEl.contains(el);
              }
              if (parentEl.compareDocumentPosition) {
                return !!(parentEl.compareDocumentPosition(el) & 16);
              }
              var prEl = el.parentNode;
              while (prEl && prEl != container) {
                if (prEl == parentEl)
                  return true;
                prEl = prEl.parentNode;
              }
              return false;
            },
            getViewport = function () {
              var m = document.compatMode == 'CSS1Compat';
              return {
                l: window.pageXOffset || (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
                t: window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
                w: window.innerWidth || (m ? document.documentElement.clientWidth : document.body.clientWidth),
                h: window.innerHeight || (m ? document.documentElement.clientHeight : document.body.clientHeight)
              };
            },
            fixHSB = function (hsb) {
              return {
                h: Math.min(360, Math.max(0, hsb.h)),
                s: Math.min(100, Math.max(0, hsb.s)),
                b: Math.min(100, Math.max(0, hsb.b))
              };
            },
            fixRGB = function (rgb) {
              return {
                r: Math.min(255, Math.max(0, rgb.r)),
                g: Math.min(255, Math.max(0, rgb.g)),
                b: Math.min(255, Math.max(0, rgb.b))
              };
            },
            fixHex = function (hex) {
              var len = 6 - hex.length;
              if (len > 0) {
                var o = [];
                for (var i = 0; i < len; i++) {
                  o.push('0');
                }
                o.push(hex);
                hex = o.join('');
              }
              return hex;
            },
            HexToRGB = function (hex) {
              var hex = parseInt(((hex.indexOf('#') > -1) ? hex.substring(1) : hex), 16);
              return {r: hex >> 16, g: (hex & 0x00FF00) >> 8, b: (hex & 0x0000FF)};
            },
            HexToHSB = function (hex) {
              return RGBToHSB(HexToRGB(hex));
            },
            RGBToHSB = function (rgb) {
              var hsb = {
                h: 0,
                s: 0,
                b: 0
              };
              var min = Math.min(rgb.r, rgb.g, rgb.b);
              var max = Math.max(rgb.r, rgb.g, rgb.b);
              var delta = max - min;
              hsb.b = max;
              if (max != 0) {

              }
              hsb.s = max != 0 ? 255 * delta / max : 0;
              if (hsb.s != 0) {
                if (rgb.r == max) {
                  hsb.h = (rgb.g - rgb.b) / delta;
                } else if (rgb.g == max) {
                  hsb.h = 2 + (rgb.b - rgb.r) / delta;
                } else {
                  hsb.h = 4 + (rgb.r - rgb.g) / delta;
                }
              } else {
                hsb.h = -1;
              }
              hsb.h *= 60;
              if (hsb.h < 0) {
                hsb.h += 360;
              }
              hsb.s *= 100 / 255;
              hsb.b *= 100 / 255;
              return hsb;
            },
            HSBToRGB = function (hsb) {
              var rgb = {};
              var h = Math.round(hsb.h);
              var s = Math.round(hsb.s * 255 / 100);
              var v = Math.round(hsb.b * 255 / 100);
              if (s == 0) {
                rgb.r = rgb.g = rgb.b = v;
              } else {
                var t1 = v;
                var t2 = (255 - s) * v / 255;
                var t3 = (t1 - t2) * (h % 60) / 60;
                if (h == 360) h = 0;
                if (h < 60) {
                  rgb.r = t1;
                  rgb.b = t2;
                  rgb.g = t2 + t3
                }
                else if (h < 120) {
                  rgb.g = t1;
                  rgb.b = t2;
                  rgb.r = t1 - t3
                }
                else if (h < 180) {
                  rgb.g = t1;
                  rgb.r = t2;
                  rgb.b = t2 + t3
                }
                else if (h < 240) {
                  rgb.b = t1;
                  rgb.r = t2;
                  rgb.g = t1 - t3
                }
                else if (h < 300) {
                  rgb.b = t1;
                  rgb.g = t2;
                  rgb.r = t2 + t3
                }
                else if (h < 360) {
                  rgb.r = t1;
                  rgb.g = t2;
                  rgb.b = t1 - t3
                }
                else {
                  rgb.r = 0;
                  rgb.g = 0;
                  rgb.b = 0
                }
              }
              return {r: Math.round(rgb.r), g: Math.round(rgb.g), b: Math.round(rgb.b)};
            },
            RGBToHex = function (rgb) {
              var hex = [
                rgb.r.toString(16),
                rgb.g.toString(16),
                rgb.b.toString(16)
              ];
              $.each(hex, function (nr, val) {
                if (val.length == 1) {
                  hex[nr] = '0' + val;
                }
              });
              return hex.join('');
            },
            HSBToHex = function (hsb) {
              return RGBToHex(HSBToRGB(hsb));
            },
            restoreOriginal = function () {
              var cal = $(this).parent();
              var col = cal.data('colorpicker').origColor;
              cal.data('colorpicker').color = col;
              fillRGBFields(col, cal.get(0));
              fillHexFields(col, cal.get(0));
              fillHSBFields(col, cal.get(0));
              setSelector(col, cal.get(0));
              setHue(col, cal.get(0));
              setNewColor(col, cal.get(0));
            };
          return {
            init: function (opt) {
              opt = $.extend({}, defaults, opt || {});
              if (typeof opt.color == 'string') {
                opt.color = HexToHSB(opt.color);
              } else if (opt.color.r != undefined && opt.color.g != undefined && opt.color.b != undefined) {
                opt.color = RGBToHSB(opt.color);
              } else if (opt.color.h != undefined && opt.color.s != undefined && opt.color.b != undefined) {
                opt.color = fixHSB(opt.color);
              } else {
                return this;
              }
              return this.each(function () {
                if (!$(this).data('colorpickerId')) {
                  var options = $.extend({}, opt);
                  options.origColor = opt.color;
                  var id = 'collorpicker_' + parseInt(Math.random() * 1000);
                  $(this).data('colorpickerId', id);
                  var cal = $(tpl).attr('id', id);
                  if (options.flat) {
                    cal.appendTo(this).show();
                  } else {
                    cal.appendTo(document.body);
                  }
                  options.fields = cal
                    .find('input')
                    .bind('keyup', keyDown)
                    .bind('change', change)
                    .bind('blur', blur)
                    .bind('focus', focus);
                  cal
                    .find('span').bind('mousedown', downIncrement).end()
                    .find('>div.colorpicker_current_color').bind('click', restoreOriginal);
                  options.selector = cal.find('div.colorpicker_color').bind('mousedown', downSelector);
                  options.selectorIndic = options.selector.find('div div');
                  options.el = this;
                  options.hue = cal.find('div.colorpicker_hue div');
                  cal.find('div.colorpicker_hue').bind('mousedown', downHue);
                  options.newColor = cal.find('div.colorpicker_new_color');
                  options.currentColor = cal.find('div.colorpicker_current_color');
                  cal.data('colorpicker', options);
                  cal.find('div.colorpicker_submit')
                    .bind('mouseenter', enterSubmit)
                    .bind('mouseleave', leaveSubmit)
                    .bind('click', clickSubmit);
                  fillRGBFields(options.color, cal.get(0));
                  fillHSBFields(options.color, cal.get(0));
                  fillHexFields(options.color, cal.get(0));
                  setHue(options.color, cal.get(0));
                  setSelector(options.color, cal.get(0));
                  setCurrentColor(options.color, cal.get(0));
                  setNewColor(options.color, cal.get(0));
                  if (options.flat) {
                    cal.css({
                      position: 'relative',
                      display: 'block'
                    });
                  } else {
                    $(this).bind(options.eventName, show);
                  }
                }
              });
            }(),
            showPicker: function () {
              return this.each(function () {
                if ($(this).data('colorpickerId')) {
                  show.apply(this);
                }
              });
            }(),
            hidePicker: function () {
              return this.each(function () {
                if ($(this).data('colorpickerId')) {
                  $('#' + $(this).data('colorpickerId')).hide();
                }
              });
            }(),
            setColor: function (col) {
              if (typeof col == 'string') {
                col = HexToHSB(col);
              } else if (col.r != undefined && col.g != undefined && col.b != undefined) {
                col = RGBToHSB(col);
              } else if (col.h != undefined && col.s != undefined && col.b != undefined) {
                col = fixHSB(col);
              } else {
                return this;
              }
              return this.each(function () {
                if ($(this).data('colorpickerId')) {
                  var cal = $('#' + $(this).data('colorpickerId'));
                  cal.data('colorpicker').color = col;
                  cal.data('colorpicker').origColor = col;
                  fillRGBFields(col, cal.get(0));
                  fillHSBFields(col, cal.get(0));
                  fillHexFields(col, cal.get(0));
                  setHue(col, cal.get(0));
                  setSelector(col, cal.get(0));
                  setCurrentColor(col, cal.get(0));
                  setNewColor(col, cal.get(0));
                }
              });
            }()
          };

        }


      }
    });
})();


'use strict';
angular
  .module('frontendapp')
  .controller('wcmsCtrl', function (ImageLoader, $window, $log, TablesService, $state, $timeout, $rootScope) {
    var vm = this;

    vm.rulesP = [
      {field: 'id', active: false, activeGrid: false, required: false},
    ];

    vm.preload = function () {
      vm.model = $state.params.model;
      vm.type = $state.params.type;
      vm.contenidoRules = {
        component: 'grid',
        model: 'webcontent',
        customProperties: {
          content: {
            label: 'Contenido',
            required: true,
            activeGrid: false,
            toolbar: [
              ['h5', 'h6', 'p'],
              ['bold', 'italics', 'underline', 'strikeThrough'],
              /* ['ul', 'ol'],*/
              ['undo', 'redo', 'clear'],
              //['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
              ['html'],
              ['insertLink'],
              //[, 'insertImage','insertLink', 'insertVideo'],
              ['wordcount', 'charcount']
            ],
            resolve: {
              helpText: function (model) {
                //////console.log('seleccionado', selected.id);
                switch (model.selected.id) {
                  default:
                    return '';
                }
              },
              jsonType: function (model) {
                console.log('model.selected', model.selected)
                if (model.selected) {
                  if (model.selected.type == 2) {
                    console.log('selected file')
                    return 'file'
                  }
                  if (model.selected.type == 3) {
                    return 'file'
                  }
                  if (model.selected.type == 1) {
                    console.log('selected textarea')
                    return 'textarea'
                  }
                  if (model.selected.type == 0) {
                    console.log('selected text')
                    return 'text'
                  }
                }
              },
              //fileType: function (model) {
              //  console.log('selected', model.selected);
              //  if (model.model.selected) {
              //    if (model.selected.type == 2) {
              //      return 'image'
              //    }
              //    if (model.selected.type == 3) {
              //      return 'pdf'
              //    }
              //  }
              //},
            }
          },
          type: {
            label: 'Tipo',
            disabled: true,
            active: false,
            activeGrid: false,
            activeForEdit: false,
            activeForCreate: false,
          }
        },
        //customFilters: {
        //  filters: {
        //    webroute: {
        //      operator: 'has',
        //      table: 'pagina',
        //      field: 'state',
        //      value: vm.model
        //    }
        //  }
        //}
      };
      vm.crudReady = true;
      console.log('wcmsCtrl !!!', $state.params.model);
    };
    vm.preload();
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      vm.preload();
    });





  });

'use strict';
angular
  .module('frontendapp')
  .controller('projectsCtrl', function ($uibModal,ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('projectsCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id: 1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id: 2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value) {

      var comment = {
        autor: 'Fernando López',
        created_at: '10 Mayo',
        active: true,
        comment: value
      };
      $rootScope.comments.push(comment);
      console.log('agrega', $rootScope.comments);
    }


    //////////////////////////////////////////

    vm.rulesP = [
      {
        field: 'servicios_id',
        itemsLabel: 'nombre_es',
        label: 'Servicio',
        order: 1,
        required: true,
      },
      {
        field: 'nombre',
        label: 'Nombre',
        order: 2,
        required: true
      },
      {
        field: 'estado',
        label: 'Estado',
        order: 3,
        required: true,
        render: true,
        renderFunction: function (value) {
          var exit = '';
          switch (value) {
            case '1':
              exit = '<p>Activo</p>';
              break;
            case '2':
              exit = '<p>Congelado</p>';
              break;
            case '3':
              exit = '<p>Culminado</p>';
              break;
          }
          return exit;
        }
      },
      {
        field: 'fecha_prog_inicio',
        label: 'Inicio programado',
        type: 'date',
        required: true,
        activeGrid: false
      },
      {
        field: 'fecha_prog_fin',
        label: 'Cierre programado',
        type: 'date',
        required: true,
        activeGrid: false
      },
      {
        field: 'fecha_real_inicio',
        label: 'Inicio',
        type: 'date',
        required: true
      },
      {
        field: 'fecha_real_fin',
        label: 'Cierre',
        type: 'date',
        required: true
      },
      {
        field: 'descripcion',
        label: 'Descripción',
        type: 'textarea',
        required: true,
        activeGrid: false
      },
    ]

    vm.customTemplate = 'app/views/projects/project/customTemplate.html';
    vm.customFilters = 'app/views/projects/project/customFilters.html';
    vm.customTitleEs = 'Proyectos';
    vm.customTitleEn = 'Projects';
  });

'use strict';
angular
  .module('frontendapp')
  .controller('productCtrl', function (ImageLoader,$window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('productCtrl');

    vm.rulesP = [
      {
        field: 'productocategoria_id',
        itemsLabel: 'titulo_es',
        label: 'Categoría',
        order: 1,
        required: true,
      },
      {
        field: 'nombre_es',
        label: 'Nombre español',
        order: 2,
        required: true
      },
      {
        field: 'nombre_en',
        label: 'Nombre ingles',
        activeGrid:false,
        order: 2,
        required: true
      },
      {
        field: 'descripcion_es',
        label: 'Descripción español',
        type:'textarea',
        toolbar:'basics',
        order: 2,
        required: true
      },
      {
        field: 'descripcion_en',
        label: 'Descripción ingles',
        type:'textarea',
        toolbar:'basics',
        activeGrid:false,
        order: 2,
        required: true
      },
      {
        field: 'status',
        label: 'Estado',
        order: 3,
        required: true,
        activeGrid:false,
        render: true,
        renderFunction: function (value) {
          var exit = '';
          switch (value) {
            case '1':
              exit = '<p>Activo</p>';
              break;
            case '0':
              exit = '<p>Congelado</p>';
              break;
          }
          return exit;
        }
      },
      {
        field: 'imagen',
        label: 'Imagen',
        type:'file',
        order: 2,
        required: true
      },
      {
        field: 'descuento',
        label: 'Descuento',
        type:'textarea',
        toolbar:'basics',
        activeGrid:false,
        order: 2,
        required: true
      },
    ]


    vm.rulesC = [
      {
        field: 'titulo_es',
        label: 'Titulo español',
        order: 1,
        required: true,
      },
      {
        field: 'titulo_en',
        label: 'Titulo ingles',
        activeGrid:false,
        order: 1,
        required: true,
      },
      {
        field: 'contenido_es',
        label: 'Contenido español',
        activeGrid:false,
        order: 1,
        required: true,
      },
      {
        field: 'contenido_en',
        label: 'Contenido ingles',
        activeGrid:false,
        order: 1,
        required: true,
      },
      {
        field: 'imagen',
        type:'file',
        order: 1,
        required: true,
      }
    ]

  });

/**
 * Created by DELL on 7/6/2018.
 */
'use strict';
angular
  .module('frontendapp')
  .controller('printCtrl', function (ImageLoader, $window, $log, $state, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('printCtrl');

    vm.globalId = $state.params.id;
    $rootScope.paymentType = $state.params.filter;
    vm.voucher9 = {
      component: 'uiinvoice',
      model: 'voucher',
      customProperties:{
        invoice_autorization:{
          hide:false
        }
      },
      customFilters: {
        per_page: 1,
        selected: vm.globalId
      }
    };
    vm.stockorder = {
      component: 'uiinvoice',
      model: 'stockorder',
      customFilters: {
        per_page: 1,
        selected: vm.globalId
      }
    };
    vm.transaction = {
      component: 'uiinvoice',
      model: 'vouchertransaction',
      customFilters: {
        per_page: 1,
        selected: vm.globalId
      }
    };
    vm.cashregisterlog = {
      component: 'uiinvoice',
      model: 'cashregisterlog',
      customFilters: {
        per_page: 1,
        selected: vm.globalId
      }
    }

  });


(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('particlesDrv', function ($window, $log)  {
      return {
        restrict: 'A',
        template: '<div class="particleJs" id="particleJs"></div>',
        link: function(scope, element, attrs, fn) {
          $log.debug('test');
          $window.particlesJS('particleJs', {
            particles: {
              number: {
                value: 80,
                density: {
                  enable: true,
                  value_area: 800
                }
              },
              color: {
                value: '#FFFFFF'
              },
              shape: {
                type: "circle",
                polygon: {
                  nb_sides: 5
                }
              },
              opacity: {
                value: 0.5,
                random: false,
                anim: {
                  enable: false,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false
                }
              },
              size: {
                value: 5,
                random: true,
                anim: {
                  enable: false,
                  speed: 40,
                  size_min: 0.1,
                  sync: false
                }
              },
              line_linked: {
                enable: true,
                distance: 150,
                color: '#ffffff',
                opacity: 0.4,
                width: 1
              },
              move: {
                enable: true,
                speed: 2,
                direction: 'none',
                random: false,
                straight: false,
                out_mode: 'out',
                bounce: false,
                attract: {
                  enable: false,
                  rotateX: 600,
                  rotateY: 1200
                }
              }
            },
            interactivity: {
              detect_on: 'canvas',
              events: {
                onhover: {
                  enable: true,
                  mode: 'grab'
                },
                onclick: {
                  enable: true,
                  mode: 'push'
                },
                resize: true
              },
              modes: {
                grab: {
                  distance: 140,
                  line_linked: {
                    opacity: 1
                  }
                },
                bubble: {
                  distance: 400,
                  size: 40,
                  duration: 2,
                  opacity: 8,
                  speed: 3
                },
                repulse: {
                  distance: 200,
                  duration: 0.4
                },
                push: {
                  particles_nb: 4
                },
                remove: {
                  particles_nb: 2
                }
              }
            },
            retina_detect: true
          });
        }
      };
    })
})();

angular
  .module('frontendapp')
  .controller('particlesCtrl', function ($rootScope, $scope) {
    $scope.showParticles = true;
  });


'use strict';
angular
  .module('frontendapp')
  .controller('offersCtrl', function (ImageLoader,$window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('offersCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id:1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active:true,
        comment:'  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id:2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active:true,
        comment:'  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value){

      var comment = {
          autor: 'Fernando López',
          created_at: '10 Mayo',
          active: true,
          comment: value
        };
      $rootScope.comments.push(comment);
      console.log('agrega',  $rootScope.comments);
    }


  });

'use strict';
angular
  .module('frontendapp')
  .controller('HomeController', function ( ImageLoader,$window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('HomeController');

    vm.sendMail = function(emailId,subject,message){
      $window.open("mailto:"+ emailId + "?subject=" + subject+"&body="+message,"_self");
    };



  });

/**
 * Created by DELL on 7/6/2018.
 */
'use strict';
angular
  .module('frontendapp')
  .controller('formsCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('formsCtrl');

    vm.switchFormView = function (value) {
      switch(value){
        case 'back':
          vm.formView --;
          break;
        default:
          vm.formView = value;
          break;
      }
    };

    vm.forms = {
      newService: {
        views: 3,
        categoriasservicios_id: '',
        servicios_id: '',
        message: ''
      },
      newDate: {
        views: 1,
        date: '',
        hour: '',
        message: ''
      },
      newOpinion: {
        views: 1,
        type: '',
        message: ''
      },
      newClaim: {
        views: 1,
        motive: '',
        message: ''
      }
    };

    vm.loadForm = function (value) {
      vm.formView = 1;
      switch (value) {
        case ('newservice'):
          $rootScope.customModal.data = angular.copy(vm.forms.newService);
          break;
        case ('schedulemeeting'):
          $rootScope.customModal.data = angular.copy(vm.forms.newDate);
          break;
        case ('newopinion'):
          $rootScope.customModal.data = angular.copy(vm.forms.newOpinion);
          break;
        case ('newclaim'):
          $rootScope.customModal.data = angular.copy(vm.forms.newClaim);
          break;
      }
      console.log('current form', $rootScope.customModal)
    };

    $rootScope.sendForm = function (data, target){
      console.log('envia mensaje', $rootScope.customModal.data);
      vm.switchFormView(0);
    };

    //CUSTOM CODE FOR SEBOING CRM
    //new service
    vm.loadServices = function () {
      TablesService.filtrar(
        'servicios',
        {
          lan: $rootScope.language,
          comparaciones: [
            {
              campo: 'categoriasservicios_id',
              operador: 'like',
              dato: $rootScope.customModal.data.categoriasservicios_id,
              dato2: ''
            }
          ]
        }
      )
        .success(function (res) {
          vm.services = res.resultado;
        });
    };
    vm.chooseCatServices = function (value) {
      $rootScope.customModal.data.categoriasservicios_id = value;
      $rootScope.customModal.data.servicios_id = '';
      vm.loadServices();
      vm.switchFormView(2);
    }


  });

'use strict';
angular
  .module('frontendapp')
  .controller('documentsCtrl', function (ImageLoader,$window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('documentsCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id:1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active:true,
        comment:'  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id:2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active:true,
        comment:'  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value){

      var comment = {
          autor: 'Fernando López',
          created_at: '10 Mayo',
          active: true,
          comment: value
        };
      $rootScope.comments.push(comment);
      console.log('agrega',  $rootScope.comments);
    }


  });

'use strict';
angular
  .module('frontendapp')
  .controller('calendarCtrl', function (ImageLoader,$window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('calendarCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id:1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active:true,
        comment:'  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id:2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active:true,
        comment:'  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value){

      var comment = {
          autor: 'Fernando López',
          created_at: '10 Mayo',
          active: true,
          comment: value
        };
      $rootScope.comments.push(comment);
      console.log('agrega',  $rootScope.comments);
    }


  });

'use strict';
angular.module('frontendapp').controller('SaleCtrl', function (UserService, ImageLoader, $window, toastr, $log, $timeout, $rootScope, $scope, $state) {
  var vm = this;
  console.log('SaleCtrl');
  vm.ready = true;
  $rootScope.$on('$stateChangeSuccess', function (event, toState) {
    console.log('detecta 1')
  });
  $rootScope.$on('$stateChangeStart', function (event, toState) {
    console.log('detecta 2')
  });
  vm.globalId = $state.params.id;
  //MANAGEMENT
  vm.salespoint = {
    component: 'uiinventoryform',
    customComponent: {
      uiinventoryform: {
        template: 'sales'
      }
    },
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        label: 'Comprobante',
        type: 'select',
        default: 9,
        itemsLabel: 'label',
        items: [{
          id: 7,
          label: 'Reserva de productos',
          label2: 'Reservas'
        }, {
          id: 8,
          label: 'Cotización',
          label2: 'Cotizaciones'
        }, {
          id: 9,
          label: 'Orden de venta',
          label2: 'Ventas anteriores',
          component: 'uipayment',
          newStockorder: true,
          newTransaction: true
        }, {
          id: 10,
          label: 'Consignación',
          label2: 'entregas a consignación',
          component: 'uicombo',
          newStockorder: true
        }, {
          id: 11,
          label: 'Alquiler de productos',
          label2: 'alquiler de productos',
          component: 'uipayment',
          newTransaction: true
        }]
      },
      status: {
        hide: true,
        hideGrid: true,
        label: 'Estado',
        type: 'select',
        default: 1,
      },
      warehouse_id: {
        //disabled: false,
        // default: 2,
        disabled: ($rootScope.access(['super-admin'])) ? false : true,
        //disabled: $rootScope.access(['gestor-local-de-inventario']),
        default: function () {
          if ($rootScope.access(['super-admin'])) {
            return 1;
          } else {
            var w = $rootScope.getCurrentUserCashregister();
            console.log('user cashregister', w, w.warehouse_id);
            return w.warehouse_id;
          }
        }()
        ,
        label: 'punto de venta',
        //hide:true,
        //hideGrid:true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
        /*default: 1,
         label: 'punto de venta',
         resolve: {
         default: function (model) {
         if (model.filters.selected) {
         return model.selected.warehouse_id = model.selected.stockorder[0].warehouse.id;
         }
         else {
         return 1;
         }
         },
         }*/
      },
      partner_id: {
        label: 'Cliente',
        hideGrid: false,
        hide: true,
      },
      partnername:{
        label:'Cliente'
      },
      partnername2:{
        label:'Vendedor'
      },
      invoice_type:{
        default: '0'
      }

    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      per_page:1,
      filters: {}
    }
  };
  vm.salesMobilerequest = {
    component: 'uiinventoryform',
    customComponent: {
      uiinventoryform: {
        template: 'sales-mobile-request'
      }
    },
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      programmed_time: {
        hide: false
      },
      programmed_type: {
        hide: false
      },
      vouchertype_id: {
        label: 'Comprobante',
        type: 'select',
        default: 7,
        itemsLabel: 'label',
        items: [{
          id: 7,
          label: 'Orden de entrega',
          label2: 'Orden de entrega'
        }]
      },
      status: {
        hide: true,
        hideGrid: true,
        label: 'Estado',
        type: 'select',
        default: 1,
      },
      warehouse_id: {
        //disabled: false,
        default: 1,
        disabled: false,
        //disabled: $rootScope.access(['gestor-local-de-inventario']),
        label: 'almacen',
        //hide:true,
        //hideGrid:true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Cliente',
        hide:false,
        hideGrid: false,
      },
      partner_related: {
        label: 'Vendedor',
        hideGrid: true,
        hide: true
      },
      partnername:{
        label:'Cliente'
      },
      partnername2:{
        label:'Vendedor'
      },
      programmed_at: {
        hide: false,
        hideGrid: false,
        required: true
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      per_page:1,
      filters: {}
    }
  };
  vm.salesMobilepoint = {
    component: 'uiinventoryform',
    customComponent: {
      uiinventoryform: {
        template: 'sales-mobile-point'
      }
    },
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        label: 'Comprobante',
        type: 'select',
        default: 9,
        itemsLabel: 'label',
        items: [{
          id: 9,
          label: 'Orden de venta',
          label2: 'Ventas anteriores',
          //component: 'uipayment',
          newStockorder: false,
          newTransaction: true
        }, {
          id: 11,
          label: 'Alquiler de productos',
          label2: 'alquiler de productos',
          //component: 'uipayment',
          newStockorder: false,
          newTransaction: true
        }, {
          id: 10,
          label: 'Consignación',
          label2: 'entregas a consignación',
          //
          // component: 'uideliveryprog',
          newStockorder: false,
          newTransaction: false
        },]
      },
      status: {
        hide: true,
        hideGrid: true,
        label: 'Estado',
        type: 'select',
        default: 1,
      },
      warehouse_id: {
        //disabled: false,
        default: 1,
        disabled: false,
        //disabled: $rootScope.access(['gestor-local-de-inventario']),
        label: 'almacen',
        //hide:true,
        //hideGrid:true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Cliente',
        hide:true,
        hideGrid: false,
      },
      partner_related: {
        label: 'Vendedor',
        hideGrid: ($rootScope.access(['super-admin', 'vendedor-punto-de-venta'])) ? false : true,
        hide: true
      },
      partnername:{
        label:'Cliente'
      },
      partnername2:{
        label:'Vendedor'
      },
      invoice_type: {
        default: '4',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      per_page:1,
      filters: {}
    }
  };
  vm.productCatalogue = {
    component: 'grid',
    model: 'product',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customOperations: {
      create: false,
      delete: false,
      update: false,
      read: true
    },
  };
  vm.salesclients = {
    component: 'grid',
    model: 'partner',
    customFilters: {
      filters: {
        type: {
          //type : 'autocomplete',
          operator: 'like',
          value: '2'
        }
      }
    },
    customProperties: {
      user_id: {
        hide: true,
        hideGrid: true
      },
      type: {
        hide: true,
        hideGrid: true,
        label: 'Socio',
        disabled: true,
        default: 2,
      },
      partnercommission: {
        hide: true,
        hideGrid: true,
        label: 'Comisiones',
        disabled: true,
      },
      latitud: {
        hide: false
      },
      longitud: {
        hide: false
      }
    }
  };
  vm.salesagenda = {
    component: 'uiselleragenda',
    model: 'selleragenda',
    customFilters: {
      filters: {
        user_id: {
          operator: 'like',
          value: $rootScope.currentUser.id
        },
        date: {
          operator: 'like',
          value: $rootScope.year + "-" + ($rootScope.month < 10 ? "0" + $rootScope.month : $rootScope.month)
        }
      }
    },
    customProperties: {
      user_id: {
        default: $rootScope.currentUser.id,
        hideGrid: true
      },
    }
  };
  //LOGS
  vm.histCotization = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      transport_amount: {
        hide: true,
        hideGrid: true,
      },
      other_amount: {
        hide: true,
        hideGrid: true,
      },
      credit_amount: {
        hide: false,
        hideGrid: true,
      },
      warehouse_id: {
        label: 'punto de venta',
        hideGrid: true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
        default: 0,
      },
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          operator: 'like',
          value: '8'
        },
        partner_related:{
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-punto-de-venta'])) {
              return "";
            }
            else {
              return $rootScope.currentUser.partner[0].id;
            }
          }()
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin','vendedor-visitador']),
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-visitador'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        },
        delivery_pending: {
          hide: true
        },
        delivery_excedent: {
          hide: true
        }
      }
    }
  };
  vm.histSales = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      transport_amount: {
        hide: true,
        hideGrid: true,
      },
      other_amount: {
        hide: true,
        hideGrid: true,
      },
      credit_amount: {
        hide: false,
        hideGrid: true,
      },
      warehouse_id: {
        label: 'punto de venta',
        hideGrid: true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
        default: 0,
      },
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          operator: 'like',
          value: '9'
        },
        partner_related:{
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-punto-de-venta'])) {
              return "";
            }
            else {
              return $rootScope.currentUser.partner[0].id;
            }
          }()
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin','vendedor-visitador']),
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-visitador'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        },
        delivery_excedent:{
          hide:false
        },
        delivery_pending:{
          hide:false
        }
      }
    }
  };
  vm.histConsignation = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      transport_amount: {
        hide: true,
        hideGrid: true,
      },
      other_amount: {
        hide: true,
        hideGrid: true,
      },
      credit_amount: {
        hide: false,
        hideGrid: true,
      },
      warehouse_id: {
        label: 'punto de venta',
        hideGrid: true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
        default: 0,
      },
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          operator: 'like',
          value: '10'
        },
        partner_related:{
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-punto-de-venta'])) {
              return "";
            }
            else {
              return $rootScope.currentUser.partner[0].id;
            }
          }()
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin','vendedor-visitador']),
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-visitador'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        },
      }
    }
  };
  vm.histRent = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      transport_amount: {
        hide: true,
        hideGrid: true,
      },
      other_amount: {
        hide: true,
        hideGrid: true,
      },
      credit_amount: {
        hide: false,
        hideGrid: true,
      },
      warehouse_id: {
        label: 'punto de venta',
        hideGrid: true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
        default: 0,
      },
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          operator: 'like',
          value: '11'
        },
        partner_related:{
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-punto-de-venta'])) {
              return "";
            }
            else {
              return $rootScope.currentUser.partner[0].id;
            }
          }()
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin','vendedor-visitador']),
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-visitador'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        },
      }
    }
  };
  vm.histSellerRequest = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      transport_amount: {
        hide: true,
        hideGrid: true,
      },
      other_amount: {
        hide: true,
        hideGrid: true,
      },
      credit_amount: {
        hide: false,
        hideGrid: true,
      },
      warehouse_id: {
        label: 'punto de venta',
        hideGrid: true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
        default: 0,
      },
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          operator: 'like',
          value: '7'
        },
        partner_related:{
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-punto-de-venta'])) {
              return "";
            }
            else {
              return $rootScope.currentUser.partner[0].id;
            }
          }()
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin','vendedor-visitador']),
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-visitador'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        },
        delivery_pending: {
          hide: true
        },
        delivery_excedent: {
          hide: true
        }

      }
    }
  };
  //STOCK MOVEMENT
  vm.deliver = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: "9,10,11",
          operator: 'whereIn',
        },
        warehouse_id: {
          value: function () {
            if ($rootScope.access(['super-admin'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        }
      }
    }
  };
  vm.deliver7 = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      partner_id: {
        label: 'Cliente',
      },
      relatedcode: {
        hide: false,
        hideGrid: false
      },
      programmed_at: {
        hide: false,
        hideGrid: false
      },
      programmed_time: {
        hide: false,
        hideGrid: false
      },
      programmed_type: {
        hide: false,
        hideGrid: false
      },
    },
    customFilters: {
      relations:'onSelect',
      filters: {
        vouchertype_id: {
          value: "7",
          operator: '=',
        },
        partner_related:{
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-punto-de-venta'])) {
              return "";
            }
            else {
              return $rootScope.currentUser.partner[0].id;
            }
          }()
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin','vendedor-visitador']),
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-visitador'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        },
      }
    }
  };
  vm.deliver10 = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      filters: {
        vouchertype_id: {
          value: "10",
          operator: '=',
        },
        warehouse_id: {
          value: function () {
            if ($rootScope.access(['super-admin'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        }
      }
    }
  };
  vm.deliver11 = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      partner_id: {
        label: 'Cliente',
      }
    },
    customFilters: {
      relations:'onSelect',
      filters: {
        vouchertype_id: {
          value: "11",
          operator: '=',
        },
        warehouse_id: {
          value: function () {
            if ($rootScope.access(['super-admin'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        }
      }
    }
  };
  //DEBTS
  vm.debt = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      partner_id: {
        label: 'Cliente',
      },
      total: {
        hide: false,
        hideGrid: false,
      },
      credit_amount:{
        hide: false,
        hideGrid: false,
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        status: {
          value: 2,
          operator: '<>'
        },
        credit_amount: {
          value: 1,
          operator: '>'
        },
        vouchertype_id: {
          value: "9,10,11",
          operator: 'whereIn',
        },
        partner_related:{
          value: function () {
            if ($rootScope.access(['super-admin','vendedor-punto-de-venta'])) {
              return "";
            }
            else {
              return $rootScope.currentUser.partner[0].id;
            }
          }()
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin']),
          value: function () {
            if ($rootScope.access(['super-admin'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        }
      }
    }
  };
  vm.transactions = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      partner_id: {
        label: 'Cliente',
      },
      total: {
        hide: false,
        hideGrid: false,
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: "9,10,11",
          operator: 'whereIn',
        },
        warehouse_id: {
          value: function () {
            if ($rootScope.access(['super-admin'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserCashregister();
              console.log('user cashregister', w.warehouse_id);
              return w.warehouse_id;
            }
          }()
        }
      }
    }
  };
  //cashregister
  if ($rootScope.currentUser.cashregisteruser) {
    vm.cashregister = {
      component: 'uicashregister',
      model: 'cashregister',
      customFilters: {
        selected: parseInt($rootScope.currentUser.cashregisteruser[0].cashregister_id),
        filters: {}
      }
    };
  }
  vm.histCashregister = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      transport_amount: {
        hide: true,
        hideGrid: true,
      },
      other_amount: {
        hide: true,
        hideGrid: true,
      },
      credit_amount: {
        hide: false,
        hideGrid: true,
      },
      warehouse_id: {
        label: 'punto de venta',
        hideGrid: true,
      },
      warehouse_id2: {
        disabled: true,
        hide: true,
        hideGrid: true,
        default: 0,
      },
      partner_id: {
        label: 'Vendedor',
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          operator: '=',
          value: '1'
        },
        status: {
          operator: 'like',
          value: '1'
        }
      }
    }
  };
});

'use strict';
angular
  .module('frontendapp')
  .controller('PurchaseCtrl', function (UserService, ImageLoader, $window,
                                          toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    console.log('PurchaseCtrl');
    vm.ready=true;
    vm.globalId = $state.params.id;

    //actions
    vm.productpurchase = {
      component: 'uiinventoryform',
      model: 'voucher',
      actionType: $rootScope.globalId?'update':'store',
      customProperties:{
        vouchertype_id:{
          label: 'Comprobante',
          type: 'select',
          default: 3,
          itemsLabel: 'label',
          items: [
            {
              id: 2, label: 'Cotización',
              label2: 'cotizaciones'
            },
            {
              id: 3, label: 'Orden de compra',
              label2: 'Compras anteriores', component: 'uipayment', newTransaction: true
            },
          ]
        },
        status: {
          hide:true,
          hideGrid:true,
          label: 'Estado',
          type: 'select',
          default: "0",
        },
        warehouse_id:{
          disabled:true,
          hide:true,
          hideGrid:true,
        },
        warehouse_id2:{
          disabled:false,
          hide:false,
          default:1,
          resolve: {
            default: function (model) {
              return 1;
            },
          }
        },
        partner_id:{
          label:'Proveedor',
          hide:true,
          hideGrid:false,
        },
        partner_related:{
          label:'Proveedor relacionado',
          hideGrid:true,
          hide:true,
        },
        partnername: {
          label: 'Proveedor',
          hide: false,
        },
        partnername2: {
          label: 'Usuario',
          hide: false,
        },
        programmed_at:{
          hide:false
        },
        invoice_autorization:{
          hide:false
        },
        invoice_type:{
          hide:false,
          default:'0'
        }
      },
      customFilters:{
        relations:'onSelect',
        selected: $rootScope.globalId,
        per_page:1,
        filters:{}
      }
    };
    vm.productCatalogue = {
      component: 'grid',
      model: 'product',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customOperations: {
        create: false,
        delete: false,
        update: false,
        read:true
      },
    };
    vm.partnerconfig = {
      component:'grid',
      model:'partner',
      customFilters: {
        selected: 1,
        filters: {
          type: {
            //type : 'autocomplete',
            operator: 'like',
            value: '3'
          }
        }
      },
      customProperties: {
        user_id: {
          hide: true,
          hideGrid: true
        },
        partnercategory_id: {
          hide: true,
          hideGrid: true
        },
        type: {
          default: 3,
          disabled:true,
        },
        partnerdiscount:{
          hide: true,
          hideGrid: true
        },
        partnercommission:{
          hide: true,
          hideGrid: true
        }
      }
    };
    //logs
    vm.histPurchase = {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId?'update':'store',
      customProperties:{
        vouchertype_id:{
          label: 'Comprobante',
        },
        status: {
          label: 'Estado',
        },
        warehouse_id:{
          disabled:true,
          hide:true,
          hideGrid:true,
        },
        warehouse_id2:{
          disabled:true,
          hide:true,
          hideGrid:true,
        },
        partner_id:{
          label:'Proveedor',
        }
      },
      customFilters:{
        relations:'onSelect',
        selected: $rootScope.globalId,
        filters:{
          vouchertype_id:{
            value:3
          }
        }
      }
    };
    vm.histCotization = {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId?'update':'store',
      customProperties:{
        vouchertype_id:{
          label: 'Comprobante',
        },
        status: {
          label: 'Estado',
        },
        warehouse_id:{
          disabled:true,
          hide:true,
          hideGrid:true,
        },
        warehouse_id2:{
          disabled:true,
          hide:true,
          hideGrid:true,
        },
        credit_amount: {
          hide: true,
          hideGrid: true,
        },
        partner_id:{
          label:'Proveedor',
        }
      },
      customFilters:{
        relations:'onSelect',
        selected: $rootScope.globalId,
        filters:{
          vouchertype_id:{
            value:2
          } ,
          delivery_pending:{
            hide:true
          },
          delivery_excedent:{
            hide:true
          }
        }
      }
    };
    //transactions
    vm.debt = {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        partner_id: {
          label: 'Proveedor',
        }
      },
      customFilters: {
        filters: {
          status: {
            value: 2,
            operator: '<>',
          },
          credit_amount: {
            value: 1,
            operator: '>'
          },
          vouchertype_id: {
            value: 3,
          }
        }
      }
    };
    vm.transactions = {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        partner_id: {
          label: 'Proveedor',
        }
      },
      customFilters: {
        filters: {
          vouchertype_id: {
            value: 3,
          }
        }
      }
    };

  });

'use strict';
angular.module('frontendapp').controller('inventoryCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
  var vm = this;
  $log.debug('inventoryCtrl');

  // INVENTORY DASHBOARD FUNCTIONS
  $rootScope.LS = 0;
  $rootScope.switchLS = function (value) {
    var lsLength = 0;
    angular.forEach($rootScope.sysNot.reports.lowerstock, function (i) {
      lsLength++;
    });
    switch (value) {
      case 'prev':
        ($rootScope.LS == 0) ?
          $rootScope.LS = lsLength - 1 :
          $rootScope.LS--;
        break;
      case 'next':
        ($rootScope.LS + 1 < lsLength) ?
          $rootScope.LS++ :
          $rootScope.LS = 0;
        break;
      default:
        $rootScope.LS = value;
        break;
    }
    console.log(lsLength, $rootScope.LS);
  };

  // UI BUILDER CONFIGURATION
  vm.comboconfig = {
    component: 'grid',
    model: 'product',
    customFilters: {
      filters: {
        productcategory_id: {
          operator: 'like',
          value: '4'
        },
        code: {
          operator: "like",
          type: "search"
        }
      }
    },
    customProperties: {
      productcategory_id: {
        default: 4,
        disabled: true
      }
    }
  };
  vm.productconfig = {
    component: 'grid',
    model: 'product',
    customProperties: {
      productcombogroup: {
        resolve: {
          hide: function (model) {
            if (model.selected.productcategory_id != 4) {
              return true;
            }
            return false;
          },
        }
      }
    }
  };
  vm.stockConfig = {
    component: 'grid',
    model: 'stock',
    customFilters: {
      filters: {
        product: {
          operator: "hasGroup",
          value: [],
          /*fields: [
           {
           isopen: false,
           search: '',
           model: 'productfamily',
           field: 'productfamily_id',
           label: 'Familia',
           searchIn: 'name',
           },
           {
           isopen: false,
           search: '',
           model: 'productbrand',
           field: 'productbrand_id',
           label: 'Marca',
           searchIn: 'name',
           },
           {
           isopen: false,
           search: '',
           model: 'productline',
           field: 'productline_id',
           label: 'Linea',
           searchIn: 'name',
           }
           ]*/
        }
      }
    },
    customOperations: {
      create: false,//*$rootScope.access(['super-admin', 'gestor-global-de-inventario'])*/ ,
      delete: false,//*$rootScope.access(['super-admin', 'gestor-global-de-inventario'])*/ ,
      update: true, //*$rootScope.access(['super-admin', 'gestor-global-de-inventario'])*/ ,
      read: true
    }
  };
  vm.lowerstockconfig = {
    component: 'grid',
    model: 'stock',
    customFilters: {
      filters: {
        current_stock: {
          operator: 'lower',
          value: 'stockmin'
        }
      }
    }
  };
  vm.histStockadjustment = {
    component: 'grid',
    model: 'stockadjustment',
    /*customFilters: {
    }*/
  };
  //TRANSFER-POINT
  vm.producttransfer = {
    component: 'uiinventoryform',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        label: 'Comprobante',
        type: 'select',
        itemsLabel: 'label',
        default: 6,
        items: [
          {
            id: 3,
            label: 'Entrada por compras',
            label2: 'Compras de productos',
            hide: true,
            component: 'uiinventorycheck',
            newStockorder: true
          },
          {
            id: 4,
            label: 'Ajuste de iventario',
            label2: 'Ajuste de inventario',
            hide: false,
            component: 'stockadjust',
            newStockorder: true
          },
          {
            id: 5,
            label: 'Solicitud',
            label2: 'solicitudes'
          }, {
            id: 6,
            label: 'Transferencia',
            label2: 'ordenes de transferencia',
            component: 'stockadjust',
            newStockorder: true
          },
        ]
      },
      status: {
        hide: true,
        hideGrid: true,
        label: 'Estado',
        type: 'select',
        default: 0,
      },
      warehouse_id: {
        disabled: function () {
          var exit = $rootScope.access(['super-admin', 'gestor-global-de-inventario']);
          return !exit;
        }(),
        default: function () {

          var w = $rootScope.getCurrentUserWarehouse();
          console.log('user warehouse', w.id);
          return w.id;

        }(),
        required: false
      },
      warehouse_id2: {
        required: true,
        resolve: {
          hide: function (model) {
            if (model.selected.vouchertype_id == 4) {
              return true;
            }
            return false;
          },

          required: function (model) {
            if (model.selected.vouchertype_id == 4) {
              return true;
            }
            return false;
          },
        }
      },
      partner_id: {
        label: 'Encargado',
        hideGrid: true,
      },
      partnername: {
        label: 'Encargado',
        hide: true,
      },
      partnername2: {
        label: 'Encargado',
        hide: true,
      },
      partner_related: {
        label: 'Cliente relacionado',
        hideGrid: true,
        hide: true,
      },
      programmed_at: {
        hide: false,
        hideGrid: false
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      per_page: 1,
      filters: {}
    }
  };
  vm.pendPurchaseIncomes = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      status: {
        label: 'Estado',
        type: 'select',
      },
      warehouse_id: {
        hide: true,
        hideGrid: true,
      },
      warehouse_id2: {
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Encargado',
      },
      partnername: {
        label: 'Encargado',
      },
      partnername2: {
        label: 'Encargado',
        hide: true,
      },
      programmed_at: {
        hide: false,
        hideGrid: false
      },
      total: {
        hide: true,
        hideGrid: true
      },
      credit_amount: {
        hide: true,
        hideGrid: true
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: 3
        },
        status: {
          value: "0"
        },
        warehouse_id:{
          hide:!$rootScope.access(['super-admin', 'gestor-global-de-inventario']),
        },
        warehouse_id2: {
          value: function () {
            if ($rootScope.access(['super-admin', 'gestor-global-de-inventario'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserWarehouse();
              console.log('user warehouse', w.id);
              return w.id;
            }
          }()
        }
      }
    }
  };
  vm.pendTransferIncomes = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      status: {
        label: 'Estado',
        type: 'select',
      },
      warehouse_id: {
        hide: true,
        hideGrid: true,
      },
      warehouse_id2: {
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Encargado',
      },
      programmed_at: {
        hide: false,
        hideGrid: false
      },
      partnername: {
        label: 'Encargado',
      },
      partnername2: {
        label: 'Encargado',
        hide: true,
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: 5
        },
        status: {
          value: "0"
        },
        warehouse_id:{
          hide:!$rootScope.access(['super-admin', 'gestor-global-de-inventario']),
        },
        warehouse_id2: {
          value: function () {
            if ($rootScope.access(['super-admin', 'gestor-global-de-inventario'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserWarehouse();
              console.log('user warehouse', w.id);
              return w.id;
            }
          }()
        },
      }
    }
  };
  /*$rootScope.$watch('voucher.ready',function(){
    $rootScope.productkardex.filters.filters.warehouse_id.value2 = 'Almacen central';
    $rootScope.productkardex.filters.filters.product_id.value2 = temp2;
  });*/
  //HISTORIALES
  vm.histAdjust = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
        default: 4
      },
      status: {
        label: 'Estado',
        type: 'select',
        default: 1,
      },
      warehouse_id: {
        hide: false,
        hideGrid: false,
      },
      warehouse_id2: {
        hide: false,
        hideGrid: false,
      },
      credit_amount: {
        hide: true,
        hideGrid: true,
      },
      total: {
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Encargado',
      },
      partnername: {
        label: 'Encargado',
      },
      partnername2: {
        label: 'Encargado',
        hide: true,
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: 4
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin', 'gestor-global-de-inventario']),
          operator: 'orwhere',
          other: ['warehouse_id2'],
          value: function () {
            if ($rootScope.access(['super-admin', 'gestor-global-de-inventario'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserWarehouse();
              console.log('user warehouse', w.id);
              return w.id;
            }
          }()
        }
        , delivery_pending:{
          hide:true
        },
        delivery_excedent:{
          hide:true
        }
      }
    }
  };
  vm.histTransfer = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
        default: 2
      },
      status: {
        label: 'Estado',
        type: 'select',
        default: 1,
      },
      warehouse_id: {
        hide: false,
        hideGrid: false,
      },
      warehouse_id2: {
        hide: false,
        hideGrid: false,
      },
      credit_amount: {
        hide: true,
        hideGrid: true,
      },
      total: {
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Encargado',
      },
      partnername: {
        label: 'Encargado',
      },
      partnername2: {
        label: 'Encargado',
        hide: true,
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: 6
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin', 'gestor-global-de-inventario']),
          operator: 'orwhere',
          other: ['warehouse_id2'],
          value: function () {
            if ($rootScope.access(['super-admin', 'gestor-global-de-inventario'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserWarehouse();
              console.log('user warehouse', w.id);
              return w.id;
            }
          }()
        }
      }
    }
  };
  vm.histTransferRequest = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
        default: 2
      },
      status: {
        label: 'Estado',
        type: 'select',
        default: 1,
      },
      warehouse_id: {
        hide: false,
        hideGrid: false,
      },
      warehouse_id2: {
        hide: false,
        hideGrid: false,
      },
      credit_amount: {
        hide: true,
        hideGrid: true,
      },
      total: {
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Encargado',
      },
      partnername: {
        label: 'Encargado',
      },
      partnername2: {
        label: 'Encargado',
        hide: true,
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: 5
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin', 'gestor-global-de-inventario']),
          operator: 'orwhere',
          other: ['warehouse_id2'],
          value: function () {
            if ($rootScope.access(['super-admin', 'gestor-global-de-inventario'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserWarehouse();
              console.log('user warehouse', w.id);
              return w.id;
            }
          }()
        }
      }
    }
  };
  vm.histPurchaseIncomes = {
    component: 'grid',
    model: 'voucher',
    actionType: $rootScope.globalId ? 'update' : 'store',
    customProperties: {
      vouchertype_id: {
        hide: true,
        hideGrid: true,
      },
      status: {
        label: 'Estado',
        type: 'select',
      },
      warehouse_id: {
        hide: true,
        hideGrid: true,
      },
      warehouse_id2: {
        hide: true,
        hideGrid: true,
      },
      credit_amount: {
        hide: true,
        hideGrid: true,
      },
      partner_id: {
        label: 'Encargado',
      },
      partnername: {
        label: 'Encargado',
      },
      partnername2: {
        label: 'Encargado',
        hide: true,
      }
    },
    customFilters: {
      relations:'onSelect',
      selected: $rootScope.globalId,
      filters: {
        vouchertype_id: {
          value: 3
        },
        warehouse_id: {
          hide:!$rootScope.access(['super-admin', 'gestor-global-de-inventario']),
          operator: 'orwhere',
          other: ['warehouse_id2'],
          value: function () {
            if ($rootScope.access(['super-admin', 'gestor-global-de-inventario'])) {
              return "";
            } else {
              var w = $rootScope.getCurrentUserWarehouse();
              console.log('user warehouse', w.id);
              return w.id;
            }
          }()
        }

      }
    }
  };
});

'use strict';
angular
  .module('frontendapp')
  .controller('dashboardCtrl', function (UserService, ImageLoader, $window, TablesService,
                                          toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    console.log('DashboardCtrl');
    vm.ready=true;
    vm.globalId = $state.params.id;


    $rootScope.loadStory = function (target, model) {
      var filters = {
        per_page: 1,
        story : {
          view: 1
        }
      };
      TablesService.filtrar(model, filters )
        .success(function (res) {
          if (res.status) {
            console.log('Report loaded', res);
            $rootScope.report = res;
            console.log('STATICS', res.statics);
          }
        });
    };
    $rootScope.report = {};
    $rootScope.loadStory($rootScope.report, 'voucher');

    $rootScope.PT = 100;

    $scope.labels = ["January", "February", "March", "April", "May", "June", "July"];
    $scope.series = ['Series A', 'Series B'];
    $scope.data = [
      [65, 0, 80, 81, 56, 55, 40],
      [28, 48, 40, 19, 86, 27, 90]
    ];
    $scope.onClick = function (points, evt) {
      console.log(points, evt);
    };




  });

'use strict';
angular
  .module('frontendapp')
  .controller('AppController', function ($state, $log, TablesService, UserService, $rootScope, $scope, toastr) {
    var vm = this;
    $log.debug('AppController');

    // SYSTEM VARIABLES
    $rootScope.system = {};
    $rootScope.system.notifications = [
      /*{id:1, label:'text'},
       {id:2, label:'text'},*/
    ];
    /// MENU CONSTRUCTION
    $rootScope.redirect = function (state, params, config) {
      $state.go(
        state, params, config
      );
    };

    //APP STRUCTURE
    $rootScope.appMenuItems = {
      purchases: [
        {
          label: 'Operaciones',
          items: [
            {
              label: 'Punto de compra',
              state: 'purchase-point',
              show: $rootScope.uiAccess('purchase-point')
            },
            {
              label: 'Deudas por pagar',
              state: 'purchases-debts'
            },

          ]
        },
        {
          label: 'Gestión y seguimiento',
          items: [
            {
              label: 'Cotizaciones a proveedores',
              state: 'hist-purchase-cotization'
            },
            {
              label: 'Compras de productos',
              state: 'hist-purchase'
            },
          ]
        },
        {
          label: 'Organización',
          items: [

            {
              label: 'Catálogo de productos',
              state: 'purchase-product-catalogue'
            },
            {
              label: 'Proveedores',
              state: 'supplier'
            },
          ]
        },
        {
          label: 'Configuración',
          items: [
            {
              label: 'Cuentas bancarias',
              state: 'purchases-accountbank'
            },
          ]
        },
      ],
      inventory: [
        {
          label: 'Operaciones',
          items: [
            {
              label: 'Punto de transferencias',
              state: 'transfer-point'
            },
            {
              label: 'Compras pendientes',
              state: 'pend-purchases-incomes'
            },
            {
              label: 'Solicitudes pendientes',
              state: 'pend-transfer-incomes'
            },
            {
              label: 'Existencias en linea', // prestados, consignados, bajas existencias
              state: 'stock'
            },
          ]
        },
        {
          label: 'Gestión y seguimiento',
          items: [
            {
              label: 'Ajustes de inventario',
              state: 'hist-adjust'
            },
            {
              label: 'Solicitudes de transferencia',
              state: 'hist-transfer-request'
            },
            {
              label: 'Transferencias de productos',
              state: 'hist-transfer'
            },
            {
              label: 'Entradas por compras',
              state: 'hist-purchases-incomes'
            },
            {
              label: 'Rastreo de movimiento',
              state: 'hist-movement'
            },
          ]
        },
        /*{
          label: 'Entregas y devoluciones',
          items: [
            {
              label: 'Solicitudes de transferencias',
              state: 'op-transfer-request'
            },
            {
              label: 'Transferencias de productos',
              state: 'op-transfer'
            },
            {
              label: 'Entradas por compras',
              state: 'op-purchases-incomes'
            },
          ]
        },*/
        {
          label: 'Configuración',
          items: [
            {
              label: 'Productos',
              state: 'product'
            },
            {
              label: 'Categorías de productos',
              state: 'productcategory'
            },
            {
              label: 'Familias de productos',
              state: 'productfamily'
            },
            {
              label: 'Marcas de productos',
              state: 'productbrand'
            },
            {
              label: 'Líneas de productos',
              state: 'productline'
            },
            {
              label: 'Grupos de productos',
              state: 'productgroup'
            },
            {
              label: 'Combos de productos',
              state: 'productcombo'
            },
            {
              label: 'Medidas',
              state: 'productmeasure'
            },
            {
              label: 'Almacenes',
              state: 'warehouse',
            }
          ]
        }
        /*{
          label: 'Control de inventarios',
          items: [
            {
              label: 'Bajas existencias', // prestados, consignados, bajas existencias
              state: 'lowerstock'
            },
            {
              label: 'Kardex de productos', // prestados, consignados, bajas existencias
              state: 'productkardex'
            },
          ]
        },*/
      ],
      sales: [
        {
          label: 'Operaciones',
          items: [
            {
              label: 'Progamación de entrega',
              state: 'sales-mobile-requests'
            },
            {
              label: 'Punto de venta móvil',
              state: 'sales-mobile-point'
            },
            {
              label: 'Punto de venta',
              state: 'sales-point'
            },
            {
              label: 'Entregas progamadas',
              state: 'sales-delivery-point-7'
            },
            {
              label: 'Deudas por cobrar',
              state: 'sales-debts'
            },
            {
              label: 'Arqueo de caja',
              state: 'sales-cash-concilation'
            },
            /*{
              label: 'Transferencias de efectivo por arqueo pendientes',
              state: 'pend-cashregister'
            },*/
          ]
        },
        {
          label: 'Gestión y seguimiento',
          items: [
            {
              label: 'Cotizaciones',
              state: 'hist-cotization'
            },
            {
              label: 'Venta de productos',
              state: 'hist-sales'
            },
            {
              label: 'Consignacion de combos',
              state: 'hist-consignation'
            },
            {
              label: 'Alquiler de mercaderia',
              state: 'hist-rent'
            },
            {
              label: 'Solicitudes de entrega',
              state: 'hist-seller-request'
            },
            {
              label: 'Arqueo de caja',
              state: 'hist-cash-conciliate'
            },
            /*
            {
              label: 'Historial de transferencias por arqueo de caja',
              state: 'hist-cashregister'
            },
            {
              label: 'Historial de transacciones',
              state: 'hist-vouchertransaction'
            },
            */
          ]
        },
        {
          label: 'Organización',
          items: [
            {
              label: 'Agenda',
              state: 'sales-seller-agenda'
            },
            {
              label: 'Catalogo de productos',
              state: 'sales-product-catalogue'
            },
            {
              label: 'Clientes',
              state: 'sales-clients'
            },

             /*
            {
              label: 'Entregas progamadas',
              state: 'sales-delivery-point-7'
            },
            {
              label: 'Deudas por cobrar',
              state: 'sales-debts'
            },
            {
              label: 'Venta de productos',
              state: 'sales-delivery-point'
            },
            {
              label: 'Entregas por combos',
              state: 'sales-delivery-point-10'
            },
            {
              label: 'Alquiler de productos',
              state: 'sales-delivery-point-11'
            },*/
          ]
        },
        /*{
          label: 'Transacciones',
          items: [
            {
              label: 'Deudas por cobrar',
              state: 'sales-debts'
            },
            {
              label: 'Transacciones por compra de productos',
              state: 'sales-transactions'
            },
          ]
        },*/
        {
          label: 'Configuracion',
          items: [
            {
              label: 'Categorías de socios',
              state: 'partnercategory'
            },
            {
              label: 'Cajas registradoras',
              state: 'cashregister'
            },
            /*
            {
              label: 'Promotores de venta',
              state: 'salespromoter'
            }*/
          ]
        },
      ],
      accounting: [
        {
          label: 'Operaciones',
          items: [
            {
              label: 'Ordenes de depósito',
              state: 'pend-cashregister'
            },
          ]
        },
        {
          label: 'Historiales',
          items: [
            {
              label: 'Ordenes de depósito',
              state: 'hist-acc-cashregister'
            },
            {
              label: 'Arqueos de caja',
              state: 'cashregisterlog'
            },
            {
              label: 'Kardex de productos',
              state: 'product-kardex'
            },
          ]
        },
        {
          label: 'Configuración',
          items: [
            {
              label: 'Cuentas bancarias',
              state: 'accounting-accountbank'
            },
            {
              label: 'Cajas registradoras',
              state: 'accounting-cashregister'
            },
          ]
        },
      ],
      dashboard: [
        {
          label: 'Tiempo real',
          state: 'story1'
        },
      ],
      admin: [
        {
          label: 'Administración de usuarios',
          items: [
            {
              label: 'Administración de usuarios', // prestados, consignados, bajas existencias
              state: 'user'
            },
            {
              label: 'Administración de roles',
              state: 'userrole'
            },
            {
              label: 'Información de empleados',
              state: 'admin-partner'
            },
            {
              label: 'Almacenes y encargados',
              state: 'admin-warehouse'
            },
            {
              label: 'Puntos de venta y encargados',
              state: 'admin-cashregister'
            },
          ]
        },

        {
          label: 'Otros',
          items: [
            {
              label: 'Edificios', // prestados, consignados, bajas existencias
              state: 'building'
            },
            {
              label: 'Ciudades', // prestados, consignados, bajas existencias
              state: 'location'
            },
            {
              label: 'Tipos de comprobantes', // prestados, consignados, bajas existencias
              state: 'vouchertype'
            },
            {
              label: 'Cuentas bancarias',
              state: 'admin-accountbank'
            },
            {
              label: 'Comunicados',
              state: 'syscommunicate',
              uibuilder: {component: 'grid', model: 'syscommunicate'}
            },
            {
              label: 'Registro de actividad',
              state: 'activitylog'
            },
          ]
        },
      ],
    };



    //notifications
    $rootScope.getNotifications = function (){
      UserService.usernotification({}).
        success(function (res) {
          //console.log('usernotification !!', res);
          //console.log('lowerstock !!', res.reports.lowerstock);
          $rootScope.sysNot= res;
          $rootScope.getNotPending();
        });
    };
    $rootScope.archiveNot= function(rem){
      rem.status = 1;
      TablesService.actualizar('userreminder', rem.id, rem)
        .success(function (res) {
          console.log('archivado', res);
          $rootScope.getNotifications();
        })
    };
    $rootScope.getNotPending = function(){
      $rootScope.notPend = 0;
      angular.forEach($rootScope.sysNot.reminders, function(i){
        if(i.status == 0){
          $rootScope.notPend++;
        }
      })
    }


    $rootScope.reloadUI = function (){
      location.reload();
    };

    //SYSTEM TIME
    $scope.getWeekNumber = function (d) {
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 0));
      var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1) / 7);
      return weekNo;
    };
    $rootScope.currentTime = new Date();
    $rootScope.month = $rootScope.currentTime.getMonth() + 1;
    $rootScope.day = $rootScope.currentTime.getDate();
    $rootScope.year = $rootScope.currentTime.getFullYear();
    $rootScope.week = $scope.getWeekNumber(new Date($rootScope.year, $rootScope.month - 1, $rootScope.day));

    $rootScope.dateToSpanishFormat = function (dateString) {
      var x = new Date(dateString);
      var y = x.toDateString();
      y = y.replace("Mon", "Lun");
      y = y.replace("Tue", "Mar");
      y = y.replace("Wed", "Mié");
      y = y.replace("Thu", "Jue");
      y = y.replace("Fri", "Vie");
      y = y.replace("Sat", "Sáb");
      y = y.replace("Sun", "Dom");
      y = y.replace("Jan", "Enero");
      y = y.replace("Feb", "Febrero");
      y = y.replace("Mar", "Marzo");
      y = y.replace("Apr", "Abril");
      y = y.replace("May", "Mayo");
      y = y.replace("Jun", "Junio");
      y = y.replace("Jul", "Julio");
      y = y.replace("Aug", "Agosto");
      y = y.replace("Sep", "Septiembre");
      y = y.replace("Oct", "Octubre");
      y = y.replace("Nov", "Noviembre");
      y = y.replace("Dec", "Diciembre");
      var z = y.split(" ");
      return (z[2] + ' de ' + z[1] + ' de ' + z[3]);
    };
    $rootScope.numberToMonth = function (dateString) {
      var y = '' + dateString;
      y = y.replace("1", "Enero");
      y = y.replace("2", "Febrero");
      y = y.replace("3", "Marzo");
      y = y.replace("4", "Abril");
      y = y.replace("5", "Mayo");
      y = y.replace("6", "Junio");
      y = y.replace("7", "Julio");
      y = y.replace("8", "Agosto");
      y = y.replace("9", "Septiembre");
      y = y.replace("10", "Octubre");
      y = y.replace("11", "Noviembre");
      y = y.replace("12", "Diciembre");
      return y;
    };


    //VOUCHER OPERATIONS
    $rootScope.saveVoucher = function () {
      console.log('UPDATE REGISTER', $rootScope.voucher);
      $rootScope.blockSaveVoucher = true;
      UserService.actualizarToken().success(function (tok) {
        $rootScope.asignarVarSession('token', tok);
        console.log('simplificado', $rootScope.voucher.selected, $rootScope.voucher.actionType);
        switch ($rootScope.voucher.actionType) {
          case 'store':
            TablesService.almacenar('voucher', $rootScope.voucher.selected)
              .success(function (res) {
                console.log('Salida almacenar', res);
                if (res.status) {
                  $rootScope.voucher.selected.id = res.result.id;
                  toastr.success('Registro almacenado', 'Exito');
                  $rootScope.blockPage=true;
                  $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;
                  //$rootScope.reloadUI();
                }
                else {
                  toastr.warning('Registro no almacenado', 'Error');
                }
              })
              .error(function (res) {
                console.log('ERROR salida almacenar', res);
                toastr.warning('Registro no almacenado', 'Error');
              });
            break;
          case 'update':
            TablesService.actualizar('voucher', $rootScope.voucher.selected.id, $rootScope.voucher.selected)
              .success(function (res) {
                console.log('Salida actualizar', res);
                if (res.status) {
                  toastr.success('Registro actualizado', 'Exito');
                  $rootScope.blockPage=true;
                  $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;
                  //$rootScope.reloadUI()
                }
                else {
                  toastr.warning('Registro no actualizado', 'Error');
                }
              })
              .error(function (res) {
                console.log('ERROR salida actualizar', res);
                toastr.warning('Registro no actualizado', 'Error');
              });
            break;
          case 'delete':
            //$rootScope.voucher.deleteRow();
            break;
        }
      });
    };

    $rootScope.saveVoucher2 = function () {
      /* $rootScope.voucher.selected =
       angular.copy($rootScope.voucher.selected);*/
      $rootScope.blockPage=true;
      $rootScope.blockPageLoading=true;
      console.log('UPDATE REGISTER', $rootScope.voucher, $rootScope.voucher.actionType);
      UserService.actualizarToken()
        .success(function (tok) {
          $rootScope.asignarVarSession('token', tok);
          console.log('simplificado', $rootScope.voucher.selected, $rootScope.voucher.actionType);
          switch ($rootScope.voucher.actionType) {
            case 'store':
              TablesService.almacenar('voucher', $rootScope.voucher.selected)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if (res.status) {
                    $rootScope[res.modelName].selected.id = res.result.id;
                    toastr.success('Registro almacenado', 'Exito');
                    $rootScope.blockPage=true;
                    $rootScope.blockPageLoading=false;
                    //$rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;
                    switch($rootScope.currentModule){
                      case 'inventory':
                        $rootScope.blockPageLink="es/printstockorder/"+res.newStockOrder.stockorder.id ;
                        break;
                      case 'sales':
                        $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;
                        break;
                    }

                    //$rootScope.reloadUI();
                  }
                  else {
                    toastr.warning('Registro no almacenado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error');
                });
              break;
            case 'update':
              $rootScope.voucher.selected.status = 1;
              TablesService.actualizar('voucher', $rootScope.voucher.selected.id, $rootScope.voucher.selected)
                .success(function (res) {
                  console.log('Salida actualizar', res);
                  if (res.status) {
                    toastr.success('Registro actualizado', 'Exito');
                    $rootScope.blockPage=true;
                    $rootScope.blockPageLoading=false;
                    switch($rootScope.currentModule){
                      case 'inventory':
                        $rootScope.blockPageLink="es/printstockorder/"+res.newStockOrder.stockorder.id ;
                        break;
                      case 'sales':
                        if($rootScope.voucher.selected.vouchertype_id == 7){
                          $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.voucher_related ;
                        }
                        else{
                          $rootScope.blockPageLink="es/print/"+$rootScope.voucher.selected.id ;
                        }
                        break;
                    }

                  }
                  else {
                    toastr.warning('Registro no actualizado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida actualizar', res);
                  toastr.warning('Registro no actualizado', 'Error');
                });
              break;
            case 'delete':
              $rootScope.voucher.deleteRow();
              break;
          }
        });
    };
    $rootScope.printVoucherData = function(){
      console.log('voucher model', $rootScope.voucher);
      console.log('voucher selected', $rootScope.voucher.selected);
      console.log('voucher selected', $rootScope.voucher.selected.voucherline);
      console.log('voucher properties', $rootScope.voucher.filters);

    };
    $rootScope.transalatePayment = function(value){
      var exit = '';
      switch(value){
        case 'cash':
              exit = 'Efectivo';
              break;
        case 'credit':
              exit= 'Crédito';
              break;
        case 'card':
              exit = 'Tarjeta';
              break;
        case 'other':
              exit='Transferencia';
              break;
      }
      return exit;
    };
    $rootScope.exchangeAmount = function ( value , currency ) {
      var exchanged = value * $rootScope.globalParams[currency];
      console.log('exchange', value , currency, '=', exchanged);
      return exchanged
    };
    $rootScope.InvGlobalOrInvLocal = function(){

    }
    $rootScope.getCurrentUserWarehouse = function (redirect){
      if($rootScope.currentUser.warehouseuser.length>0){
        //console.log('getCurrentUserWarehouse',$rootScope.currentUser.warehouseuser[0].warehouse);
        return  $rootScope.currentUser.warehouseuser[0].warehouse;
      }
      else{
         if(redirect){
             toastr.warning('Almacen no asignado','Error');
             $state.go('home', {lan: $rootScope.language});
          }
          return false;
      }
    };
    $rootScope.getCurrentUserCashregister= function (redirect){

         if($rootScope.currentUser.cashregisteruser.length>0){
           return  $rootScope.currentUser.cashregisteruser[0].cashregister;
         }
         else{
           if(redirect){
             toastr.warning('Caja no asignada','Error');
             $state.go('home', {lan: $rootScope.language});
           }
           return false;
         }



    };


  });

'use strict';
angular
  .module('frontendapp')
  .controller('AccountingCtrl', function (UserService, ImageLoader, $window,
                                          toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    console.log('PurchaseCtrl');
    vm.ready=true;
    vm.globalId = $state.params.id;

    vm.pendingCashregister= {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          hide: true,
          hideGrid: true,
        },
        transport_amount: {
          hide: true,
          hideGrid: true,
        },
        other_amount: {
          hide: true,
          hideGrid: true,
        },
        credit_amount: {
          hide: false,
          hideGrid: true,
        },
        warehouse_id: {
          label: 'Punto de venta',
          hideGrid: true,
        },
        warehouse_id2: {
          disabled: true,
          hide: true,
          hideGrid: true,
          default: 0,
        },
        partner_id: {
          label: 'Vendedor',
        }

      },
      customFilters: {
        selected: $rootScope.globalId,
        filters: {
          vouchertype_id: {
            operator: '=',
            value: '1'
          },
          status: {
            value: '0',
            operator: '='
          },
        }
      }
    };
    vm.histCashregister= {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          hide: true,
          hideGrid: true,
        },
        transport_amount: {
          hide: true,
          hideGrid: true,
        },
        other_amount: {
          hide: true,
          hideGrid: true,
        },
        credit_amount: {
          hide: false,
          hideGrid: true,
        },
        warehouse_id: {
          label: 'Punto de venta',
          hideGrid: true,
        },
        warehouse_id2: {
          disabled: true,
          hide: true,
          hideGrid: true,
          default: 0,
        },
        partner_id: {
          label: 'Vendedor',
        }

      },
      customFilters: {
        selected: $rootScope.globalId,
        filters: {
          vouchertype_id: {
            operator: '=',
            value: '1'
          },

        }
      }
    };


    vm.productkardex = {
      component: 'grid',
      model: 'product',
      customProperties: {
        productcombogroup: {
          resolve: {
            hide: function(model) {
              if (model.selected.productcategory_id != 4) {
                return true;
              }
              return false;
            },
          }
        }
      },
      customOperations :{
        create: false,
        update: false,
        delete: false,
        read: true,
        productkardex: true
      }
    };


    $rootScope.showkardex = function () {
      console.log('showkardex!!!', $rootScope.product.selected.id);
      var temp = angular.copy($rootScope.product.selected.id);
      var temp2 = angular.copy($rootScope.product.selected.description);
      var params = {
       // component: 'grid',
        component: 'gridsmall',
        model: 'productkardex',
        parentModel: 'product',
        customFilters: {
          filters:{
            product_id:{
              operator: '=',
              value: temp
            },
            warehouse_id:{
              operator: '=',
              value: 1
            }
          },/*
          orderBy:{
            field:'id',
            direction:'asc',
          }*/
        }
      };

      $rootScope.uiConf.switchView('new', params);
      $rootScope.$watch('productkardex.ready',function(){
        $rootScope.productkardex.filters.filters.warehouse_id.value2 = 'Almacen central';
        $rootScope.productkardex.filters.filters.product_id.value2 = temp2;
      });
      $rootScope.$watch('productkardex',function(){
        console.log('original',temp);
       // $rootScope.productkardex.filters.filters.product_id.value = temp;
      },true);
    };



  });

'use strict';
angular
  .module('frontendapp')
  .controller('UserController', function (UserService, ImageLoader, $window,
                                          toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    $log.debug('UserController');

    /*ContentService.sendform( {
      mailingcategory_id:1,
      fields:{}
    })
      .success(function (res) {
        console.log('envia!!!!!!', res)
        if(res.status){
          console.log('sendform', res)
        }
      });*/

    vm.saveUserData = function (){
      console.log('almacena informacion', vm.profile)
      UserService.updateclientprofile(vm.profile)
        .success(function (res) {
          console.log('salida perfil', res)
          $rootScope.asignarVarSession('currentUser', res.profile);
          $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
        });
    }

    vm.restore = function (){
      vm.profile = angular.copy($rootScope.currentUser);
    };

    vm.usercp={fail:false};

    vm.validatePassword = function () {
      if (vm.usercp.newpass != vm.usercp.newpass2){
        return false;
      }
      else{
        return true;
      }
    };

    vm.changePassword = function (redirect){
      console.log('modifica contrasenña');
      if(vm.validatePassword()){
        console.log('enviado', vm.usercp)
        UserService.usercp(vm.usercp)
          .success(function (res) {
            console.log('salida usercp', res)
            if(res.status){
              toastr.success('Contraseña actualizada', 'Exito' );
              $rootScope.asignarVarSession('currentUser', res.profile);
              $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
              if(redirect){
                $state.go('home', {lan:$rootScope.language});
              }
            }
            else{
              toastr.warning('Contraseña invalida', 'Error' );
            }
          });
      }
      else{
        toastr.warning('Las contraseñas no coinciden', 'Error' );
      }

    }

    vm.reset = {
      email : ''
    }
    vm.forgotPassword = function (){
      console.log('ejecuta');
      UserService.forgotpassword(vm.reset)
        .success(function (res) {
          console.log(res)
        })
    }


    vm.userFilterSet = {
      firstname: {
        value:'',
        operator:'like',
        type: 'autocomplete'
      },
      lastname: {
        value:'',
        operator:'like',
        type: 'autocomplete'
      },
      email: {
        value:'',
        operator:'like',
        type: 'search'
      }
    };

    vm.partnerconfig = {
      component:'grid',
      model:'partner',
      customFilters: {
        //selected: 1,
        filters: {
          type: {
            //type : 'autocomplete',
            operator: 'like',
            value: '1'
          },
          name: {
            type : 'search',
            operator: 'like',
            value: ''
          },
        }
      },
      customProperties: {
        partnercategory_id: {
          hide: true,
          hideGrid: true
        }
      }
    };

    vm.userconfig = {
      component:'grid',
      model:'user',
      customProperties:{
        email:{
          helpText:'hola!!',
          resolve: {
            helpText: function (model) {
              if(model.model == 'user'){
                return '* hola user';
              }
              return 'pfff';
            },
          }
        }
      }
      /*customFilters:{
        selected:1,
        filters: {
          email:{
            type : 'autocomplete',
            operator:'like',
            value:'gmail'
          }
        }
      }*/
    }

  });

'use strict';
angular
  .module('frontendapp')
  .controller('ResetController', function (UserService, ImageLoader, $window,
                                          toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    $log.debug('ContactController');

    vm.validatePassword = function () {
      if (vm.reset.newpass != vm.reset.newpass2){
        return false;
      }
      else{
        return true;
      }
    };
    vm.reset = {
      ac : $state.params.ac,
      rtk : $state.params.rtk
    };
    vm.resetForgottenPassword = function (){
      console.log('modifica contrasenña');
      if(vm.validatePassword()){
        console.log('enviado', vm.reset)
        UserService.resetforgotten(vm.reset)
          .success(function (res) {
            console.log('salida reset', res)
            if(res.status){
              toastr.success('Contraseña actualizada', 'Exito' );
              $state.go('auth');
            }
            else{
              toastr.warning('Contraseña invalida', 'Error' );
            }
          });
      }
      else{
        toastr.warning('Las contraseñas no coinciden', 'Error' );
      }
    };

    UserService.checklink($state.params)
      .success(function (res) {
        console.log('forgotlink',res)
        if(!res.status){
          toastr.warning('Invalid', 'Error' );
          $state.go('auth');
        }
      })

  });

'use strict';
angular
  .module('frontendapp')
  .controller('LoginCtrl', function ($rootScope, $scope, $state, $auth,
                                     $log, UserService, localStorageService,
                                     toastr, $timeout) {
    var vm = this;
    console.log('loginCtrl')

    if($rootScope.currentState == 'activatelink'){
      console.log('activatelink');
      UserService.checklink($state.params)
        .success(function (res) {
          console.log('forgotlink',res)
          if(!res.status){
            toastr.warning('Invalid', 'Error' );
            $state.go('auth');
          }
          else{
            vm.email = res.email;
            vm.password = res.email;
          }
        });
    }

    //temporary values
    /*vm.email = 'lopezfer.moscoso@gmail.com';
    vm.password = 'AKNA.test';  */
    vm.email = '';
    vm.password = '';

    //recaptcha
    vm.gc = '';
     vm.generarSeguridad = function () {
     vm.gc = '';
     //grecaptcha.reset();
     };

    $rootScope.loginNew = function (user, pass) {
      console.log('step 0', user, pass);
      $auth.login({
        email: user,
        password: pass,
        gc: '..'
      })
        .then(function (res) {
          $rootScope.tk = $auth.getToken();
          $rootScope.asignarVarSession('token', $auth.getToken());
          console.log('step 1', res, $rootScope.tk);
          UserService.owneraccount()
            .success(function (user) {
              console.log('step 2', user);
              $rootScope.asignarVarSession('currentUser', user.profile);
              $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
              $timeout(function () {
                vm.email = '';
                vm.password = '';
                vm.errorDatos = false;
                console.log('Bienvenido');
                toastr.success($rootScope.switchText('Bienvenido','Welcome'), 'Exito');
                $state.go('home', {lan: 'es'}, {reload: true});
              }, 500);
            })
            .error(function (res) {
              console.log('error 1', res);
              toastr.warning(res, 'Error');
              $rootScope.logout();
            });
        })
        .catch(function (response) {
          switch (response.data.error) {
            case 'invalid_credentials':
              toastr.warning('invalid credentials', 'Error');
              break;
            case 'could_not_create_token':
              toastr.warning('could not create token', 'Error');
              break;
            case 'is_robot':
              toastr.warning('verify captcha first', 'Error');
              break;
            case 'not_security_validation':
              toastr.warning('not security validation', 'Error');
              break;
          }
          console.log('error 2', response.data.error);
          vm.generarSeguridad();
        });
    };

  });

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .controller('FixedContentsCtrl', function ($scope, $rootScope,$log, $state, $location) {
      var vm = this;

      switch($rootScope.currentState){
        case 'homegeneral':
          vm.paginaId = 1;
          vm.paginalabel = 'Inicio';
          break;
        case 'productgeneral':
          vm.paginaId = 2;
          vm.paginalabel = 'Productos';
          break;
        case 'paymentgeneral':
          vm.paginaId = 3;
          vm.paginalabel = 'Pagos';
          break;
        case 'bloggeneral':
          vm.paginaId = 5;
          vm.paginalabel = 'Contactos';
          break;
        case 'contactgeneral':
          vm.paginaId = 4;
          vm.paginalabel = 'Contactos';
          break;
      }


      vm.rules = [
        {
          field: 'paginas_id',
          label: 'Página',
          active: false,
          activeGrid: false,
          activeForEdit: false,
          activeForCreate: false,
        },
        {
          field: 'nombre',
          label: 'Campo',
          disabled: true,
          required: true
        },
        {
          field: 'contenido_es',
          label: 'Contenido',
          language:'es',
          required: true,
          activeGrid:false,
          toolbar:[
            [ 'h5', 'h6', 'p'],
            ['bold', 'italics', 'underline', 'strikeThrough'],
            /* ['ul', 'ol'],*/
            [ 'undo', 'redo', 'clear'],
            //['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
            ['html'],
            ['insertLink'],
            //[, 'insertImage','insertLink', 'insertVideo'],
            ['wordcount', 'charcount']
          ],
          resolve: {
            helpText: function (dataset, selected) {
              //////console.log('seleccionado', selected.id);
              switch (selected.id) {
                default:
                  return '';
                case 23:
                  return 'Formato sugerido JPG 1440x900';
                case 36:
                  return 'Formato sugerido JPG 1440x900';
                case 37:
                  return 'Formato sugerido JPG 1440x900';
                case 39:
                  return 'Formato sugerido JPG 1440x900';
                case 26:
                  return 'Formato sugerido JPG 600x350';
                case 29:
                  return 'Formato sugerido JPG 600x350';
                case 19:
                  return 'Formato sugerido JPG 600x350';
              }
            },
            type: function (dataset, selected) {
              if (selected) {
                if (selected.html == 2) {
                  return 'file'
                }
                if (selected.html == 3) {
                  return 'pdf'
                }
                if (selected.html == 1) {
                  return 'textarea'
                }
                if (selected.html == 0)  {
                  return 'text'
                }
              }
            },
          }
        },
        {
          field:'contenido_en',
          label: 'Contenido',
          activeGrid:false,
          language:'en',
          toolbar:[
            //[ 'h5', 'h6', 'p'],
            ['bold', 'italics', 'underline', 'strikeThrough'],
            /* ['ul', 'ol'],*/
            [ 'undo', 'redo', 'clear'],
            //['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
            ['html'],
            ['insertLink'],
            //[, 'insertImage','insertLink', 'insertVideo'],
            ['wordcount', 'charcount']
          ],
          resolve: {
            active: function (dataset, selected) {
              if (selected) {
                if (selected.html == 2 || selected.html == 3) {
                  return false;
                }
                if (selected.html == 1 || selected.html == 0) {
                  return true;
                }
              }
            },
            type: function (dataset, selected) {
              if (selected) {
                if (selected.html == 2) {
                  return 'file'
                }
                if (selected.html == 3) {
                  return 'pdf'
                }
                if (selected.html == 1) {
                  return 'textarea'
                }
                if (selected.html == 0)  {
                  return 'text'
                }
              }
            },
          }
        },
        {
          field: 'html',
          label: 'HTML',
          active:false,
          activeGrid: false,
          activeForEdit: false,
          activeForCreate: false,

        }
      ];

      vm.rulesForImages = [
        {
          field: 'paginas_id',
          label: 'Página',
          active: false,
          activeGrid: false,
          activeForEdit: false,
          activeForCreate: false,
        },
        {
          field: 'imagen',
          label: 'Archivo',
          required: true,
          /*activeForCreate: true,
           activeForEdit: true,*/
          resolve: {
            type: function (dataset, selected) {
              if (selected) {
                if (selected.tipo == 0) {
                  return 'file'
                }
                else {
                  return 'pdf'
                }
              }

            }
          }
        },
        {
          field: 'tipo',
          label: 'Tipo',
          activeGrid: false
        }
      ];
      vm.options={
        create: false,
        read:false,
        update:true,
        delete:false,
        goToOwnState:false,
        relationsLinks:false
      };


    })
})();

/**
 * Created by FER-PC-WIN10 on 28/08/2017.
 */

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .controller('CrudGeneratorCtrl', function (TablesService,$rootScope ,$scope, $http) {

      $scope.rules = [
        {
          field: 'test_id',
          label: 'Categoria',
          itemsLabel: 'title',
          required: true,
          order: 1
        }
      ];

      $scope.crudStep = 1;

      $scope.data = {
        model:"",
        dataEstructure: [],
        permissions: {insert:'', update:'', delete:'', review:''},
        administration: {section:'', group:''}
      }

      $scope.addField = function (){
        $scope.data.dataEstructure.push (
          {
            "dbField": "",
            "dbType": "TEXT",
            "dbSize": "",
            "dbDefault": "",
            "dbNull": false,
            "dbIndex": "",
            "dbFkTable": "",
            "dbFkField": "",
            "dbFkCascadeDelete": false,
            "dbComment": "",
            "dbAutoTraduction": false,
            "dbLanguages": [
              'es',
              'en'/*,
              'fr',
              'pt',
              'de',
              'it'*/
            ],
            "modelLabel": "",
            "modelType": "text",
            "modelRequired": true,
            "modelDisabled": false,
            "showDB":false,
            "showMV":false,
          }
        )
      }

      $scope.deleteField = function (sourceF,index){
        $scope.data.dataEstructure.splice(index, index+1);
      }

      $scope.changeFormDetail = function (source, type ,value){
        source[type] = !source[type]
      }

      $scope.changeValue = function( value){
        $scope.crudStep = value;
      }

      $scope.generateCrud = function (){
        console.log('modelo', $scope.data)
        TablesService.corebuild( $scope.data )
          .success(function (res) {
            console.log(res)
            $rootScope.buildtemp = res;
          })
      }

      $scope.onFileChange = function (fileEl) {
        var files = fileEl.files;
        var file = files[0];
        var reader = new FileReader();
        reader.onloadend = function(evt) {
          if (evt.target.readyState === FileReader.DONE) {
            $scope.$apply(function () {
              $scope.something = JSON.parse(evt.target.result);
              console.log("JSON",$scope.something);
              $scope.data = $scope.something;
            });
          }
        };
        reader.readAsText(file);
      };

      $scope.modelvalid =false;

      $scope.verifyModelName = function (){
        for ( var i = 0; i < $scope.migrations.length ; i++){
          if($scope.migrations[i].table== $scope.data.model){
            console.log('elemento repetido')
            $scope.modelvalid =false;
            break;
          }
          else{
            $scope.modelvalid =true;
            console.log('tabla valida')
          }
        }
      };

      //Services to extract list of tables and permissions
      $scope.getDataTowork = function () {
        TablesService.getTable( {table:'all'})
          .success(function (res) {
            //console.log(res)
            $scope.migrations = res.resultado;
          });
        /*TablesService.getTable( {table:'permisos'})
          .success(function (res) {
            //console.log(res)
            $scope.permissions = res.resultado;
          });*/
        /*TablesService.listar( 'vistas' )
         .success(function (res) {
         console.log(res)
         $scope.pages = res.resultado;
         });*/
      };

      $scope.getDataTowork();

      $scope.getTableColumns = function (table){
        TablesService.getTableColumns({table:table})
          .success(function (res) {
            console.log(res);
            $scope.migrationsColunns = res.resultado;
          })
      }

      $scope.createPermission = function (data) {
        TablesService.almacenar('permisos', data)
          .success(function (res) {
            $scope.last = res.resultado;
            TablesService.getTable({table: 'permisos'})
              .success(function (res) {
                $scope.permissions = res.resultado;
                for (var i = 0; i < $scope.permissions.length; i++) {
                  if($scope.permissions[i].id==$scope.last){
                    $scope.data.permissions[$scope.temp ] = $scope.permissions[i].id;
                    break;
                  }
                }
              });
          });
      };

      $scope.createView = function (data) {
        TablesService.almacenar('vistas', data)
          .success(function (res) {
            $scope.last = res.resultado;
            TablesService.listar( 'vistas' )
              .success(function (res) {
                $scope.pages = res.resultado;
                for (var i = 0; i < $scope.pages.length; i++) {
                  if($scope.pages[i].id==$scope.last){
                    $scope.data.administration[$scope.temp ] = $scope.pages[i].id;
                    break;
                  }
                }
              });
          });
      };

      $scope.setTempValue = function(temp){
        $scope.temp = temp;
        console.log('valor temporal: ',$scope.temp)
      };

      $scope.closeModal=function(targetModal){
        angular.element('#'+targetModal).modal('hide');
        angular.element('body').removeClass('modal-open');
        angular.element('.modal-backdrop').remove();
      };



      /// tools for develope
      $scope.print = function (target){
        console.log(target + ': ',$scope[target])
      }





    })

})();

'use strict';
angular
  .module('frontendapp')
  .controller('AdminController', function (UserService, ImageLoader, $window,
                                          toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    $log.debug('AdminController');

    vm.userFilterSet = {
      firstname: {
        value:'',
        operator:'like',
        type: 'autocomplete'
      },
      lastname: {
        value:'',
        operator:'like',
        type: 'autocomplete'
      },
      email: {
        value:'',
        operator:'like',
        type: 'search'
      }
    };

    vm.warehouseuser = {
      component:'grid',
      model:'warehouse',
      customFilters: {
        filters: {
          name: {
            type : 'search',
            operator: 'like',
            value: ''
          },
        }
      },
      /*customProperties: {
        partnercategory_id: {
          hide: true,
          hideGrid: true
        }
      }*/
    };

    vm.partnerconfig = {
      component:'grid',
      model:'partner',
      customFilters: {
        //selected: 1,
        filters: {
          type: {
            //type : 'autocomplete',
            operator: 'like',
            value: '1'
          },
          name: {
            type : 'search',
            operator: 'like',
            value: ''
          },
        }
      },
      customProperties: {
        clientdiscount: {
          hide: true,
          hideGrid: true
        },
        partnercontact: {
          hide: true,
          hideGrid: true
        },
        partnercategory_id: {
          hide: false,
          hideGrid: false
        },
        type: {
          default: 1,
          disabled:true,
          hideGrid: true
        }
      }
    };

    vm.userconfig = {
      component:'grid',
      model:'user',
      customProperties:{
        email:{
          helpText:'hola!!',
          resolve: {
            helpText: function (model) {
              if(model.model == 'user'){
                return '* hola user';
              }
              return 'pfff';
            },
          }
        }
      }
      /*customFilters:{
        selected:1,
        filters: {
          email:{
            type : 'autocomplete',
            operator:'like',
            value:'gmail'
          }
        }
      }*/
    }

  });

(function() {
  'use strict';

  angular
      .module('frontendapp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, localStorageService, toastr, UserService, $timeout, $window, $auth) {
    //$rootScope.api = 'http://localhost:8000';
    //$rootScope.api = 'http://192.168.0.13:8000';
    $rootScope.api = 'http://guiberp.aknatechnologies.com/restapi/public';
    //$rootScope.api = 'http://guiberp2.aknatechnologies.com/restapi/public';
    $rootScope.switchText = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };

    $rootScope.language = 'es';

    $rootScope.obtenerVarSession = function (key) {
      return localStorageService.get(key);
    };

    $rootScope.asignarVarSession = function (key, val) {
      return localStorageService.set(key, val);
    };

    $rootScope.eliminarVarSession = function () {
      return localStorageService.clearAll();
    };

    $rootScope.changeLanguage = function (value, state) {
      console.log('cambia lenguaje');
      $rootScope.language = value;
      $rootScope.asignarVarSession('language', value);
      $state.go(state, {lan: value});
    };

    $rootScope.logout = function () {
      $auth.logout().then(function () {
        if (!$rootScope.logued()) {
          $rootScope.eliminarVarSession();
          //console.log('sesion terminada')
          location.href = './auth';
        }
      });
    };
    $rootScope.logued = function () {
      //////console.log('ejecuta logued')
      //console.log('step 2')
      $rootScope.actS = $auth.isAuthenticated();
      $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
      if(!$rootScope.currentUser){
        /*$rootScope.tk = $auth.getToken();
        $rootScope.asignarVarSession('token', $auth.getToken());
        console.log('step 1', $rootScope.tk);
        UserService.owneraccount()
          .success(function (user) {
            console.log('step 2', user);
            $rootScope.asignarVarSession('currentUser', user.profile);
            $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
          })
          .error(function(res){
            console.log('error2',res)
          })*/
      }
      return $rootScope.actS;
    };

    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////

    $rootScope.infoMenu = false;
    $rootScope.alertMenu = false;

    $rootScope.showInfoMenu = function (value) {
      console.log('infoMenu');
      $rootScope.infoMenu = value?value:!$rootScope.infoMenu;
    };
    $rootScope.showAlertMenu = function (value) {
      console.log('alertMenu');
      $rootScope.alertMenu = value?value:!$rootScope.alertMenu;
    };

    $rootScope.appMenu = false;

    $rootScope.showAppMenu = function () {
      console.log('infoMenu');
      $rootScope.appMenu = !$rootScope.appMenu;
    };

    //$rootScope.currentModule = 'default';
    $rootScope.switchModule = function (value){
      $rootScope.asignarVarSession('currentModule', value);
      $rootScope.currentModule = $rootScope.obtenerVarSession('currentModule');
      //console.log('nuevo modulo', $rootScope.currentModule );
    };

    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////

    $rootScope.showNotsGlobal = false;

    $rootScope.globalParams = {
      currency : 'Bs.',
      TcUSD : 6.96
    };

    $rootScope.showNotsG = function () {
      //console.log('showNotsG');
      $rootScope.showNotsGlobal = !$rootScope.showNotsGlobal;
    };

    $rootScope.showSideBar = false;
    $rootScope.showSideBarG = function () {
      //console.log('showSideBar');
      $rootScope.showSideBar = !$rootScope.showSideBar;
    };

    $rootScope.access = function (aliasList){
      var access = false;
      angular.forEach(aliasList, function (alias){
        angular.forEach($rootScope.currentUser.userrole, function(u){
          if(u.appmodulerole.alias == alias || u.appmodulerole.alias == 'super-admin' ) access = true;
        });
        //console.log('MATCH ', alias, ' = ', access);
      });
      //console.log('ACCESO ',  access);
      return access;
    };

    $rootScope.uiAccess = function (state){
      //console.log('uiAccess', state);
      if($rootScope.logued()) {
        var target = $state.get(state);
        if(target){
          var exit = $rootScope.access(target.data.roles);
        }
        else{
          var exit = true;
        }
      }
      return  exit;
    };

    /*var test = $state.get('purchase-point');
    console.log('test', test.data.roles);*/


    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      // auto scroll to top
      $("html, body").animate({scrollTop: 0}, 1000);

      // state validations
      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.currentState = $state.current.name;
      $rootScope.currentModule = $rootScope.obtenerVarSession('currentModule');

      //console.log('$rootScope.currentModule ',$rootScope.currentModule );
      $rootScope.publicStates = [
        'auth',
        'activate',
        'activatelink',
        'forgot',
        'reset'
      ];
      if (!$rootScope.logued() && $rootScope.publicStates.indexOf($state.current.name)==-1 ) {
        $rootScope.logout();
      }

      //activation logic interaction
      if($rootScope.logued()){
        if($rootScope.currentUser.status == 0){
          console.log('redirecciona new password');
          $state.go('newpassword', {lan: $rootScope.language});
          toastr.info($rootScope.switchText('Cree una contraseña para continuar','Create a new password to continue'), 'Atención' );
        }
        else{
           $rootScope.validateURD ();
        }
        /*if($rootScope.currentUser.status == 1 && $rootScope.currentState == 'newpassword'){
          $state.go('profile', {lan: $rootScope.language});
        }*/
        var roles = (toState.data)?toState.data.roles:null;
        if(roles){
          //console.log('VALIDATING ', $rootScope.currentState, roles);
          if(!$rootScope.access(roles)){
            toastr.error('Acceso denegado','AKNA - SUITE');
            $state.go('home', {lan: $rootScope.language});
          }
        }



        if($rootScope.currentState == 'sales' || $rootScope.currentState == 'inventory' ||  $rootScope.currentState == 'purchases' ){
          console.log('LOAD NOTIFICATIONS ON MAIN');
          $rootScope.getNotifications();
        }
      }

      // language configuration
      var x = $rootScope.obtenerVarSession('language');
      (x) ? $rootScope.language = x : $rootScope.language = 'es';
      //console.log('actual', $rootScope.currentState, x)

      $rootScope.infoMenu = false;

      //temporal viewTitle
      //console.log('ANCESTORS', $state.$current.includes);
      angular.forEach($state.$current.includes, function (value, key){
        //console.log(key, value);
        switch (key) {
          case 'inventory':
          case 'purchases':
          case 'sales':
          case 'accounting':
          case 'admin':
          case 'dashboard':
          case 'crm':
          case 'wcms':
            $rootScope.switchModule(key);
            break;
          default:
            break;
        }
      });



      $rootScope.appMenu = false;

      $rootScope.getCurrentTitle();
      $rootScope.globalId = $state.params.id;
      $rootScope.ready=true;

      //console.log('globalId',$rootScope.globalId )
    });

    $rootScope.getCurrentTitle = function (){
      //console.log('modulo', $rootScope.currentModule)
      $rootScope.currentTitle ="";
      $rootScope.currentSec ="";
      if ($rootScope.currentState == $rootScope.currentModule){
        switch ($state.current.name) {
          case 'inventory':
            $rootScope.currentTitle = 'Inventarios';
            break;
          case 'purchases':
            $rootScope.currentTitle = 'Compras';
            break;
          case 'sales':
            $rootScope.currentTitle = 'Ventas';
            break;
          case 'accounting':
            $rootScope.currentTitle = 'Contabilidad';
            break;
          case 'admin':
            $rootScope.currentTitle = 'Administración';
            break;
          case 'dashboard':
            $rootScope.currentTitle = 'Tablero de control';
            break;
        }
      }
      else{
        angular.forEach( $rootScope.appMenuItems[$rootScope.currentModule] ,function(value, key){
          if (value.items){
            $rootScope.mapLevel(value);
          }
          else{
            $rootScope.currentTitle = value.label;
          }
        });
      }
      if ($rootScope.currentState=='home'){
        $rootScope.currentTitle = 'Inicio';
      }

      //console.log('titulo actual', $rootScope.currentTitle, $rootScope.currentState);
      return  $rootScope.currentTitle;
    };

    $rootScope.mapLevel = function (target){
      angular.forEach( target.items ,function(value, key){
        if(value.state == $rootScope.currentState){
          //console.log('encontrado en', value, target);
          $rootScope.currentTitle = value.label;
          $rootScope.currentSec = target.label;
        }
      });
    };


    $rootScope.backTop = function () {
      $("html, body").animate({scrollTop: 0}, 1000);
    };

    $rootScope.stateGoParent = function () {
      $state.go('^');
    };

    $rootScope.stateGo = function (state, params) {
      $state.go(state, params);
    };

    $log.debug('intenet explerer navigator', window.navigator.userAgent);
    if (navigator.userAgent.indexOf("MSIE") != -1) {
      $log.debug('intenet explerer navigator', window.navigator.userAgent);
    }

    $rootScope.customModal = {
      visible: false,
      ngClass: '',
      ngTemplate: '',
      target: '',
      data: {}
    };

    $rootScope.openCustomModal = function (template, target) {
      console.log('abre menu')
      $rootScope.customModal.visible = true;
      $rootScope.customModal.ngTemplate = template;
      $rootScope.customModal.target = target;
    };

    $rootScope.closeCustomModal = function () {
      console.log('cierra menu');
      $rootScope.customModal.visible = false;
    };

    $rootScope.validateURD = function(){
       //console.log('validateURD');
       if($rootScope.currentUser.partner.length==0){
          toastr.error('Empleado no registrado','Advertencia');
          $state.go('home', {lan: $rootScope.language});
       }
       angular.forEach($rootScope.currentUser.userrole, function(u){
         //console.log('ROL VERIFICADO', u.appmodulerole.alias);
         switch( u.appmodulerole.alias ){

            case 'vendedor-visitador':
            case 'vendedor-punto-de-venta':
              if($rootScope.currentUser.cashregisteruser.length==0){
                 toastr.error('Caja registradora no asignadas','Advertencia');
                 $state.go('home', {lan: $rootScope.language});
              }
              break;

            case 'gestor-global-de-inventario':
            case 'gestor-local-de-inventario':
                if($rootScope.currentUser.warehouseuser.length==0){
                   toastr.error('Almacen no asignado','Advertencia');
                   $state.go('home', {lan: $rootScope.language});
                }
                break;

            case 'gestor-de-compras':

                 break;
          }
        });
      }



    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');
    $stateProvider

      ///////////////////////////////////////////////
      ///////////// AUTHENTICATION //////////////////
      ///////////////////////////////////////////////
      .state('print', {
        url: '/es/print/:id',
        templateUrl: 'app/views/print.html',
        controller: 'printCtrl',
        controllerAs: 'print',

      })
      .state('printstockorder', {
        url: '/es/printstockorder/:id',
        templateUrl: 'app/views/printstockorder.html',
        controller: 'printCtrl',
        controllerAs: 'print'
      })
      .state('printtransaction', {
        url: '/es/printtransaction/:id',
        templateUrl: 'app/views/printtransaction.html',
        controller: 'printCtrl',
        controllerAs: 'print'
      })
      .state('printcashregisterlog', {
        url: '/es/printcashregisterlog/:id/:filter',
        templateUrl: 'app/views/printcashregisterlog.html',
        controller: 'printCtrl',
        controllerAs: 'print'
      })
      .state('auth', {
        url: '/auth',
        templateUrl: 'app/views/auth/login.html',
        controller: 'LoginCtrl',
        controllerAs: 'auth'
      })
      .state('activate', {
        url: '/activate',
        templateUrl: 'app/views/auth/activate.html',
        controller: 'LoginCtrl',
        controllerAs: 'auth'
      })
      .state('activatelink', {
        url: '/activatelink/:ac/:rtk',
        templateUrl: 'app/views/auth/activate.html',
        controller: 'LoginCtrl',
        controllerAs: 'auth'
      })
      .state('forgot', {
        url: '/forgot',
        templateUrl: 'app/views/auth/forgot.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      .state('reset', {
        url: '/reset/:ac/:rtk',
        templateUrl: 'app/views/auth/reset.html',
        controller: 'ResetController',
        controllerAs: 'us'
      })
      .state('profile', {
        parent: 'home',
        url: '/profile',
        templateUrl: 'app/views/auth/profile.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      .state('password', {
        parent: 'home',
        url: '/password',
        templateUrl: 'app/views/auth/password.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      .state('newpassword', {
        url: '/newpassword',
        parent: 'home',
        templateUrl: 'app/views/auth/newpassword.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      ///////////////////////////////////////////////
      ///////////// AUTHENTICATION //////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ///////////// AKNA SUITE MAIN /////////////////
      ///////////////////////////////////////////////
      .state('home', {
        url: '/:lan',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/appmain.html',
        data: {
          displayName: 'Inicio'
        }
      })
      ///////////////////////////////////////////////
      ///////////// AKNA SUITE MAIN /////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      /////////////// SYSTEM TOOLS //////////////////
      ///////////////////////////////////////////////
      .state('crudgenerator', {
        parent: 'home',
        templateUrl: 'app/views/crudgenerator/crudgenerator_home.html',
        url: '/crudgenerator',
        controller: 'CrudGeneratorCtrl',
        data: {displayName: 'Generador MVC'}
      })
      ///////////////////////////////////////////////
      /////////////// SYSTEM TOOLS //////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      /////////////////// ADMIN /////////////////////
      ///////////////////////////////////////////////
      .state('admin', {
        url: '/admin',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Administración',
          roles: (function() {
            return ['super-admin'];
          })()
        }
      })
      .state('user', {
        url: '/user',
        parent: 'admin',
        templateUrl: 'app/admin/user.html',
        controller: 'UserController',
        controllerAs: 'us',
      })
      .state('userrole', {
        url: '/userrole',
        parent: 'admin',
        templateUrl: 'app/admin/userrole.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      .state('vouchertype', {
        url: '/vouchertype',
        parent: 'admin',
        templateUrl: 'app/views/default/defaultcrud.html',
      })
      .state('building', {
        url: '/building',
        parent: 'admin',
        templateUrl: 'app/views/default/defaultcrud.html',
      })
      .state('location', {
        url: '/location',
        parent: 'admin',
        templateUrl: 'app/views/default/defaultcrud.html',
      })
      .state('syscommunicate', {
        url: '/syscommunicate',
        parent: 'admin',
        templateUrl: 'app/views/default/defaultcrud.html',
      })
      .state('admin-partner', {
        url: '/admin-partner',
        parent: 'admin',
        templateUrl: 'app/admin/admin-partner.html',
        controller: 'AdminController',
        controllerAs: 'ad'
      })
      .state('admin-warehouse', {
        url: '/admin-warehouse',
        parent: 'admin',
        templateUrl: 'app/admin/admin-warehouse.html',
        controller: 'AdminController',
        controllerAs: 'ad'
      })
      .state('admin-cashregister', {
        url: '/admin-cashregister',
        parent: 'admin',
        templateUrl: 'app/admin/admin-cashregister.html',
        controller: 'AdminController',
        controllerAs: 'ad'
      })
      .state('admin-accountbank', {
        url: '/admin-accountbank',
        parent: 'admin',
        templateUrl: 'app/admin/admin-accountbank.html',
        controller: 'AdminController',
        controllerAs: 'ad'
      })

      ///////////////////////////////////////////////
      /////////////////// ADMIN /////////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ///////////////// PURCHASES ///////////////////
      ///////////////////////////////////////////////
      .state('purchases', {
        url: '/purchases',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Compras',
          roles: (function() {
            return ['super-admin','gestor-de-compras'];
          })()
        }
      })
      //ACTIONS
      .state('purchase-point', {
        url: '/purchase-point/:id',
        parent: 'purchases',
        templateUrl: 'app/purchase/purchase-point.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur',
      })
      .state('purchase-product-catalogue', {
        url: '/purchase-product-catalogue/:id',
        parent: 'purchases',
        templateUrl: 'app/purchase/purchase-product-catalogue.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur'
      })
      .state('supplier', {
        url: '/supplier',
        parent: 'purchases',
        templateUrl: 'app/purchase/supplier.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur'
      })
      //LOGS
      .state('hist-purchase-cotization', {
        url: '/hist-purchase-cotization',
        parent: 'purchases',
        templateUrl: 'app/purchase/hist-purchase-cotization.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur'
      })
      .state('hist-purchase', {
        url: '/hist-purchase',
        parent: 'purchases',
        templateUrl: 'app/purchase/hist-purchase.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur'
      })
      //TRANSACTIONS
      .state('purchases-debts', {
        url: '/purchases-debts',
        parent: 'purchases',
        templateUrl: 'app/purchase/purchases-debts.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur'
      })
      .state('purchases-transactions', {
        url: '/purchases-transactions',
        parent: 'purchases',
        templateUrl: 'app/purchase/purchases-transactions.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur'
      })
      //CONFIG
      .state('purchases-accountbank', {
        url: '/purchases-accountbank',
        parent: 'purchases',
        templateUrl: 'app/purchase/purchases-accountbank.html',
        controller: 'PurchaseCtrl',
        controllerAs: 'pur'
      })
      ///////////////////////////////////////////////
      ///////////////// PURCHASES ///////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ////////////////// INVENTORY //////////////////
      ///////////////////////////////////////////////
      .state('inventory', {
        url: '/inventory',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
       /* controller: 'inventoryCtrl',
        controllerAs: 'pro',*/
        data: {
          displayName: 'Inventarios',
          roles: (function() {
            return [
              'super-admin',
              'gestor-global-de-inventario',
              'gestor-local-de-inventario',
            ];
          })()
        },
      })
      .state('transfer-point', {
        url: '/transfer-point',
        parent: 'inventory',
        templateUrl: 'app/inventory/transfer-point.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
      })
      .state('pend-purchases-incomes', {
        url: '/pend-purchases-incomes',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/pend-purchases-incomes.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('pend-transfer-incomes', {
        url: '/pend-transfer-incomes',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/pend-transfer-incomes.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('stock', {
        url: '/stock',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/stock.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      //CONFIG
      .state('productfamily', {
        url: '/productfamily',
        parent: 'inventory',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      .state('productcategory', {
        url: '/productcategory',
        parent: 'inventory',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      .state('productbrand', {
        url: '/productbrand',
        parent: 'inventory',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      .state('productline', {
        url: '/productline',
        parent: 'inventory',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      .state('productgroup', {
        url: '/productgroup',
        parent: 'inventory',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      .state('productcombo', {
        url: '/productcombo',
        parent: 'inventory',
        templateUrl: 'app/inventory/admin/productcombo.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },

      })
      .state('product', {
        url: '/product',
        parent: 'inventory',
        templateUrl: 'app/inventory/admin/product.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      .state('productmeasure', {
        url: '/productmeasure',
        parent: 'inventory',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      .state('warehouse', {
        url: '/warehouse',
        parent: 'inventory',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        },
      })
      //HIST
      .state('hist-movement', {
        url: '/hist-movement',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/hist-movement.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('hist-adjust', {
        url: '/hist-adjust',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/hist-adjust.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('hist-transfer', {
        url: '/hist-transfer',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/hist-transfer.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('hist-transfer-request', {
        url: '/hist-transfer-request',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/hist-transfer-request.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('hist-purchases-incomes', {
        url: '/hist-purchases-incomes',
        parent: 'inventory',
        templateUrl: 'app/inventory/reports/hist-purchases-incomes.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      //INVENTORY OPERATIONS
      .state('op-transfer-request',   {
        url: '/op-transfer-request',
        parent: 'inventory',
        templateUrl: 'app/inventory/operations/op-transfer-request.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('op-transfer', {
        url: '/op-transfer',
        parent: 'inventory',
        templateUrl: 'app/inventory/operations/op-transfer.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('op-purchases-incomes', {
        url: '/op-purchases-incomes',
        parent: 'inventory',
        templateUrl: 'app/inventory/operations/op-purchases-incomes.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      //OLDER REPORTS
      .state('lowerstock', {
        url: '/lowerstock',
        parent: 'inventory',
        templateUrl: 'app/inventory/lowerstock.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      .state('productkardex', {
        url: '/productkardex',
        parent: 'inventory',
        templateUrl: 'app/inventory/product-kardex.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro'
      })
      ///////////////////////////////////////////////
      ////////////////// INVENTORY //////////////////
      ///////////////////////////////////////////////


      ///////////////////////////////////////////////
      /////////////////// SALES /////////////////////
      ///////////////////////////////////////////////
      .state('sales', {
        url: '/sales',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Ventas',
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
              'mensajero'
            ];
          })()
        }
      })
      //MANAGEMENT
      .state('sales-point', {
        url: '/sales-point/:id',
        parent: 'sales',
        templateUrl: 'app/sales/management/sales-point.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
            ];
          })()
        }
      })
      .state('sales-mobile-point', {
        url: '/sales-mobile-point/:id',
        parent: 'sales',
        templateUrl: 'app/sales/management/sales-mobile-point.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('sales-mobile-requests', {
        url: '/sales-mobile-requests/:id',
        parent: 'sales',
        templateUrl: 'app/sales/management/sales-mobile-requests.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('sales-product-catalogue', {
        url: '/sales-product-catalogue/:id',
        parent: 'sales',
        templateUrl: 'app/sales/management/sales-product-catalogue.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('sales-clients', {
        url: '/sales-clients/:id',
        parent: 'sales',
        templateUrl: 'app/sales/management/sales-clients.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal'
      })
      .state('sales-seller-agenda', {
        url: '/sales-seller-agenda/:id',
        parent: 'sales',
        templateUrl: 'app/sales/management/sales-seller-agenda.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal'
      })
      .state('sales-cash-concilation', {
        url: '/sales-cash-concilation/:id',
        parent: 'sales',
        templateUrl: 'app/sales/management/sales-cash-concilation.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
            ];
          })()
        }
      })
      //DELIVERY
      .state('sales-delivery-point', {
        url: '/sales-delivery-point/:id',
        parent: 'sales',
        templateUrl: 'app/sales/delivery/sales-delivery-point.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('sales-delivery-point-7', {
        url: '/sales-delivery-point-7/:id',
        parent: 'sales',
        templateUrl: 'app/sales/delivery/sales-delivery-point-7.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('sales-delivery-point-10', {
        url: '/sales-delivery-point-10/:id',
        parent: 'sales',
        templateUrl: 'app/sales/delivery/sales-delivery-point-10.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('sales-delivery-point-11', {
        url: '/sales-delivery-point-11/:id',
        parent: 'sales',
        templateUrl: 'app/sales/delivery/sales-delivery-point-11.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      //DEBTS
      .state('sales-debts', {
        url: '/sales-debts/:id',
        parent: 'sales',
        templateUrl: 'app/sales/sales-debts.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
              'mensajero',
            ];
          })()
        }
      })
      .state('sales-transactions', {
        url: '/sales-transactions/:id',
        parent: 'sales',
        templateUrl: 'app/sales/sales-transactions.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
              'mensajero',
            ];
          })()
        }
      })
      //LOGS
      .state('hist-cotization', {
        url: '/hist-cotization/:id',
        parent: 'sales',
        templateUrl: 'app/sales/logs/hist-cotization.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('hist-sales', {
        url: '/hist-sales/:id',
        parent: 'sales',
        templateUrl: 'app/sales/logs/hist-sales.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('hist-consignation', {
        url: '/hist-consignation/:id',
        parent: 'sales',
        templateUrl: 'app/sales/logs/hist-consignation.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('hist-rent', {
        url: '/hist-rent/:id',
        parent: 'sales',
        templateUrl: 'app/sales/logs/hist-rent.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('hist-seller-request', {
        url: '/hist-seller-request/:id',
        parent: 'sales',
        templateUrl: 'app/sales/logs/hist-seller-r.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      //CASH REGISTER
      .state('hist-cashregister', {
        url: '/hist-cashregister/:id',
        parent: 'sales',
        templateUrl: 'app/sales/reports/hist-cashregister.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('hist-cash-conciliate', {
        url: '/hist-cash-conciliate/:id',
        parent: 'sales',
        templateUrl: 'app/sales/reports/hist-cash-conciliate.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('hist-vouchertransaction', {
        url: '/hist-vouchertransaction/:id',
        parent: 'sales',
        templateUrl: 'app/sales/reports/hist-vouchertransaction.html',
        controller: 'SaleCtrl',
        controllerAs: 'sal',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      //CONFIG
      .state('cashregister', {
        url: '/cashregister/:id',
        parent: 'sales',
        templateUrl: 'app/views/default/defaultcrud.html',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        }
      })
      .state('partnercategory', {
        url: '/partnercategory',
        parent: 'sales',
        templateUrl: 'app/views/default/defaultcrud.html',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        }
      })
      ///////////////////////////////////////////////
      /////////////////// SALES /////////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ////////////////// ACCOUNTING /////////////////
      ///////////////////////////////////////////////
      .state('accounting', {
        url: '/accounting',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        controller:'AccountingCtrl',
        data: {
          displayName: 'Contabilidad',
          roles: (function() {
            return ['super-admin'];
          })()
        }
      })
      .state('accounting-accountbank', {
        url: '/accounting-accountbank',
        parent: 'accounting',
        templateUrl: 'app/accounting/accounting-accountbank.html',
        controller: 'AccountingCtrl',
        controllerAs: 'acc'
      })
      .state('pend-cashregister', {
        url: '/pend-cashregister/:id',
        parent: 'accounting',
        templateUrl: 'app/accounting/pend-cashregister.html',
        controller: 'AccountingCtrl',
        controllerAs: 'acc',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('hist-acc-cashregister', {
        url: '/hist-acc-cashregister/:id',
        parent: 'accounting',
        templateUrl: 'app/accounting/hist-acc-cashregister.html',
        controller: 'AccountingCtrl',
        controllerAs: 'acc',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('cashregisterlog', {
        url: '/cashregisterlog/:id',
        parent: 'accounting',
        templateUrl: 'app/views/default/defaultcrud.html',
        controller: 'AccountingCtrl',
        controllerAs: 'acc',
        data: {
          roles: (function() {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
            ];
          })()
        }
      })
      .state('accounting-cashregister', {
        url: '/accounting-cashregister/:id',
        parent: 'accounting',
        templateUrl: 'app/accounting/accounting-cashregister.html',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        }
      })
      .state('product-kardex', {
        url: '/product-kardex/:id',
        parent: 'accounting',
        templateUrl: 'app/accounting/product-kardex.html',
        controller: 'AccountingCtrl',
        controllerAs: 'acc',
        data: {
          roles: (function() {
            return [
              'super-admin',
            ];
          })()
        }
      })

      ///////////////////////////////////////////////
      ////////////////// ACCOUNTING /////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ////////////////// DASHBOARD //////////////////
      ///////////////////////////////////////////////
      .state('dashboard', {
        url: '/dashboard',
        parent: 'home',
        templateUrl: 'app/dashboard/main.html',
        data: {
          displayName: 'Tablero de control',
          roles: (function() {
            return ['super-admin'];
          })()
        }
      })
      .state('story1', {
        url: '/story1',
        parent: 'dashboard',
        templateUrl: 'app/dashboard/story1.html',
        controller: 'dashboardCtrl',
        controllerAs: 'da',
      })
      ///////////////////////////////////////////////
      ////////////////// DASHBOARD //////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      //////////////////// WCMS /////////////////////
      ///////////////////////////////////////////////
      .state('wcms', {
        url: '/wcms',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {displayName: 'Contenidos web'}
      })
      .state('contents', {
        url: '/contents/:model/:type',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/contents.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      ///////////////////////////////////////////////
      //////////////////// WCMS /////////////////////
      ///////////////////////////////////////////////



    ;

  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendapp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider, $authProvider, localStorageServiceProvider) {
    /*// Set the default quality
    $colorThiefProvider.setDefaultQuality(50);

    // Set the default palette color count
    $colorThiefProvider.setDefaultColorCount(5);

    // Set wether to return arrays (ColorThief's default) or
    // objects like {r: 242, g: 124, b: 91} (false by default).
    $colorThiefProvider.setReturnObjects(true);*/

    // Login
    //$authProvider.loginUrl = 'http://localhost:8000/api/authenticate';
    //$authProvider.loginUrl = 'http://192.168.0.13:8000/api/authenticate';
    $authProvider.loginUrl = 'http://guiberp.aknatechnologies.com/restapi/public/api/authenticate';                                                                                                                                                          $authProvider.loginUrl = 'http://guiberp.aknatechnologies.com/restapi/public/api/authenticate';
    //$authProvider.loginUrl = 'http://guiberp2.aknatechnologies.com/restapi/public/api/authenticate';

    localStorageServiceProvider
      .setPrefix('adminApp')
      .setStorageType('localStorage')
      .setNotify(true, true);


    // Enable logui
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.preventOpenDuplicates = false;
    toastrConfig.progressBar = true;
    new WOW().init();
  }

})();

angular.module("frontendapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/accounting/accounting-accountbank.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Cuentas bancarias\" ui-first-level=\"{component:\'grid\',model:\'accountbank\'}\"></uibuilder></div>");
$templateCache.put("app/accounting/accounting-cashregister.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Cajas registradoras\" ui-first-level=\"{component:\'grid\',model:\'cashregister\'}\"></uibuilder></div>");
$templateCache.put("app/accounting/hist-acc-cashregister.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Ordenes de depósito\" ui-first-level=\"acc.histCashregister\"></uibuilder></div>");
$templateCache.put("app/accounting/pend-cashregister.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Ordenes de depósito pendientes\" ui-first-level=\"acc.pendingCashregister\"></uibuilder></div>");
$templateCache.put("app/accounting/product-kardex.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Kardex de productos\" ui-first-level=\"acc.productkardex\"></uibuilder></div>");
$templateCache.put("app/admin/admin-accountbank.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Cuentas bancarias\" ui-first-level=\"{component:\'grid\',model:\'accountbank\'}\"></uibuilder></div>");
$templateCache.put("app/admin/admin-cashregister.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Puntos de venta y encargados\" ui-first-level=\"{component:\'grid\',model:\'cashregister\'}\"></uibuilder></div>");
$templateCache.put("app/admin/admin-partner.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Información de empleados\" ui-first-level=\"ad.partnerconfig\"></uibuilder></div>");
$templateCache.put("app/admin/admin-warehouse.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Almacenes y encargados\" ui-first-level=\"ad.warehouseuser\"></uibuilder></div>");
$templateCache.put("app/admin/user.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de usuarios\" ui-first-level=\"us.userconfig\"></uibuilder></div>");
$templateCache.put("app/admin/userrole.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de roles\" ui-first-level=\"{component:\'grid\',model:\'appmodulerole\'}\"></uibuilder></div>");
$templateCache.put("app/dashboard/main.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{$root.currentTitle}}</h1></div></div></div>");
$templateCache.put("app/dashboard/story1.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{$root.currentTitle}}</h1></div></div><div class=\"dash-wrapper\"><div class=\"data-box row-x1 col-x4\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Total Ventas</div></div><h4 class=\"data-value income\">Bs. {{$root.report.statics.incomes.sumTotal}}</h4></div></div><div class=\"data-box row-x1 col-x4\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Cuentas por cobrar</div></div><h4 class=\"data-value income\">Bs. {{$root.report.statics.incomes.sumCreditAmount}}</h4></div></div><div class=\"data-box row-x1 col-x4\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Número de ventas</div></div><h4 class=\"data-value income\">{{$root.report.statics.incomes.totalRows}}</h4></div></div><div class=\"data-box row-x1 col-x4\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Total Compras</div></div><h4 class=\"data-value outcome\">Bs. {{$root.report.statics.outcomes.sumTotal}}</h4></div></div><div class=\"data-box row-x1 col-x4\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Cuentas por pagar</div></div><h4 class=\"data-value outcome\">Bs. {{$root.report.statics.outcomes.sumCreditAmount}}</h4></div></div><div class=\"data-box row-x1 col-x4\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Número de compras</div></div><h4 class=\"data-value outcome\">{{$root.report.statics.outcomes.totalRows}}</h4></div></div><div class=\"data-box row-x3 col-x8\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Lorem</div><div class=\"data-filter\"><a class=\"filter\" href=\"\">Días</a> <a class=\"filter\" href=\"\">Semana</a> <a class=\"filter\" href=\"\">Mes</a></div></div><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"data\" chart-labels=\"labels\" chart-series=\"series\" chart-options=\"options\" chart-dataset-override=\"datasetOverride\" chart-click=\"onClick\"></canvas></div></div><div class=\"data-box row-x3 col-x4\"><div class=\"data-body\"><div class=\"data-header\"><div class=\"data-title\">Lorem</div><div class=\"data-filter\"><a class=\"filter\" href=\"\">Opcion</a></div></div><div class=\"svg-percentage\"><svg viewbox=\"0 0 36 36\" class=\"svg-chart success\"><path class=\"base\" d=\"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831\"></path><path class=\"progress\" stroke-dasharray=\"{{$root.PT}}, 100\" d=\"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831\"></path><text x=\"18\" y=\"21.35\" class=\"percentage\">{{$root.PT}}%</text></svg><p class=\"goal-desc center success\"><span class=\"circle\"></span> <span>Meta</span></p></div></div></div></div></div>");
$templateCache.put("app/inventory/lowerstock.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Bajas existencias\" ui-first-level=\"pro.lowerstockconfig\"></uibuilder></div>");
$templateCache.put("app/inventory/productkardex.html","<div class=\"container-fluid\"><crudv3 state=\"productkardex\" table-name=\"productkardex\" table-label=\"Movimiento de inventario\" crud-title=\'{{$root.switchText(\"Movimientos de inventario\", \"Kardex\")}}\'></crudv3></div>");
$templateCache.put("app/inventory/productwarehouse.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Existencias\" ui-first-level=\"{component:\'grid\',model:\'productwarehouse\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/transfer-point.html","<div class=\"container-fluid\" data-ng-if=\"$root.logued()\"><uibuilder ui-crud-title=\"Punto de tranferencias\" ui-first-level=\"pro.producttransfer\"></uibuilder></div>");
$templateCache.put("app/inventory/voucher.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Historial de transferencias\" ui-first-level=\"pro.vouchertransfer\"></uibuilder></div>");
$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/purchase/hist-purchase-cotization.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Cotizaciones a proveedores\" ui-first-level=\"pur.histCotization\"></uibuilder></div>");
$templateCache.put("app/purchase/hist-purchase.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Compras de productos\" ui-first-level=\"pur.histPurchase\"></uibuilder></div>");
$templateCache.put("app/purchase/purchase-point.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Punto de compra\" ui-first-level=\"pur.productpurchase\"></uibuilder></div>");
$templateCache.put("app/purchase/purchase-product-catalogue.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Catálogo de productos\" ui-first-level=\"pur.productCatalogue\"></uibuilder></div>");
$templateCache.put("app/purchase/purchases-accountbank.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Cuentas bancarias\" ui-first-level=\"{ component:\'grid\', model:\'accountbank\', customOperations: {read:true,update:false,delete:false,create:false} }\"></uibuilder></div>");
$templateCache.put("app/purchase/purchases-debts.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Deudas por compra de productos\" ui-first-level=\"pur.debt\"></uibuilder></div>");
$templateCache.put("app/purchase/purchases-transactions.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Transacciones por compra de productos\" ui-first-level=\"pur.transactions\"></uibuilder></div>");
$templateCache.put("app/purchase/supplier.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Proveedores\" ui-first-level=\"pur.partnerconfig\"></uibuilder></div>");
$templateCache.put("app/sales/sales-debts.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Historial de deudas\" ui-first-level=\"sal.debt\"></uibuilder></div>");
$templateCache.put("app/sales/sales-transactions.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Transacciones por venta de productos\" ui-first-level=\"sal.transactions\"></uibuilder></div>");
$templateCache.put("app/wcms/main.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{currentModule}}</h1></div></div><ul class=\"tree\"><li class=\"root\" data-ng-repeat=\"level in appMenuItems[currentModule] track by $index\"><a style=\"text-transform: capitalize\" data-ng-click=\"(level.items)?\'\':stateGo(level.state, level.stateParams)\">{{level.label}}</a><ul data-ng-if=\"level.items\"><li data-ng-repeat=\"subitem in level.items\"><a style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem.state, subitem.stateParams)\">{{subitem.label}}</a></li></ul></li></ul></div>");
$templateCache.put("app/views/appmain.html","<div class=\"app-body {{currentModule}}\" windowheight=\"\"><appmenu menu-items=\"appMenuItems[currentModule]\" menu-title=\"{{currentModule}}\" menu-class=\"{{currentModule}}\" menu-depth=\"3\"></appmenu><a data-ng-if=\"$root.currentState!=\'home\'\" data-ng-click=\"$root.showAlertMenu()\" class=\"alert-btn-close {{$root.currentModule}} hidden-xs\"><i class=\"fas fa-bell\"></i> <span class=\"bubble\">{{$root.notPend}}</span></a><div class=\"app-wrapper\" windowheight=\"\"><div data-ng-class=\"{ \'min\': infoMenu }\" class=\"app-view\" windowheight=\"\"><ui-breadcrumbs displayname-property=\"data.displayName\"></ui-breadcrumbs><div class=\"app-interface\" ui-heigth=\"\" minus=\"50\" ui-view=\"\"><ng-include src=\"\'app/views/main/home.html\'\"></ng-include></div></div><div data-ng-if=\"$root.alertMenu && $root.currentState!=\'home\'\"><div data-ng-class=\"{ \'active\': $root.alertMenu }\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.alertMenu}\" data-ng-click=\"$root.showAlertMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>{{switchText(\'Notificaciones\', \'Notifications\')}}</h5></div></div><div class=\"info-menu-body p0\" ui-heigth=\"\"><div class=\"not-box\" data-ng-class=\"{\'pend\':r.status == 0}\" data-ng-repeat=\"r in $root.sysNot.reminders\"><a data-ng-click=\"$root.archiveNot(r)\" class=\"archive-not\"><i class=\"fas fa-times\"></i></a><div class=\"not-icon\"><img src=\"../assets/images/icons/icon-inventario-a.svg\" alt=\"\"></div><div class=\"not-text\"><p><strong>{{$root.currentUser.firstname}}</strong></p><p>{{r.comment}}</p></div></div></div></div></div></div></div>");
$templateCache.put("app/views/authView.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/180711-AKNA-MARCA-02.png\" alt=\"AKNA SRL\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\"></h3><form class=\"\" data-ng-submit=\"loginNew()\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"auth.email\" data-ng-required=\"true\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"{{switchText(\'Contraseña\', \'Password\')}}\" data-ng-model=\"auth.password\" data-ng-required=\"true\"></div><div class=\"form-group capt-box\"><div class=\"captcont g-recaptcha flex\" data-sitekey=\"6LfWFTkUAAAAACrUuVvLAFmtfaRzbWRTQMf_e8PV\"></div></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" data-ng-bind-html=\"switchText(\'¿Olvidaste tu contraseña?\', \'Forgot your password?\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/footer.html","<div class=\"container-fluid\"><div class=\"view-footer\"><div class=\"col-xs-12\"><span class=\"copyright\">©akna</span> <span class=\"mail\">aknabolivia@gmail.com</span></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"container-fluid menu-header\"><div class=\"header row\"><div class=\"navbar navbar-default\" role=\"navigation\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-ng-init=\"navCollapsed = true\" data-ng-click=\"navCollapsed = !navCollapsed\" data-toggle=\"collapse\" data-target=\"#js-navbar-collapse\"><span class=\"icon-arrow-down\"></span> <span class=\"icon-arrow-up\"></span></button> <a class=\"navbar-brand logo\" ui-sref=\"home({lan: language})\" href=\"\" data-ng-if=\"currentState!=\'auth\'\"></a></div><div class=\"collapse navbar-collapse\" id=\"js-navbar-collapse\" collapse=\"navCollapsed\"><ul class=\"nav navbar-nav\" data-ng-if=\"currentState!=\'auth\'\"><li class=\"button-burger\"><a href=\"\" data-ng-click=\"showSideBarG()\"><img style=\"max-height: 18px;\" src=\"../assets/images/iconos/menu-akna1.svg\" alt=\"\"></a></li></ul><ul class=\"nav navbar-nav\" data-ng-class=\"group.ngClass\" data-ng-repeat=\"group in menu | orderBy : \'order\'\"><li data-ng-repeat=\"item in group.items\" data-ng-if=\"actS || item.showAlways\"><a href=\"\" data-ng-class=\"item.ngClass\" data-ng-style=\"item.ngStyle\" data-ng-if=\"!item.render\" ui-sref=\"{{item.stateGo}}({lan:language})\" data-ng-bind-html=\"item.label()\"></a> <span class=\"navbar-text\" data-ng-class=\"item.ngClass\" data-ng-if=\"item.render\" render-html=\"item.template\"></span></li></ul></div></div></div></div>");
$templateCache.put("app/views/home.html","<ng-include src=\"\'app/views/notifications.html\'\"></ng-include><ng-include src=\"\'app/views/sidebar.html\'\"></ng-include><div class=\"view-breadcrumb\"><ui-breadcrumbs displayname-property=\"data.displayName\"></ui-breadcrumbs></div><div class=\"view-body\" customheight=\"\" minus=\"140\"><div class=\"view-body-wrapper\" ui-view=\"\"><h3 class=\"body-title\">Hola, bienvenido al sistema de administración</h3><p class=\"body-instructions\">A continuación le presentamos las secciones a las cuales puede acceder. Haga clic en alguna de ellas para realizar una acción.</p><div class=\"button-box\"><div class=\"button-sys\" ui-sref=\"contents\"><h5>{{switchText(\'Contenidos\',\'Contents\')}}</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde, voluptatibus?</p><a href=\"\" class=\"buton-sys-bottom\">{{switchText(\'Ingresar\',\'Go to\')}} <span class=\"glyphicon glyphicon-chevron-right\"></span></a></div></div><div class=\"button-box\"><div class=\"button-sys\"><h5>{{switchText(\'Configuracion\',\'Configuration\')}}</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde, voluptatibus?</p><a href=\"\" class=\"buton-sys-bottom\">{{switchText(\'Ingresar\',\'Go to\')}} <span class=\"glyphicon glyphicon-chevron-right\"></span></a></div></div></div></div>");
$templateCache.put("app/views/notifications.html","<div class=\"site-not\" data-ng-show=\"showNotsGlobal\"><div class=\"site-not-title\"><p data-ng-bind-html=\"switchText(\'Notificaciones\', \'Notifications\')\"></p><a href=\"\" data-ng-click=\"showNotsGlobal = !showNotsGlobal\" class=\"btn btn-close glyphicon glyphicon-remove\"></a></div><div class=\"info-menu-body\" ui-heigth=\"\"><div class=\"col-xs-12\"><p>hello</p></div><div class=\"not-box\" data-ng-repeat=\"r in $root.sysNot.reminders\"><div class=\"not-icon\"><img src=\"../assets/images/icons/icon-inventario-a.svg\" alt=\"\"></div><div class=\"not-text\"><p><strong>{{$root.currentUser.firstname}}</strong></p><p>{{r.comment}}</p></div></div></div></div>");
$templateCache.put("app/views/print.html","<div class=\"container-fluid\" style=\"background:grey;\"><uibuilder ui-first-level=\"print.voucher9\" style=\"background: white;\"></uibuilder></div>");
$templateCache.put("app/views/printcashregisterlog.html","<div class=\"container-fluid\" style=\"background:grey;padding: 0\"><uibuilder ui-first-level=\"print.cashregisterlog\" style=\"background: white;\"></uibuilder></div>");
$templateCache.put("app/views/printstockorder.html","<div class=\"container-fluid\" style=\"background:grey;\"><uibuilder ui-first-level=\"print.stockorder\" style=\"background: white;\"></uibuilder></div>");
$templateCache.put("app/views/printtransaction.html","<div class=\"container-fluid\" style=\"background:grey;padding: 0\"><uibuilder ui-first-level=\"print.transaction\" style=\"background: white;\"></uibuilder></div>");
$templateCache.put("app/views/sidebar.html","<div class=\"navbar-default sidebar\" role=\"navigation\"><div class=\"sidebar-nav navbar-collapse\" data-ng-show=\"showSideBar\"><ul class=\"nav in\" id=\"side-menu\"><li class=\"sidebar-header active\"><h2>Menu <span data-ng-click=\"showSideBarG()\" class=\"glyphicon glyphicon-remove\"></span></h2></li><li class=\"profile active\"><a ui-sref=\"profile\"><div class=\"sidebar-profile\"></div><div class=\"user\"><span class=\"sidebar-user\" style=\"overflow: hidden\">{{currentUser.email}}</span> <small class=\"online\"><i class=\"fa dot fa-circle\" aria-hidden=\"true\"></i> online</small></div></a></li><li ui-sref-active=\"active\" class=\"nav-first-level\"><a ui-sref=\"inicio.home\"><span class=\"glyphicon glyphicon-home\"></span> Inicio</a></li><li ng-class=\"{active: collapseVar == 7}\" class=\"nav-first-level\"><a href=\"\" ng-click=\"check(7)\" ui-sref=\"contents\"><span class=\"glyphicon glyphicon-pencil\"></span> {{switchText(\'Contenidos\', \'Contents\')}}</a></li><li ng-class=\"{active: collapseVar == 99}\" class=\"nav-first-level\" restricted=\"\" blocked-for=\"configuracion\"><a href=\"\" ng-click=\"check(99)\" ui-sref=\"configuracion\"><span class=\"glyphicon glyphicon-cog\"></span> Configuración<span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=99\"><li ng-init=\"third = !third\" ng-class=\"{active: multiCollapseVar == 13}\" restricted=\"\" blocked-for=\"users-home\"><a href=\"\" ui-sref=\"users-home\" ng-click=\"multiCheck(13)\">Usuarios y Roles <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\" collapse=\"multiCollapseVar!=13\"><li><a ui-sref=\"usuarios\">Administración de usuarios</a></li><li><a ui-sref=\"roles\">Administración de roles</a></li></ul></li><li ng-init=\"third = !third\" ng-class=\"{active: multiCollapseVar == 21}\" restricted=\"\" blocked-for=\"sessionlogs\"><a href=\"\" ui-sref=\"sessionlogs\">Historial de actividad de usuarios</a></li></ul></li><li ng-class=\"{active: collapseVar == 6}\" class=\"nav-first-level\"><a href=\"\" data-ng-click=\"logout()\"><span class=\"glyphicon glyphicon-log-out\"></span> Salir</a></li><li ng-class=\"{active: collapseVar == 99}\" class=\"hidden-lg hidden-md hidden-sm\"><a href=\"\" ng-click=\"check(99)\"><i class=\"fa fa-bell\" aria-hidden=\"true\"></i> Notificaciones <span class=\"notification\">{{notificationsTotal}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=99\" data-ng-if=\"activeSession\"><li data-ng-repeat=\"notifications in notificationsPendings\" data-ng-if=\"notifications.pendings > 0\"><a><i class=\"fa fa-arrow-circle-right\" aria-hidden=\"true\"></i> {({{notifications.type + \' - \'+ notifications.name}})</a></li></ul></li><li ng-class=\"{active: collapseVar == 100}\" class=\"hidden-lg hidden-md hidden-sm nav-first-level\"><a href=\"\" ng-click=\"check(100)\"><i class=\"fa fa-user fa-fw\"></i>{{currentUser.email}}<span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=100\" data-ng-if=\"!activeSession\"><li><a ui-sref=\"auth\"><i class=\"fa fa-sign-in fa-fw\"></i> Iniciar Sesión</a></li></ul><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=100\" data-ng-if=\"activeSession\"><li><a data-ng-click=\"logout()\"><i class=\"fa fa-sign-out fa-fw\"></i> Cerrar sesión</a></li></ul></li></ul></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/inventory/admin/product.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Productos\" ui-first-level=\"pro.productconfig\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productcombo.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Combos de productos\" ui-first-level=\"pro.comboconfig\"></uibuilder></div>");
$templateCache.put("app/inventory/operations/op-purchases-incomes.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Entradas por compras\" ui-first-level=\"pro.histPurchaseIncomes\"></uibuilder></div>");
$templateCache.put("app/inventory/operations/op-transfer-request.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Solicitudes de transferencias\" ui-first-level=\"pro.histTransferRequest\"></uibuilder></div>");
$templateCache.put("app/inventory/operations/op-transfer.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Transferencias de productos\" ui-first-level=\"pro.histTransfer\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/hist-adjust.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Ajustes de inventario\" ui-first-level=\"pro.histAdjust\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/hist-movement.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Rastreo de movimiento\" ui-first-level=\"pro.histStockadjustment\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/hist-purchases-incomes.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Entradas por compras\" ui-first-level=\"pro.histPurchaseIncomes\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/hist-transfer-request.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Solicitudes de transferencia\" ui-first-level=\"pro.histTransferRequest\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/hist-transfer.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Transferencias de productos\" ui-first-level=\"pro.histTransfer\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/pend-purchases-incomes.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Compras pendientes\" ui-first-level=\"pro.pendPurchaseIncomes\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/pend-transfer-incomes.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Solicitudes pendientes\" ui-first-level=\"pro.pendTransferIncomes\"></uibuilder></div>");
$templateCache.put("app/inventory/reports/stock.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Stock\" ui-first-level=\"pro.stockConfig\"></uibuilder></div>");
$templateCache.put("app/sales/config/cashregister.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Puntos de venta y encargados\" ui-first-level=\"{component:\'grid\',model:\'cashregister\'}\"></uibuilder></div>");
$templateCache.put("app/sales/delivery/sales-delivery-point-10.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Entregas y devoluciones por combos\" ui-first-level=\"sal.deliver10\"></uibuilder></div>");
$templateCache.put("app/sales/delivery/sales-delivery-point-11.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Entregas y devoluciones por alquileres\" ui-first-level=\"sal.deliver11\"></uibuilder></div>");
$templateCache.put("app/sales/delivery/sales-delivery-point-7.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Reservas pendientes\" ui-first-level=\"sal.deliver7\"></uibuilder></div>");
$templateCache.put("app/sales/delivery/sales-delivery-point.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Entregas devoluciones\" ui-first-level=\"sal.deliver\"></uibuilder></div>");
$templateCache.put("app/sales/logs/hist-consignation.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Consignación de combos\" ui-first-level=\"sal.histConsignation\"></uibuilder></div>");
$templateCache.put("app/sales/logs/hist-cotization.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Cotizaciones\" ui-first-level=\"sal.histCotization\"></uibuilder></div>");
$templateCache.put("app/sales/logs/hist-rent.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Alquiler de mercaderia\" ui-first-level=\"sal.histRent\"></uibuilder></div>");
$templateCache.put("app/sales/logs/hist-sales.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Venta de productos\" ui-first-level=\"sal.histSales\"></uibuilder></div>");
$templateCache.put("app/sales/logs/hist-seller-r.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Solicitudes de entrega\" ui-first-level=\"sal.histSellerRequest\"></uibuilder></div>");
$templateCache.put("app/sales/management/sales-cash-concilation.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Arqueo de caja - {{$root.currentUser.cashregisteruser[0].cashregister.name}}\" ui-first-level=\"sal.cashregister\"></uibuilder></div>");
$templateCache.put("app/sales/management/sales-clients.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Clientes\" ui-first-level=\"sal.salesclients\"></uibuilder></div>");
$templateCache.put("app/sales/management/sales-mobile-point.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Punto de venta móvil - {{$root.currentUser.partner[0].name}}\" ui-first-level=\"sal.salesMobilepoint\"></uibuilder></div>");
$templateCache.put("app/sales/management/sales-mobile-requests.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Progamación de entrega - {{$root.currentUser.partner[0].name}}\" ui-first-level=\"sal.salesMobilerequest\"></uibuilder></div>");
$templateCache.put("app/sales/management/sales-point.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Punto de venta - {{$root.currentUser.cashregisteruser[0].cashregister.name}}\" ui-first-level=\"sal.salespoint\"></uibuilder></div>");
$templateCache.put("app/sales/management/sales-product-catalogue.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Catálogo de productos\" ui-first-level=\"sal.productCatalogue\"></uibuilder></div>");
$templateCache.put("app/sales/management/sales-seller-agenda.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Agenda\" ui-first-level=\"sal.salesagenda\"></uibuilder></div>");
$templateCache.put("app/sales/reports/hist-cash-conciliate.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Arqueo de caja\" ui-first-level=\"{component:\'grid\', model:\'cashregisterlog\'}\"></uibuilder></div>");
$templateCache.put("app/sales/reports/hist-cashregister.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Historial de transferencias por arqueo de caja\" ui-first-level=\"sal.histCashregister\"></uibuilder></div>");
$templateCache.put("app/sales/reports/hist-vouchertransaction.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Transacciones\" ui-first-level=\"{component:\'grid\',model:\'vouchertransaction\'}\"></uibuilder></div>");
$templateCache.put("app/wcms/contents/contents.html","<div class=\"container-fluid\" data-ng-if=\"wc.crudReady && wc.type==\'dinamic\'\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{wc.model}}\" ui-first-level=\"{component:\'grid\',model:wc.model}\"></uibuilder></div></div><div class=\"container-fluid\" data-ng-if=\"wc.crudReady && wc.type==\'fixed\'\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{wc.model + \' contenidos fijos\'}}\" ui-first-level=\"wc.contenidoRules\"></uibuilder></div></div>");
$templateCache.put("app/wcms/contents/dinamicdefault.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{$root.currentState}}\" ui-first-level=\"{component:\'grid\':model:$root.currentState}}\"></uibuilder></div><div ui-view=\"\"></div>");
$templateCache.put("app/wcms/contents/fixedcontent.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body></body></html>");
$templateCache.put("app/views/auth/activate.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"GUIBDENTAL\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Activa tu cuenta\', \'Active account\')\"></h3><form class=\"\" data-ng-submit=\"loginNew(auth.email,auth.email)\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"auth.email\" data-ng-required=\"true\"></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'¿Olvidaste tu contraseña?\', \'Forgot your password?\')\" class=\"fhelp pull-left\"></a> <a ui-sref=\"auth\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Inicia sesión\', \'Login\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/auth/forgot.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"GUIBDENTAL\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Restaurar contraseña\', \'Restore password\')\"></h3><form class=\"\" data-ng-submit=\"us.forgotPassword()\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"us.reset.email\" data-ng-required=\"true\"></div><div class=\"form-group capt-box\"><div class=\"captcont g-recaptcha flex\" data-sitekey=\"6LfWFTkUAAAAACrUuVvLAFmtfaRzbWRTQMf_e8PV\"></div></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"auth\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\" class=\"fhelp pull-left\"></a> <a ui-sref=\"activate\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Activa tu cuenta\', \'Active account\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/auth/login.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"GUIBDENTAL\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\"></h3><form class=\"\" data-ng-submit=\"loginNew(auth.email,auth.password)\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"auth.email\" data-ng-required=\"true\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"{{switchText(\'Contraseña\', \'Password\')}}\" data-ng-model=\"auth.password\" data-ng-required=\"true\"></div><div class=\"form-group capt-box\"><div class=\"captcont g-recaptcha flex\" data-sitekey=\"6LfWFTkUAAAAACrUuVvLAFmtfaRzbWRTQMf_e8PV\"></div></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'¿Olvidaste tu contraseña?\', \'Forgot your password?\')\" class=\"fhelp pull-left\"></a> <a ui-sref=\"activate\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Activa tu cuenta\', \'Active account\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/auth/newpassword.html","<div class=\"container-fluid crud-form-body\" ui-heigth=\"\" style=\"position: relative;\"><div class=\"grid-title\"><ul class=\"header-tab\"><h3 style=\"text-transform: uppercase\">Creación de contraseña</h3></ul></div><form class=\"crud-form\" data-ng-init=\"us.usercp.currentpass = $root.currentUser.email\" data-ng-submit=\"us.changePassword(true)\"><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Nueva contraseña\',\'New password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Repita la contraseña\',\'Confirm password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass2\"></div></div><div class=\"forms\"><button type=\"submit\" style=\"margin-right: 5px\" class=\"btn btn-action success pull-right\">{{switchText(\'Guardar\',\'Save\')}}</button> <button type=\"button\" style=\"margin-right: 5px\" data-ng-click=\"us.restore()\" class=\"btn btn-action info pull-right\">{{switchText(\'Cancelar\',\'Cancel\')}}</button></div></form></div>");
$templateCache.put("app/views/auth/password.html","<div class=\"container-fluid crud-form-body\" style=\"position: relative;\"><div class=\"grid-title\"><ul class=\"header-tab\"><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"profile({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'profile\'}\">{{$root.switchText(\'Perfil\',\'Profile\')}}</a></li><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"password({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'password\'}\">{{$root.switchText(\'Contraseña\',\'Password\')}}</a></li></ul></div><form class=\"crud-form\" data-ng-submit=\"us.changePassword(true)\"><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Contraseña actual\',\'Current Password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.currentpass\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Nueva contraseña\',\'New password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Repita la contraseña\',\'Confirm password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass2\"></div></div><div class=\"forms\"><button type=\"submit\" style=\"margin-right: 5px\" class=\"btn btn-action success pull-right\">{{switchText(\'Guardar\',\'Save\')}}</button> <button type=\"button\" style=\"margin-right: 5px\" data-ng-click=\"us.restore()\" class=\"btn btn-action info pull-right\">{{switchText(\'Cancelar\',\'Cancel\')}}</button></div></form></div>");
$templateCache.put("app/views/auth/profile.html","<div class=\"container-fluid crud-form-body\" style=\"position: relative;\"><div class=\"grid-title\"><ul class=\"header-tab\"><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"profile({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'profile\'}\">{{$root.switchText(\'Perfil\',\'Profile\')}}</a></li><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"password({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'password\'}\">{{$root.switchText(\'Contraseña\',\'Password\')}}</a></li></ul></div><form class=\"crud-form\" data-ng-init=\"us.restore()\" data-ng-submit=\"us.saveUserData()\"><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'nombres\',\'firtname\')}}</span></div><div class=\"box-input\"><input class=\"form-control\" disabled=\"\" data-ng-model=\"us.profile.firstname\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'apeliidos\',\'lastname\')}}</span></div><div class=\"box-input\"><input class=\"form-control\" disabled=\"\" data-ng-model=\"us.profile.lastname\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'correo electrónico\',\'email\')}}</span></div><div class=\"box-input\"><input type=\"text\" disabled=\"\" class=\"form-control\" data-ng-model=\"us.profile.email\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'telefono\',\'phone\')}}</span></div><div class=\"box-input\"><input type=\"text\" disabled=\"\" class=\"form-control\" data-ng-model=\"us.profile.phone\"></div></div><div class=\"forms\"><button type=\"submit\" style=\"margin-right: 5px\" class=\"btn btn-action success pull-right\">{{switchText(\'Guardar\',\'Save\')}}</button> <button type=\"button\" style=\"margin-right: 5px\" data-ng-click=\"us.restore()\" class=\"btn btn-action info pull-right\">{{switchText(\'Cancelar\',\'Cancel\')}}</button></div></form></div>");
$templateCache.put("app/views/auth/reset.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"GUIBDENTAL\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Nueva contraseña\', \'New password\')\"></h3><form class=\"\" data-ng-submit=\"us.resetForgottenPassword()\"><div class=\"form-group\"><input type=\"password\" id=\"newpass\" placeholder=\"{{switchText(\'Nueva contraseña\', \'New password\')}}\" required=\"\" data-ng-model=\"us.reset.newpass\" class=\"form-control\"></div><div class=\"form-group\"><input type=\"password\" placeholder=\"{{$root.switchText(\'Confirmar contraseña\', \'Confirm password\')}}\" required=\"\" data-ng-model=\"us.reset.newpass2\" class=\"form-control\"></div><div class=\"form-group capt-box\"><div class=\"captcont g-recaptcha flex\" data-sitekey=\"6LfWFTkUAAAAACrUuVvLAFmtfaRzbWRTQMf_e8PV\"></div></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/crudgenerator/crudgenerator_home.html","<div class=\"container-fluid\" style=\"background:white;\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"page-header\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generador de cruds</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\">Crear Crud</h4></div><div class=\"col-xs-12 mB20\"><div class=\"col-xs-12 col-md-3\"><a class=\"btn btn-lg\" data-ng-class=\"{\'btn-primary\':crudStep==1 ,\'btn-default\':crudStep!=1}\" data-ng-click=\"changeValue(1)\" style=\"border-radius: inherit;width: 100%;font-size: 14px;\">1. Nombre</a></div><div class=\"col-xs-12 col-md-3\"><a class=\"btn btn-lg\" data-ng-class=\"{\'btn-primary\':crudStep==2 ,\'btn-default\':crudStep!=2}\" data-ng-click=\"changeValue(2)\" style=\"border-radius: inherit;width: 100%;font-size: 14px;\">2. Campos</a></div></div></div><ng-include src=\"\'app/views/crudgenerator/includes/step1.html\'\" data-ng-if=\"crudStep==1\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/step2.html\'\" data-ng-if=\"crudStep==2\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/step3.html\'\" data-ng-if=\"crudStep==3\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/step4.html\'\" data-ng-if=\"crudStep==4\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/addPermission.html\'\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/addSection.html\'\"></ng-include><div class=\"row\"><div class=\"col-xs-12\"><a href=\"\" class=\"btn btn-success\" data-ng-click=\"print(\'data\')\">Imprimir datos de modelo</a></div></div></div>");
$templateCache.put("app/views/crudgenerator/newModel.html","<form action=\"\" name=\"myForm\" data-ng-submit=\"generateCrud()\"><div class=\"row form-group admin-form\"><div class=\"box-options\"><a href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-click=\"addField()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar columna</a></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form.html\'\" data-ng-repeat=\"field in data.dataEstructure\"></ng-include><div class=\"row form-group admin-form\"><div class=\"box-options\"><button type=\"submit\" href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-disabled=\"data.dataEstructure.length ==0\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generar Crud</button></div></div><ng-include src=\"\'app/views/crudgenerator/includes/addPermission.html\'\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/addSection.html\'\"></ng-include></form>lalala");
$templateCache.put("app/views/crudgenerator/test16.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"page-header\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generador de cruds</h1></div></div><crud state=\"test16\" table-name=\"test16\" table-label=\"test16\" title-field=\"title1\" rules=\"rules\" relations=\"relations\" grid-options=\"gridOptions\" file-upload=\"multiFileUpload\" file-route=\"archivos/imagenes/productos\"></crud></div>");
$templateCache.put("app/views/default/defaultcrud.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{$root.currentTitle}}\" ui-first-level=\"{component:\'grid\',model:$root.currentState}\"></uibuilder></div>");
$templateCache.put("app/views/default/main.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{$root.currentTitle}}</h1></div></div><div class=\"dash-item-box\"><div class=\"dash-item\" data-ng-if=\"$root.currentModule==\'inventory\'\"><div class=\"dash-item-container\"><div class=\"dash-icon\"><a href=\"\"><i class=\"fas fa-truck\"></i></a></div><div class=\"dash-ind\">{{$root.sysNot.inventory.pending_purchase.length}}</div><div class=\"dash-text\">Ordenes de entrega</div><a class=\"dash-action {{$root.currentModule}}\" href=\"\" ui-sref=\"transfer-point\"><i class=\"fas fa-arrow-right\"></i> Ir punto de transferencias</a></div></div><div class=\"dash-item\" data-ng-if=\"$root.currentModule==\'inventory\'\"><div class=\"dash-item-container\" data-ng-if=\"$index == $root.LS\" data-ng-repeat=\"(key,ls) in $root.sysNot.reports.lowerstock\"><div class=\"dash-icon\"><a href=\"\"><i class=\"fas fa-chart-pie\"></i></a></div><div class=\"dash-ind\">{{ls.total}}</div><div class=\"dash-text\">{{key}}</div><a class=\"dash-action {{$root.currentModule}}\" target=\"_blank\" ng-href=\"{{$root.api+\'/print/stockreport\'+\'?lowerstock=true\' + ( (ls.data)?\'&warehouse_id=\'+ls.data:\'\' ) }}\" type=\"button\"><i class=\"fas fa-cloud-download-alt\"></i> Descargar reporte</a> <a href=\"\" data-ng-click=\"$root.switchLS(\'prev\')\" class=\"dash-arrow left\"><i class=\"fas fa-chevron-left\"></i></a> <a href=\"\" data-ng-click=\"$root.switchLS(\'next\')\" class=\"dash-arrow right\"><i class=\"fas fa-chevron-right\"></i></a></div></div><div class=\"dash-item com\" data-ng-if=\"$root.currentModule==\'sales\'\"><div class=\"dash-item-container\" ui-sref=\"sales-seller-agenda({lan:$root.language})\"><div class=\"dash-icon\"><a href=\"\"><i class=\"fas fa-calendar-alt\"></i></a></div><div class=\"dash-text\">Agenda del día</div></div></div><div class=\"dash-item com\"><div class=\"dash-item-container\"><div class=\"dash-icon\"><a href=\"\"><i class=\"fas fa-comment\"></i></a></div><div class=\"dash-ind\">{{$root.sysNot.syscommunicate.title}}</div><div class=\"dash-text\">{{$root.sysNot.syscommunicate.message}}</div></div></div></div><div class=\"clearfix\"></div><div class=\"dash-nav-box\"><div class=\"dash-nav\" data-ng-init=\"level1.hide=true\" data-ng-hide=\"level1.hide\" data-ng-repeat=\"level1 in appMenuItems[currentModule] track by $index\"><div data-ng-if=\"level1.items\" classitem=\"dash-nav-group\" class=\"dash-nav-group\" equalheight=\"\"><a class=\"{{$root.currentModule}}\" style=\"text-transform: uppercase\" data-ng-click=\"(level1.items)?\'\':stateGo(level1.state, level1.stateParams)\"><strong>{{level1.label}}</strong></a><li data-ng-repeat=\"level2 in level1.items\"><a class=\"{{$root.currentModule}}\" data-ng-init=\"($root.uiAccess(level2.state)==true)?level1.hide=false:\'\'\" data-ng-show=\"(level2.items)?true:$root.uiAccess(level2.state)\" data-ng-click=\"stateGo(level2.state, level2.stateParams)\">{{level2.label}}</a><ul data-ng-if=\"level2.items\"><li data-ng-repeat=\"level3 in level2.items\"><a class=\"{{$root.currentModule}}\" data-ng-click=\"stateGo(level3.state, level3.stateParams)\">{{level3.label}}</a></li></ul></li></div></div></div></div>");
$templateCache.put("app/views/default/user-info.html","");
$templateCache.put("app/views/inventory/invmain.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{currentModule}}</h1></div></div><ul class=\"tree\"><li class=\"root\" data-ng-repeat=\"level in appMenuItems[currentModule] track by $index\"><a style=\"text-transform: capitalize\" data-ng-click=\"(level.items)?\'\':stateGo(level.state, level.stateParams)\">{{level.label}}</a><ul data-ng-if=\"level.items\"><li data-ng-repeat=\"subitem in level.items\"><a style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem.state, subitem.stateParams)\">{{subitem.label}}</a><ul data-ng-if=\"subitem.items\"><li data-ng-repeat=\"subitem2 in subitem.items\"><a style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem2.state, subitem2.stateParams)\">{{subitem2.label}}</a></li></ul></li></ul></li></ul></div>");
$templateCache.put("app/views/main/home.html","<div class=\"app-main\" customheight=\"\" minus=\"70\"><div class=\"main-button-box\"><div class=\"col-xs-12 main-title\"><h2>Hola, bienvenido al sistema ERP GuibDental</h2><p>Seleccione el módulo al cual desee acceder</p></div><div class=\"main-button\" ui-sref=\"wcms\" data-ng-if=\"$root.appMenuItems.wcms\"><img src=\"../assets/images/icons/icon-web.svg\" alt=\"\"><p>Contenidos web</p></div><div class=\"main-button\" ui-sref=\"crm\" data-ng-if=\"$root.appMenuItems.crm\"><img src=\"../assets/images/icons/icon-crm.svg\" alt=\"\"><p>CRM</p></div><div class=\"main-button\" ui-sref=\"purchases\" data-ng-if=\"$root.appMenuItems.purchases && $root.uiAccess(\'purchases\')\"><img src=\"../assets/images/icons/icon-compra-a.svg\" alt=\"\"><p>Compras</p></div><div class=\"main-button\" ui-sref=\"inventory\" data-ng-if=\"$root.appMenuItems.inventory && $root.uiAccess(\'inventory\')\"><img src=\"../assets/images/icons/icon-inventario-a.svg\" alt=\"\"><p>Inventario</p></div><div class=\"main-button\" ui-sref=\"sales\" data-ng-if=\"$root.appMenuItems.sales && $root.uiAccess(\'sales\')\"><img src=\"../assets/images/icons/icon-venta-a.svg\" alt=\"\"><p>Ventas</p></div><div class=\"main-button\" ui-sref=\"accounting\" data-ng-if=\"$root.appMenuItems.accounting && $root.uiAccess(\'accounting\')\"><img src=\"../assets/images/icons/icon-contabilidad-a.svg\" alt=\"\"><p>Contabilidad</p></div><div class=\"main-button\" ui-sref=\"dashboard\" data-ng-if=\"$root.appMenuItems.dashboard && $root.uiAccess(\'dashboard\')\"><img src=\"../assets/images/icons/icon-dashboard-a.svg\" alt=\"\"><p>Tablero de control</p></div><div class=\"main-button\" ui-sref=\"admin\" data-ng-if=\"$root.appMenuItems.admin && $root.uiAccess(\'admin\')\"><img src=\"../assets/images/icons/icon-admin-a.svg\" alt=\"\"><p>Administración</p></div></div></div>");
$templateCache.put("app/views/user/changepass.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"view-menu\"><div class=\"view-menu-items\"><ul class=\"submenu\"><li><a href=\"\" ui-sref=\"profile\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Perfil\', \'Profile\')}}</a></li><li><a href=\"\" ui-sref=\"changepass\" class=\"active\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Cambiar contraseña\', \'Change Password\')}}</a></li></ul></div><div class=\"view-menu-options\"></div></div><div class=\"view-not\" data-ng-show=\"showNots\"><div class=\"context-box\"><div class=\"context-icon\"><img src=\"../assets/images/iconos/icon-project1.svg\" alt=\"\"></div><div class=\"context-title\"><p>Medio ambiente</p></div><a href=\"\" data-ng-click=\"showNots = !showNots\" class=\"btn btn-close glyphicon glyphicon-remove\"></a></div><div class=\"options-box\"><div class=\"option\" data-ng-click=\"notDisplay = 1\" data-ng-class=\"{\'active\':notDisplay === 1}\"><p data-ng-bind-html=\"switchText(\'Detalles\', \'Details\')\"></p></div><div class=\"option\" data-ng-click=\"notDisplay = 2\" data-ng-class=\"{\'active\':notDisplay == 2}\"><p data-ng-bind-html=\"switchText(\'Comentarios\', \'Comments\')\"></p></div></div><div contextheight=\"\" data-ng-if=\"notDisplay === 1\" class=\"context-content\"><div class=\"data-box\"><div class=\"data-label\"><p>Titulo:</p></div><div class=\"data-cont\"><p>Informe del estudio realizado</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Descripcion:</p></div><div class=\"data-cont\"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia.</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Proyecto:</p></div><div class=\"data-cont\"><p>Medio ambiente</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Creado:</p></div><div class=\"data-cont\"><p>1 de junio de 2018</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Actualizado:</p></div><div class=\"data-cont\"><p>1 de junio de 2019</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Autor:</p></div><div class=\"data-cont\"><p>Fernando López</p></div></div></div><div contextheight=\"\" data-ng-if=\"notDisplay == 2\" class=\"context-content\"><div class=\"comment-form\"><form data-ng-submit=\"addComment(newComment)\"><input type=\"text\" data-ng-model=\"newComment\" placeholder=\"{{switchText(\'Añadir un comentario\', \'Add comment\')}}\" class=\"form-control\"> <button type=\"submit\" class=\"btn btn-comment\"><img src=\"../assets/images/iconos/icon-next.svg\" alt=\"\"></button></form></div><div class=\"comment-box\" data-ng-repeat=\"item in comments\" data-ng-class=\"{\'active\':doc[$index]}\" data-ng-show=\"item.active\" data-ng-init=\"doc[$index] = false\"><div class=\"not-date\"><span>{{item.created_at}}, {{item.autor}}</span></div><div class=\"not-icon\"><img src=\"../assets/images/brand.svg\" alt=\"\"></div><div class=\"not-body\" data-ng-click=\"doc[$index] = !doc[$index]\"><p data-ng-class=\"{\'show\':doc[$index]}\" data-ng-bind-html=\"item.comment\"></p><span data-ng-click=\"doc[$index] = !doc[$index]\" data-ng-show=\"!doc[$index] && item.comment.length > 90\" data-ng-bind-html=\"switchText(\'Más...\', \'More...\')\"></span></div><a href=\"\" data-ng-click=\"item.active=false\" class=\"btn btn-close-not glyphicon glyphicon-remove\"></a></div></div></div></div></div><div class=\"container-fluid view-content\"><div class=\"row\"><div class=\"content-title\"><h3 data-ng-bind-html=\"switchText(\'Cambiar contraseña\', \'Change password\')\"></h3></div></div></div><div class=\"container-fluid view-content\"><div class=\"view-user\"><div class=\"forms\"><span class=\"filter-label\">Actual:</span> <input class=\"form-control\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Nueva:</span> <input class=\"form-control\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Verifique:</span> <input class=\"form-control\" name=\"\" id=\"\"></div><div class=\"forms\"><button class=\"btn btn-theme2 pull-right\">Save</button> <button class=\"btn btn-theme2 pull-right\">Cancel</button> <button class=\"btn btn-theme2 pull-right\">Generate</button></div></div></div>");
$templateCache.put("app/views/user/profile.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"view-menu\"><div class=\"view-menu-items\"><ul class=\"submenu\"><li><a href=\"\" ui-sref=\"profile\" class=\"active\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Perfil\', \'Profile\')}}</a></li><li><a href=\"\" ui-sref=\"changepass\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Cambiar contraseña\', \'Change Password\')}}</a></li></ul></div><div class=\"view-menu-options\"></div></div><div class=\"view-not\" data-ng-show=\"showNots\"><div class=\"context-box\"><div class=\"context-icon\"><img src=\"../assets/images/iconos/icon-project1.svg\" alt=\"\"></div><div class=\"context-title\"><p>Medio ambiente</p></div><a href=\"\" data-ng-click=\"showNots = !showNots\" class=\"btn btn-close glyphicon glyphicon-remove\"></a></div><div class=\"options-box\"><div class=\"option\" data-ng-click=\"notDisplay = 1\" data-ng-class=\"{\'active\':notDisplay === 1}\"><p data-ng-bind-html=\"switchText(\'Detalles\', \'Details\')\"></p></div><div class=\"option\" data-ng-click=\"notDisplay = 2\" data-ng-class=\"{\'active\':notDisplay == 2}\"><p data-ng-bind-html=\"switchText(\'Comentarios\', \'Comments\')\"></p></div></div><div contextheight=\"\" data-ng-if=\"notDisplay === 1\" class=\"context-content\"><div class=\"data-box\"><div class=\"data-label\"><p>Titulo:</p></div><div class=\"data-cont\"><p>Informe del estudio realizado</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Descripcion:</p></div><div class=\"data-cont\"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia.</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Proyecto:</p></div><div class=\"data-cont\"><p>Medio ambiente</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Creado:</p></div><div class=\"data-cont\"><p>1 de junio de 2018</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Actualizado:</p></div><div class=\"data-cont\"><p>1 de junio de 2019</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Autor:</p></div><div class=\"data-cont\"><p>Fernando López</p></div></div></div><div contextheight=\"\" data-ng-if=\"notDisplay == 2\" class=\"context-content\"><div class=\"comment-form\"><form data-ng-submit=\"addComment(newComment)\"><input type=\"text\" data-ng-model=\"newComment\" placeholder=\"{{switchText(\'Añadir un comentario\', \'Add comment\')}}\" class=\"form-control\"> <button type=\"submit\" class=\"btn btn-comment\"><img src=\"../assets/images/iconos/icon-next.svg\" alt=\"\"></button></form></div><div class=\"comment-box\" data-ng-repeat=\"item in comments\" data-ng-class=\"{\'active\':doc[$index]}\" data-ng-show=\"item.active\" data-ng-init=\"doc[$index] = false\"><div class=\"not-date\"><span>{{item.created_at}}, {{item.autor}}</span></div><div class=\"not-icon\"><img src=\"../assets/images/brand.svg\" alt=\"\"></div><div class=\"not-body\" data-ng-click=\"doc[$index] = !doc[$index]\"><p data-ng-class=\"{\'show\':doc[$index]}\" data-ng-bind-html=\"item.comment\"></p><span data-ng-click=\"doc[$index] = !doc[$index]\" data-ng-show=\"!doc[$index] && item.comment.length > 90\" data-ng-bind-html=\"switchText(\'Más...\', \'More...\')\"></span></div><a href=\"\" data-ng-click=\"item.active=false\" class=\"btn btn-close-not glyphicon glyphicon-remove\"></a></div></div></div></div></div><div class=\"container-fluid view-content\"><div class=\"row\"><div class=\"content-title\"><h3 data-ng-bind-html=\"switchText(\'Perfil\', \'Profile\')\"></h3></div></div></div><div class=\"container-fluid view-content\"><div class=\"view-user\"><div class=\"forms\"><span class=\"filter-label\">Nombre:</span> <input class=\"form-control\" data-ng-model=\"currentUser.nombres\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Apellidos:</span> <input class=\"form-control\" data-ng-model=\"currentUser.apellidos\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Email:</span> <input class=\"form-control\" data-ng-model=\"currentUser.email\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Cargo:</span> <input class=\"form-control\" value=\"BI Engineer\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Area:</span> <input class=\"form-control\" value=\"BI\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Profesión:</span> <input class=\"form-control\" value=\"BI Engineer\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Edad:</span> <input class=\"form-control\" value=\"29\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Punto focal:</span> <input class=\"form-control\" value=\"Si\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Toma desiciones:</span> <input class=\"form-control\" value=\"Si\" name=\"\" id=\"\"></div><div class=\"forms\"><button class=\"btn btn-theme2 pull-right\">Save</button> <button class=\"btn btn-theme2 pull-right\">Cancel</button></div></div></div>");
$templateCache.put("app/scripts/directives/appcontextmenu/appcontextmenu.html","<div><a href=\"\" class=\"info-btn-close {{$parent.currentModule}}\" tooltip-placement=\"{{\'left\'}}\" uib-tooltip=\"Detalle\" data-ng-class=\"{\'hide\': $parent.infoMenu}\" data-ng-click=\"$parent.showInfoMenu()\"><i class=\"fas fa-info-circle\"></i></a><div data-ng-class=\"{ \'active\': $parent.infoMenu }\" class=\"app-info-menu {{$parent.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$parent.infoMenu}\" data-ng-click=\"$parent.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a></div></div>");
$templateCache.put("app/scripts/directives/appmenu/appmenu.html","<div><script type=\"text/ng-template\" id=\"userPopover.html\"><ul class=\"menu-items {{$root.currentModule}}\"> <li><a href=\"\" style=\"font-weight: bold;text-transform: uppercase;\"> {{$root.currentUser.firstname+\' \'+$root.currentUser.lastname}}</a></li> <li><a ui-sref=\"profile\">Ver perfil</a></li> <li><a data-ng-click=\"logout()\">Cerrar sesión</a></li> </ul></script><script type=\"text/ng-template\" id=\"appPopover.html\"><div class=\"app-popover\"> <div class=\"main-button\" ui-sref=\"wcms\" data-ng-if=\"$root.appMenuItems.wcms && $root.uiAccess(\'wcms\')\"> <img src=\"../assets/images/icons/icon-web.svg\" alt=\"\"> <p>Contenidos web</p> </div> <div class=\"main-button\" ui-sref=\"crm\" data-ng-if=\"$root.appMenuItems.crm && $root.uiAccess(\'crm\')\"> <img src=\"../assets/images/icons/icon-crm.svg\" alt=\"\"> <p>CRM</p> </div> <div class=\"main-button\" ui-sref=\"purchases\" data-ng-if=\"$root.appMenuItems.purchases && $root.uiAccess(\'purchases\')\"> <img src=\"../assets/images/icons/icon-compra-a.svg\" alt=\"\"> <p>Compras</p> </div> <div class=\"main-button\" ui-sref=\"inventory\" data-ng-if=\"$root.appMenuItems.inventory && $root.uiAccess(\'inventory\')\"> <img src=\"../assets/images/icons/icon-inventario-a.svg\" alt=\"\"> <p>Inventario</p> </div> <div class=\"main-button\" ui-sref=\"sales\" data-ng-if=\"$root.appMenuItems.sales && $root.uiAccess(\'sales\')\"> <img src=\"../assets/images/icons/icon-venta-a.svg\" alt=\"\"> <p>Ventas</p> </div> <div class=\"main-button\" ui-sref=\"accounting\" data-ng-if=\"$root.appMenuItems.accounting && $root.uiAccess(\'accounting\')\"> <img src=\"../assets/images/icons/icon-contabilidad-a.svg\" alt=\"\"> <p>Contabilidad</p> </div> <div class=\"main-button\" ui-sref=\"dashboard\" data-ng-if=\"$root.appMenuItems.dashboard && $root.uiAccess(\'dashboard\')\"> <img src=\"../assets/images/icons/icon-dashboard-a.svg\" alt=\"\"> <p>Tablero de ccntrol</p> </div> <div class=\"main-button\" ui-sref=\"admin\" data-ng-if=\"$root.appMenuItems.admin && $root.uiAccess(\'admin\')\"> <img src=\"../assets/images/icons/icon-admin-a.svg\" alt=\"\"> <p>Administración</p> </div> </div></script><div class=\"app-menu {{menuClass}}\"><a href=\"\" class=\"menu-btn burger\" data-ng-if=\"currentState != \'home\'\" data-ng-click=\"showAppMenu()\"><i data-ng-if=\"!appMenu\" class=\"fas fa-bars\"></i> <i data-ng-if=\"appMenu\" class=\"fas fa-arrow-left\"></i></a> <a href=\"\" class=\"menu-btn profile hidden-xs\" popover-placement=\"{{\'right\'}}\" uib-popover-template=\"userPopover.templateUrl\"><i class=\"fas fa-user-circle\"></i></a><a href=\"\" class=\"menu-btn help hidden-xs\" data-ng-click=\"$root.printVoucherData()\"><i class=\"fas fa-question-circle\"></i></a> <a href=\"\" class=\"menu-btn apps hidden-xs\" popover-placement=\"{{\'right-bottom\'}}\" uib-popover-template=\"appPopover.templateUrl\"><i class=\"fas fa-th\"></i></a><div data-ng-if=\"$root.currentState!=\'home\'\"><a href=\"\" class=\"menu-btn info hidden-sm hidden-md hidden-lg\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"fas fa-info-circle\"></i></a> <a href=\"\" class=\"menu-btn not hidden-sm hidden-md hidden-lg\" data-ng-click=\"$root.showAlertMenu()\"><i class=\"fas fa-bell\"></i> <span class=\"bubble\">{{$root.notPend}}</span></a></div></div><div class=\"menu-box {{menuClass}}\" data-ng-class=\"{\'showmenu\': appMenu}\"><a href=\"\" class=\"menu-btn burger\" data-ng-if=\"currentState != \'home\'\" data-ng-click=\"showAppMenu()\"><i data-ng-if=\"appMenu\" class=\"fas fa-arrow-left\"></i></a><div class=\"menu-header {{menuClass}}\"><h5 style=\"text-transform: uppercase\">{{menuTitle}}</h5><div class=\"col-xs-12\" style=\"padding: 0\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Search for...\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" style=\"padding: 0 5px;\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div></div></div><div class=\"menu-level {{menuClass}}\" data-ng-show=\"$index<=currentLevel\" data-ng-repeat=\"level in menuLevels track by $index\"><a class=\"menu-back\" data-ng-click=\"showParent()\" data-ng-show=\"currentLevel>0 && $index>0\"><i class=\"fas fa-long-arrow-alt-left\"></i></a><ul class=\"menu-items {{menuClass}}\"><li data-ng-repeat=\"item in level\" data-ng-show=\"(item.items)?true:$root.uiAccess(item.state)\"><hr data-ng-if=\"item.hr\" style=\"margin: 5px 0;\"><a href=\"\" data-ng-click=\"(item.items)?selectItems(item, $parent.$index ):stateGo(item.state, item.stateParams)\">{{item.label}} <i data-ng-show=\"item.items && $parent.$index ==currentLevel\" class=\"fas fa-caret-right\"></i></a></li></ul></div><a href=\"\" class=\"menu-btn profile\" popover-placement=\"{{\'right\'}}\" uib-popover-template=\"userPopover.templateUrl\"><i class=\"fas fa-user-circle\"></i></a> <a href=\"\" class=\"menu-btn help\" data-ng-click=\"$root.printVoucherData()\"><i class=\"fas fa-question-circle\"></i></a> <a href=\"\" class=\"menu-btn apps\" ui-sref=\"home({\'lan\':es})\"><i class=\"fas fa-th\"></i></a></div></div>");
$templateCache.put("app/scripts/directives/appnotification/appnotification.html","<div><a href=\"\" data-ng-if=\"$root.currentState!=\'home\'\" data-ng-click=\"$root.showAlertMenu()\" class=\"alert-btn-close {{$root.currentModule}}\"><i class=\"fas fa-bell\"></i></a><div data-ng-if=\"$root.alertMenu && $root.currentState!=\'home\'\"><div data-ng-class=\"{ \'active\': $root.alertMenu }\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.alertMenu}\" data-ng-click=\"$root.showAlertMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>{{switchText(\'Notificaciones\', \'Notifications\')}}</h5></div></div><div class=\"info-menu-body\" ui-heigth=\"\"><div class=\"not-box\" data-ng-repeat=\"r in $root.sysNot.reminders\"><div class=\"not-icon\"><img src=\"../assets/images/icons/icon-inventario-a.svg\" alt=\"\"></div><div class=\"not-text\"><p><strong>{{$root.currentUser.firstname}}</strong></p><p>{{r.comment}}</p></div></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/datepicker/datepicker.html","<div class=\"form-group input-group\" style=\"margin-bottom: 0\"><input type=\"text\" style=\"width: 100%\" class=\"form-control search\" placeholder=\"{{pl}}\" datepicker-popup=\"{{format}}\" ng-model=\"ngModel\" ng-change=\"ngChange\" ng-required=\"ngRequired\" is-open=\"opened\" datepicker-options=\"dateOptions\" date-disabled=\"disabled(date, mode)\" close-text=\"Close\"> <span class=\"input-group-btn\"><button class=\"btn form-control\" style=\"min-width: 35px;border-left: 0;\" ng-click=\"onSubmit();open($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div>");
$templateCache.put("app/scripts/directives/uiBreadcrumbs/uiBreadcrumbs.tpl.html","<ol class=\"breadcrumb\"><li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{active: $last}\"><a ui-sref=\"{{crumb.route}}\" class=\"{{currentModule}}\" ui-sref-opts=\"{reload: true}\" style=\"text-transform: capitalize\" ng-if=\"!$last\" data-ng-bind-html=\"crumb.displayName\"></a> <a style=\"text-transform: capitalize\" class=\"{{($root.currentModule)?$root.currentModule:\'home\'}}\" ui-sref=\"{{($root.currentModule)?$root.currentModule:\'home\'}}\" ng-show=\"$root.currentSec && $last\">{{$root.currentSec}} <span style=\"padding: 0 5px; color:#ccc\">/</span></a> <span style=\"text-transform: capitalize\" ng-show=\"!$last\">&nbsp;</span> <span style=\"text-transform: capitalize\" ng-show=\"$last\" data-ng-bind-html=\"$root.currentTitle\"></span></li></ol>");
$templateCache.put("app/scripts/directives/uibuilder/uibuilder.html","<div class=\"container-fluid\" style=\"padding: 0;\"><a href=\"\" class=\"info-btn-close {{$root.currentModule}} hidden-xs\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"fas fa-info-circle\"></i></a><uicontextualmenu data-ng-if=\"$root.infoMenu\" model-name=\"{{$root.uiConf.level[0].model}}\"></uicontextualmenu><div class=\"crud-grid-header\" data-ng-if=\"uiCrudTitle\"><div class=\"grid-title\"><h3>{{uiCrudTitle}}</h3></div></div><div data-ng-repeat=\"view in $root.uiConf.level\"><uicrudgrid data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'grid\'\" model-name=\"{{view.model}}\"></uicrudgrid><uicrudgridsmall data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'gridsmall\'\" model-name=\"{{view.model}}\"></uicrudgridsmall><uidefaultform data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uidefaultform\'\" level=\"$index\" model-name=\"{{view.model}}\"></uidefaultform><uiinventoryform data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiinventoryform\'\" level=\"$index\" custom-properties=\"view.customComponent.uiinventoryform\" model-name=\"{{view.model}}\"></uiinventoryform><uiselector data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiselector\'\" level=\"$index\" custom-params=\"$index\" model-name=\"{{view.model}}\"></uiselector><uipiker data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uipiker\'\" level=\"$index\" custom-params=\"$index\" model-name=\"{{view.model}}\"></uipiker><uipayment data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uipayment\'\" level=\"$index\" model-name=\"{{view.model}}\"></uipayment><uiinvoice data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiinvoice\'\" level=\"$index\" model-name=\"{{view.model}}\"></uiinvoice><uireadvoucher data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uireadvoucher\'\" level=\"$index\" model-name=\"{{view.model}}\"></uireadvoucher><uiinventorycheck data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiinventorycheck\'\" level=\"$index\" model-name=\"{{view.model}}\"></uiinventorycheck><uicombo data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uicombo\'\" level=\"$index\" model-name=\"{{view.model}}\"></uicombo><uideliveryprog data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uideliveryprog\'\" level=\"$index\" model-name=\"{{view.model}}\"></uideliveryprog><uicashregister data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uicashregister\'\" level=\"$index\" model-name=\"{{view.model}}\"></uicashregister><uiselleragenda data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiselleragenda\'\" level=\"$index\" model-name=\"{{view.model}}\"></uiselleragenda><uidebt data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uidebt\'\" level=\"$index\" model-name=\"{{view.model}}\"></uidebt><uiinvoicestock data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiinvoicestock\'\" level=\"$index\" model-name=\"{{view.model}}\"></uiinvoicestock><div class=\"block-page {{$root.currentModule}}\" data-ng-if=\"$root.blockPage\" windowheigth=\"\"><div class=\"col-xs-12\"><h1>{{$root.blockPageLoading?\'Un momento por favor\':\'operación almacenada\'}}</h1></div><div class=\"col-xs-12\" data-ng-if=\"!$root.blockPageLoading\"><a target=\"_blank\" data-ng-if=\"$root.blockPageLink != \'\'\" ng-href=\"{{ $root.blockPageLink }}\" style=\"color: white; font-size: 25px; display: block; width: 100px; text-align: center; margin: 10px 60px; text-decoration: underline !important;\">Imprimir</a> <a href=\"\" data-ng-click=\"$root.reloadUI();\" style=\"color: white; font-size: 25px; display: block; width: 100px; text-align: center; margin: 10px 60px; text-decoration: underline !important;\">Continuar</a></div></div></div></div>");
$templateCache.put("app/views/crudgenerator/includes/addPermission.html","<div class=\"modal fade modal-add\" id=\"crudAddPermission\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\">CREAR NUEVO PERMISO</h4></div><div class=\"modal-body\"><p>¿Esta seguro de agregar este nuevo permiso?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Nombre</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newPermission.nombre\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Permiso</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newPermission.permiso\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Descripción</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newPermission.descripcion\" class=\"form-control\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"createPermission(newPermission,temp);closeModal(\'crudAddPermission\')\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/views/crudgenerator/includes/addSection.html","<div class=\"modal fade modal-add\" id=\"crudAddSection\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\">CREAR NUEVA SECCIÓN</h4></div><div class=\"modal-body\"><p>¿Esta seguro de agregar esta nueva sección?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Vista</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.nombre\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">State</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.state\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Url</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.url\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Padre</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.parent\" class=\"form-control\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"createView(newView);closeModal(\'crudAddSection\')\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/views/crudgenerator/includes/form.html","<div class=\"field-box\"><div class=\"admin-form\"><a href=\"\" class=\"btn btn-danger\" data-ng-click=\"deleteField(field, $index)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Eliminar</a></div><div class=\"form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Nombre</label> <small class=\"text-info\">No incluir espacios o caracteres especiales</small></div><div class=\"box-rigth\"><input class=\"form-control\" data-ng-required=\"true\" type=\"text\" data-ng-model=\"field.dbField\"></div></div><div class=\"admin-form\"><div class=\"col-xs-12 subdivision\"><h4 class=\"\" data-ng-click=\"changeFormDetail(field,\'showDB\')\">Base de datos <i class=\"fa fa-caret-down\" aria-hidden=\"true\" data-ng-if=\"field.showDB\"></i> <i class=\"fa fa-caret-left\" aria-hidden=\"true\" data-ng-if=\"!field.showDB\"></i></h4></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form_db_fields.html\'\" data-ng-if=\"field.showDB\"></ng-include><div class=\"admin-form\"><div class=\"col-xs-12 subdivision\"><h4 class=\"\" data-ng-click=\"changeFormDetail(field, \'showMV\')\">Validaciones de formulario <i class=\"fa fa-caret-down\" aria-hidden=\"true\" data-ng-if=\"field.showMV\"></i> <i class=\"fa fa-caret-left\" aria-hidden=\"true\" data-ng-if=\"!field.showMV\"></i></h4></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form_validation_fields.html\'\" data-ng-if=\"field.showMV\"></ng-include></div>");
$templateCache.put("app/views/crudgenerator/includes/form_db_fields.html","<div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Tipo de campo</label></div><div class=\"box-rigth\"><select class=\"form-control\" data-ng-model=\"field.dbType\"><option value=\"INT\">INT</option><option value=\"BIGINT\">BIGINT</option><option value=\"MEDIUMINT\">MEDIUMINT</option><option value=\"SMALLINT\">SMALLINT</option><option value=\"TINYINT\">TINYINT</option><option value=\"DECIMAL\">DECIMAL</option><option value=\"DOUBLE\">DOUBLE</option><option value=\"FLOAT\">FLOAT</option><option value=\"BLOB\">BLOB</option><option value=\"CHAR\">CHAR</option><option value=\"LONGTEXT\">LONGTEXT</option><option value=\"MEDIUMTEXT\">MEDIUMTEXT</option><option value=\"TEXT\">TEXT</option><option value=\"VARCHAR\">VARCHAR</option><option value=\"DATE\">DATE</option><option value=\"DATETIME\">DATETIME</option><option value=\"TIME\">TIME</option><option value=\"TIMESTAMP\">TIMESTAMP</option><option value=\"DATE\">DATE</option><option value=\"IP\">IP</option><option value=\"JSON\">JSON</option><option value=\"JSONB\">JSONB</option><option value=\"MAC\">MAC</option><option value=\"ENUM\">ENUM</option><option value=\"UUID\">UUID</option></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbType == \'VARCHAR\' || field.dbType == \'CHAR\'\"><div class=\"box-left\"><label class=\"label-form\">Tamaño</label></div><div class=\"box-rigth\"><input type=\"TEXT\" class=\"form-control\" data-ng-model=\"field.dbSize\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Valor por defecto</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\" data-ng-model=\"field.dbDefault\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Habilitar campo con traducción</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"field.dbAutoTraduction\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Traducciones</label></div><div class=\"box-rigth\"><select name=\"\" id=\"dbLanguages\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-model=\"field.dbLanguages\"><option selected=\"\" value=\"\">-- No --</option><option value=\"es\">Español</option><option value=\"en\">Ingles</option><option value=\"fr\">Frances</option><option value=\"pt\">Portugues</option><option value=\"de\">Aleman</option><option value=\"it\">Italiano</option></select></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permitir valores nulos</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"field.dbNull\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Indices</label></div><div class=\"box-rigth\"><select name=\"\" id=\"dbIndex\" class=\"form-control\" data-ng-model=\"field.dbIndex\"><option selected=\"\" value=\"\">-- No --</option><option value=\"PK\">(PK) Llave primaria</option><option value=\"FK\">(FK) Llave foranea</option><option value=\"UNIQUE\">UNIQUE</option><option value=\"INDEX\">INDEX</option></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbIndex == \'FK\'\"><div class=\"box-left\"><label class=\"label-form\">Tabla de referencia</label></div><div class=\"box-rigth\"><select ng-options=\"item.table as item.table for item in migrations\" name=\"\" id=\"dbFkTable\" data-ng-change=\"getTableColumns(field.dbFkTable)\" class=\"form-control\" data-ng-model=\"field.dbFkTable\"></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbIndex == \'FK\'\"><div class=\"box-left\"><label class=\"label-form\">Campo de referencia</label></div><div class=\"box-rigth\"><select ng-options=\"o as o for o in migrationsColunns\" id=\"\" class=\"form-control\" data-ng-model=\"field.dbFkField\"></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbIndex == \'FK\'\"><div class=\"box-left\"><label class=\"label-form\">Eliminación en cascada</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"field.dbFkCascadeDelete\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Comentarios</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\" data-ng-model=\"field.dbComment\"></div></div>");
$templateCache.put("app/views/crudgenerator/includes/form_validation_fields.html","<div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Tipo de campo</label></div><div class=\"box-rigth\"><select class=\"form-control\"></select></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Etiqueta</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Requerido</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Desabilitado</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Personalizado</label></div><div class=\"box-rigth\"><textarea class=\"form-control\"></textarea></div></div>");
$templateCache.put("app/views/crudgenerator/includes/step1.html","<form action=\"\" data-ng-submit=\"changeValue(2)\"><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\" data-ng-class=\"{\'text-danger\':!modelvalid && data.model.length>0}\">{{(!modelvalid && data.model.length>0)?\'* \':\'\'}}Nombre de la tabla</label></div><div class=\"box-rigth\"><input class=\"form-control\" data-ng-change=\"verifyModelName()\" type=\"text\" data-ng-model=\"data.model\" data-ng-required=\"true\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Origen de datos</label></div><div class=\"box-rigth\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().onFileChange(this)\"></div></div><div class=\"col-xs-12 mT20\" style=\"margin-top: 50px\"><button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" class=\"btn btn-primary pull-left\">Anterior</button> <button type=\"submit\" data-ng-disabled=\"!modelvalid\" class=\"btn btn-primary pull-left mL20\">Siguiente</button></div></form>");
$templateCache.put("app/views/crudgenerator/includes/step2.html","<form action=\"\" name=\"myForm\" data-ng-submit=\"changeValue(3)\"><div class=\"row admin-form\"><div class=\"box-options\"><a href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-click=\"addField()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar columna</a></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form.html\'\" data-ng-repeat=\"field in data.dataEstructure\"></ng-include><div class=\"row admin-form\" data-ng-if=\"data.dataEstructure.length>0\"><div class=\"box-options\"><a href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-click=\"addField()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar columna</a></div></div><div class=\"col-xs-12 mT20\"><button type=\"submit\" data-ng-click=\"generateCrud()\" class=\"btn btn-primary pull-right btn-op\" data-ng-disabled=\"data.dataEstructure.length ==0\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generar Crud</button><button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" class=\"btn btn-primary pull-left\">Anterior</button></div></form>");
$templateCache.put("app/views/crudgenerator/includes/step3.html","<form action=\"\" name=\"myForm3\" data-ng-submit=\"changeValue(4)\"><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para creación</label></div><div class=\"box-rigth\"><select ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"insert\" class=\"form-control\" data-ng-model=\"data.permissions.insert\" required=\"\"></select><a class=\"btn btn-primary btn-op mT10\" data-ng-click=\"setTempValue(\'insert\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</a></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para actualización</label></div><div class=\"box-rigth\"><select ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"update\" class=\"form-control\" data-ng-model=\"data.permissions.update\" required=\"\"></select><a class=\"btn btn-primary btn-op mT10\" data-ng-click=\"setTempValue(\'update\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</a></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para eliminación</label></div><div class=\"box-rigth\"><select ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"delete\" class=\"form-control\" data-ng-model=\"data.permissions.delete\" required=\"\"></select><a class=\"btn btn-primary btn-op mT10\" data-ng-click=\"setTempValue(\'delete\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</a></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Habilitar edición con revisiones</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"data.permissions.reviewEnable\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para aprobar o rechazar</label></div><div class=\"box-rigth\"><select data-ng-disabled=\"!data.permissions.reviewEnable\" ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"review\" class=\"form-control\" data-ng-model=\"data.permissions.review\" required=\"\"></select><button class=\"btn btn-primary btn-op mT10\" data-ng-disabled=\"!data.permissions.reviewEnable\" data-ng-click=\"setTempValue(\'review\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</button></div></div><div class=\"col-xs-12 mT20\"><button type=\"submit\" data-ng-disabled=\"!permission.review||!permission.insert||!permission.update||!permission.delete\" class=\"btn btn-primary pull-right mL20\">Siguiente</button> <button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" class=\"btn btn-primary pull-right\">Anterior</button></div></form>");
$templateCache.put("app/views/crudgenerator/includes/step4.html","<div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Habilitar interfaz de adminstración</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"data.administration.enable\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Seccion de administracion</label></div><div class=\"box-rigth\"><select name=\"\" id=\"\" class=\"form-control\" data-ng-click=\"setTempValue(\'section\')\" data-ng-disabled=\"!data.administration.enable\" ng-options=\"item.id as item.nombre for item in pages\" data-ng-model=\"data.administration.section\"></select><button class=\"btn btn-primary btn-op mT10\" data-ng-disabled=\"!data.administration.enable\" data-toggle=\"modal\" data-target=\"#crudAddSection\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nueva sección</button></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Agrupar por</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\" data-ng-disabled=\"!data.administration.enable\" data-ng-model=\"data.administration.group\"> <button class=\"btn btn-primary btn-op mT10\" data-ng-disabled=\"!data.administration.enable\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo grupo</button></div></div><div class=\"col-xs-12 mT20\"><button type=\"submit\" data-ng-click=\"generateCrud()\" class=\"btn btn-primary pull-right btn-op\" data-ng-disabled=\"data.dataEstructure.length ==0\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generar Crud</button> <button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" style=\"margin-right: 20px;\" class=\"btn btn-primary pull-right\">Anterior</button></div>");
$templateCache.put("app/views/directives/crud/crud.html","<div class=\"row mT10 mB30\"><div data-ng-if=\"true\" class=\"mB40\"><ng-include src=\"\'app/views/directives/crud/crudGrid.html\'\" data-ng-if=\"crudView==\'crudGrid\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudForm.html\'\" data-ng-if=\"crudView==\'crudForm\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudView.html\'\" data-ng-if=\"crudView==\'crudView\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudPassword.html\'\" data-ng-if=\"crudView==\'crudPassword\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudDelete.html\'\"></ng-include></div></div>");
$templateCache.put("app/views/directives/crud/crudDelete.html","<div class=\"modal fade modal-delete\" id=\"crudDeleteModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\">Eliminar {{crudTitle}}</h4></div><div class=\"modal-body\"><p>¿Esta seguro de eliminar este registro y su contenido relacionado?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button> <button type=\"button\" class=\"btn btn-delete\" data-ng-click=\"updateRegister(tabla,selected,actionType);$dismiss()\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/views/directives/crud/crudDownloadFields.html","<form action=\"\" data-ng-submit=\"reloadData()\"><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Desde</p><mydatepicker ng-model=\"filters.dateFrom\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened1\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Hasta</p><mydatepicker ng-model=\"filters.dateTo\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened2\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\"><button class=\"btn btn-primary pull-left\" type=\"submit\" data-ng-if=\"!csvReady\" style=\"width: 140px;\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Filtrar por fecha</button></div><div class=\"col-xs-12 mB20\"><hr style=\"margin: 0px 0px 10px 0px;\"><a href=\"\" class=\"btn btn-primary pull-right\" data-ng-click=\"reloadData(true)\" style=\"width: 140px;\"><i class=\"fa fa-cloud-download\" aria-hidden=\"true\"></i> Generar csv</a> <a href=\"{{dataset.downloadLink}}\" class=\"pull-right\" target=\"_blank\" data-ng-if=\"dataset.downloadLink !=\'\' && downloadReady\" style=\"margin: 8px 15px;\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Documento generado</a> <img src=\"images/loader_blue.gif\" data-ng-if=\"(dataset.downloadLink.length > 0 && !downloadReady)\" class=\"mR20 pull-right\" alt=\"\" style=\"width: 34px;\"></div></form>");
$templateCache.put("app/views/directives/crud/crudForm.html","<div class=\"row\"><div class=\"pL30 pR30\"><form action=\"\" name=\"myForm\" data-ng-submit=\"updateRegister(tabla,selected,actionType)\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\" data-ng-if=\"actionType==\'edit\'\">{{crudTitle}}</h4><h4 class=\"header-subtitle\" data-ng-if=\"actionType==\'new\'\">Agregar registro</h4><h4 class=\"header-subtitle\" data-ng-if=\"actionType==\'password\'\">Modificar contraseña</h4></div></div><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties | orderBy:\'order\'\" data-ng-if=\"actionType!=\'password\' && ( (dato.active && dato.activeForCreate==null && dato.activeForEdit == null) || (dato.active && !dato.activeForCreate && dato.activeForEdit && actionType==\'edit\') || (dato.active && dato.activeForCreate && !dato.activeForEdit && actionType==\'new\'))\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"row\" data-ng-show=\"!dato.groupedBy || (dato.groupedBy == lan)\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind-html=\"dato.invalid+dato.label\" class=\"label-form\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></label> <small class=\"text-info\" data-ng-if=\"dato.helpText\" style=\"width: 100%;float: left;text-align: right; padding-right: 40px;\" data-ng-bind-html=\"dato.helpText\"></small></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'text\'\" name=\"{{dato.name}}\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, selected[dato.name] ,dato.name)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'email\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'number\'\" data-ng-disabled=\"dato.disabled\"><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div data-ng-if=\"dato.type==\'password\'\" data-ng-init=\"cloneField(selected[dato.name])\"><input class=\"form-control\" type=\"password\" ng-change=\"validatePassword(dato.name+1,dato.name+2)\" id=\"{{dato.name+1}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"password\" ng-change=\"validatePassword(dato.name+1,dato.name+2)\" id=\"{{dato.name+2}}\" data-ng-required=\"dato.required\" data-ng-model=\"copyField\" data-ng-if=\"dato.type==\'password\'\" data-ng-disabled=\"dato.disabled\"></div><textarea class=\"form-control\" data-ng-model=\"selected[dato.name]\" data-ng-required=\"dato.required\" style=\"min-height: 34px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\n            </textarea><text-angular data-ng-model=\"selected[dato.name]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"dato.toolbar\" data-ng-disabled=\"dato.disabled\"></text-angular><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'Allfiles\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"!dato.disabled\" ngf-select=\"\" ng-model=\"selected.file\" id=\"file\" name=\"file2\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar archivo</button><div data-ng-if=\"selected.tipo == 1\"><a data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\"></a> <img data-ng-if=\"selected.file.name!=null\" ngf-thumbnail=\"selected.file || \'/thumb.jpg\'\" style=\"margin-left:10px;height: 100px;\"></div><div data-ng-if=\"selected.tipo == 2\"><a data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p style=\"max-height: 100px\">Abrir documento</p></a></div><div data-ng-if=\"selected.tipo == 3\"><video controls=\"\" ngf-src=\"selected.file\" style=\"max-height: 200px; margin-left: 10px;\"></video><video heigth=\"400\" controls=\"\" data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 200px\"></video></div><span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected.file.name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected.file!=null\"></i>{{selected.file.name}}</span></div><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'file\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"dato.type==\'file\'\" data-ng-change=\"print(selected)\" ngf-select=\"\" ng-model=\"selected[(fileUpload===\'true\')?\'file\':dato.name]\" id=\"{{[(fileUpload===\'true\')?\'file\':dato.name]}}\" name=\"{{dato.name}}\" ngf-pattern=\"\'.jpg,.jpeg,.png,.gif,.svg\'\" ngf-accept=\"\'image/jpg,image/jpeg,image/png,image/gif,image/svg + xml\'\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar imagen</button> <a data-ng-if=\"actionType==\'edit\' && selected[(fileUpload===\'true\')?\'file\':dato.name].name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\"></a> <img data-ng-if=\"selected[(fileUpload===\'true\')?\'file\':dato.name].name!=null\" ngf-thumbnail=\"selected[(fileUpload===\'true\')?\'file\':dato.name] || \'/thumb.jpg\'\" style=\"margin-left:10px;height: 100px;\"> <span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected[(fileUpload===\'true\')?\'file\':dato.name].name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected[(fileUpload===\'true\')?\'file\':dato.name]!=null\"></i>{{selected[(fileUpload===\'true\')?\'file\':dato.name].name}}</span></div><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'pdf\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"dato.type==\'pdf\'\" ngf-select=\"\" ng-model=\"selected[(fileUpload===\'true\')?\'file\':dato.name]\" id=\"file\" ngf-pattern=\"\'.pdf,.csv,.xls,.xlsx\'\" ngf-accept=\"\'application/pdf,application/vnd.ms-excel,application/csv\'\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar documento</button> <a data-ng-if=\"actionType==\'edit\' && selected[(fileUpload===\'true\')?\'file\':dato.name].name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p style=\"max-height: 100px\">Abrir documento</p></a> <span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected[(fileUpload===\'true\')?\'file\':dato.name].name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected[(fileUpload===\'true\')?\'file\':dato.name]!=null\"></i>{{selected[(fileUpload===\'true\')?\'file\':dato.name].name}}</span></div><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'video\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"!dato.disabled\" ngf-select=\"\" ng-model=\"selected.file\" id=\"file\" ngf-pattern=\"\'video/*\'\" ngf-accept=\"\'video/*\'\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar video</button><video controls=\"\" ngf-src=\"selected.file\" style=\"max-height: 200px; margin-left: 10px;\"></video><video heigth=\"400\" controls=\"\" data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 200px\"></video><span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected.file.name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected.file!=null\"></i>{{selected.file.name}}</span></div><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-init=\"(dato.default)?selected[dato.name]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange(dataset,selected)\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'select\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'selectMultiple\'\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><div class=\"flex mT5\" style=\"justify-content: flex-start\"><input type=\"checkbox\" ng-model=\"selected[dato.name]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'checkbox\'\" style=\"width: 20px;height: 20px;margin: 0;\" ng-checked=\"selected[dato.name]==1\" ng-true-value=\"1\" ng-false-value=\"0\"> <span class=\"text-info mL10\" data-ng-if=\"dato.type==\'checkbox\' && selected[dato.name]==1\">{{dato.labelChecked}}</span> <span class=\"text-info mL10\" data-ng-if=\"dato.type==\'checkbox\' && selected[dato.name]==0\">{{dato.labelUnchecked}}</span></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type==\'mapLon\' && actionType==\'edit\'\" class=\"mT20\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><ng-map center=\"-16.495859,-68.133529\" data-ng-if=\"dato.type==\'mapLon\' && actionType==\'new\'\" class=\"mT20\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><switch-customized-crud id=\"selected[dato.name]\" name=\"selected[dato.name]\" ng-model=\"selected[dato.name]\" data-ng-change=\"dato.ngChange(selected,dato, dataset)\" data-ng-init=\"dato.ngInit(selected,dato, dataset)\" required=\"dato.required\" disabled=\"dato.disabled\" class=\"green\" on=\"{{dato.on}}\" off=\"{{dato.off}}\" data-ng-if=\"dato.type==\'switchCustom\'\"></switch-customized-crud><switch id=\"selected[dato.name]\" name=\"selected[dato.name]\" ng-model=\"selected[dato.name]\" data-ng-change=\"dato.ngChange(selected,dato)\" required=\"dato.required\" disabled=\"dato.disabled\" class=\"green\" data-ng-if=\"dato.type==\'switch\'\" on=\"{{dato.on}}\" off=\"{{dato.off}}\"></switch></div></div></div><div class=\"form-group\" data-ng-if=\"tableName==\'usuarios\' && actionType==\'new\'\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Contraseña</label> <small data-ng-class=\"{\'text-info\': (selected.password || selected.password.length > 10),\'text-warning\': (!selected.password || selected.password.length < 10) }\" style=\"width: 100%;float: left;text-align: right; padding-right: 40px;\">*Se requieren al menos 8 caracteres</small></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><div data-ng-init=\"cloneField(selected.password)\"><input class=\"form-control\" type=\"password\" placeholder=\"Ingrese su contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" id=\"{{\'password1\'}}\" data-ng-required=\"true\" maxlength=\"20\" data-ng-model=\"selected.password\"> <input class=\"form-control mT5\" type=\"password\" placeholder=\"Repita su contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" maxlength=\"20\" id=\"{{\'password2\'}}\" data-ng-required=\"true\" data-ng-model=\"copyField\"></div></div></div><div class=\"row mT10\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Generar contraseña automática</label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p class=\"form-control\" data-ng-if=\"passGeneratorReady\">{{selected.password}}</p><a href=\"\" class=\"btn btn-primary\" data-ng-click=\"passGenerator(8)\">Generar Contraseña</a></div></div></div><div class=\"form-group\" data-ng-if=\"tableName==\'usuarios\' && actionType==\'password\'\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Contraseña</label> <small data-ng-class=\"{\'text-info\': (selected.password || selected.password.length > 10),\'text-warning\': (!selected.password || selected.password.length < 10) }\" style=\"width: 100%;float: left;text-align: right; padding-right: 40px;\">*Se requieren al menos 8 caracteres</small></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><div data-ng-init=\"cloneField(selected.password)\"><input class=\"form-control\" type=\"password\" placeholder=\"Ingrese una nueva contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" id=\"{{\'password1\'}}\" data-ng-required=\"true\" maxlength=\"20\" data-ng-model=\"selected.password\"> <input class=\"form-control mT5\" type=\"password\" placeholder=\"Repita una nueva contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" id=\"{{\'password2\'}}\" data-ng-required=\"true\" maxlength=\"20\" data-ng-model=\"copyField\"></div></div></div><div class=\"row mT10\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Generar contraseña automática</label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p class=\"form-control\" data-ng-if=\"passGeneratorReady\">{{selected.password}}</p><a href=\"\" class=\"btn btn-primary\" data-ng-click=\"passGenerator(8)\">Generar Contraseña</a></div></div></div><div><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"resetRegisterAndGoBack();\">Cancelar</button> <button type=\"submit\" class=\"btn btn-primary pull-right\" data-ng-if=\"actionType!=\'password\'\" data-ng-disabled=\"actionType==\'new\' && tableName ==\'usuarios\' && selected.password.length < 8\">Guardar</button> <button type=\"submit\" class=\"btn btn-primary pull-right\" data-ng-if=\"actionType==\'password\'\">Modificar contraseña.</button><button type=\"button\" class=\"btn btn-default pull-right mR10\" data-ng-click=\"resetRegister()\">Revertir</button></div></form></div></div>");
$templateCache.put("app/views/directives/crud/crudGrid.html","<div data-ng-if=\"!hideHeader\"><div class=\"col-xs-12 col-sm-12 col-md-4\" data-ng-if=\"dataset.options.create && fieldsLoaded\"><a class=\"btn btn-primary\" ui-sref=\"{{state}}.new\" data-ng-click=\"showGrid(1);chooseRegister(\'\',\'new\')\" title=\"Editar\"><i class=\"fa fa-plus\"></i> Agregar Registro</a></div><div class=\"col-xs-12 col-sm-6 flex\" data-ng-class=\"{\'col-md-4\':dataset.options.create,\'col-md-8\':!dataset.options.create}\" data-ng-if=\"fieldsLoaded\" style=\"display:flex;justify-content: flex-start; align-items: center\"><p class=\"text-info\" style=\"margin-bottom:0;margin-right: 15px;font-size: 12px;\">Mostrando</p><select data-ng-model=\"filters.per_page\" data-ng-change=\"changePerPage()\" class=\"form-control\" style=\"max-width: 75px;\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4\" data-ng-if=\"fieldsLoaded\"><div class=\"form-group input-group\"><input class=\"form-control\" type=\"search\" placeholder=\"Buscar por {{(titleFieldLabel)?titleFieldLabel:titleField}}\" data-ng-model=\"filters.comparaciones[0].dato\" data-ng-change=\"search()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"search()\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><ng-include src=\"\'views/directives/crud/crudDownloadFields.html\'\" data-ng-if=\"downloadData && fieldsLoaded\"></ng-include></div><div><div class=\"col-xs-12\" style=\"overflow-x: scroll;\"><table class=\"table table-hover table-striped\" style=\"margin: 0;margin-bottom: 40px;\"><thead><tr><th style=\"max-width: 130px; width: 100px\" data-ng-hide=\"dataset.options.hideTools\">OPCIONES</th><th data-ng-repeat=\"modelProperties in dataset.modelProperties\" data-ng-click=\"sortBy(modelProperties.name)\" data-ng-class=\"{active: propertyName == modelProperties.name}\" data-ng-if=\"modelProperties.activeGrid && modelProperties.name !=\'password\'\" style=\"text-transform: uppercase\"><div class=\"flex\" style=\"justify-content: space-between\"><div><p data-ng-bind-html=\"modelProperties.label\" style=\"margin: 0; padding: 0;\"></p></div><div class=\"pull-right\"><i data-ng-show=\"propertyName == \'\' || propertyName != modelProperties.name\" class=\"fa fa-sort mL5\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == modelProperties.name && !reverse\" class=\"fa fa-sort-desc mL5\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == modelProperties.name && reverse\" class=\"fa fa-sort-asc mL5\" aria-hidden=\"true\"></i></div></div></th></tr></thead><tbody><tr ng-repeat=\"register in dataset.resultado.data\" data-ng-if=\"fieldsLoaded\"><td class=\"center\" data-ng-hide=\"dataset.options.hideTools\"><div class=\"btn-group flex\" style=\"justify-content: center\"><button type=\"button\" data-ng-if=\"dataset.relations && dataset.options.relationsLinks && dataset.relations.hasMany.length>0\" class=\"dropdown-toggle btn btn-default\" tooltip=\"Más\" tooltip-placement=\"right\" data-toggle=\"dropdown\" style=\"padding-left: 12px; padding-right: 12px;\"><i class=\"fa fa-ellipsis-h\" aria-hidden=\"true\"></i></button><ul class=\"dropdown-menu dropdown-user\"><li data-ng-repeat=\"relations in dataset.relations.hasMany\"><a ui-sref=\"{{relations.table}}\" data-ng-if=\"relations.redirectToSection!=null&&relations.redirectToSection\" data-ng-click=\"getSubtitile(register.nombre); setFilter(relations.table,register.id,register[titleField], titleField);\"><i class=\"fa fa-plus\"></i> Administrar {{relations.tableLabel==null?relations.table:relations.tableLabel}}</a></li></ul><div data-ng-if=\"dataset.options.customButton\" render-html=\"dataset.options.customButton\"></div><button type=\"button\" class=\"btn btn-default\" ui-sref=\"{{state}}.select({id:register.id})\" data-ng-click=\"chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.update\" tooltip=\"Editar\" tooltip-placement=\"bottom\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-default\" ui-sref=\"{{state}}.view({id:register.id})\" data-ng-click=\"showGrid(3);chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.read\" tooltip=\"Ver\" tooltip-placement=\"bottom\"><i class=\"fa fa-eye\"></i></button> <button type=\"button\" class=\"btn btn-default\" data-toggle=\"modal\" data-target=\"#crudDeleteModal\" data-ng-click=\"chooseRegister(register,\'delete\')\" data-ng-if=\"dataset.options.delete\" data-ng-disabled=\"register.email==currentUser.email && tableName==\'usuarios\'\" tooltip=\"Eliminar\" tooltip-placement=\"bottom\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-default\" ui-sref=\"{{state}}.select({id:register.id})\" data-ng-click=\"showGrid(1);chooseRegister(register,\'password\')\" data-ng-if=\"tableName == \'usuarios\'\" tooltip=\"Cambiar contraseña\" tooltip-placement=\"bottom\"><i class=\"fa fa-unlock-alt\" aria-hidden=\"true\"></i></button></div></td><td data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.activeGrid && dato.name !=\'password\'\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[dato.name])\"></p><div data-ng-if=\"dato.render == false\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'pdf\' && dato.type!=\'video\' && dato.type!=\'Allfiles\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[dato.name]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[dato.name])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[dato.name]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><img data-ng-if=\"dato.type==\'file\'\" data-ng-src=\"{{register[dato.name]}}\" alt=\"\" style=\"max-height: 100px;\"></a> <a data-ng-if=\"dato.type==\'video\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><video heigth=\"400\" controls=\"\" data-ng-if=\"dato.type==\'video\'\" data-ng-src=\"{{register[dato.name]}}\" style=\"height: 200px\"></video></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><p>{{(register[dato.name])?\'Abrir documento\':\'Sin documento\'}}</p></a></div></td></tr><tr data-ng-if=\"results.length == 0 || resultEmpty\" style=\"text-align: center\"><td colspan=\"{{dataset.modelProperties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr><tr data-ng-if=\"!fieldsLoaded\"><td colspan=\"{{dataset.modelProperties.length+1}}\" style=\"text-align: center\"><strong>Cargando...</strong></td></tr></tbody></table></div><div class=\"col-sm-12 col-md-6 flex mT20\" style=\"justify-content: flex-start;height: 34px\" data-ng-if=\"!hideHeader\"><b class=\"text-info\" style=\"margin-bottom: 0;\">Total de registros obtenidos {{dataset.resultado.total}}</b></div><div class=\"col-sm-12 col-md-6 mT20\" data-ng-if=\"!hideHeader\"><div class=\"pagination\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(filters.page)<=1\" class=\"btn btn-primary\"><i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Inicio</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(filters.page)<=1\" class=\"btn btn-primary\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>Página <b>{{filters.page}}</b> de <b>{{pagesTotal}}</b></span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(filters.page)>=pagesTotal\" class=\"btn btn-primary\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage(pagesTotal)\" data-ng-disabled=\"(filters.page)>=pagesTotal\" class=\"btn btn-primary\">Último <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></button></div></div></div>");
$templateCache.put("app/views/directives/crud/crudPassword.html","<div class=\"row\" data-ng-if=\"formView == true\"><div class=\"pL30 pR30\"><form action=\"\" data-ng-submit=\"updateRegister(tabla, selected, actionType)\"><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.active == true\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'Email\' && actionType!=\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'new\'\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'text\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'email\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'number\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"><div data-ng-if=\"(dato.type == \'password\' && actionType==\'new\') || dato.type == \'password\' && actionType==\'password\'\" data-ng-init=\"cloneField(selected[dato.name])\"><input class=\"form-control\" type=\"password\" placeholder=\"Nueva contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 1}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control mT10\" type=\"password\" placeholder=\"Repita su contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 2}}\" data-ng-required=\"dato.required\" data-ng-model=\"copyField\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"></div><text-angular data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'textarea\'\" data-ng-disabled=\"dato.disabled\"></text-angular><img data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 50px;\" data-ng-if=\"dato.type == \'file\'\"> <input type=\"file\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'file\'\" data-ng-disabled=\"dato.disabled\"><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'select\'\" data-ng-disabled=\"dato.disabled\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'selectMultiple\'\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type == \'mapLon\'\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"resetRegisterAndGoBack();\">Cancelar</button><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"resetRegister()\">Revertir</button> <button type=\"submit\" class=\"btn btn-primary\">Guardar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crud/crudView.html","<div class=\"row\"><div class=\"pL30 pR30\"><form action=\"\"><div class=\"row\" data-ng-if=\"(crudView==\'crudView\')\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\">{{crudTitle}}</h4></div></div><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"( (dato.active && dato.activeForCreate==null && dato.activeForEdit == null) || (dato.active && !dato.activeForCreate && dato.activeForEdit && actionType==\'edit\') || (dato.active && dato.activeForCreate && !dato.activeForEdit && actionType==\'new\'))\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p data-ng-bind-html=\"selected[dato.name]\" class=\"form-control\" style=\"height: auto\" data-ng-if=\"dato.type==\'text\'||dato.type==\'email\'||dato.type==\'number\'||dato.type==\'password\'||dato.type==\'textarea\'||dato.type==\'textareaSimple\'\"></p><p data-ng-bind-html=\"dateToSpanishFormat(selected[dato.name])\" data-ng-if=\"dato.type==\'date\'\" class=\"form-control\"></p><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\" data-ng-if=\"dato.type==\'file\'\"></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p>Abrir documento</p></a><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'select\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'selectMultiple\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLat\'\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLon\'\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type==\'mapLon\'\" class=\"mT20\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><div class=\"\"><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"showGrid(2);resetRegisterAndGoBack();\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary pull-right\" data-ng-disabled=\"!dataset.options.update\" ui-sref=\"{{tabla}}.select({id:selected.id})\" data-ng-click=\"showGrid(1);chooseRegister(selected,\'edit\')\">Editar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crud/modalRestart.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"text-align: center; background: #337ab7;\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" data-ng-click=\"$dismiss()\" aria-hidden=\"true\" style=\"color:white; opacity: 1;\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\" style=\"text-align: center; color:white\">Modificación de permisos</h4></div><div class=\"modal-body\"><div class=\"row\" style=\"text-align: center;\"><span style=\"padding: 0px 30px;\">Para aplicar los cambios es necesario reiniciar su sesión, ¿Desea continuar?</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn-default btn pull-left\" data-ng-click=\"$dismiss()\">Cancelar</button> <button type=\"submit\" class=\"btn-primary btn pull-right\" data-ng-click=\"logout()\">Cerrar sesión</button></div></div>");
$templateCache.put("app/views/directives/crudform/crud.html","<div class=\"container-fluid\"><ng-include src=\"\'app/views/directives/crudform/crudContextMenu.html\'\"></ng-include><div class=\"crud-container\" customheight=\"\" minus=\"50\"><div class=\"crud-grid-header\"><div class=\"grid-title\"><h3>{{crudTitle}} {{(crud.crudView!=\'grid\')?crudTitleSecond:\'\'}}</h3><a class=\"btn btn-action\" data-ng-if=\"dataset.options.create && crud.crudView==\'grid\'\" data-ng-click=\"showCrudForm(true);chooseRegister(\'\',\'new\')\"><i class=\"fa fa-plus\"></i> {{switchText(\'Nuevo\', \'New\')}}</a></div></div><ng-include src=\"\'app/views/directives/crudform/crudGridFilters.html\'\" data-ng-if=\"!customFilters && crud.crudView==\'grid\'\"></ng-include><ng-include src=\"customFilters\" data-ng-if=\"customFilters && crud.crudView==\'custom\' || customFilters && crud.crudView==\'grid\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudPagination.html\'\" data-ng-if=\"crud.crudView==\'grid\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudGrid.html\'\" data-ng-if=\"crud.crudView==\'grid\'\"></ng-include><ng-include src=\"customTemplates\" data-ng-if=\"crud.crudView==\'custom\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudPagination.html\'\" data-ng-if=\"crud.crudView==\'grid\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudForm.html\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudInnerCrud.html\'\"></ng-include><ng-include src=\"\'app/views/directives/customModal/customModal2.html\'\"></ng-include><script type=\"text/ng-template\" id=\"deleteModal.html\"><div class=\"modal-header warning\"> <h3 class=\"modal-title\" id=\"modal-title\">Eliminando {{$parent.selected[titleField]}}</h3> </div> <div class=\"modal-body\" id=\"modal-body\"> <p>¿Esta seguro de eliminar este registro y su contenido relacionado?{{$parent.titleField}}</p> <span class=\"text-danger\"> <i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno </span> </div> <div class=\"modal-footer\"> <button class=\"btn btn-action danger pull-rigth\" type=\"button\" ng-click=\"updateRegister(tabla,selected,actionType);\">OK</button> <button class=\"btn btn-action success pull-left\" type=\"button\" ng-click=\"$dismiss(true)\">Cancel</button> </div></script></div></div>");
$templateCache.put("app/views/directives/crudform/crudContextMenu.html","<div><a href=\"\" class=\"info-btn-close {{$root.currentModule}}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"fas fa-info-circle\"></i></a><div data-ng-class=\"{ \'active\': $root.infoMenu }\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5 data-ng-class=\"{\'hide\': !$root.infoMenu}\">{{selected[titleField]}}</h5></div></div><div class=\"info-menu-body\" ui-heigth=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h5><strong>Detalles</strong></h5></div></div><div class=\"data-box\" data-ng-if=\"selected\" data-ng-repeat=\"dato in dataset.modelProperties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><ng-include ng-init=\"context=\'detail\'\" src=\"\'app/views/directives/crudform/form/formwidget/\'+dato.type+\'.html\'\"></ng-include><p data-ng-if=\"!selected[dato.name] || selected[dato.name]==\'\'\">Sin datos</p></div></div><div class=\"row\"><div class=\"col-xs-12\"><button style=\"margin: auto;\" data-ng-if=\"selected\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"showCrudForm(true);\">{{switchText(\'Editar\', \'Edit\')}}</button></div></div></div></div></div>");
$templateCache.put("app/views/directives/crudform/crudDelete.html","<div class=\"cmodal-content small\"><div class=\"cmodal-header\"><h4 class=\"modal-title\" id=\"myModalLabel\">Eliminar \"{{crudTitle}}\"</h4></div><div class=\"cmodal-body\"><p>¿Esta seguro de eliminar este registro y su contenido relacionado?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"updateRegister(tabla,selected,actionType);\">Confirmar</button></div></div>");
$templateCache.put("app/views/directives/crudform/crudDownloadFields.html","<form action=\"\" data-ng-submit=\"reloadData()\"><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Desde</p><mydatepicker ng-model=\"filters.dateFrom\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened1\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Hasta</p><mydatepicker ng-model=\"filters.dateTo\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened2\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\"><button class=\"btn btn-primary pull-left\" type=\"submit\" data-ng-if=\"!csvReady\" style=\"width: 140px;\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Filtrar por fecha</button></div><div class=\"col-xs-12 mB20\"><hr style=\"margin: 0px 0px 10px 0px;\"><a href=\"\" class=\"btn btn-primary pull-right\" data-ng-click=\"reloadData(true)\" style=\"width: 140px;\"><i class=\"fa fa-cloud-download\" aria-hidden=\"true\"></i> Generar csv</a> <a href=\"{{dataset.downloadLink}}\" class=\"pull-right\" target=\"_blank\" data-ng-if=\"dataset.downloadLink !=\'\' && downloadReady\" style=\"margin: 8px 15px;\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Documento generado</a> <img src=\"images/loader_blue.gif\" data-ng-if=\"(dataset.downloadLink.length > 0 && !downloadReady)\" class=\"mR20 pull-right\" alt=\"\" style=\"width: 34px;\"></div></form>");
$templateCache.put("app/views/directives/crudform/crudForm.html","<div class=\"crud-form-body level1 wow slideInLeft\" data-ng-if=\"crudForm\"><form class=\"crud-form level1\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister(tabla,selected,actionType)\"><div class=\"forms\"><div class=\"form-header sub\"><h3>Nuevo {{crudTitleSecond}}</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"showCrudForm(false)\"><i class=\"far fa-times-circle\"></i></a></div></div><div class=\"forms\" data-ng-if=\"dato.active\" data-ng-repeat=\"dato in dataset.modelProperties | orderBy:\'order\'\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"box-label\"><span class=\"filter-label\" data-ng-bind-html=\"dato.invalid+dato.label\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></span></div><div class=\"box-input\"><ng-include ng-init=\"context=\'form\'\" src=\"\'app/views/directives/crudform/form/formwidget/\'+dato.type+\'.html\'\"></ng-include></div></div><div class=\"forms\"><button type=\"submit\" class=\"btn btn-action success pull-right\">Save</button> <button data-ng-click=\"resetRegister()\" class=\"btn btn-action info pull-right\">Revert</button> <button class=\"btn btn-action danger pull-left\" data-ng-click=\"showCrudForm(false);resetRegisterAndGoBack();\">Cancel</button></div></form></div>");
$templateCache.put("app/views/directives/crudform/crudGrid.html","<div class=\"crud-grid-body wow fadeInUp\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th data-ng-hide=\"dataset.options.hideTools\" class=\"column-title grid-options\"><strong>Opciones</strong></th><th data-ng-repeat=\"modelProperties in dataset.modelProperties\" data-ng-click=\"sortBy(modelProperties.name)\" data-ng-class=\"{active: propertyName == modelProperties.name}\" data-ng-if=\"modelProperties.activeGrid && modelProperties.name !=\'password\'\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"modelProperties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName == modelProperties.name && !reverse\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == modelProperties.name && reverse\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th></tr></thead><tbody><tr ng-repeat=\"register in dataset.result.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':(selected.id == register.id && $root.infoMenu)}\"><td class=\"grid-options\" data-ng-hide=\"dataset.options.hideTools\"><div data-ng-if=\"dataset.options.customButton\" render-html=\"dataset.options.customButton\"></div><button type=\"button\" class=\"btn btn-grid {{$root.currentModule}}\" ui-sref=\"{{childrenState}}({id:register.id})\" data-ng-if=\"childrenState\" tooltip=\"{{switchText(\'Ingresar\', \'Get into\')}}\"><i class=\"fas fa-sign-in-alt\"></i></button> <button type=\"button\" class=\"btn btn-grid {{$root.currentModule}}\" data-ng-click=\"$root.showInfoMenu();chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.read\" tooltip=\"{{switchText(\'Detalles\', \'Details\')}}\"><i class=\"fas fa-info\"></i></button> <button type=\"button\" class=\"btn btn-grid edit {{$root.currentModule}}\" data-ng-click=\"showCrudForm(true);chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.update\" tooltip=\"{{switchText(\'Editar\', \'Edit\')}}\"><i class=\"fas fa-edit\"></i></button> <button type=\"button\" class=\"btn btn-grid delete {{$root.currentModule}}\" data-ng-click=\"chooseRegister(register,\'delete\');updateRegister(tabla,selected,actionType);openModal(\'deleteModal.html\')\" data-ng-if=\"dataset.options.delete\" data-ng-disabled=\"register.email==$root.currentUser.email && tableName==\'usuarios\'\" tooltip=\"{{switchText(\'Eliminar\', \'Delete\')}}\"><i class=\"fas fa-times\"></i></button> <button type=\"button\" class=\"btn btn-grid\" ui-sref=\"{{state}}.select({id:register.id})\" data-ng-click=\"showGrid(1);chooseRegister(register,\'password\')\" data-ng-if=\"tableName == \'usuarios\'\" tooltip=\"Cambiar contraseña\"><i class=\"fas fa-times\"></i></button></td><td data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.activeGrid && dato.name !=\'password\'\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[dato.name])\"></p><div data-ng-if=\"dato.render == false\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'pdf\' && dato.type!=\'video\' && dato.type!=\'Allfiles\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[dato.name]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[dato.name])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[dato.name]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><img data-ng-if=\"dato.type==\'file\'\" data-ng-src=\"{{register[dato.name]}}\" alt=\"\" style=\"max-height: 100px;\"></a> <a data-ng-if=\"dato.type==\'video\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><video heigth=\"400\" controls=\"\" data-ng-if=\"dato.type==\'video\'\" data-ng-src=\"{{register[dato.name]}}\" style=\"height: 200px\"></video></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><p>{{(register[dato.name])?\'Abrir documento\':\'Sin documento\'}}</p></a></div></td></tr><tr data-ng-if=\"dataset.result.data.length==0\" style=\"text-align: center\"><td colspan=\"{{dataset.modelProperties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/views/directives/crudform/crudGridFilters.html","<div class=\"crud-grid-filters\"><div class=\"filters-header\"><a class=\"btn btn-action\" data-ng-click=\"showGridFilters()\"><i data-ng-class=\"{\'open\':gridFilters}\" class=\"fa fa-plus\"></i> {{switchText(\'Filtros\', \'Filters\')}}</a></div><div data-ng-show=\"gridFilters\" class=\"filters-box\"><div class=\"form-group flex\" data-ng-repeat=\"cfilter in customFiltersSet\"><span class=\"filter-label\">{{cfilter.label}}:</span><select class=\"form-control\" data-ng-change=\"reload2(cfilter.field)\" data-ng-model=\"filterCustomFields[cfilter.field]\"><option value=\"\">Todos</option><option value=\"{{y.id}}\" data-ng-repeat=\"y in cfilter.options\">{{y.label}}</option></select></div><div class=\"form-group flex\"><span class=\"filter-label\">Mostrar:</span><select data-ng-model=\"filters.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage()\" class=\"form-control\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div><div class=\"form-group input-group\"><input type=\"text\" placeholder=\"Search\" data-ng-model=\"filters.comparaciones[0].dato\" data-ng-change=\"search()\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div></div></div>");
$templateCache.put("app/views/directives/crudform/crudInnerCrud.html","<div class=\"crud-form-body level2 wow slideInLeft\" data-ng-if=\"innerCrud\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"saveInnerCrud()\"><div class=\"forms\"><div class=\"form-header sub\"><h3>{{(innerCruds[innerTable].actionType==\'insert\')?\'Agregar \' :\'\'}} {{(innerCruds[innerTable].actionType==\'update\')?\'Editar \' :\'\'}} {{(innerCruds[innerTable].actionType==\'delete\')?\'Eliminar \':\'\'}}</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"showCrudInnercrud(false)\"><i class=\"far fa-times-circle\"></i></a></div></div><form data-ng-submit=\"saveInnerCrud()\"><div class=\"cmodal-body\" data-ng-if=\"innerCruds[innerTable].actionType == \'delete\'\"><p>¿Esta seguro de eliminar este registro y su contenido relacionado?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span></div><div class=\"forms\" data-ng-if=\"innerCruds[innerTable].actionType != \'delete\'\"><div class=\"forms\" data-ng-repeat=\"dato in innerCrudModel track by $index\"><div class=\"col-xs-12\" data-ng-show=\"dato.subtitle\"><h4 class=\"header-subtitle-2\">{{dato.subtitle}}</h4><hr></div><div class=\"box-label\"><div class=\"filter-label\"><p>{{dato.label}}</p></div></div><div class=\"box-input\"><input class=\"form-control\" type=\"text\" data-ng-required=\"true\" data-ng-model=\"innerCruds[innerTable][dato.name]\" data-ng-if=\"dato.type==\'text\'\" data-ng-disabled=\"dato.disabled\"><select data-ng-model=\"innerCruds[innerTable][dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in dato.items\" data-ng-if=\"dato.type==\'select\'\"></select><select data-ng-model=\"innerCruds[innerTable][dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" data-ng-init=\"innerCruds[innerTable][dato.name+\'list\']=[]\" data-ng-change=\"(tableName==\'mailing\')?addToList(innerCruds[innerTable][dato.name],dato.name+\'list\'):0\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in dato.items\" data-ng-if=\"dato.type==\'list\'\"></select><div data-ng-if=\"dato.type==\'list\'\" data-ng-repeat=\"it in innerCruds[innerTable][dato.name+\'list\']\"><span data-ng-repeat=\"i in dato.items track by $index\" style=\"display: block;float: left;padding-right: 10px;font-size: 12px;\" data-ng-show=\"it == i.id\">{{i[dato.itemsLabel]}} <span style=\"font-size: 12px;cursor:pointer\" data-ng-click=\"removeFromList(i.$index,dato.name+\'list\')\" class=\"glyphicon glyphicon-remove\"></span></span></div><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"innerCruds[innerTable][dato.name]\" date-options=\"dateOptions\" opened=\"opened\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><textarea class=\"form-control\" data-ng-model=\"innerCruds[innerTable][dato.name]\" data-ng-required=\"dato.required\" style=\"min-height: 50px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\n          </textarea></div></div></div><div class=\"forms\"><button type=\"button\" class=\"btn btn-action danger pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"submit\" data-ng-if=\"tableName!=\'mailing\'\" class=\"btn btn-action success pull-right\">Confirmar</button></div></form></form></div>");
$templateCache.put("app/views/directives/crudform/crudPagination.html","<div class=\"crud-grid-pagination\" data-ng-if=\"crud.crudView==\'grid\'\"><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\">{{switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{filters.page}} {{switchText(\'de\', \'from\')}} {{pagesTotal}}</span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(filters.page)>=pagesTotal\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage(pagesTotal)\" data-ng-disabled=\"(filters.page)>=pagesTotal\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\">{{switchText(\'Último\', \'Last\')}}</button></div><div class=\"pagination-records\" data-ng-class=\"$root.currentModule\"><div class=\"form-group flex\"><span class=\"filter-label\">Mostrar:</span><select data-ng-model=\"filters.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage()\" class=\"form-control\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div></div><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><span class=\"result\">{{switchText(\'Registros\', \'Records\')}}: {{dataset.resultado.total}}</span></div></div>");
$templateCache.put("app/views/directives/crudform/crudPassword.html","<div class=\"row\" data-ng-if=\"formView == true\"><div class=\"pL30 pR30\"><form action=\"\" data-ng-submit=\"updateRegister(tabla, selected, actionType)\"><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.active == true\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'Email\' && actionType!=\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'new\'\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'text\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'email\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'number\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"><div data-ng-if=\"(dato.type == \'password\' && actionType==\'new\') || dato.type == \'password\' && actionType==\'password\'\" data-ng-init=\"cloneField(selected[dato.name])\"><input class=\"form-control\" type=\"password\" placeholder=\"Nueva contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 1}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control mT10\" type=\"password\" placeholder=\"Repita su contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 2}}\" data-ng-required=\"dato.required\" data-ng-model=\"copyField\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"></div><text-angular data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'textarea\'\" data-ng-disabled=\"dato.disabled\"></text-angular><img data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 50px;\" data-ng-if=\"dato.type == \'file\'\"> <input type=\"file\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'file\'\" data-ng-disabled=\"dato.disabled\"><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'select\'\" data-ng-disabled=\"dato.disabled\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'selectMultiple\'\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type == \'mapLon\'\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"resetRegisterAndGoBack();\">Cancelar</button><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"resetRegister()\">Revertir</button> <button type=\"submit\" class=\"btn btn-primary\">Guardar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crudform/crudView.html","<div class=\"row\"><div class=\"pL30 pR30\"><form action=\"\"><div class=\"row\" data-ng-if=\"(crudView==\'crudView\')\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\">{{crudTitle}}</h4></div></div><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"( (dato.active && dato.activeForCreate==null && dato.activeForEdit == null) || (dato.active && !dato.activeForCreate && dato.activeForEdit && actionType==\'edit\') || (dato.active && dato.activeForCreate && !dato.activeForEdit && actionType==\'new\'))\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p data-ng-bind-html=\"selected[dato.name]\" class=\"form-control\" style=\"height: auto\" data-ng-if=\"dato.type==\'text\'||dato.type==\'email\'||dato.type==\'number\'||dato.type==\'password\'||dato.type==\'textarea\'||dato.type==\'textareaSimple\'\"></p><p data-ng-bind-html=\"dateToSpanishFormat(selected[dato.name])\" data-ng-if=\"dato.type==\'date\'\" class=\"form-control\"></p><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\" data-ng-if=\"dato.type==\'file\'\"></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p>Abrir documento</p></a><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'select\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'selectMultiple\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLat\'\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLon\'\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type==\'mapLon\'\" class=\"mT20\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><div class=\"\"><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"showGrid(2);resetRegisterAndGoBack();\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary pull-right\" data-ng-disabled=\"!dataset.options.update\" ui-sref=\"{{tabla}}.select({id:selected.id})\" data-ng-click=\"showGrid(1);chooseRegister(selected,\'edit\')\">Editar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crudform/modalRestart.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"text-align: center; background: #337ab7;\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" data-ng-click=\"$dismiss()\" aria-hidden=\"true\" style=\"color:white; opacity: 1;\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\" style=\"text-align: center; color:white\">Modificación de permisos</h4></div><div class=\"modal-body\"><div class=\"row\" style=\"text-align: center;\"><span style=\"padding: 0px 30px;\">Para aplicar los cambios es necesario reiniciar su sesión, ¿Desea continuar?</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn-default btn pull-left\" data-ng-click=\"$dismiss()\">Cancelar</button> <button type=\"submit\" class=\"btn-primary btn pull-right\" data-ng-click=\"logout()\">Cerrar sesión</button></div></div>");
$templateCache.put("app/views/directives/datepicker/datepicker.html","<p class=\"input-group\"><input type=\"text\" style=\"width: 100%;\" class=\"form-control\" datepicker-popup=\"{{format}}\" ng-model=\"ngModel\" ng-change=\"ngChange\" is-open=\"opened\" datepicker-options=\"dateOptions\" date-disabled=\"disabled(date, mode)\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button class=\"btn form-control\" style=\"min-width: 35px;border-left: 0;\" ng-click=\"open($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p>");
$templateCache.put("app/views/directives/customModal/customModal.html","<div class=\"wow fadeIn container-fluid custom-modal\" data-ng-if=\"customModal.visible\" modalheight=\"\"><a data-ng-click=\"closeCustomModal()\" class=\"btn btn-close-modal\"><i class=\"fas fa-times\"></i></a><div class=\"cmodal-body\"><ng-include src=\"customModal.ngTemplate\" data-ng-if=\"customModal.ngTemplate\"></ng-include></div></div>");
$templateCache.put("app/views/directives/customModal/customModal2.html","<div class=\"wow fadeIn container-fluid custom-modal\" data-ng-if=\"customModal2.visible\" modalheight=\"\"><a data-ng-click=\"closeCustomModal2()\" class=\"btn btn-close-modal\"><i class=\"fas fa-times\"></i></a><div class=\"cmodal-body\"><ng-include src=\"customModal2.ngTemplate\" data-ng-if=\"customModal2.ngTemplate\"></ng-include></div></div>");
$templateCache.put("app/views/directives/crudform/customModals/addEvent.html","<div class=\"cmodal-content medium\"><div class=\"cmodal-header\"><h4 class=\"modal-title\">{{switchText(\'Agregar evento\', \'Add event\')}}</h4></div><div class=\"cmodal-body\"><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Nombre\', \'Name\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Tipo\', \'Type\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Fecha\', \'Date\')}}</p></div><div class=\"data-cont\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Tipo\', \'Type\')}}</p></div><div class=\"data-cont\"><textarea name=\"\" style=\"min-height: 50px\" class=\"form-control\"></textarea></div></div></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"\">Confirmar</button></div></div>");
$templateCache.put("app/views/directives/crudform/customModals/addProjectStage.html","<div class=\"cmodal-content medium\"><div class=\"cmodal-header\"><h4 class=\"modal-title\">{{switchText(\'Agregar etapa\', \'Add project stage\')}}</h4></div><div class=\"cmodal-body\"><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Nombre\', \'Name\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Orden\', \'Order\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Fecha inicio\', \'Start Date\')}}</p></div><div class=\"data-cont\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Fecha cierre\', \'Closing date\')}}</p></div><div class=\"data-cont\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Descripción\', \'Description\')}}</p></div><div class=\"data-cont\"><textarea name=\"\" style=\"min-height: 50px\" class=\"form-control\"></textarea></div></div></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"\">Confirmar</button></div></div>");
$templateCache.put("app/views/directives/crudform/customModals/addUser.html","<div class=\"cmodal-content medium\"><div class=\"cmodal-header\"><h4 class=\"modal-title\">{{switchText(\'Agregar usuario\', \'Add user\')}}</h4></div><div class=\"cmodal-body\"><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Correo electrónico\', \'Email\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"\">Confirmar</button></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicashregister/uicashregister.html","<div class=\"crud-grid-body wow fadeInUp\"><form data-ng-submit=\"\"><div class=\"grid-table-box {{$root.currentModule}} cashreconcile\"><table class=\"table table-hover cashregister\" style=\"margin-bottom: 30px\"><thead><tr><th><strong>Nro.</strong></th><th class=\"column-title\"><strong>Corte</strong></th><th class=\"column-title\"><strong>Cantidad Bs.</strong></th><th class=\"column-title\"><strong>Importe Bs.</strong></th><th class=\"column-title\"><strong>Cantidad USD</strong></th><th class=\"column-title\"><strong>Importe USD</strong></th></tr></thead><tbody><tr data-ng-repeat=\"ct in $root.currencyCuts track by $index\" data-ng-if=\"$index<11\"><td>#{{$index + 1}}</td><td>{{ (ct.isFraction) ? (ct.cut*100) + \' ctvs.\' : ct.cut }}</td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.bs\" class=\"form-control\" data-ng-model=\"ct.amount.bs\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.bs | number : 2}}</p></td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.usd || ct.notMultiply\" class=\"form-control\" data-ng-model=\"ct.amount.usd\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.usd | number : 2}}</p></td></tr><tr><td></td><td><strong>Conteo de efectivo (A)</strong></td><td>Bs.</td><td class=\"align-right\">{{$root[modelName].selected.cash_reconcilied_bs | number : 2}}</td><td>USD</td><td class=\"align-right\">{{$root[modelName].selected.cash_reconcilied_usd | number : 2}}</td></tr><tr><td></td><td><strong>Montos apertura (B)</strong></td><td>Bs.</td><td class=\"align-right\">{{$root[modelName].selected.initial_amount_bs | number : 2}}</td><td>USD</td><td class=\"align-right\">{{$root[modelName].selected.initial_amount_usd | number : 2}}</td></tr><tr><td></td><td><strong>Ingresos registrados por efectivo (C)</strong></td><td>Bs.</td><td class=\"align-right\">{{$root[modelName].selected.cash_amount_bs | number : 2}}</td><td>USD</td><td class=\"align-right\">{{$root[modelName].selected.cash_amount_usd | number : 2}}</td></tr><tr><td></td><td><strong>Diferencia de efectivo: (A - B - C)</strong></td><td>Bs.</td><td class=\"align-right\" data-ng-class=\"{ \'success\': $root.summatory([$root[modelName].selected.cash_reconcilied_bs, - $root[modelName].selected.initial_amount_bs , -$root[modelName].selected.cash_amount_bs]) == 0 , \'danger\' : $root.summatory([$root[modelName].selected.cash_reconcilied_bs, - $root[modelName].selected.initial_amount_bs , -$root[modelName].selected.cash_amount_bs]) !=0}\">{{ $root.summatory([$root[modelName].selected.cash_reconcilied_bs, - $root[modelName].selected.initial_amount_bs , -$root[modelName].selected.cash_amount_bs]) | number : 2 }}</td><td>USD</td><td class=\"align-right\" data-ng-class=\"{ \'success\': $root.summatory([$root[modelName].selected.cash_reconcilied_usd, - $root[modelName].selected.initial_amount_usd , -$root[modelName].selected.cash_amount_usd]) == 0 , \'danger\': $root.summatory([$root[modelName].selected.cash_reconcilied_usd, - $root[modelName].selected.initial_amount_usd , -$root[modelName].selected.cash_amount_usd]) !=0 }\">{{ $root.summatory([$root[modelName].selected.cash_reconcilied_usd, - $root[modelName].selected.initial_amount_usd , -$root[modelName].selected.cash_amount_usd]) | number : 2 }}</td></tr><tr><td></td><td><strong>Comentarios sobre arqueo de efectivo:</strong></td><td colspan=\"4\"><textarea style=\"float: left;min-height: 56px;\" placeholder=\"Comentarios sobre arqueo de efectivo\" data-ng-model=\"$root[modelName].selected.comment_cash\" class=\"form-control\">\n                </textarea></td></tr><tr><td></td><td colspan=\"4\"><h5>Generar orden de depósito</h5></td></tr><tr><td></td><td><strong>Monto Bs:</strong></td><td><input type=\"number\" min=\"0\" class=\"form-control\" data-ng-change=\"$root.limitAmount(\'nextBs\', $root[modelName].selected.cash_reconcilied_bs)\" data-ng-model=\"$root.nextBs\"></td><td></td><td><strong>Prox. monto apertura Bs.</strong></td><td class=\"align-right\"><p>{{ $root[modelName].selected.cash_reconcilied_bs - $root.nextBs | number : 2}}</p></td></tr><tr><td></td><td><strong>Monto USD:</strong></td><td><input type=\"number\" min=\"0\" class=\"form-control\" data-ng-change=\"$root.limitAmount(\'nextUSD\', $root[modelName].selected.cash_reconcilied_usd)\" data-ng-model=\"$root.nextUSD\"></td><td></td><td><strong>Prox. monto apertura USD:</strong></td><td class=\"align-right\"><p>{{ $root[modelName].selected.cash_reconcilied_usd - $root.nextUSD | number : 2}}</p></td></tr><tr><td></td><td><strong>Comentarios para la orden de depósito:</strong></td><td colspan=\"4\"><textarea style=\"float: left;min-height: 56px;\" placeholder=\"Comentarios para la orden de depósito\" data-ng-model=\"$root[modelName].selected.comment\" class=\"form-control\">\n                </textarea></td></tr></tbody></table><table class=\"table table-hover cashregister\" style=\"margin-bottom: 30px\"><thead><tr><th><strong>Nro.</strong></th><th class=\"column-title\"><strong>Corte</strong></th><th class=\"column-title\"><strong>Cantidad Bs.</strong></th><th class=\"column-title\"><strong>Importe Bs.</strong></th><th class=\"column-title\"><strong>Cantidad USD</strong></th><th class=\"column-title\"><strong>Importe USD</strong></th></tr></thead><tbody><tr data-ng-repeat=\"ct in $root.currencyCuts\" data-ng-if=\"$index==11\"><td>#{{$index + 1}}</td><td>{{ct.cut}}</td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.bs\" class=\"form-control\" data-ng-model=\"ct.amount.bs\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.bs | number : 2}}</p></td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.usd || ct.notMultiply\" class=\"form-control\" data-ng-model=\"ct.amount.usd\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.usd | number : 2}}</p></td></tr><tr><td></td><td><strong>Ingresos registrados por tarjeta</strong></td><td>Bs.</td><td class=\"align-right\">{{$root[modelName].selected.card_amount | number : 2}}</td><td>USD</td><td class=\"align-right\">0.00</td></tr><tr><td></td><td><strong>Diferencia de transacciones por tarjeta:</strong></td><td>Bs.</td><td class=\"align-right\" data-ng-class=\"{\'success\': $root[modelName].selected.card_amount - $root[modelName].selected.card_reconcilied == 0 , \'danger\': $root[modelName].selected.card_amount - $root[modelName].selected.card_reconcilied !=0}\">{{$root[modelName].selected.card_amount - $root[modelName].selected.card_reconcilied | number : 2}}</td><td>USD</td><td class=\"align-right\">0.00</td></tr><tr><td></td><td><strong>Comentarios sobre arqueo de pagos con tarjeta:</strong></td><td colspan=\"4\"><textarea style=\"float: left;min-height: 56px;\" placeholder=\"Comentarios sobre arqueo de pagos con tarjeta\" data-ng-model=\"$root[modelName].selected.comment_card\" class=\"form-control\">\n                </textarea></td></tr></tbody></table><table class=\"table table-hover cashregister\" style=\"margin-bottom: 30px\"><thead><tr><th><strong>Nro.</strong></th><th class=\"column-title\"><strong>Corte</strong></th><th class=\"column-title\"><strong>Cantidad Bs.</strong></th><th class=\"column-title\"><strong>Importe Bs.</strong></th><th class=\"column-title\"><strong>Cantidad USD</strong></th><th class=\"column-title\"><strong>Importe USD</strong></th></tr></thead><tbody><tr data-ng-repeat=\"ct in $root.currencyCuts\" data-ng-if=\"$index==12\"><td>#{{$index + 1}}</td><td>{{ct.cut}}</td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.bs\" class=\"form-control\" data-ng-model=\"ct.amount.bs\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.bs | number : 2}}</p></td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.usd || ct.notMultiply\" class=\"form-control\" data-ng-model=\"ct.amount.usd\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.usd | number : 2}}</p></td></tr><tr><td></td><td><strong>Ingresos registrados por transferencias</strong></td><td>Bs.</td><td class=\"align-right\">{{$root[modelName].selected.other_amount | number : 2}}</td><td>USD</td><td class=\"align-right\">0.00</td></tr><tr><td></td><td><strong>Diferencia de transacciones por transferencias:</strong></td><td>Bs.</td><td class=\"align-right\" data-ng-class=\"{\'success\': $root[modelName].selected.other_amount - $root[modelName].selected.other_reconcilied == 0 , \'danger\': $root[modelName].selected.other_amount - $root[modelName].selected.other_reconcilied !=0}\">{{$root[modelName].selected.other_amount - $root[modelName].selected.other_reconcilied | number : 2}}</td><td>USD</td><td class=\"align-right\">0.00</td></tr><tr><td></td><td><strong>Comentarios sobre arqueo de pagos por transferencias:</strong></td><td colspan=\"4\"><textarea style=\"float: left;min-height: 56px;\" placeholder=\"Comentarios sobre arqueo de pagos por transferencias\" data-ng-model=\"$root[modelName].selected.comment_other\" class=\"form-control\">\n                </textarea></td></tr></tbody></table><table class=\"table table-hover cashregister\" style=\"margin-bottom: 30px\"><thead><tr><th><strong>Nro.</strong></th><th class=\"column-title\"><strong>Corte</strong></th><th class=\"column-title\"><strong>Cantidad Bs.</strong></th><th class=\"column-title\"><strong>Importe Bs.</strong></th><th class=\"column-title\"><strong>Cantidad USD</strong></th><th class=\"column-title\"><strong>Importe USD</strong></th></tr></thead><tbody><tr data-ng-repeat=\"ct in $root.currencyCuts\" data-ng-if=\"$index==13\"><td>#{{$index + 1}}</td><td>{{ct.cut}}</td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.bs\" class=\"form-control\" data-ng-model=\"ct.amount.bs\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.bs | number : 2}}</p></td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"!ct.currency.usd || ct.notMultiply\" class=\"form-control\" data-ng-model=\"ct.amount.usd\"></td><td class=\"align-right\"><p class=\"form-control disabled\">{{ct.value.usd | number : 2}}</p></td></tr><tr><td></td><td><strong>Ingresos registrados por pagos a crédito</strong></td><td>Bs.</td><td class=\"align-right\">{{$root[modelName].selected.credit_amount | number : 2}}</td><td>USD</td><td class=\"align-right\">0.00</td></tr><tr><td></td><td><strong>Diferencia de transacciones a crédito:</strong></td><td>Bs.</td><td class=\"align-right\" data-ng-class=\"{\'success\': $root[modelName].selected.credit_amount - $root[modelName].selected.credit_reconcilied == 0 , \'danger\': $root[modelName].selected.credit_amount - $root[modelName].selected.credit_reconcilied !=0}\">{{$root[modelName].selected.credit_amount - $root[modelName].selected.credit_reconcilied | number : 2}}</td><td>USD</td><td class=\"align-right\">0.00</td></tr><tr><td></td><td><strong>Comentarios sobre arqueo de pagos a crédito:</strong></td><td colspan=\"4\"><textarea style=\"float: left;min-height: 56px;\" placeholder=\"Comentarios sobre arqueo de pagos a crédito\" data-ng-model=\"$root[modelName].selected.comment_credit\" class=\"form-control\">\n                </textarea></td></tr></tbody></table></div><div class=\"forms-expanded\"><button class=\"btn btn-action success pull-right\" type=\"button\" data-ng-click=\"saveConcilied()\">Conciliar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/uicontextualmenu.html","<div><ng-include src=\"currentTemplate\"></ng-include></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicombo/uicombo.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\"><div data-ng-class=\"{\'danger\':$root.voucher.actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3><i class=\"fa fa-plus\"></i> Entrega de combos a consignación</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.transferDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\" data-ng-init=\"$root.voucher.selected.stockorder.type=true\"><switch name=\"yesNo\" ng-model=\"$root.voucher.selected.stockorder.type\" on=\"Salida\" off=\"Ingreso\" class=\"wide\"></switch></div><div class=\"forms expanded\" data-ng-if=\"$root.voucher.selected.voucherlineTemp.length>0\" data-ng-repeat=\"cg in $root.comboGroup\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr style=\"background: #f0f0f0;\" data-ng-class=\"{\'danger\': 0, \'success\': (comboQuantity * cg.min) == cg.currentTotal }\"><th></th><th colspan=\"3\"><strong>Grupo</strong><br>{{cg.group}} <small>{{\'(Cant min. x grupo: \'+cg.min+\')\'}}</small></th><th><strong>Por entregar</strong><br>{{comboQuantity * cg.min}}</th><th><strong>Entr. Anterior</strong><br>{{cg.prevTotal}}</th><th><strong>Entr. actual</strong><br>{{cg.currentTotal}}</th><th><strong>Saldo</strong><br>{{ (comboQuantity * cg.min) - cg.currentTotal}}</th></tr><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>Entr. Anterior</strong></th><th class=\"column-title\"><strong>Entr. total</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id\"><strong>Entr. nueva</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-if=\"register.group == cg.group\" data-ng-repeat=\"register in $root.voucher.selected.voucherlineTemp\"><tr data-ng-click=\"$root.setPicked(register.product.id)\" class=\"test {{$root.currentModule}}\"><td data-ng-init=\"$root.calculateIssuedTotal(register)\"></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-class=\"{\'danger\': checkGoodStock(register.product)<=0 }\"><stockpicker register=\"register\" data-ng-if=\"checkGoodStock(register.product)>0\" new-stock=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\"></stockpicker><p data-ng-if=\"checkGoodStock(register.product)<=0\">{{register.product.description}}</p></td><td></td><td data-ng-class=\"{\'danger\': 0 , \'success\': 0 }\">{{register.quantity_allIssued}} {{ ($root.getOlderIssued(register.product.id)>0)?$root.getOlderIssued(register.product.id):\'\' }}</td><td data-ng-class=\"{\'danger\': 0 , \'success\': 0 }\">{{register.quantity_issued}}</td><td data-ng-class=\"{\'danger\': 0 , \'success\': 0 }\">{{register.quantity_issued}}</td></tr><tr style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in $root.getSubitems(register)\"><td></td><td></td><td></td><td data-ng-if=\"!st.isNew\" style=\"padding-left: 20px;\">Lote - {{(st.batchcode)?st.batchcode:\'No asignado\'}}</td><td data-ng-if=\"st.isNew\"><input class=\"grid-input form-control\" type=\"text\" data-ng-model=\"st.batchcode\"></td><td>{{st.shelf}}</td><td></td><td><input class=\"grid-input form-control\" data-ng-change=\"$root.calculateComboTotals(); $root.calculateIssuedTotal(register)\" min=\"0\" type=\"number\" data-ng-model=\"st.quantity_issued\"></td><td></td></tr></tbody></table></div></div><div class=\"forms expanded\"><button type=\"button\" data-ng-click=\"$root.saveVoucher3()\" class=\"btn btn-action success pull-right\">conciliar</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancel</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicombo/uicombo_old.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3 data-ng-if=\"$root[modelName].actionType==\'store\'\"><i class=\"fa fa-plus\"></i> Registrar entrega de productos {{$root[modelName].selected.voucherlineOld[0].product.description}}</h3><h3 data-ng-if=\"$root[modelName].actionType==\'update\'\"><i class=\"fas fa-edit\"></i> Editar entrega de productos</h3><h3 data-ng-if=\"$root[modelName].actionType==\'delete\'\"><i class=\"fas fa-exclamation-triangle\" style=\"color: #d94a4a;\"></i> Anular entrega de productos</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"closeAndBack()\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"pay-header\"><h5>Detalle de entrega</h5></div></div></div><div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Grupo</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>C. Total</strong></th><th class=\"column-title\"><strong>C. Entregada</strong></th><th class=\"column-title\"><strong>Saldo</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-class=\"{\'divided\':register.isFirst===true}\" data-ng-repeat=\"register in $root[modelName].selected.voucherline\"><tr data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-class=\"{\'divided\':register.isFirst===true}\" class=\"test {{$root.currentModule}}\"><td><a data-ng-click=\"markLine(register)\"><i data-ng-if=\"register.active\" style=\"color: #1ea587;\" class=\"fas fa-check-circle\"></i> <i data-ng-if=\"!register.active\" style=\"color: #1ea587;\" class=\"far fa-circle\"></i></a></td><td>#{{$index + 1}}</td><td data-ng-init=\"isFirst(register.combogroup.id)\"><strong data-ng-if=\"register.isFirst===true\">{{register.combogroup.name}}</strong> <span data-ng-if=\"register.isFirst===true\" class=\"text-info\">Items Max.{{register.combogroupMax}}</span></td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-init=\"register.batchPicker=false\"><a style=\"width: 25px;float: left;padding: 0;margin-right: 5px;\" data-ng-if=\"register.product.stock.length>1\" data-ng-click=\"register.batchPicker=!register.batchPicker;loadProducts(\'\', register.product.description)\" class=\"btn btn-theme\"><i class=\"fa fa-plus\"></i></a> {{register.product.description}}<ul data-ng-if=\"products.length>0 && register.batchPicker\" class=\"grid-selector-options {{$root.currentModule}}\"><li><ul><li><i class=\"fas fa-search\"></i> Cod 1</li><li><i class=\"fas fa-search\"></i> Cod 2</li><li><i class=\"fas fa-search\"></i> Producto</li><li>Stock {{$root[modelName].selected.vouchertype_id}}</li></ul><ul data-ng-repeat=\"product in products track by $index\" data-ng-class=\"{\'text-danger\': (product.stock.length==0 || product.stock.current_stock <= 0)}\"><li>{{product.code}}</li><li>{{product.code_secondary}}</li><li>{{product.description}}</li><li>{{(product.stock.length==1)?product.stock[0].current_stock:\'\'}}</li><li data-ng-repeat=\"st in product.stock\" data-ng-if=\"product.stock.length>1 && st.current_stock > 0\" data-ng-click=\"register.batchPicker=false;addProduct(product, st)\" class=\"level2\"><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px;float: left; font-weight: normal;color: inherit;width: 120px;\">Lote - {{st.batchcode}}</p><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px ;float: left; font-weight: normal;color:inherit\">{{st.current_stock - reserved_stock}}</p></li></ul></li></ul></td><td>{{(register.product.stock.length==1)?register.product.stock[0].batchcode:\'\'}}</td><td><input class=\"grid-input form-control\" min=\"0\" step=\"1\" data-ng-disabled=\"true\" title=\"Must be an integer number\" data-ng-change=\"calculateSubTotal2(register)\" type=\"number\" data-ng-model=\"register.quantity\"> <span class=\"text-info\">Cant. Vendida:{{register.itemMin}}</span></td><td><input class=\"grid-input form-control\" min=\"0\" step=\"1\" title=\"Must be an integer number\" data-ng-disabled=\"!register.active\" data-ng-if=\"register.stockadjustment.length > 1\" type=\"number\" data-ng-model=\"register.totalQuantity\"> <input class=\"grid-input form-control\" min=\"0\" step=\"1\" data-ng-disabled=\"!register.active\" data-ng-if=\"register.stockadjustment.length == 1\" data-ng-change=\"calculateSubTotal2(register)\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.stockadjustment[0].quantity_issued\"> <span class=\"text-info\">Cant. Limite,:{{register.itemMax}}</span></td><td>{{register.totalExpected}}</td></tr><tr data-ng-if=\"register.product.stock.length>1\" style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in register.stockadjustment\"><td></td><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{st.batchcode}}</td><td>{{st.batchcode}}</td><td><input class=\"grid-input form-control\" min=\"0\" step=\"1\" data-ng-change=\"calculateSubTotal2(register)\" data-ng-disabled=\"!register.active\" type=\"number\" data-ng-model=\"st.quantity_issued\"></td><td colspan=\"3\"></td></tr></tbody><tbody><tr><td rowspan=\"2\" colspan=\"7\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n                </textarea></td><td style=\"text-align: right\">Otros:</td><td style=\"text-align: right\">{{othersTotal}}</td></tr><tr><td style=\"text-align: right;border-top: none;\"><strong style=\"color: #02579B;\">Total:</strong></td><td style=\"background: #E1F5FE; color: #02579B; text-align: right;border-top: none;\"><strong style=\"font-size: 18px; coloe:#02579B;\">{{$root[modelName].selected.total}}</strong></td></tr></tbody></table></div></div><div class=\"forms expanded\"><button type=\"submit\" class=\"btn btn-action success pull-right\">Save</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"closeAndBack()\">Cancel</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html","<div class=\"container-fluid\"><div class=\"crud-grid-pagination\"><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{$root[modelName].dataset.current_page}} {{$root.switchText(\'de\', \'from\')}} {{$root[modelName].dataset.last_page}}</span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(filters.page)>=$root[modelName].dataset.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage($root[modelName].dataset.last_page)\" data-ng-disabled=\"(filters.page)>=$root[modelName].dataset.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Último\', \'Last\')}}</button></div><div class=\"pagination-records\" data-ng-class=\"$root.currentModule\"><div class=\"form-group flex\"><select data-ng-model=\"filters.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage(filters.per_page)\" class=\"form-control\"><option value=\"5\">Mostrar 5</option><option value=\"10\">Mostrar 10</option><option value=\"20\">Mostrar 20</option><option value=\"50\">Mostrar 50</option><option value=\"100\">Mostrar 100</option></select></div></div><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><span class=\"result\">{{$root.switchText(\'Registros\', \'Records\')}}: {{$root[modelName].dataset.total}}</span></div><div class=\"pagination-total statics {{$root.currentModule}}\" data-ng-class=\"$root.currentModule\" data-ng-if=\"$root.access([\'super-admin\']) && $root[modelName].globalStatics && $root.currentModule!=\'inventory\'\"><span class=\"result\">Total: Bs. {{$root[modelName].globalStatics.sumTotal}}</span></div><div class=\"pagination-total statics {{$root.currentModule}}\" data-ng-class=\"$root.currentModule\" data-ng-if=\"$root.access([\'super-admin\']) && $root[modelName].globalStatics && $root.currentModule!=\'inventory\'\"><span class=\"result\">Total Creditos: Bs. {{$root[modelName].globalStatics.sumCreditAmount}}</span></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicrudgrid/crudgrid.html","<div class=\"crud-grid-body wow fadeInUp\"><div class=\"row\"><div class=\"col-xs-12\"><a class=\"btn btn-action\" data-ng-if=\"$root[modelName].operations.create\" data-ng-click=\"$root.chooseRegister(modelName, {}, \'store\');\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Nuevo\', \'New\')}}</a> <a class=\"btn btn-action\" data-ng-if=\"$root[modelName].operations.createinventory\" data-ng-click=\"$root.chooseRegister(modelName, {}, \'store\', false, \'uiinventoryform\');\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Nuevo\', \'New\')}}</a></div></div><uifilters data-ng-if=\"$root[modelName].ready\" model-name=\"{{modelName}}\"></uifilters><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th data-ng-repeat=\"(key, properties) in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(key)\" data-ng-class=\"{active: propertyName == key}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName != key\" class=\"fa fa-sort\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == key && dir==\'desc\'\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == key && dir==\'asc\'\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td style=\"cursor: pointer\" data-ng-click=\"$root.chooseRegister(modelName, register,\'read\')\" data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\' && dato.type!=\'json\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat(register[key]) }}</p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><div data-ng-if=\"dato.type==\'json\'\"><p>{{register[key].es}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td></tr><tr data-ng-if=\"dataset.result.data.length==0\" style=\"text-align: center\"><td colspan=\"{{dataset.properties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr></tbody></table></div><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicrudgrid/uicrudgridsmall.html","<div class=\"crud-form-body\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><div class=\"crud-form wow slideInLeft\" ui-heigth=\"\" name=\"myForm\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3>{{ modelName }}</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\"><p class=\"detail-label\">Producto:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{$root.product.selected.description}}</p></div><div class=\"detail\"><p class=\"detail-label\">Almacen:</p><p class=\"detail-item\">{{$root.productkardex.filters.filters.warehouse_id.value2}}</p></div><div class=\"detail\"><p class=\"detail-label\">Total unidades:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{$root.getCurrentkardex($root.product.selected,$root.productkardex.filters.filters.warehouse_id.value).total_quantity}}</p></div><div class=\"detail\"><p class=\"detail-label\">Valor total:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{$root.getCurrentkardex($root.product.selected,$root.productkardex.filters.filters.warehouse_id.value).total_amount}} Bs.</p></div><div class=\"detail\"><p class=\"detail-label\">Valor unitario:</p><p class=\"detail-item success\">{{$root.getUnitcost($root.product.selected,$root.productkardex.filters.filters.warehouse_id.value)}} Bs.</p></div></div></div><div class=\"forms expanded\"><uifilters data-ng-if=\"$root[modelName].ready\" model-name=\"{{modelName}}\"></uifilters></div><div class=\"forms expanded\"><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include><div class=\"grid-table-box {{$root.currentModule}}\" style=\"margin-top: 15px;\"><table class=\"table table-hover\"><thead><tr><th></th><th colspan=\"3\" style=\"text-align: center;background: #eaeaea;\"><strong>Entradas</strong></th><th colspan=\"3\" style=\"text-align: center;background: #eaeaea;\"><strong>Salidas</strong></th><th colspan=\"3\" style=\"text-align: center;background: #eaeaea;\"><strong>Existencias</strong></th></tr><tr><th data-ng-repeat=\"(key, properties) in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(key)\" data-ng-class=\"{active: propertyName == key}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName != key\" class=\"fa fa-sort\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == key && dir==\'desc\'\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == key && dir==\'asc\'\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th></tr></thead><tbody>{{$root[modelName].dataset.data[0][\'description\']}}<tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id)}\"><td style=\"cursor: pointer\" data-ng-click=\"$root.chooseRegister(modelName, register,\'read\')\" data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\' && dato.type!=\'json\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat(register[key]) }}</p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><div data-ng-if=\"dato.type==\'json\'\"><p>{{register[key].es}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td></tr><tr data-ng-if=\"dataset.result.data.length==0\" style=\"text-align: center\"><td colspan=\"{{dataset.properties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr></tbody></table></div><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include></div><div class=\"forms expanded buttons\"><button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root[modelName].resetRegister(true);\">Cancelar</button></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uidefaultform/uidefaultform.html","<div class=\"crud-form-body\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form wow slideInLeft\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3 data-ng-if=\"$root[modelName].actionType==\'store\'\"><i class=\"fa fa-plus\"></i> Nuevo {{ modelName }}</h3><h3 data-ng-if=\"$root[modelName].actionType==\'update\'\"><i class=\"fas fa-edit\"></i> Editar {{ $root[modelName].selected[referenceField]?modelName:$root[modelName].selected[referenceField] }}</h3><h3 data-ng-if=\"$root[modelName].actionType==\'delete\'\"><i class=\"fas fa-exclamation-triangle\" style=\"color: #d94a4a;\"></i> Eliminar {{ $root[modelName].selected[referenceField]?modelName:$root[modelName].selected[referenceField] }}</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\" data-ng-if=\"!dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"box-label\"><span class=\"filter-label\" data-ng-bind-html=\"dato.invalid+dato.label\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></span> <small data-ng-bind-html=\"dato.helpText\"></small></div><div class=\"box-input webcontent\"><ng-include data-ng-if=\"dato.type==\'innerCrud\'\" src=\"\'app/scripts/directives/uibuilder/components/uiformwidgets/innercrud.html\'\"></ng-include><div data-ng-if=\"dato.type==\'log\'\"><p data-ng-init=\"toJson($root[modelName].selected[key])\"></p><p data-ng-bind-html=\"$root[modelName].selected.logrender\"></p></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'text\'\" name=\"{{key}}\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'number\'\" name=\"{{key}}\" min=\"0\" step=\"0.01\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'email\'\" data-ng-disabled=\"dato.disabled\"><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'select\' && $root[modelName].properties[key].items\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><button data-ng-if=\"dato.type==\'select\' && dato.onclick==true && !$root[modelName].properties[key].items\" data-ng-click=\"$root.loadItemList($root[modelName].properties[key], dato.itemsSource)\" type=\"button\" class=\"btn btn-primary\">Cargar elementos</button><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel].es for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'selectArray\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"$root[modelName].selected[key]\" date-options=\"dateOptions\" opened=\"opened\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><textarea class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\n       </textarea><text-angular data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"dato.toolbar\" data-ng-disabled=\"dato.disabled\"></text-angular><div data-ng-if=\"dato.type==\'file\'\" class=\"upload-box\"><div class=\"upload-preview\" data-ng-if=\"!selected[key+\'_file\'].name\"><a target=\"_blank\" style=\"display: block;width: calc(100% - 80px); float: left;\" href=\"{{$root.api+$root[modelName].selected[key]}}\">{{$root[modelName].selected[key]}}</a> <img data-ng-if=\"dato.fileType == \'image\'\" ng-src=\"{{$root.api+$root[modelName].selected[key]}}\" alt=\"\"> <button class=\"upload-btn\" data-ngf-select=\"\" data-ng-model=\"$root[modelName].selected[key+\'_file\']\" data-ngf-max-size=\"4096MB\"><i class=\"fas fa-cloud-upload-alt\"></i></button> <a class=\"upload-btn\" style=\"padding-left: 9px;\" data-ng-click=\"$root[modelName].selected[key]=\'\'\"><i class=\"fas fa-times\"></i></a></div><div data-ng-if=\"$root[modelName].selected[key+\'_file\'].name\" class=\"upload-preview\"><span data-ng-if=\"dato.fileType != \'image\'\">{{selected[key]}}</span> <a style=\"display: block;width: calc(100% - 50px); float: left;\">{{ $root[modelName].selected[key+\'_file\'].name }}</a> <img data-ng-if=\"$root[modelName].selected[key+\'_file\'].name!=null\" ngf-thumbnail=\"$root[modelName].selected[key+\'_file\'] || \'/thumb.jpg\'\"> <a class=\"upload-btn\" style=\"opacity: 0.5\" href=\"\"><i class=\"fas fa-check\" style=\"color: green;\"></i></a></div></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.latitud\" data-ng-if=\"dato.type==\'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.longitud\" data-ng-if=\"dato.type==\'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{$root[modelName].selected.latitud}},{{$root[modelName].selected.longitud}}\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'update\'\"><marker position=\"{{$root[modelName].selected.latitud}},{{$root[modelName].selected.longitud}}\" draggable=\"true\" on-dragend=\"$root.pos()\"></marker></ng-map><ng-map center=\"-16.495859,-68.133529\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'store\'\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"$root.pos()\"></marker></ng-map><div data-ng-if=\"dato.type==\'json\'\" class=\"webcontent\"><div data-ng-repeat=\"(k, v) in $root[modelName].selected[key]\" style=\"position: relative; display: flex;\"><input data-ng-if=\"dato.jsonType==\'text\'\" type=\"text\" class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\"> <textarea class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\n            </textarea><text-angular data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"loadToolBar(dato.toolbar)\" data-ng-disabled=\"dato.disabled\"></text-angular><button class=\"btn btn-default btn-flag\"><span class=\"lan-flag {{k}}\"></span></button></div></div></div></div><div class=\"forms buttons\"><button type=\"submit\" class=\"btn btn-action success pull-right\">Guardar</button> <button data-ng-click=\"$root[modelName].resetRegister()\" type=\"button\" data-ng-disabled=\"$root[modelName].$root[modelName].actionType == \'store\'\" class=\"btn btn-action info pull-right\">Revertir</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root[modelName].resetRegister(true);\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uidebt/uidebt.html","<div class=\"crud-grid-body wow fadeInUp\"><div class=\"row\"><div class=\"col-xs-12\"><a class=\"btn btn-action\" data-ng-if=\"$root[modelName].operations.create\" data-ng-click=\"$root.chooseRegister(modelName, {}, \'store\');\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Nuevo\', \'New\')}}</a> <a class=\"btn btn-action\" data-ng-if=\"$root[modelName].operations.createinventory\" data-ng-click=\"$root.chooseRegister(modelName, {}, \'store\', false, \'uiinventoryform\');\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Nuevo\', \'New\')}}</a></div></div><uifilters data-ng-if=\"$root[modelName].ready\" model-name=\"{{modelName}}\"></uifilters><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><td class=\"column-title\"><strong>Comprobante</strong></td><td class=\"column-title\"><strong>Cliente</strong></td><td class=\"column-title\"><strong>Deuda</strong></td><td class=\"column-title\"><strong>Ultimo pago</strong></td></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td>{{register.code}}</td><td>{{register.partner.name}}</td><td>{{register.credit_amount}}</td><td>{{register.updated_at}}</td></tr><tr data-ng-if=\"dataset.result.data.length==0\" style=\"text-align: center\"><td colspan=\"{{dataset.properties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr></tbody></table></div><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uifilters/uifilters.html","<div><ng-include src=\"currentTemplate\"></ng-include></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uideliveryprog/uideliveryprog.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\"><div data-ng-class=\"{\'danger\':$root.voucher.actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3><i class=\"fa fa-plus\"></i> Reserva de productos para entrega de combos</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.transferDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\" data-ng-init=\"comboQuantity = $root.voucher.selected.voucherline[0].quantity; cg.newTotal = 0\" data-ng-repeat=\"cg in $root.voucher.selected.voucherline[0].stockissued.groups\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr style=\"background: #f0f0f0;\" data-ng-class=\"{\'danger\': ( cg.totalBalance - cg.newTotal) != 0, \'success\': ( cg.totalBalance - cg.newTotal) == 0 }\"><th></th><th colspan=\"2\"><strong>Grupo</strong><br>{{cg.group}} <small>{{\'(Cant min. x grupo: \'+cg.min+\')\'}}</small></th><th><strong>Por entregar</strong><br>{{comboQuantity * cg.min}}</th><th><strong>Entr. Anterior</strong><br>{{cg.totalIssued}}</th><th><strong>Entr. actual</strong><br>{{cg.newTotal}}</th><th><strong>Saldo</strong><br>{{ cg.totalBalance - cg.newTotal}}</th></tr><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Entr. Anterior</strong></th><th class=\"column-title\"><strong>Entr. nueva</strong></th><th class=\"column-title\"><strong>Entr. total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-repeat=\"register in cg.product\"><tr data-ng-click=\"$root.setPicked(register.product_id)\" data-ng-class=\"{\'danger\':checkGoodStock(register.product) <= 0}\" class=\"test {{$root.currentModule}}\"><td></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-class=\"{\'danger\': checkGoodStock(register.product)<=0 }\"><p>{{register.product.description}}</p></td><td>{{register.stockissued}}</td><td><input type=\"number\" min=\"0\" data-ng-disabled=\"checkGoodStock(register.product) <= 0\" data-ng-change=\"newTotalDelivery(cg, register, checkGoodStock(register.product))\" data-ng-model=\"register.quantity\" class=\"form-control\"> <small class=\"text-info\">Stock disponible: {{checkGoodStock(register.product)}}</small></td><td>{{register.stockissued + register.quantity}}</td></tr></tbody></table></div></div><div class=\"forms expanded\"><button type=\"button\" data-ng-click=\"$root.saveVoucher4()\" class=\"btn btn-action success pull-right\">conciliar</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancel</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventorycheck/uiinventorycheck.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"$root.saveVoucher2()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3>Entrega de productos</h3><a class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.transferDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\" data-ng-if=\"$root.voucher.selected.status == 1\"><div class=\"col-xs-12\"><div class=\"alert alert-success\" style=\"text-align: center\" role=\"alert\">Esta orden ya fue ejecutada</div></div></div><div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}} uistock\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th colspan=\"4\" data-ng-init=\"$root.voucher.selected.stockorder.type=true\"><switch name=\"yesNo\" data-ng-if=\"$root.currentState != \'pend-purchases-incomes\' && $root.currentState != \'pend-transfer-incomes\' && $root.currentState != \'sales-delivery-point-7\'\" ng-model=\"$root.voucher.selected.stockorder.type\" on=\"Salida\" off=\"Ingreso\" class=\"wide\"></switch></th><th colspan=\"2\" style=\"background: #f0f0f0;text-align: center;\" ç=\"\" data-ng-if=\"$root.voucher.selected.warehouse_id\"><a style=\"position: relative;height: 20px;display: inline-block;margin-bottom: 5px;\"><i class=\"fas fa-warehouse\"></i> <i class=\"fas fa-arrow-alt-circle-right\" style=\"position: absolute; top: 10px;left:8px;color: green;\"></i></a><br><strong>Stock {{$root.getWarehousename($root.voucher.selected.warehouse_id)}}</strong></th><th></th><th colspan=\"2\" style=\"background: #f0f0f0;text-align: center;\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"><a style=\"position: relative;height: 20px;display: inline-block;margin-bottom: 5px;\"><i class=\"fas fa-warehouse\"></i> <i class=\"fas fa-arrow-alt-circle-left\" style=\"position: absolute; top: 10px;left:8px;color: green;\"></i></a><br><strong>Stock {{$root.getWarehousename($root.voucher.selected.warehouse_id2)}}</strong></th><th></th></tr><tr><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>Cantidad requerida</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id\"><strong>Actual</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id\"><strong>Nuevo</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"><strong>Actual</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"><strong>Nuevo</strong></th><th class=\"column-title\"><strong>Saldo</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-repeat=\"register in $root.voucher.selected.voucherline\"><tr data-ng-click=\"$root.setPicked(register.product.id)\" class=\"test {{$root.currentModule}}\"><td data-ng-init=\"$root.calculateIssuedTotal(register)\">#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td><stockpicker register=\"register\" data-ng-if=\"$root.voucher.selected.vouchertype_id!=3\" new-stock=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\"></stockpicker><p data-ng-if=\"$root.voucher.selected.vouchertype_id==3\">{{register.product.description}}</p><a data-ng-if=\"$root.voucher.selected.vouchertype_id==3\" data-ng-click=\"showPicker(false);$root.newStockBatch(register.product)\" style=\"padding: 4px; margin: auto auto 10px; min-width: 60px;\" class=\"btn btn-action\"><i class=\"fa fa-plus\"></i> Lote</a></td><td></td><td>{{register.quantity}}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id)}}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id) - (($root.voucher.selected.stockorder.type==false)?register.quantity_issued*-1:register.quantity_issued)}}</td><td data-ng-class=\"{\'danger\': register.quantity_expected != 0 , \'success\': register.quantity_expected == 0 }\">{{register.quantity_issued}}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id2\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id2)}}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id2\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id2) + (($root.voucher.selected.stockorder.type==false)?register.quantity_issued*-1:register.quantity_issued)}}</td><td data-ng-class=\"{\'danger\': register.quantity_expected != 0 , \'success\': register.quantity_expected == 0 }\">{{register.quantity_expected}}</td></tr><tr style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in $root.getSubitems(register)\"><td><a data-ng-click=\"remove($index,register)\" data-ng-if=\"st.isNew\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td></td><td data-ng-if=\"!st.isNew\" style=\"padding-left: 20px;\">Lote - {{(st.batchcode)?st.batchcode:\'No asignado\'}}</td><td data-ng-if=\"st.isNew\"><select data-ng-model=\"st.shelf\" class=\"grid-input form-control\" placeholder=\"Seleccionar estanteria\"><option value=\"{{s.shelf}}\" data-ng-if=\"s.warehouse_id == $root.voucher.selected.warehouse_id2 && s.shelf\" data-ng-repeat=\"s in register.product.shelfs\">{{s.shelf}}</option></select><input class=\"grid-input form-control\" placeholder=\"Estantería\" type=\"text\" data-ng-model=\"st.shelf\"> <input class=\"grid-input form-control\" placeholder=\"Código de lote\" type=\"text\" data-ng-model=\"st.batchcode\"><mydatepicker ng-model=\"st.expire_at\" date-options=\"dateOptions\" opened=\"opened\" ng-required=\"false\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></td><td>{{st.shelf}}</td><td></td><td colspan=\"2\" data-ng-if=\"$root.voucher.selected.warehouse_id\">{{st.current_stock}}</td><td><input class=\"grid-input form-control\" min=\"0\" data-ng-change=\"$root.calculateIssuedTotal(register,st)\" type=\"number\" data-ng-model=\"st.quantity_issued\"></td><td colspan=\"2\" data-ng-if=\"$root.voucher.selected.warehouse_id\"></td><td></td></tr></tbody><tbody><tr><td rowspan=\"2\" colspan=\"7\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n                </textarea></td><td style=\"text-align: right\"></td><td style=\"text-align: right\"></td></tr><tr><td style=\"text-align: right;border-top: none;\"></td><td style=\"color: #02579B; text-align: right;border-top: none;\"></td></tr></tbody></table></div></div><div class=\"modal\"></div><div class=\"forms expanded\"><button type=\"submit\" data-ng-disabled=\"$root.blockUiForm\" class=\"btn btn-action success pull-right\">Conciliar</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiformwidgets/innercrud.html","<div class=\"innercrud-box\" style=\"width: 100%\" data-ng-if=\"dato.type==\'innerCrud\'\"><input style=\"cursor: not-allowed;\" disabled=\"\" placeholder=\"Almacene el registro, para habilitar este campo\" class=\"form-control\" data-ng-if=\"$root[modelName].actionType==\'store\'\"> <button class=\"btn btn-action\" data-ng-if=\"dato.saveMany && $root[modelName].actionType==\'update\'\" type=\"button\" style=\"margin-bottom: 5px;float: left; margin-right: 5px\" data-ng-disabled=\"dato.disabled\" data-ng-click=\"$root.openPicker( modelName )\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Agregar varios\', \'Add New\')}}</button> <button class=\"btn btn-action\" data-ng-if=\"$root[modelName].actionType==\'update\'\" type=\"button\" style=\"margin-bottom: 5px;float: left;\" data-ng-disabled=\"dato.disabled\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'store\', modelName);\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Agregar nuevo\', \'Add New\')}}</button><div class=\"form-group input-group\"><input type=\"text\" placeholder=\"Buscar\" data-ng-model=\"iSearch\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div><div class=\"innercrud-item\" data-ng-if=\"$root[modelName].actionType!=\'store\'\" data-ng-repeat=\"subitem in dato.items | filter:iSearch\"><p data-ng-if=\"dato.subType!=\'file\'\" style=\"margin-bottom: 0;\" class=\"item-text {{$root.currentModule}}\">{{subitem.referenceField}}</p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\"><span>Abrir</span></a> <a target=\"_blank\" data-ng-if=\"dato.subType==\'image\'\" href=\"{{$root.api+subitem.referenceField}}\"><img data-ng-src=\"{{$root.api+ subitem.referenceField }}\" style=\"max-height: 50px\"></a><div class=\"inner-options\"><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName);\"></i></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/uiinventoryform.html","<div class=\"crud-grid-body wow fadeInUp\"><form class=\"\" name=\"myForm\" data-ng-if=\"$root.voucher.ready\" data-ng-submit=\"$root.executeVoucherForm()\"><div class=\"forms expanded wow fadeIn dp-box\" data-ng-if=\"$root.voucher.ready\"><div class=\"btn-group operation\" data-ng-if=\"$root.voucher.ready\" uib-dropdown=\"\" is-open=\"status.isopen\"><button id=\"single-button\" type=\"button\" class=\"btn operation-dropdown {{$root.currentModule}}\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\">{{ $root.voucher.selected.vouchertypeLabel }} <i data-ng-if=\"$root.voucher.actionType == \'store\'\" class=\"fas fa-chevron-down\"></i></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li data-ng-click=\"$root.setVoucherType(item.id)\" data-ng-hide=\"item.hide || $root.voucher.actionType != \'store\'\" data-ng-repeat=\"item in $root.voucher.properties.vouchertype_id.items\"><a>{{item[$root.voucher.properties.vouchertype_id.itemsLabel]}}</a></li></ul></div></div><div class=\"forms expanded\"><div class=\"crud-grid-filters\"><div class=\"filters-box\"><partnerpicker data-ng-hide=\"$root.voucher.properties.partner_id.hideGrid\" target-field=\"partner_id\"></partnerpicker><partnerpicker data-ng-hide=\"$root.voucher.properties.partner_related.hideGrid\" target-field=\"partner_related\"></partnerpicker><div class=\"form-group input-group\" data-ng-hide=\"$root.voucher.properties.warehouse_id.hide || $root.voucher.selected.vouchertype_id==3\"><select class=\"form-control\" ng-model=\"$root.voucher.selected.warehouse_id\" data-ng-init=\"($root.voucher.actionType==\'store\')?$root.voucher.selected.warehouse_id=$root.voucher.properties.warehouse_id.default:\'\'\" data-ng-required=\"$root.voucher.properties.warehouse_id.required\" data-ng-disabled=\"$root.voucher.properties.warehouse_id.disabled\" data-ng-change=\"$root.refreshVoucher()\" ng-options=\"item.id as item[$root.voucher.properties.warehouse_id.itemsLabel] for item in $root.voucher.properties.warehouse_id.items\"><option value=\"\" disabled=\"\" selected=\"\">Almacen salida</option></select><span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" style=\"position: relative;\" type=\"button\"><i class=\"fas fa-warehouse\"></i> <i class=\"fas fa-arrow-alt-circle-right\" style=\"position: absolute; top: 15px; right: 2px; color: green;\"></i></button></span></div><div class=\"form-group input-group\" data-ng-hide=\"$root.voucher.properties.warehouse_id2.hide || $root.voucher.selected.vouchertype_id==4\"><select class=\"form-control\" data-ng-model=\"$root.voucher.selected.warehouse_id2\" data-ng-init=\"($root.voucher.actionType==\'store\')?$root.voucher.selected.warehouse_id2=$root.voucher.properties.warehouse_id2.default:\'\'\" data-ng-required=\"$root.voucher.properties.warehouse_id2.required\" data-ng-disabled=\"$root.voucher.properties.warehouse_id2.disabled\" data-ng-change=\"$root.voucher.properties.warehouse_id2.ngChange(dataset,selected)\" data-ng-options=\"item.id as item[$root.voucher.properties.warehouse_id2.itemsLabel] disable when item.id == $root.voucher.selected.warehouse_id for item in $root.voucher.properties.warehouse_id2.items\"><option value=\"\" disabled=\"\" selected=\"\">Almacen destino</option></select><span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\"><i class=\"fas fa-warehouse\"></i> <i class=\"fas fa-arrow-alt-circle-left\" style=\"position: absolute; top: 15px;right: 2px;color: green;\"></i></button></span></div><div class=\"form-group input-group\" data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><input type=\"number\" placeholder=\"Transporte\" min=\"0\" value=\"0\" step=\"0.01\" data-ng-change=\"$root.calculateOthersTotal()\" data-ng-disabled=\"$root.voucher.actionType!=\'store\'\" data-ng-model=\"$root.voucher.selected.transport_amount\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\">Bs.</button></span></div><div class=\"form-group input-group\" data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><input type=\"number\" placeholder=\"Otros\" min=\"0\" value=\"0\" step=\"0.01\" data-ng-change=\"$root.calculateOthersTotal()\" data-ng-disabled=\"$root.voucher.actionType!=\'store\'\" data-ng-model=\"$root.voucher.selected.other_amount\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\">Bs.</button></span></div><div class=\"form-group input-group\" data-ng-if=\"$root.currentState == \'sales-mobile-point\'\"><select placeholder=\"Solicitar entrega\" data-ng-model=\"$root.voucher.selected.programmed_delivery\" data-ng-change=\"$root.programDelivery()\" class=\"form-control\"><option value=\"0\">Entrega pendiente</option><option value=\"1\">Entrega programada</option></select><span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\"><i class=\"fas fa-shopping-cart\"></i></button></span></div><div class=\"\" data-ng-if=\"$root.voucher.properties.programmed_at.hide==false\"><mydatepicker ng-model=\"$root.voucher.selected.programmed_at\" date-options=\"dateOptions\" opened=\"opened\" date-required=\"false\" pl=\"Fecha programada\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"form-group input-group\" data-ng-if=\"$root.voucher.properties.programmed_time.hide==false\"><input type=\"time\" placeholder=\"Hora Programada\" data-ng-model=\"$root.voucher.selected.programmed_time\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\"><i class=\"far fa-clock\"></i></button></span></div><div class=\"form-group input-group\" data-ng-if=\"$root.voucher.properties.programmed_type.hide==false\"><select placeholder=\"Entregar en\" data-ng-init=\"$root.voucher.selected.programmed_type= \'Entrega en almacen\'\" data-ng-model=\"$root.voucher.selected.programmed_type\" class=\"form-control\"><option value=\"Entrega en almacen\">Entrega en almacen</option><option value=\"Envío al cliente\">Envío al cliente</option><option value=\"Envío currier\">Envío currier</option></select><span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\"><i class=\"fas fa-map-marker-alt\"></i></button></span></div><div class=\"form-group input-group\" data-ng-if=\"$root.voucher.properties.invoice_autorization.hide==false\"><input type=\"text\" placeholder=\"Nro. autorización\" data-ng-model=\"$root.voucher.selected.invoice_autorization\" data-ng-required=\"$root.voucher.selected.invoice_type == \'1\' || $root.voucher.selected.invoice_type == \'2\'\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\"><i class=\"fas fa-file-invoice\"></i></button></span></div><div class=\"form-group input-group\" data-ng-if=\"$root.voucher.properties.invoice_type.hide==false\"><select class=\"form-control\" data-ng-init=\"($root.voucher.actionType==\'store\')?$root.voucher.selected.invoice_type=$root.voucher.properties.invoice_type.default:\'\'\" ng-model=\"$root.voucher.selected.invoice_type\"><option value=\"\" disabled=\"\" selected=\"\">Seleccione una opción</option><option value=\"0\">Recibo</option><option value=\"1\">Factura</option><option value=\"2\">Poliza de importación</option></select><span class=\"input-group-btn\"><button class=\"btn btn-default\" disabled=\"\" type=\"button\"><i class=\"fas fa-file-invoice-dollar\"></i></button></span></div></div></div></div><ng-include src=\"\'app/scripts/directives/uibuilder/components/uiinventoryform/templates/\'+tableTemplate+\'.html\'\"></ng-include><div class=\"forms expanded\"><div class=\"box-button left\"><button data-ng-hide=\"$root.voucher.actionType!=\'store\' || $root.blockPikerCustom()\" type=\"button\" class=\"btn btn-action default pull-left\" data-ng-click=\"enableSync();$root.openPickerCustom();\">{{$root.switchText(\'Agregar varios\', \'Add many\')}}</button></div></div><div class=\"forms expanded\"><div class=\"box-button right\"><button type=\"submit\" data-ng-disabled=\"$root.uiinvBlock\" class=\"btn btn-action success pull-right\">Registrar</button> <button data-ng-click=\"$root.reloadUI()\" type=\"button\" class=\"btn btn-action info pull-right\">Nuevo</button></div></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinvoice/uiinvoice.html","<div class=\"crud-grid-body\"><div class=\"crud-form\" style=\"padding: 0 10%;\"><div class=\"crud-grid-header\"><div class=\"grid-title\"><h3>Impresión de comprobante</h3></div></div><div id=\"invoice\"><div class=\"forms expanded\"><h3 style=\"text-align: center; margin: 0 0 20px; text-transform: uppercase\" data-ng-if=\"modelName == \'voucher\'\">{{$root.voucher.selected.vouchertype.name}}</h3><h3 style=\"text-align: center; margin: 0 0 20px; text-transform: uppercase\" data-ng-if=\"modelName == \'vouchertransaction\'\">Transacción por {{$root.vouchertransaction.selected.voucher.vouchertype.name}}<br></h3><h3 style=\"text-align: center; margin: 0 0 20px; text-transform: uppercase\" data-ng-if=\"modelName == \'stockorder\'\">Ajuste de stock por {{$root.stockorder.selected.voucher.vouchertype.name}}<br></h3><h3 style=\"text-align: center; margin: 0 0 20px; text-transform: uppercase\" data-ng-if=\"modelName == \'cashregisterlog\'\">Historial de transacciones {{$root[modelName].selected.cashregister.name}}<br></h3><div class=\"pay-box\"><div class=\"detail\" data-ng-if=\"i.value\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\">{{i.value}}</p></div></div></div><div class=\"forms expanded\" data-ng-if=\"modelName == \'voucher\' && $root.currentModule != \'inventory\'\"><div class=\"grid-table-box invoice-print {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Item</strong></th><th class=\"\"><strong>Cant.</strong></th><th class=\"\"><strong>Código</strong></th><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Marca</strong></th><th class=\"\" data-ng-if=\"$root.voucher.selected.vouchertype_id==7\"><strong>Ubicación</strong></th><th class=\"\"><strong>Pre.</strong></th><th class=\"\"><strong>Desc.</strong></th><th class=\"\"><strong>Total</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td>#{{$index + 1}}</td><td>{{register.quantity}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{register.product.productbrand.name}}</td><td data-ng-if=\"$root.voucher.selected.vouchertype_id==7\"><p data-ng-repeat=\"shelf in register.productshelf\" data-ng-if=\"shelf.warehouse_id == $root.voucher.selected.warehouse_id && shelf.shelf\">{{shelf.shelf}}</p></td><td>{{register.value}}</td><td>{{register.discount}}</td><td>{{register.sub}}</td></tr><tr data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><td colspan=\"7\" style=\"text-align: right\"><strong>Transporte Bs.</strong></td><td><strong>{{ $root.voucher.selected.transport_amount}}</strong></td></tr><tr data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><td colspan=\"7\" style=\"text-align: right\"><strong>Otros Bs.</strong></td><td><strong>{{ $root.voucher.selected.other_amount}}</strong></td></tr><tr><td colspan=\"7\" style=\"text-align: right\"><strong>TOTAL Bs.</strong></td><td><strong>{{ $root.voucher.selected.total}}</strong></td></tr></tbody><tbody style=\"border-top: 0;\"><tr data-ng-repeat=\"vt in $root[modelName].selected.vouchertransaction\" data-ng-if=\"vt.original_payment == 1\"><td colspan=\"7\" style=\"text-align: right\"><strong>{{$root.transalatePayment(vt.payment_type)}} {{(vt.amount_usd>0)?\'USD\':\'Bs.\'}}</strong></td><td><strong data-ng-if=\"vt.payment_type == \'cash\'\">{{ (vt.amount_usd>0)?vt.amount_usd:vt.amount_issued }}</strong> <strong data-ng-if=\"vt.payment_type != \'cash\'\">{{ vt.amount }}</strong></td></tr><tr><td colspan=\"7\" style=\"text-align: right\"><strong>Cambio Bs.</strong></td><td><strong>{{ $root.voucher.selected.transactionExcedent}}</strong></td></tr></tbody></table></div></div><div class=\"forms expanded\" data-ng-if=\"modelName == \'voucher\' && $root.currentModule == \'inventory\'\"><div class=\"grid-table-box invoice-print {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Item</strong></th><th class=\"\"><strong>Cant.</strong></th><th class=\"\"><strong>Código</strong></th><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Marca</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td>#{{$index + 1}}</td><td>{{register.quantity}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{register.product.productbrand.name}}</td></tr><tr data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><td colspan=\"4\" style=\"text-align: right\"><strong>Transporte</strong></td><td><strong>{{ $root.voucher.selected.transport_amount}}</strong></td></tr><tr data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><td colspan=\"4\" style=\"text-align: right\"><strong>Otros</strong></td><td><strong>{{ $root.voucher.selected.other_amount}}</strong></td></tr><tr><td colspan=\"4\" style=\"text-align: right\"><strong>Total</strong></td><td><strong>{{ $root.voucher.selected.total}}</strong></td></tr></tbody></table></div></div><div class=\"forms expanded\" data-ng-if=\"modelName == \'stockorder\'\"><div class=\"grid-table-box invoice-print {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Item</strong></th><th class=\"\"><strong>Cant.</strong></th><th class=\"\"><strong>Código</strong></th><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Marca</strong></th><th class=\"\" data-ng-if=\"$root[modelName].selected.warehouse_id\"><strong>Ubicación {{getWName($root[modelName].selected.warehouse_id)}}</strong></th><th class=\"\" data-ng-if=\"$root[modelName].selected.warehouse_id2\"><strong>Ubicación {{getWName($root[modelName].selected.warehouse_id2)}}</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].selected.stockadjustment\" class=\"{{$root.currentModule}}\"><td>#{{$index + 1}}</td><td>{{register.quantity_issued}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{(register.stock2.batchcode)?register.stock2.batchcode:register.stock.batchcode}}</td><td>{{register.product.productbrand.name}}</td><td data-ng-if=\"$root[modelName].selected.warehouse_id\">{{register.stock.shelf}}</td><td data-ng-if=\"$root[modelName].selected.warehouse_id2\">{{register.stock2.shelf}}</td></tr></tbody></table></div></div><div class=\"forms expanded\" data-ng-if=\"modelName == \'vouchertransaction\'\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Item</strong></th><th class=\"\"><strong>Monto (Bs.)</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\" data-ng-if=\"$root.vouchertransaction.selected.payment_type==\'cash\'\"><strong>Cambio (Bs.)</strong></th><th class=\"\" data-ng-if=\"$root.vouchertransaction.selected.payment_type==\'other\'\"><strong>Cuenta</strong></th><th class=\"\" data-ng-if=\"$root.vouchertransaction.selected.payment_type==\'other\'\"><strong>Nro. Orden</strong></th></tr></thead><tbody><tr class=\"{{$root.currentModule}}\"><td>#1</td><td>{{$root.vouchertransaction.selected.amount}}</td><td>{{$root.transalatePayment($root.vouchertransaction.selected.payment_type)}}</td><td class=\"\" data-ng-if=\"$root.vouchertransaction.selected.payment_type==\'cash\'\">{{$root.vouchertransaction.selected.amount_excedent}}</td><td class=\"\" data-ng-if=\"$root.vouchertransaction.selected.payment_type==\'other\'\">{{$root.vouchertransaction.selected.accountbank.code}}</td><td class=\"\" data-ng-if=\"$root.vouchertransaction.selected.payment_type==\'other\'\">{{$root.vouchertransaction.selected.bankcode}}</td></tr></tbody></table></div></div><div class=\"forms expanded\" data-ng-if=\"modelName == \'cashregisterlog\'\"><div class=\"grid-table-box invoice-print {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Item</strong></th><th class=\"\"><strong>Monto.</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Nota</strong></th><th class=\"\" data-ng-if=\"$root.paymentType == \'other\'\"><strong>Cuenta</strong></th><th class=\"\" data-ng-if=\"$root.paymentType == \'other\'\"><strong>Nro. Orden</strong></th></tr></thead><tbody><tr data-ng-repeat=\"vt in $root[modelName].selected.vouchertransaction\" data-ng-if=\"vt.payment_type== $root.paymentType\" class=\"{{$root.currentModule}}\"><td>#1</td><td>{{vt.amount}}</td><td>{{$root.transalatePayment(vt.payment_type)}}</td><td>{{vt.comment}}</td><td class=\"\" data-ng-if=\"vt.payment_type==\'other\'\">{{vt.accountbank.code}}</td><td class=\"\" data-ng-if=\"vt.payment_type==\'other\'\">{{vt.bankcode}}</td></tr></tbody></table></div></div><div class=\"forms expanded\" data-ng-if=\"modelName == \'vouchertransaction\'\"><div class=\"col-xs-12\"><p class=\"firm\"><strong>Comentarios:</strong> {{$root.vouchertransaction.selected.comment}}</p></div></div><div class=\"forms expanded\" data-ng-if=\"modelName == \'voucher\'\"><div class=\"col-xs-12\"><p class=\"firm\"><strong>Comentarios:</strong> {{$root.voucher.selected.comments}}</p></div></div><div class=\"forms expanded\"><div class=\"col-xs-12\" style=\"min-height: 150px\"></div><div class=\"pay-box\"><div class=\"detail t2\"><p class=\"firm\">Elaborado por:</p></div><div class=\"detail t2\"><p class=\"firm\">Entregado por:</p></div><div class=\"detail t2\"><p class=\"firm\">Recibido por:</p></div></div><div class=\"col-xs-12\" style=\"padding: 0; margin-top: 30px\"><p>{{tPrint}}</p><p>{{uPrint}}</p></div></div></div><div class=\"forms expanded\"><button type=\"button\" data-ng-click=\"$root.printDiv(\'invoice\');\" class=\"btn btn-action success pull-right\">Imprimir</button></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinvoice/uiinvoicestock.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3><i class=\"fa fa-plus\"></i> Comprobante de entrega</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"closeAndBack()\"><i class=\"far fa-times-circle\"></i></a></div><div id=\"invoice\"><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"pay-header\"><h5>Detalle {{$root.memVoucher.code}}</h5></div></div></div><div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Lote</strong></th><th class=\"column-title\"><strong>Cantidad programada</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.vouchertype_id != 10\"><strong>Precio</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.vouchertype_id != 10\"><strong>Total</strong></th></tr></thead><tbody data-ng-if=\"$root.voucher.selected.vouchertype_id == 10\" style=\"border-top: 1px solid #ddd;\"><tr class=\"test {{$root.currentModule}}\" ng-repeat=\"register in $root.stockOrderSelected.stockadjustment\"><td></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{register.batchcode}}</td><td>{{(register.quantity_issued)?register.quantity_issued:\'variable\'}}</td></tr></tbody><tbody data-ng-if=\"$root.voucher.selected.vouchertype_id != 10\" data-ng-repeat=\"line in $root.voucher.selected.voucherline\" style=\"border-top: 1px solid #ddd;\"><tr class=\"test {{$root.currentModule}}\" data-ng-if=\"line.product_id == register.product_id\" ng-repeat=\"register in $root.stockOrderSelected.stockadjustment\"><td></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{register.batchcode}}</td><td>{{(register.quantity)?register.quantity:\'variable\'}}</td><td>{{line.value}}</td><td>{{register.quantity * line.value}}</td></tr></tbody></table></div></div></div><div class=\"forms expanded\"><button type=\"button\" style=\"margin-right: 5px\" class=\"btn btn-action success pull-right\">cargar</button> <button type=\"button\" style=\"margin-right: 5px\" data-ng-click=\"$root.printDiv(\'invoice\');\" class=\"btn btn-action success pull-right\">imprimir</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"closeAndBack()\">Cancel</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipayment/uipayment.html","<div class=\"crud-form-body level1\"><form class=\"crud-form wow slideInLeft\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"$root.saveVoucher()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3><i class=\"fa fa-plus\"></i> Registrar transacción</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\"><div class=\"pay-box none-border-bottom\"><div class=\"pay-header\"><h5 style=\"float: left;margin-right: 20px;margin-top: 5px;margin-bottom: 20px;\">{{$root.paymentTitle}}</h5><button type=\"button\" data-ng-class=\"{\'disabled\':!t.enable}\" data-ng-hide=\"t.hidden()\" data-ng-disabled=\"!t.enable\" data-ng-repeat=\"t in $root.paymentTypes\" style=\"margin-right: 10px\" data-ng-click=\"$root.newPay(t.type,t.currency,t.verification, t.label)\" class=\"btn-action\">{{t.label}}</button></div></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"pay-method\"><div class=\"pay-item-box\" data-ng-repeat=\"tr in $root.voucher.selected.vouchertransaction track by $index | orderBy:\'payment_type\'\"><div class=\"pay-icon\"><svg data-ng-if=\"tr.payment_type==\'cash\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-efectivo\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-05\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M18.5895126,7.98669683 L18.5895126,6.83822798 C18.5895126,5.66070525 17.7934915,4.67647488 16.7398607,4.45268794 L16.7398607,2.74307091 C16.7398607,2.47798423 16.5361376,2.26284141 16.2851215,2.26284141 L15.0525508,2.26284141 C14.9290891,1.04305848 13.949126,0.089562802 12.7618019,0.089562802 L2.45445502,0.089562802 C1.1839136,0.089562802 0.150063948,1.18112446 0.150063948,2.52288568 L0.150063948,13.4541097 C0.150063948,14.7958709 1.18368623,15.8874326 2.45445502,15.8874326 L16.2851215,15.8874326 C17.5556629,15.8874326 18.5895126,14.7958709 18.5895126,13.4541097 L18.5895126,12.395924 C19.3075458,11.9831667 19.7959358,11.1795027 19.7959358,10.2572219 L19.7959358,10.1258791 C19.7959358,9.20359839 19.3075458,8.39921398 18.5895126,7.98669683 Z M15.8303823,4.40466499 L3.57629672,4.40466499 C3.26798352,4.40466499 3.01696746,4.1395783 3.01696746,3.81422281 C3.01696746,3.4883871 3.26798352,3.22354053 3.57629672,3.22354053 L14.6112264,3.22354053 L15.8301549,3.22354053 L15.8301549,4.40466499 L15.8303823,4.40466499 Z M17.6800341,13.4541097 C17.6800341,14.2661778 17.0543129,14.9269736 16.2851215,14.9269736 L2.45445502,14.9269736 C1.68526361,14.9269736 1.05954242,14.2661778 1.05954242,13.4541097 L1.05954242,2.52288568 C1.05954242,1.7108176 1.68526361,1.0500218 2.45445502,1.0500218 L12.7618019,1.0500218 C13.4468666,1.0500218 14.0182464,1.57443242 14.134887,2.26284141 L3.57629672,2.26284141 C2.76640614,2.26284141 2.10748899,2.95869396 2.10748899,3.8139827 C2.10748899,4.66927144 2.76640614,5.36488387 3.57629672,5.36488387 L16.2851215,5.36488387 C17.0543129,5.36488387 17.6800341,6.02567967 17.6800341,6.83798787 L17.6800341,7.70240097 C17.6177348,7.69711845 17.5552082,7.69231615 17.4917721,7.69231615 L13.7087964,7.69231615 C12.4382549,7.69231615 11.4046327,8.78411792 11.4046327,10.1258791 L11.4046327,10.2572219 C11.4046327,11.598743 12.4382549,12.6903047 13.7087964,12.6903047 L17.4915447,12.6903047 C17.5549808,12.6903047 17.6175075,12.6855024 17.6798067,12.6802199 L17.6798067,13.4541097 L17.6800341,13.4541097 Z M18.8864573,10.2572219 C18.8864573,11.06929 18.2607361,11.7298457 17.4917721,11.7298457 L13.7087964,11.7298457 C12.9398323,11.7298457 12.3141111,11.06929 12.3141111,10.2572219 L12.3141111,10.1258791 C12.3141111,9.31357095 12.9396049,8.65277515 13.7087964,8.65277515 L17.4915447,8.65277515 C18.2605087,8.65277515 18.8862299,9.31357095 18.8862299,10.1258791 L18.8862299,10.2572219 L18.8864573,10.2572219 Z\" id=\"Shape\"></path><ellipse id=\"Oval\" cx=\"13.7708683\" cy=\"10.1911904\" rx=\"0.710075316\" ry=\"0.749878366\"></ellipse></g></g></g></svg><svg data-ng-if=\"tr.payment_type==\'card\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-tarjeta\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-19\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M17.9217986,4.68226115 L17.2439313,4.68226115 L16.1861765,1.53034885 C15.845177,0.514070674 14.8056509,-0.0126540474 13.868206,0.358267716 L1.39024761,5.28411928 C0.936229683,5.46338495 0.573841714,5.82376167 0.369679477,6.29855207 C0.165517241,6.7736061 0.144128817,7.30613059 0.309403008,7.79832031 L2.84052863,15.3414507 C2.88136108,15.4637731 2.96181072,15.5552513 3.05830169,15.6148308 C3.36624639,16.2211706 3.96099043,16.6326907 4.64298952,16.6326907 L17.9220416,16.6326907 C18.91952,16.6326907 19.7305788,15.7527072 19.7305788,14.6710498 L19.7305788,6.64390211 C19.7305788,5.56224469 18.9192769,4.68226115 17.9217986,4.68226115 Z M3.80641045,7.582147 L18.7583776,7.582147 L18.7583776,8.63665095 L3.80641045,8.63665095 L3.80641045,7.582147 Z M18.7474404,6.52764305 L3.81734771,6.52764305 C3.87057573,6.08264239 4.21838068,5.73676509 4.64274647,5.73676509 L17.9217986,5.73676509 C18.3461644,5.73676509 18.6942124,6.08264239 18.7474404,6.52764305 Z M14.2009418,1.34871055 C14.6338144,1.17761728 15.115297,1.42094407 15.2727936,1.8909892 L16.2095093,4.68226115 L5.75737506,4.68226115 L14.2009418,1.34871055 Z M1.25073675,6.74407999 C1.34504026,6.52447954 1.5125019,6.35786792 1.72225429,6.27508936 L3.03108005,5.75838243 C2.90590916,6.0249083 2.83396628,6.3251783 2.83396628,6.64390211 L2.83396628,12.2404182 L1.22254291,7.43767996 C1.14646818,7.21017073 1.15643324,6.96394406 1.25073675,6.74407999 Z M17.9217986,15.5784504 L4.64298952,15.5784504 C4.18192314,15.5784504 3.8066535,15.1714119 3.8066535,14.6713134 L3.8066535,9.69115489 L18.7586207,9.69115489 L18.7586207,14.6713134 C18.7583776,15.1714119 18.383108,15.5784504 17.9217986,15.5784504 Z\" id=\"Shape\"></path><path d=\"M7.76594258,10.7564675 L5.26471214,10.7564675 C4.99638463,10.7564675 4.77861158,10.9926764 4.77861158,11.2837195 L4.77861158,13.9966945 C4.77861158,14.2877376 4.99638463,14.5239465 5.26471214,14.5239465 L7.76594258,14.5239465 C8.03427009,14.5239465 8.25204314,14.2877376 8.25204314,13.9966945 L8.25204314,11.2837195 C8.25204314,10.9924128 8.03451314,10.7564675 7.76594258,10.7564675 Z M7.27984202,13.4694425 L5.7508127,13.4694425 L5.7508127,11.8109715 L7.27984202,11.8109715 L7.27984202,13.4694425 Z\" id=\"Shape\"></path></g></g></g></svg><svg data-ng-if=\"tr.payment_type==\'other\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-deposito\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-27\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M19.2563877,5.59601502 L14.3193073,0.381418141 C14.1800395,0.234343717 13.9715024,0.190452396 13.7894577,0.270021457 C13.6078991,0.349590517 13.4895336,0.536706147 13.4895336,0.744355727 L13.4895336,3.19020598 L9.72225429,3.19020598 C9.45392678,3.19020598 9.23615373,3.42018623 9.23615373,3.70355475 C9.23615373,3.98692328 9.45392678,4.21690353 9.72225429,4.21690353 L13.9756342,4.21690353 C14.2439617,4.21690353 14.4617348,3.98692328 14.4617348,3.70355475 L14.4617348,1.98383635 L18.2251253,5.95869593 L14.4617348,9.93329884 L14.4617348,8.21332376 C14.4617348,7.92995524 14.2439617,7.69997498 13.9756342,7.69997498 L5.95157223,7.69997498 C5.95497494,7.45356757 5.95497494,7.13837142 5.95497494,6.73333924 L5.95497494,5.25361139 C5.95497494,5.04596181 5.83660945,4.85884618 5.65505089,4.77927712 C5.47276318,4.69945138 5.26446909,4.7433427 5.12520128,4.8906738 L0.188120918,10.1045007 C-0.00170135197,10.3049634 -0.00170135197,10.6299131 0.188120918,10.8303758 L5.12495823,16.044716 C5.21804648,16.1430223 5.34224518,16.1951272 5.46863132,16.1951272 C5.5313383,16.1951272 5.59453137,16.1822935 5.65480784,16.1561127 C5.8363664,16.0765437 5.95473189,15.889428 5.95473189,15.6817784 L5.95473189,13.2351582 L9.72225429,13.2351582 C9.9905818,13.2351582 10.2083549,13.0051779 10.2083549,12.7218094 C10.2083549,12.4384409 9.9905818,12.2084606 9.72225429,12.2084606 L5.46838827,12.2084606 C5.20006076,12.2084606 4.98228771,12.4384409 4.98228771,12.7218094 L4.98228771,12.7279696 C4.98253076,12.7857213 4.98277381,13.6596976 4.98277381,14.4422978 L1.21938326,10.4674382 L4.98277381,6.49309201 C4.98277381,7.26029176 4.98253076,8.11578749 4.98228771,8.20280011 C4.98155856,8.23924787 4.98471821,8.27595231 4.99152362,8.31265675 C5.03648792,8.55341732 5.23627525,8.72667254 5.46838827,8.72667254 L13.4895336,8.72667254 L13.4895336,11.1725228 C13.4895336,11.3801724 13.6078991,11.567288 13.7894577,11.6468571 C13.9715024,11.7261694 14.1797964,11.6825348 14.3193073,11.5354604 L19.2563877,6.32189019 C19.4462099,6.12142749 19.4462099,5.79647772 19.2563877,5.59601502 Z\" id=\"Shape\"></path></g></g></g></svg><svg data-ng-if=\"tr.payment_type==\'credit\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-cheque\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-02\" transform=\"translate(0.000000, 1.000000)\"><path d=\"M19.1969457,0.119841272 L4.98349486,0.119841272 C4.7241116,0.119841272 4.51359765,0.342155516 4.51359765,0.616078423 L4.51359765,11.7563544 L0.551894273,11.7563544 C0.292511013,11.7563544 0.0819970631,11.9786686 0.0819970631,12.2525915 L0.0819970631,14.806476 C0.0819970631,16.3763222 1.29127753,17.6533885 2.77756241,17.6533885 L16.9708076,17.6533885 L16.9755066,17.6533885 C16.9771512,17.6533885 16.9785609,17.6528923 16.9802056,17.6528923 C18.4624963,17.6474337 19.6668429,16.3728486 19.6668429,14.806476 L19.6668429,0.616078423 C19.6668429,0.341907397 19.4563289,0.119841272 19.1969457,0.119841272 Z M2.77756241,16.6609142 C1.80933921,16.6609142 1.02179148,15.8289727 1.02179148,14.806476 L1.02179148,12.7488287 L14.2750073,12.7488287 L14.2750073,14.806476 C14.2750073,15.5141102 14.5207636,16.162444 14.9269897,16.6609142 L2.77756241,16.6609142 L2.77756241,16.6609142 Z M18.7270485,14.806476 C18.7270485,15.8289727 17.9392658,16.6609142 16.9708076,16.6609142 C16.0025844,16.6609142 15.2148018,15.8289727 15.2148018,14.806476 L15.2148018,12.2525915 C15.2148018,11.9786686 15.0042878,11.7563544 14.7449046,11.7563544 L5.45339207,11.7563544 L5.45339207,1.11231557 L18.7268135,1.11231557 L18.7268135,14.806476 L18.7270485,14.806476 Z\" id=\"Shape\"></path><path d=\"M7.94408223,4.40683402 L15.9922467,4.40683402 C16.25163,4.40683402 16.4621439,4.18451978 16.4621439,3.91059687 C16.4621439,3.63667396 16.25163,3.41435972 15.9922467,3.41435972 L7.94408223,3.41435972 C7.68469897,3.41435972 7.47418502,3.63667396 7.47418502,3.91059687 C7.47418502,4.18451978 7.68446402,4.40683402 7.94408223,4.40683402 Z\" id=\"Shape\"></path><path d=\"M7.94408223,6.82499766 L15.9922467,6.82499766 C16.25163,6.82499766 16.4621439,6.60268342 16.4621439,6.32876051 C16.4621439,6.0548376 16.25163,5.83252336 15.9922467,5.83252336 L7.94408223,5.83252336 C7.68469897,5.83252336 7.47418502,6.0548376 7.47418502,6.32876051 C7.47418502,6.60268342 7.68446402,6.82499766 7.94408223,6.82499766 Z\" id=\"Shape\"></path><path d=\"M7.94408223,9.24291318 L13.2682526,9.24291318 C13.5276358,9.24291318 13.7381498,9.02059894 13.7381498,8.74667603 C13.7381498,8.47275312 13.5276358,8.25043888 13.2682526,8.25043888 L7.94408223,8.25043888 C7.68469897,8.25043888 7.47418502,8.47275312 7.47418502,8.74667603 C7.47418502,9.02059894 7.68446402,9.24291318 7.94408223,9.24291318 Z\" id=\"Shape\"></path></g></g></g></svg></div><div class=\"pay-block\"><div class=\"pay-label\"><p>{{tr.payment_label}} Bs.:</p></div><div class=\"pay-item\"><p class=\"form-control disabled\" data-ng-show=\"tr.amount_excedent\">{{tr.amount_issued }}</p><input class=\"form-control\" type=\"number\" data-ng-hide=\"tr.amount_excedent\" min=\"0\" step=\"0.01\" data-ng-disabled=\"tr.currency != $root.globalParams.currency || $root.voucher.selected.balance<=0\" data-ng-change=\"$root.calculateBalance(tr)\" data-ng-model=\"tr.amount\"></div><div class=\"clearfix\"></div><div class=\"pay-label\" data-ng-if=\"tr.currency != $root.globalParams.currency\"><p data-ng-if=\"tr.currency != $root.globalParams.currency\">{{tr.currency}}:</p></div><div class=\"pay-item\" data-ng-if=\"tr.currency != $root.globalParams.currency\"><input class=\"form-control\" type=\"number\" min=\"0\" step=\"0.01\" data-ng-disabled=\"$root.voucher.selected.balance<=0\" data-ng-change=\"$root.calculateBalance(tr)\" data-ng-model=\"tr.amounthOther\"></div><div class=\"clearfix\"></div><div class=\"pay-label\" data-ng-if=\"tr.verification\"><p>Nro. cuenta:</p></div><div class=\"pay-item\" data-ng-if=\"tr.verification\"><select name=\"\" id=\"\" class=\"form-control\" required=\"\" data-ng-model=\"tr.accountbank_id\" data-ng-options=\"item.id as item.code for item in $root.bankaccounts\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select></div><div class=\"clearfix\"></div><div class=\"pay-label\" required=\"\" data-ng-if=\"tr.verification\"><p>Nro. orden:</p></div><div class=\"pay-item\" data-ng-if=\"tr.verification\"><input class=\"form-control\" type=\"text\" data-ng-model=\"tr.bankcode\"></div></div></div><textarea class=\"form-control\" style=\"float: left;min-height: 56px;\" placeholder=\"Notas\" data-ng-if=\"$root.voucher.selected.vouchertransaction.length > 0\" data-ng-model=\"$root.voucher.selected.vouchertransaction[0].comment\">\n            </textarea></div><div class=\"pay-resume\"><div class=\"pay-result\"><div class=\"result-label\"><p>Total a pagar:</p></div><div class=\"result-amount\"><p>{{ $root.voucher.selected.total | number : \'2\'}}</p></div></div><div class=\"pay-result\"><div class=\"result-label\"><p>Total cancelado:</p></div><div class=\"result-amount\"><p>{{ ($root.voucher.selected.totalAmount + $root.voucher.selected.positiveBalance) | number : \'2\'}}</p></div></div><div class=\"pay-result\"><div class=\"result-label\"><p>Deuda:</p></div><div class=\"result-amount\" data-ng-class=\"{\'danger\': $root.voucher.selected.balance > 0 , \'success\': $root.voucher.selected.balance == 0 }\"><p>{{ $root.voucher.selected.balance | number : \'2\'}}</p></div><button data-ng-click=\"$root.newPay(\'credit\',\'\',false, \'Crédito\')\" type=\"button\" data-ng-disabled=\"($root.voucher.selected[partnerTarget].partnercategory.topcredit - $root.voucher.selected[partnerTarget].credit_amount) < $root.voucher.selected.balance && $root.currentModule == \'sales\'\" data-ng-if=\"$root.voucher.selected.balance > 0 && $root.voucher.actionType == \'store\'\" class=\"btn btn-action info pull-right\"><i class=\"fa fa-plus\"></i> CRÉDITO</button></div><div class=\"pay-result\" data-ng-if=\"$root.creditIndex >= 0\"><div class=\"result-label\"><p>Nuevo crédito:</p></div><div class=\"result-amount info\"><p>{{ $root.voucher.selected.vouchertransaction[$root.creditIndex].amount | number : \'2\'}}</p></div><button data-ng-click=\"$root.undoCredit()\" type=\"button\" class=\"btn btn-action danger pull-right\"><i class=\"fa fa-times\"></i> Cancelar</button></div><div class=\"pay-result\"><div class=\"result-label\"><p>Cambio:</p></div><div class=\"result-amount\" data-ng-class=\"{\'info\': $root.voucher.selected.positiveBalance >0 }\"><p>{{ $root.voucher.selected.positiveBalance | number : \'2\'}}</p></div></div></div></div></div><div class=\"forms expanded\"><button type=\"submit\" data-ng-disabled=\"$root.blockPay || $root.voucher.selected.totalAmount<=0\" class=\"btn btn-action success pull-right\">Guardar</button> <button data-ng-click=\"resetPay()\" type=\"button\" class=\"btn btn-action info pull-right\">Revertir</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipayment/uipaymentold.html","<div class=\"crud-form-body level1\"><form class=\"crud-form wow slideInLeft\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3 data-ng-if=\"$root[modelName].actionType==\'store\'\"><i class=\"fa fa-plus\"></i> Registrar transaccion</h3><h3 data-ng-if=\"$root[modelName].actionType==\'update\'\"><i class=\"fas fa-edit\"></i> Editar transacción</h3><h3 data-ng-if=\"$root[modelName].actionType==\'delete\'\"><i class=\"fas fa-exclamation-triangle\" style=\"color: #d94a4a;\"></i> Anular transacción</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\"><p class=\"label\">Cliente:</p><p>{{$root.voucher.selected.partner.name}}</p></div><div class=\"detail\"><p class=\"label\">Categoría:</p><p>{{$root.voucher.selected.partner.partnercategory.name}}</p></div><div class=\"detail\"><p class=\"label\">NIT/CI:</p><p>{{$root.voucher.selected.partner.docid}}</p></div><div class=\"detail\"><p class=\"label\">Categoría:</p><p>{{$root.voucher.selected.partner.partnercategory.topcredit}}</p></div><div class=\"detail\"><p class=\"label\">Fecha / Hora:</p><p>{{$root.dateNow}} / {{$root.timeNow}}</p></div><div class=\"detail\"><p class=\"label\">Punto de venta:</p><p>Sucursal Miraflores</p></div></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><p class=\"detail-header\">Detalle</p><p><strong>Total a pagar:</strong>{{$root.voucher.selected.total}}</p></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><p class=\"detail-header\">Forma de pago</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th></th><th class=\"column-title\"><strong>Tipo</strong></th><th class=\"column-title\"><strong>A pagar</strong></th><th class=\"column-title\"><strong>Importe</strong></th><th class=\"column-title\"><strong>Saldo</strong></th></tr></thead><tbody data-ng-if=\"$root.voucher.selected.vouchertransaction.length>0\"><tr data-ng-repeat=\"pay in $root.voucher.selected.vouchertransaction track by $index\" class=\"test {{$root.currentModule}}\"><td><a data-ng-click=\"remove($index)\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td><select ng-model=\"pay.payment_type\" data-ng-change=\"$root.calculateBalance()\" data-ng-disabled=\"($index < $root.voucher.selected.vouchertransaction.length-1)\" class=\"form-control\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option><option value=\"1\">Efectivo</option><option value=\"2\">Tarjeta</option><option value=\"3\">Cheque</option></select></td><td><input disabled=\"\" data-ng-model=\"pay.debit\" type=\"text\" class=\"form-control\"></td><td><input type=\"number\" data-ng-model=\"pay.amount\" data-ng-disabled=\"($index < $root.voucher.selected.vouchertransaction.length-1)\" data-ng-change=\"$root.calculateBalance()\" class=\"form-control\"></td><td class=\"transaction-total\" data-ng-class=\"{\'danger\':pay.balance<0}\">{{pay.balance}}</td></tr><tr><td colspan=\"4\" style=\"text-align: right; padding: 0;\"><button data-ng-disabled=\"$root.voucher.selected.balance==0 || $root.voucher.selected.vouchertransaction[$root.voucher.selected.vouchertransaction.length-1].payment_type==\'\' || $root.voucher.selected.vouchertransaction[$root.voucher.selected.vouchertransaction.length-1].amount<=0\" style=\"float: left;\" type=\"button\" data-ng-click=\"$root.newPay()\" class=\"btn btn-primary\">Agregar</button> <strong style=\"color: #02579B;line-height: 3; margin-right: 5px;\">Total adeudado:</strong></td><td class=\"transaction-total\" data-ng-class=\"{\'danger\':$root.voucher.selected.balance>0}\"><strong>{{$root.voucher.selected.balance}} Bs.</strong></td></tr></tbody></table></div></div><div class=\"forms expanded\"><button type=\"submit\" data-ng-disabled=\"$root.blockPay\" class=\"btn btn-action success pull-right\">Guardar</button> <button data-ng-click=\"resetPay()\" type=\"button\" class=\"btn btn-action info pull-right\">Revertir</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/uipiker.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"saveSelection();\"><div class=\"form-header sub {{$root.currentModule}}\"><h3>Selección de productos</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\"><strong></strong></div><div class=\"forms expanded\"><div class=\"crud-grid-filters\"><div data-ng-if=\"modelName!=\'voucher\'\" class=\"filters-box\"><div class=\"form-group input-group\"><select class=\"form-control\" data-ng-model=\"pikerFilter.filters.productbrand_id.value\"><option value=\"\" disabled=\"\" selected=\"\">Marca</option><option value=\"{{l.id}}\" data-ng-repeat=\"l in productbrand\">{{l.name}}</option></select></div><div class=\"form-group input-group\"><select class=\"form-control\" data-ng-model=\"pikerFilter.filters.productcategory_id.value\"><option value=\"\" disabled=\"\" selected=\"\">Categoría</option><option value=\"{{l.id}}\" data-ng-repeat=\"l in productcategory\">{{l.name}}</option></select></div><div class=\"form-group input-group\"><select class=\"form-control\" data-ng-model=\"pikerFilter.filters.productfamily_id.value\"><option value=\"\" disabled=\"\" selected=\"\">Familia</option><option value=\"{{l.id}}\" data-ng-repeat=\"l in productfamily\">{{l.name}}</option></select></div><div class=\"form-group input-group\"><select class=\"form-control\" data-ng-model=\"pikerFilter.filters.productline_id.value\"><option value=\"\" disabled=\"\" selected=\"\">Línea</option><option value=\"{{l.id}}\" data-ng-repeat=\"l in productLine\">{{l.name}}</option></select></div><div class=\"form-group input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"codigo 1\" data-ng-model=\"pikerFilter.filters.code.value\"></div><div class=\"form-group input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"codigo 2\" data-ng-model=\"pikerFilter.filters.code_secondary.value\"></div><div class=\"form-group input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"producto\" data-ng-model=\"pikerFilter.filters.description.value\"></div><a style=\"float: left;\" data-ng-click=\"loadItem()\" class=\"btn-action\">Buscar</a></div><div data-ng-if=\"modelName==\'voucher\'\" class=\"filters-box\"><div class=\"form-group input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Codigo, descripción\" data-ng-model=\"pikerFilter.filters.code.value\"></div><a style=\"float: left;\" data-ng-click=\"loadItem(pikerFilter.filters.code.value)\" class=\"btn-action\">Buscar</a></div></div></div><ng-include data-ng-if=\"productItem\" src=\"\'app/scripts/directives/uibuilder/components/uipiker/templates/default2.html\'\"></ng-include><div class=\"forms expanded\"><button type=\"submit\" class=\"btn btn-action success pull-right\">Save</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancel</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiproductpiker/uiproductpiker.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body></body></html>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiselector/uiselector.html","<div class=\"crud-form-body\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form wow slideInLeft\" data-ng-submit=\"updateRegister()\" name=\"myForm\" ui-heigth=\"\"><div class=\"form-header sub {{$root.currentModule}}\" data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\"><h3 data-ng-if=\"$root[modelName].actionType==\'store\'\"><i class=\"fa fa-plus\"></i> Nuevo {{ modelName }}</h3><h3 data-ng-if=\"$root[modelName].actionType==\'update\'\"><i class=\"fas fa-edit\"></i> Editar {{ $root[modelName].selected[referenceField]?modelName:$root[modelName].selected[referenceField] }}</h3><h3 data-ng-if=\"$root[modelName].actionType==\'delete\'\"><i class=\"fas fa-exclamation-triangle\" style=\"color: #d94a4a;\"></i> Eliminar {{ $root[modelName].selected[referenceField]?modelName:$root[modelName].selected[referenceField] }}</h3><a class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\" href=\"\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\"><h3>Selector</h3><h3>Resultados obtenidos</h3></div><div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"column-title\" data-ng-class=\"{active: propertyName == key}\" data-ng-click=\"sortBy(key)\" data-ng-if=\"!properties.hideGrid\" data-ng-repeat=\"(key, properties) in $root[modelName].properties\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i aria-hidden=\"true\" class=\"fa fa-sort\" data-ng-show=\"propertyName != key\"></i> <i aria-hidden=\"true\" class=\"fa fa-sort-down\" data-ng-show=\"propertyName == key && dir==\'desc\'\"></i> <i aria-hidden=\"true\" class=\"fa fa-sort-up\" data-ng-show=\"propertyName == key && dir==\'asc\'\"></i></div></div></th></tr></thead><tbody><tr class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\" ng-repeat=\"register in $root[modelName].dataset.data\"><td data-ng-click=\"$root.chooseRegister(modelName, register,\'read\')\" data-ng-if=\"!dato.hideGrid\" data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" style=\"cursor: pointer\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-bind-html=\"register[key]\" data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\' && dato.type!=\'json\'\"></p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat(register[key]) }}</p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><div data-ng-if=\"dato.type==\'json\'\"><p>{{register[key].es}}</p></div><a data-ng-if=\"dato.type==\'file\'\" href=\"{{$root.api+register[key]}}\" target=\"_blank\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" data-ng-src=\"{{$root.api+register[key]}}\" style=\"width: 100px;\"></a></div></td></tr><tr data-ng-if=\"dataset.result.data.length==0\" style=\"text-align: center\"><td colspan=\"{{dataset.properties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr></tbody></table></div></div><div class=\"forms buttons\"><button class=\"btn btn-action success pull-right\" type=\"submit\">Guardar</button> <button class=\"btn btn-action info pull-right\" data-ng-click=\"$root[modelName].resetRegister()\" type=\"button\">Revertir</button> <button class=\"btn btn-action danger pull-left\" data-ng-click=\"$root[modelName].resetRegister(true);\" type=\"button\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uireadvoucher/uireadvoucher.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3 data-ng-if=\"$root[modelName].actionType==\'store\'\"><i class=\"fa fa-plus\"></i> Comprobante</h3><h3 data-ng-if=\"$root[modelName].actionType==\'update\'\"><i class=\"fas fa-edit\"></i> Editar entrega de productos</h3><h3 data-ng-if=\"$root[modelName].actionType==\'delete\'\"><i class=\"fas fa-exclamation-triangle\" style=\"color: #d94a4a;\"></i> Anular entrega de productos</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"closeAndBack()\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"pay-header\"><h5>Detalle {{$root.memVoucher.code}}</h5></div></div></div><div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\"><strong>Precio</strong></th><th class=\"column-title\"><strong>Descuento</strong></th><th class=\"column-title\"><strong>Total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-repeat=\"register in $root.memVoucher.voucherline\"><tr class=\"test {{$root.currentModule}}\"><td></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{(register.product.stock.length==1)?register.product.stock[0].batchcode:\'\'}}</td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.discount}} %</td><td>{{register.sub}}</td></tr><tr data-ng-if=\"register.product.stock.length>1\" style=\"background: #F8F8F8;\" data-ng-repeat=\"st in register.stockadjustment\"><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{st.batchcode}}</td><td>{{st.batchcode}}</td><td>{{st.quantity}}</td><td colspan=\"3\"></td></tr></tbody><tbody><tr><td rowspan=\"3\" colspan=\"7\"><strong>Comentarios:</strong>{{$root.memVoucher.comments}}</td><td><strong>transporte:</strong></td><td><strong>{{ $root.memVoucher.transport_amount}}</strong></td></tr><tr><td><strong>Otros:</strong></td><td><strong>{{ $root.memVoucher.other_amount}}</strong></td></tr><tr><td><strong>Total:</strong></td><td><strong>{{ $root.memVoucher.total}}</strong></td></tr></tbody></table></div></div><div class=\"forms expanded\" data-ng-if=\"$root.memVoucher.vouchertype_id==10\"><div class=\"pay-box\"><div class=\"pay-header\"><h5>Estado de entregas</h5></div></div></div><div class=\"forms expanded\" data-ng-init=\"comboQuantity = $root.memVoucher.voucherline[0].quantity; cg.newTotal = 0\" data-ng-repeat=\"cg in $root.memVoucher.voucherline[0].stockissued.groups\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr style=\"background: #f0f0f0;\" data-ng-class=\"{\'danger\': 0, \'success\': (comboQuantity * cg.min) == cg.currentTotal }\"><th></th><th colspan=\"2\"><strong>Grupo</strong><br>{{cg.group}} <small>{{\'(Cant min. x grupo: \'+cg.min+\')\'}}</small></th><th><strong>Por entregar</strong><br>{{comboQuantity * cg.min}}</th><th><strong>Entr. Anterior</strong><br>{{cg.totalIssued}}</th><th><strong>Entr. actual</strong><br>{{cg.newTotal}}</th><th><strong>Saldo</strong><br>{{ cg.totalBalance - cg.newTotal}}</th></tr><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"></th><th class=\"column-title\"></th><th class=\"column-title\"><strong>Entr. total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-repeat=\"register in cg.product\"><tr data-ng-click=\"$root.setPicked(register.product_id)\" class=\"test {{$root.currentModule}}\"><td data-ng-init=\"$root.calculateIssuedTotal(register)\"></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-class=\"{\'danger\': checkGoodStock(register.product)<=0 }\"><p>{{register.product.description}}</p></td><td></td><td></td><td>{{register.stockissued}}</td></tr></tbody></table></div></div><div class=\"forms expanded\"><button type=\"button\" style=\"margin-right: 5px\" data-ng-if=\"$root.currentState != \'sales-mobile-requests\'\" data-ng-click=\"$root.copyVoucherLines($root.memVoucher);closeAndBack()\" class=\"btn btn-action success pull-right\">copiar</button> <button type=\"button\" data-ng-if=\"$root.currentState == \'sales-mobile-requests\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.copyVoucherLines($root.memVoucher);$root.setVoucherRelated($root.memVoucher);closeAndBack()\" class=\"btn btn-action success pull-right\">cargar</button> <a style=\"margin-right: 5px\" target=\"_blank\" href=\"/es/print/{{$root.memVoucher.id}}\" class=\"btn btn-action success pull-right\">imprimir</a> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"closeAndBack()\">Cancel</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiselleragenda/uiselleragenda.html","<div class=\"crud-grid-body wow fadeInUp\"><div class=\"row\" data-ng-if=\"!$root.dayView\"><div class=\"col-xs-12\"><a class=\"btn btn-action\" data-ng-click=\"$root.getDaySchedule($root.today)\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Hoy\', \'Today\')}}</a></div></div><div class=\"calendar-month-box\" data-ng-if=\"!$root.dayView\"><div class=\"calendar-prev\" data-ng-click=\"$root.switchCalendarView(\'month\',\'prev\')\">&#10094;</div><div class=\"calendar-next\" data-ng-click=\"$root.switchCalendarView(\'month\',\'next\')\">&#10095;</div><div class=\"month\"><ul><li><h5 style=\"text-transform: uppercase\" data-ng-repeat=\"y in $root.months\" data-ng-if=\"y.id == $root.month\">{{y.label}}</h5><span>{{$root.year}}</span></li></ul></div><ul class=\"weekdays\"><li>Su</li><li>Mo</li><li>Tu</li><li>We</li><li>Th</li><li>Fr</li><li>Sa</li></ul><ul class=\"days\"><li data-ng-repeat=\"item in $root.calendar.items\" data-ng-class=\"{\'today\': item.today}\"><span class=\"day\" data-ng-click=\"$root.getDaySchedule(item)\" style=\"padding: 2px; right: 0; top: 0; left: 0; bottom: 0; position: absolute;\" data-ng-class=\"{\'off\': item.extra}\">{{item.day}}</span><a class=\"dot-info\" data-ng-class=\"{\'active\':$root.checkInfo(item)}\"></a></li></ul></div><div class=\"row\" data-ng-if=\"$root.dayView == true\"><div class=\"schedule-box\"><a href=\"\" class=\"btn btn-theme back\" data-ng-click=\"$root.dayView = false; $root.editDayView=false;\"><i class=\"fas fa-arrow-left\"></i> Volver</a> <a href=\"\" data-ng-show=\"!$root.editDayView\" data-ng-click=\"$root.editDayView=!$root.editDayView\" class=\"btn btn-theme add\">Editar</a> <a href=\"\" data-ng-show=\"$root.editDayView\" data-ng-click=\"$root.editDayView=false;\" class=\"btn btn-theme add\">Aceptar</a><div class=\"partner-list\"><ul><li data-ng-init=\"$root.checkClient(i)\" data-ng-show=\"$root.editDayView || !$root.editDayView && i.picked\" data-ng-repeat=\"i in $root.sellerClients\"><span class=\"list-check\" data-ng-show=\"$root.editDayView\"><i data-ng-if=\"!i.picked\" data-ng-click=\"$root.addSchedule(i)\" class=\"far fa-circle\"></i> <i data-ng-if=\"i.picked\" data-ng-click=\"$root.removeSchedule(i)\" class=\"fas fa-circle\"></i></span> <span class=\"list-name\" data-ng-click=\"$root.selectPartner(i)\">{{i.name}}</span> <a href=\"\" data-ng-show=\"!$root.editDayView\" data-ng-click=\"$root.markSchedule(i)\" data-ng-class=\"{\'check\':i.status==1}\" class=\"list-option\"><i class=\"fas fa-check\"></i></a> <a href=\"\" data-ng-show=\"!$root.editDayView\" data-ng-click=\"$root.setPartnertask(i,\'sales-debts\')\" class=\"list-option\"><i class=\"fas fa-dollar-sign\"></i></a> <a href=\"\" data-ng-show=\"!$root.editDayView\" data-ng-click=\"$root.setPartnertask(i,\'sales-mobile-point\')\" class=\"list-option\"><i class=\"fas fa-shopping-cart\"></i></a> <a href=\"\" data-ng-show=\"!$root.editDayView\" data-ng-init=\"i.isOpen = false\" data-ng-click=\"i.isOpen = !i.isOpen\" class=\"list-option\"><i class=\"far fa-comment-alt\"></i></a> <textarea data-ng-if=\"i.isOpen\" style=\"\" data-ng-model=\"i.selleragenda.comments\" class=\"list-comment form-control\">\n            </textarea> <a href=\"\" data-ng-if=\"i.isOpen\" data-ng-click=\"$root.commentSchedule(i)\" class=\"btn btn-theme save {{$root.currentModule}}\">Guardar <i class=\"fas fa-check\"></i></a></li></ul></div></div></div></div>");
$templateCache.put("app/views/directives/crudform/form/formwidget/innercrud.html","<div><div data-ng-if=\"context == \'form\'\" class=\"flex\" style=\"align-items: flex-start; justify-content: flex-start\"><button class=\"btn btn-action disabled\" data-ng-if=\"actionType==\'new\'\" type=\"button\" data-ng-click=\"trigguerMessage(\'info\',\'Almacene el registro primero\',\'\')\"><i class=\"fa fa-plus\"></i> {{switchText(\'Nuevo\', \'New\')}}</button> <button class=\"btn btn-action\" data-ng-if=\"actionType!=\'new\'\" type=\"button\" data-ng-disabled=\"dato.disabled\" data-ng-click=\"setInnerCrud(\'insert\', selected.id, dato.default, dato);showCrudInnercrud(true);\"><i class=\"fa fa-plus\"></i> {{switchText(\'Nuevo.\', \'New\')}}</button><div class=\"pull-left\" style=\"width: 300px;\"><small style=\"background: #eee; padding: 5px; margin-left: 5px;margin-bottom: 5px; display: block; float: left; height: 25px;\" data-ng-repeat=\"st in selected[dato.name]\">{{st[dato.titleField]}} <i class=\"fas fa-pencil-alt\" style=\"margin-left: 5px\" data-ng-if=\"!dato.disabled\" data-ng-click=\"setInnerCrud(\'update\', selected.id, st, dato);showCrudInnercrud(true);\"></i> <i class=\"fas fa-times\" style=\"margin-left: 5px\" data-ng-if=\"!dato.disabled\" data-ng-click=\"setInnerCrud(\'delete\', selected.id, st, dato);showCrudInnercrud(true);\"></i></small></div></div><div data-ng-if=\"context == \'default\'\"><p data-ng-repeat=\"st in selected[dato.name] track by $index\">{{st[dato.titleField]}}</p></div><div data-ng-if=\"context == \'custom\'\" render-html=\"widget.customTemplate\"></div></div>");
$templateCache.put("app/views/directives/crudform/form/formwidget/select.html","<div><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-init=\"(dato.default)?selected[dato.name]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange(dataset,selected)\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"context==\'form\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><div data-ng-if=\"context==\'detail\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == selected[dato.name]\">{{itemselect[dato.itemsLabel]}}</p></div></div>");
$templateCache.put("app/views/directives/crudform/form/formwidget/text.html","<div><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"context==\'form\'\" name=\"{{dato.name}}\" data-ng-init=\"(dato.default)?selected[dato.name]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, selected[dato.name] ,dato.name)\" data-ng-disabled=\"dato.disabled\"><p data-ng-if=\"context==\'detail\'\" data-ng-bind=\"selected[dato.name]\"></p></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/cashregister-log.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>{{$root[modelName].selected[$root[modelName].referenceField]}}</h5><ul class=\"info-menu-tabs\"><li><a href=\"\" class=\"{{$root.currentModule}}\" data-ng-class=\"{\'active\':$root.tab==1}\" data-ng-click=\"$root.tab=1;\">Estado</a> <a href=\"\" class=\"{{$root.currentModule}}\" data-ng-class=\"{\'active\':$root.tab==2}\" data-ng-click=\"$root.tab=2;\">Efectivo</a> <a href=\"\" class=\"{{$root.currentModule}}\" data-ng-class=\"{\'active\':$root.tab==3}\" data-ng-click=\"$root.tab=3;\">Tarjeta</a> <a href=\"\" class=\"{{$root.currentModule}}\" data-ng-class=\"{\'active\':$root.tab==4}\" data-ng-click=\"$root.tab=4;\">Transfer</a> <a href=\"\" class=\"{{$root.currentModule}}\" data-ng-class=\"{\'active\':$root.tab==5}\" data-ng-click=\"$root.tab=5;\">Créditos</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-if=\"!$root[modelName].selected || ( $root[modelName].selected && $root[modelName].actionType==\'store\' )\" minus=\"100\" ui-heigth=\"\"><div class=\"col-xs-12\"><p>Seleccione un elemento</p></div></div><div class=\"info-menu-body\" data-ng-show=\"$root[modelName].selected && $root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide || dato.hideRead\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"$root[modelName].selected[key]===\'\'\">Sin datos.</p><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'text\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'mapLat\' || dato.type==\'mapLon\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat($root[modelName].selected[key]) }}</p><p data-ng-if=\"dato.type==\'json\'\" data-ng-bind-html=\"$root[modelName].selected[key].es\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div><ng-map center=\"{{$root[modelName].selected.latitud}},{{$root[modelName].selected.longitud}}\" style=\"margin-bottom: 20px;margin-top: 20px\" data-ng-if=\"dato.type==\'mapLon\'\"><marker position=\"{{$root[modelName].selected.latitud}},{{$root[modelName].selected.longitud}}\" draggable=\"true\" on-dragend=\"$root.pos()\"></marker></ng-map></div><ng-include data-ng-if=\"modelName==\'purchase\'\" src=\"\'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/purchase.html\'\"></ng-include><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.clientdiscount\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"$root.setSelector (\'clientdiscount\', $root[modelName].selected, \'update\', modelName)\">{{$root.switchText(\'Selector\', \'Selector\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.productkardex\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"$root.showkardex()\">{{$root.switchText(\'Kardex valorado\', \'Kardex valorado\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.update\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\');\">{{$root.switchText(\'Editar\', \'Edit\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.delete\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'delete\');\">{{$root.switchText(\'Eliminar\', \'Delete\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Monto</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root[modelName].selected.vouchertransaction\" data-ng-show=\"vt.payment_type == \'cash\'\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.amount}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{$root.transalatePayment(vt.payment_type)}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" href=\"/es/printcashregisterlog/{{($root[modelName].selected.currentCL)?$root[modelName].selected.currentCL:$root[modelName].selected.id}}/cash\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir reporte</a></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Monto</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root[modelName].selected.vouchertransaction\" data-ng-show=\"vt.payment_type == \'card\'\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.amount}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{$root.transalatePayment(vt.payment_type)}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" href=\"/es/printcashregisterlog/{{($root[modelName].selected.currentCL)?$root[modelName].selected.currentCL:$root[modelName].selected.id}}/card\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir reporte</a></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==4\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Monto</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root[modelName].selected.vouchertransaction\" data-ng-show=\"vt.payment_type == \'other\'\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.amount}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{$root.transalatePayment(vt.payment_type)}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" href=\"/es/printcashregisterlog/{{($root[modelName].selected.currentCL)?$root[modelName].selected.currentCL:$root[modelName].selected.id}}/other\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir reporte</a></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==5\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Monto</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root[modelName].selected.vouchertransaction\" data-ng-show=\"vt.payment_type == \'credit\'\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.amount}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{$root.transalatePayment(vt.payment_type)}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" href=\"/es/printcashregisterlog/{{($root[modelName].selected.currentCL)?$root[modelName].selected.currentCL:$root[modelName].selected.id}}/credit\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir reporte</a></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/default.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>{{$root[modelName].selected[$root[modelName].referenceField]}}</h5><ul class=\"info-menu-tabs\"><li><a href=\"\" class=\"{{$root.currentModule}} active\">Detalles</a> <a href=\"\" class=\"{{$root.currentModule}}\"></a> <a href=\"\" class=\"{{$root.currentModule}}\"></a></li></ul></div></div><div class=\"info-menu-body\" data-ng-if=\"!$root[modelName].selected || ( $root[modelName].selected && $root[modelName].actionType==\'store\' )\" minus=\"100\" ui-heigth=\"\"><div class=\"col-xs-12\"><p>Seleccione un elemento</p></div></div><div class=\"info-menu-body\" data-ng-if=\"$root[modelName].selected\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide || dato.hideRead\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"$root[modelName].selected[key]===\'\'\">Sin datos.</p><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'text\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'mapLat\' || dato.type==\'mapLon\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat($root[modelName].selected[key]) }}</p><p data-ng-if=\"dato.type==\'json\'\" data-ng-bind-html=\"$root[modelName].selected[key].es\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div><ng-map center=\"{{$root[modelName].selected.latitud}},{{$root[modelName].selected.longitud}}\" style=\"margin-bottom: 20px;margin-top: 20px\" data-ng-if=\"dato.type==\'mapLon\'\"><marker position=\"{{$root[modelName].selected.latitud}},{{$root[modelName].selected.longitud}}\" draggable=\"true\" on-dragend=\"$root.pos()\"></marker></ng-map></div><ng-include data-ng-if=\"modelName==\'purchase\'\" src=\"\'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/purchase.html\'\"></ng-include><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.clientdiscount\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"$root.setSelector (\'clientdiscount\', $root[modelName].selected, \'update\', modelName)\">{{$root.switchText(\'Selector\', \'Selector\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.productkardex\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"$root.showkardex()\">{{$root.switchText(\'Kardex valorado\', \'Kardex valorado\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.update\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\');\">{{$root.switchText(\'Editar\', \'Edit\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.delete\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'delete\');\">{{$root.switchText(\'Eliminar\', \'Delete\')}}</button></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/salepoint.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root[modelName].selected[$root[modelName].referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a style=\"width: 50%;\" href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Por conciliar</a> <a style=\"width: 50%;\" href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">Conciliado</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root[modelName].selected[key]!=\'\'\" data-ng-bind-html=\"$root[modelName].selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Fecha</strong></th><th class=\"\"><strong>Caja</strong></th><th class=\"\"><strong>Esperado Bs.</strong></th><th class=\"\"><strong>Conciliado Bs.</strong></th></tr></thead><tbody ng-repeat=\"register in $root[modelName].selected.salepointverification\"><tr class=\"{{$root.currentModule}}\"><td>Caja 1</td><td>{{register.created_at}}</td><td>{{register.cash_initial_amount}}</td><td>{{register.cash_ending_amount}}</td></tr><tr><td colspan=\"4\">{{register.comment}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/salepointverification.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root[modelName].selected[$root[modelName].referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root[modelName].properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Stock</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root[modelName].selected[key]!=\'\'\" data-ng-bind-html=\"$root[modelName].selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\"><strong>Costo</strong></th><th class=\"\"><strong>Sub</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.value * register.quantity}}</td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Total: {{ $root[modelName].selected.total}}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\" data-ng-if=\"$root.currentState == \'debts\'\"><a href=\"\" class=\"btn-action\" data-ng-click=\"$root.setDebt(); $root.openPayment();\">Cancelar</a></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root[modelName].selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root[modelName].selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root[modelName].selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root[modelName].selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root[modelName].properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root[modelName].properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\" data-ng-if=\"(p.product.id == $root.voucher.picked) || !$root.voucher.picked\" data-ng-repeat=\"p in $root[modelName].selected.voucherline\"><div class=\"col-xs-12\" style=\"padding: 0 5px\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Stock</strong></th><th class=\"\"><strong>Disp.</strong></th><th class=\"\"><strong>Reserv.</strong></th><th class=\"\"><strong>Fecha Ent.</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.current_stock}}</td><td>{{st.current_stock}}</td><td>{{st.reserved_stock}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/selleragenda.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle</h5><ul class=\"info-menu-tabs\"></ul></div></div><div class=\"info-menu-body\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.selleragenda.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.selleragenda.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.selleragenda.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.selleragenda.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.selleragenda.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.selleragenda.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-creation.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root.voucher.properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Stock</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" minus=\"100\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.voucher.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.voucher.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.voucher.selected[key]!=\'\'\" data-ng-bind-html=\"$root.voucher.selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.voucher.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.voucher.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.voucher.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.voucher.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Costo</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Desc</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Sub</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.value | number : 2}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.discount}} %</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.sub | number : 2}}</td></tr><tr><td colspan=\"5\" data-ng-if=\"$root.currentModule != \'inventory\'\" style=\"text-align: right\"><strong>Total: {{$root.voucher.selected.total | number : 2}}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" data-ng-if=\"$root.voucher.actionType != \'store\'\" href=\"/es/print/{{$root.voucher.selected.id}}\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir</a></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" minus=\"100\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.voucher.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.voucher.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-repeat=\"item in $root.vouchercat\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); loadVouchers(item)\">{{item.name}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"{{$root.voucher.selected.partner.latitud}},{{$root.voucher.selected.partner.longitud}}\"><marker position=\"{{$root.voucher.selected.partner.latitud}},{{$root.voucher.selected.partner.longitud}}\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\" data-ng-if=\"$root.voucher.selected.vouchertype_id == 10\" data-ng-repeat=\"p in $root.voucher.selected.voucherlineTemp\"><div class=\"col-xs-12\" style=\"padding: 0 5px\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Ubicación</strong></th><th class=\"\"><strong>Stock</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.shelf}}</td><td>{{st.current_stock}}</td></tr></tbody></table></div></div><div class=\"row\" style=\"padding: 0 10px\" data-ng-if=\"$root.voucher.selected.vouchertype_id!= 10\" data-ng-repeat=\"p in $root.voucher.selected.voucherline\"><div class=\"col-xs-12\" style=\"padding: 0 5px\" data-ng-if=\"(p.product.id == $root.voucher.picked || !$root.voucher.picked)\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"(p.product.id == $root.voucher.picked || !$root.voucher.picked)\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Ubicación</strong></th><th class=\"\"><strong>Stock</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.shelf}}</td><td>{{st.current_stock}}</td></tr></tbody></table></div></div></div></div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 2\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"switchClevel(\'prev\');\"><i class=\"fas fa-chevron-left\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Historial</h5><ul class=\"info-menu-tabs\"><li><a data-ng-click=\"$root.tabl2 = 1\" data-ng-class=\"{\'active\':$root.tabl2==1}\" style=\"width: 50%; text-transform: capitalize;\" class=\"{{$root.currentModule}}\">{{voucherLabel}}</a> <a data-ng-click=\"$root.tabl2 = 2\" data-ng-class=\"{\'active\':$root.tabl2==2}\" style=\"width: 50%; text-transform: capitalize;\" class=\"{{$root.currentModule}}\">Productos</a></li></ul></div></div><div ui-heigth=\"\" class=\"info-menu-body\" data-ng-if=\"$root.tabl2 == 1\"><div class=\"form-group input-group\"><input type=\"text\" placeholder=\"Buscar código\" data-ng-model=\"voucherSearch\" class=\"form-control\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"loadVouchers(null,voucherSearch)\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div><div style=\"margin-bottom: 60px\" class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\" style=\"width: 90px;\"><strong>Fecha</strong></th><th class=\"\"><strong>Comprobante</strong></th><th class=\"\"><strong>Total</strong></th></tr></thead><tbody><tr data-ng-if=\"$root.voucherList.data.length==0\"><td colspan=\"3\">No se encontrarón resultados</td></tr><tr ng-repeat=\"v in $root.voucherList.data\" data-ng-click=\"$root.readTempVoucher(v)\" class=\"{{$root.currentModule}}\"><td>{{v.created_at}}</td><td>{{v.code}}<p class=\"text-success\" style=\"background: rgba(118,245,133,0.31);\">{{(v.delivery_pending==0 && v.delivery_excedent==0)?\'(Entr. completada)\':\'\'}}</p><p class=\"text-info\" style=\"background: rgba(0,90,245,0.11);\">{{(v.delivery_pending==1)?\'(Entr. pendientes)\':\'\'}}</p><p class=\"text-info\" style=\"background: rgba(0,90,245,0.11);\">{{(v.delivery_excedent==1)?\'(Entr. excedentes)\':\'\'}}</p><p class=\"text-danger\">{{(v.status==2)?\'(Anulada)\':\'\'}}</p></td><td>{{v.total | number : 2}}</td></tr></tbody></table><p><strong>{{\'Total comprobantes: \'+ $root.voucherList.total}}</strong></p><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"\">Mostrar más</button></div></div><div ui-heigth=\"\" class=\"info-menu-body\" data-ng-if=\"$root.tabl2 == 2\"><div style=\"margin-bottom: 60px\" class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th></tr></thead><tbody><tr data-ng-repeat=\"i in $root.productIndex\"><td>{{i.description}}</td><td>{{i.total}}</td></tr></tbody></table><p><strong>{{\'Total comprobantes: \'+ $root.voucherList.total}}</strong></p></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-readall.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"$root.tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root.voucher.properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-if=\"$root.currentModule!=\'inventory\'\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Pagos</a> <a href=\"\" data-ng-click=\"$root.tab=4;\" data-ng-class=\"{\'active\':$root.tab==4}\" class=\"{{$root.currentModule}}\">Entregas</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" minus=\"100\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.voucher.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.voucher.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.voucher.selected[key]!=\'\'\" data-ng-bind-html=\"$root.voucher.selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.voucher.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.voucher.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.voucher.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.voucher.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Costo</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Desc</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Sub</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.value | number : 2}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.discount}} %</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.sub | number : 2}}</td></tr><tr><td colspan=\"5\" data-ng-if=\"$root.currentModule != \'inventory\'\" style=\"text-align: right\"><strong>Total: {{$root.voucher.selected.total | number : 2}}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" data-ng-if=\"$root.voucher.actionType != \'store\' && $root.currentModule!=\'inventory\'\" href=\"/es/print/{{$root.voucher.selected.id}}\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir</a> <a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" class=\"info-btn-option danger\" data-ng-hide=\"$root.compareDates() || $root[modelName].selected.status == 2 || ($root[modelName].selected.vouchertype_id == 3 && $root.currentModule==\'inventory\')\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'delete\');\">{{$root.switchText(\'Anular\', \'Delete\')}}</a></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" minus=\"100\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.voucher.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.voucher.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"{{$root.voucher.selected.partner.latitud}},{{$root.voucher.selected.partner.longitud}}\"><marker position=\"{{$root.voucher.selected.partner.latitud}},{{$root.voucher.selected.partner.longitud}}\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3 && $root.currentModule!=\'inventory\'\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Monto</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root.voucher.selected.vouchertransaction\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.amount}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{$root.transalatePayment(vt.payment_type)}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div><div class=\"row\" data-ng-if=\"$root.voucher.selected.status!=2\"><div class=\"col-xs-12\" data-ng-if=\"$root.voucher.selected.vouchertype_id!=2 && $root.voucher.selected.vouchertype_id!=8\"><button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.access([\'super-admin\',\'vendedor-punto-de-venta\',\'gestor-de-compras\'])\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"$root.setDebt(); $root.openPayment();\"><svg class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-efectivo\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-05\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M18.5895126,7.98669683 L18.5895126,6.83822798 C18.5895126,5.66070525 17.7934915,4.67647488 16.7398607,4.45268794 L16.7398607,2.74307091 C16.7398607,2.47798423 16.5361376,2.26284141 16.2851215,2.26284141 L15.0525508,2.26284141 C14.9290891,1.04305848 13.949126,0.089562802 12.7618019,0.089562802 L2.45445502,0.089562802 C1.1839136,0.089562802 0.150063948,1.18112446 0.150063948,2.52288568 L0.150063948,13.4541097 C0.150063948,14.7958709 1.18368623,15.8874326 2.45445502,15.8874326 L16.2851215,15.8874326 C17.5556629,15.8874326 18.5895126,14.7958709 18.5895126,13.4541097 L18.5895126,12.395924 C19.3075458,11.9831667 19.7959358,11.1795027 19.7959358,10.2572219 L19.7959358,10.1258791 C19.7959358,9.20359839 19.3075458,8.39921398 18.5895126,7.98669683 Z M15.8303823,4.40466499 L3.57629672,4.40466499 C3.26798352,4.40466499 3.01696746,4.1395783 3.01696746,3.81422281 C3.01696746,3.4883871 3.26798352,3.22354053 3.57629672,3.22354053 L14.6112264,3.22354053 L15.8301549,3.22354053 L15.8301549,4.40466499 L15.8303823,4.40466499 Z M17.6800341,13.4541097 C17.6800341,14.2661778 17.0543129,14.9269736 16.2851215,14.9269736 L2.45445502,14.9269736 C1.68526361,14.9269736 1.05954242,14.2661778 1.05954242,13.4541097 L1.05954242,2.52288568 C1.05954242,1.7108176 1.68526361,1.0500218 2.45445502,1.0500218 L12.7618019,1.0500218 C13.4468666,1.0500218 14.0182464,1.57443242 14.134887,2.26284141 L3.57629672,2.26284141 C2.76640614,2.26284141 2.10748899,2.95869396 2.10748899,3.8139827 C2.10748899,4.66927144 2.76640614,5.36488387 3.57629672,5.36488387 L16.2851215,5.36488387 C17.0543129,5.36488387 17.6800341,6.02567967 17.6800341,6.83798787 L17.6800341,7.70240097 C17.6177348,7.69711845 17.5552082,7.69231615 17.4917721,7.69231615 L13.7087964,7.69231615 C12.4382549,7.69231615 11.4046327,8.78411792 11.4046327,10.1258791 L11.4046327,10.2572219 C11.4046327,11.598743 12.4382549,12.6903047 13.7087964,12.6903047 L17.4915447,12.6903047 C17.5549808,12.6903047 17.6175075,12.6855024 17.6798067,12.6802199 L17.6798067,13.4541097 L17.6800341,13.4541097 Z M18.8864573,10.2572219 C18.8864573,11.06929 18.2607361,11.7298457 17.4917721,11.7298457 L13.7087964,11.7298457 C12.9398323,11.7298457 12.3141111,11.06929 12.3141111,10.2572219 L12.3141111,10.1258791 C12.3141111,9.31357095 12.9396049,8.65277515 13.7087964,8.65277515 L17.4915447,8.65277515 C18.2605087,8.65277515 18.8862299,9.31357095 18.8862299,10.1258791 L18.8862299,10.2572219 L18.8864573,10.2572219 Z\" id=\"Shape\"></path><ellipse id=\"Oval\" cx=\"13.7708683\" cy=\"10.1911904\" rx=\"0.710075316\" ry=\"0.749878366\"></ellipse></g></g></g></svg>Registrar pago</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==4\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Codigo</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root.voucher.selected.stockorderhist\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printstockorder/{{vt.id}}\">{{vt.id}}</a></td><td><a target=\"_blank\" href=\"/es/printstockorder/{{vt.id}}\">{{(vt.type==true)?\'Entrega\':\'Devolución\'}}</a></td><td><a target=\"_blank\" href=\"/es/printstockorder/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div><div class=\"row\" data-ng-if=\"$root.voucher.selected.status!=2\"><div class=\"col-xs-12\" data-ng-if=\"$root.voucher.selected.vouchertype_id==10\"><button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.access([\'super-admin\',\'vendedor-punto-de-venta\',\'gestor-global-de-inventario\',\'gestor-local-de-inventario\'])\" data-ng-click=\"$root.openComboview()\" class=\"info-btn-option {{$root.currentModule}}\"><svg class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-deposito\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-27\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M19.2563877,5.59601502 L14.3193073,0.381418141 C14.1800395,0.234343717 13.9715024,0.190452396 13.7894577,0.270021457 C13.6078991,0.349590517 13.4895336,0.536706147 13.4895336,0.744355727 L13.4895336,3.19020598 L9.72225429,3.19020598 C9.45392678,3.19020598 9.23615373,3.42018623 9.23615373,3.70355475 C9.23615373,3.98692328 9.45392678,4.21690353 9.72225429,4.21690353 L13.9756342,4.21690353 C14.2439617,4.21690353 14.4617348,3.98692328 14.4617348,3.70355475 L14.4617348,1.98383635 L18.2251253,5.95869593 L14.4617348,9.93329884 L14.4617348,8.21332376 C14.4617348,7.92995524 14.2439617,7.69997498 13.9756342,7.69997498 L5.95157223,7.69997498 C5.95497494,7.45356757 5.95497494,7.13837142 5.95497494,6.73333924 L5.95497494,5.25361139 C5.95497494,5.04596181 5.83660945,4.85884618 5.65505089,4.77927712 C5.47276318,4.69945138 5.26446909,4.7433427 5.12520128,4.8906738 L0.188120918,10.1045007 C-0.00170135197,10.3049634 -0.00170135197,10.6299131 0.188120918,10.8303758 L5.12495823,16.044716 C5.21804648,16.1430223 5.34224518,16.1951272 5.46863132,16.1951272 C5.5313383,16.1951272 5.59453137,16.1822935 5.65480784,16.1561127 C5.8363664,16.0765437 5.95473189,15.889428 5.95473189,15.6817784 L5.95473189,13.2351582 L9.72225429,13.2351582 C9.9905818,13.2351582 10.2083549,13.0051779 10.2083549,12.7218094 C10.2083549,12.4384409 9.9905818,12.2084606 9.72225429,12.2084606 L5.46838827,12.2084606 C5.20006076,12.2084606 4.98228771,12.4384409 4.98228771,12.7218094 L4.98228771,12.7279696 C4.98253076,12.7857213 4.98277381,13.6596976 4.98277381,14.4422978 L1.21938326,10.4674382 L4.98277381,6.49309201 C4.98277381,7.26029176 4.98253076,8.11578749 4.98228771,8.20280011 C4.98155856,8.23924787 4.98471821,8.27595231 4.99152362,8.31265675 C5.03648792,8.55341732 5.23627525,8.72667254 5.46838827,8.72667254 L13.4895336,8.72667254 L13.4895336,11.1725228 C13.4895336,11.3801724 13.6078991,11.567288 13.7894577,11.6468571 C13.9715024,11.7261694 14.1797964,11.6825348 14.3193073,11.5354604 L19.2563877,6.32189019 C19.4462099,6.12142749 19.4462099,5.79647772 19.2563877,5.59601502 Z\" id=\"Shape\"></path></g></g></g></svg>Devolución / Entrega (Combos)</button></div><div class=\"col-xs-12\" data-ng-if=\"$root.voucher.selected.vouchertype_id!=10 && $root.voucher.selected.vouchertype_id!=2 && $root.voucher.selected.vouchertype_id!=8\"><button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-hide=\"$root.compareDates()\" data-ng-if=\"$root.access([\'super-admin\',\'gestor-global-de-inventario\']) || ( $root.access([\'gestor-local-de-inventario\']) && $root.getCurrentUserWarehouse().id == $root.voucher.selected.warehouse_id2 ) || ( $root.access([\'gestor-local-de-inventario\']) && !$root.voucher.selected.warehouse_id ) || ( $root.access([\'vendedor-punto-de-venta\']) && $root.getCurrentUserWarehouse().id == $root.voucher.selected.warehouse_id )\" data-ng-click=\"$root.openStockview()\" class=\"info-btn-option {{$root.currentModule}}\"><svg class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-deposito\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-27\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M19.2563877,5.59601502 L14.3193073,0.381418141 C14.1800395,0.234343717 13.9715024,0.190452396 13.7894577,0.270021457 C13.6078991,0.349590517 13.4895336,0.536706147 13.4895336,0.744355727 L13.4895336,3.19020598 L9.72225429,3.19020598 C9.45392678,3.19020598 9.23615373,3.42018623 9.23615373,3.70355475 C9.23615373,3.98692328 9.45392678,4.21690353 9.72225429,4.21690353 L13.9756342,4.21690353 C14.2439617,4.21690353 14.4617348,3.98692328 14.4617348,3.70355475 L14.4617348,1.98383635 L18.2251253,5.95869593 L14.4617348,9.93329884 L14.4617348,8.21332376 C14.4617348,7.92995524 14.2439617,7.69997498 13.9756342,7.69997498 L5.95157223,7.69997498 C5.95497494,7.45356757 5.95497494,7.13837142 5.95497494,6.73333924 L5.95497494,5.25361139 C5.95497494,5.04596181 5.83660945,4.85884618 5.65505089,4.77927712 C5.47276318,4.69945138 5.26446909,4.7433427 5.12520128,4.8906738 L0.188120918,10.1045007 C-0.00170135197,10.3049634 -0.00170135197,10.6299131 0.188120918,10.8303758 L5.12495823,16.044716 C5.21804648,16.1430223 5.34224518,16.1951272 5.46863132,16.1951272 C5.5313383,16.1951272 5.59453137,16.1822935 5.65480784,16.1561127 C5.8363664,16.0765437 5.95473189,15.889428 5.95473189,15.6817784 L5.95473189,13.2351582 L9.72225429,13.2351582 C9.9905818,13.2351582 10.2083549,13.0051779 10.2083549,12.7218094 C10.2083549,12.4384409 9.9905818,12.2084606 9.72225429,12.2084606 L5.46838827,12.2084606 C5.20006076,12.2084606 4.98228771,12.4384409 4.98228771,12.7218094 L4.98228771,12.7279696 C4.98253076,12.7857213 4.98277381,13.6596976 4.98277381,14.4422978 L1.21938326,10.4674382 L4.98277381,6.49309201 C4.98277381,7.26029176 4.98253076,8.11578749 4.98228771,8.20280011 C4.98155856,8.23924787 4.98471821,8.27595231 4.99152362,8.31265675 C5.03648792,8.55341732 5.23627525,8.72667254 5.46838827,8.72667254 L13.4895336,8.72667254 L13.4895336,11.1725228 C13.4895336,11.3801724 13.6078991,11.567288 13.7894577,11.6468571 C13.9715024,11.7261694 14.1797964,11.6825348 14.3193073,11.5354604 L19.2563877,6.32189019 C19.4462099,6.12142749 19.4462099,5.79647772 19.2563877,5.59601502 Z\" id=\"Shape\"></path></g></g></g></svg>Devolución / Entrega</button></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-stockorder.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root.voucher.properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Entregas</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.voucher.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.voucher.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.voucher.selected[key]!=\'\'\" data-ng-bind-html=\"$root.voucher.selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.voucher.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.voucher.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.voucher.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.voucher.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Costo</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Desc</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Sub</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.value | number : 2}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.discount}} %</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.sub | number : 2}}</td></tr><tr><td colspan=\"5\" data-ng-if=\"$root.currentModule != \'inventory\'\" style=\"text-align: right\"><strong>Total: {{$root.voucher.selected.total | number : 2}}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" data-ng-if=\"$root.voucher.actionType != \'store\' && $root.currentModule!=\'inventory\'\" href=\"/es/print/{{$root.voucher.selected.id}}\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir</a> <a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" data-ng-if=\"$root.voucher.selected.vouchertype_id==7\" href=\"/es/print/{{$root.voucher.selected.voucher_related}}\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir original</a> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-hide=\"$root.compareDates()\" data-ng-if=\"$root.access([\'super-admin\',\'vendedor-punto-de-venta\',\'gestor-global-de-inventario\',\'gestor-local-de-inventario\']) && $root.voucher.selected.vouchertype_id!=10\" data-ng-click=\"$root.openStockview()\" class=\"info-btn-option {{$root.currentModule}}\">Devolución / Entrega</button> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.access([\'super-admin\',\'vendedor-punto-de-venta\',\'gestor-global-de-inventario\',\'gestor-local-de-inventario\']) && $root.voucher.selected.vouchertype_id==10\" data-ng-click=\"$root.openComboview()\" class=\"info-btn-option {{$root.currentModule}}\">Devolución / Entrega (C)</button></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-hide=\"$root.compareDates()\" data-ng-if=\"$root.voucher.operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.voucher.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.voucher.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.voucher.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.voucher.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Codigo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root.voucher.selected.stockorderhist\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printstockorder/{{vt.id}}\">{{vt.id}}</a></td><td><a target=\"_blank\" href=\"/es/printstockorder/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-transaction.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root.voucher.properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Pagos</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.voucher.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.voucher.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.voucher.selected[key]!=\'\'\" data-ng-bind-html=\"$root.voucher.selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.voucher.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.voucher.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.voucher.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.voucher.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr data-ng-if=\"$root.currentModule != \'accounting\'\"><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Costo</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Desc</strong></th><th class=\"\" data-ng-if=\"$root.currentModule != \'inventory\'\"><strong>Sub</strong></th></tr></thead><tbody><tr data-ng-if=\"$root.currentModule != \'accounting\'\" data-ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.value | number : 2}}</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.discount}} %</td><td data-ng-if=\"$root.currentModule != \'inventory\'\">{{register.sub | number : 2}}</td></tr><tr><td colspan=\"5\" data-ng-if=\"$root.currentModule != \'inventory\'\" style=\"text-align: right\"><strong>Total: {{$root.voucher.selected.total | number : 2}}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.access([\'super-admin\',\'vendedor-punto-de-venta\',\'gestor-de-compras\'])\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"$root.setDebt(); $root.openPayment();\">Registrar pago</button> <a style=\"margin: auto;margin-bottom: 15px;padding: 15px;text-align: center;\" target=\"_blank\" data-ng-if=\"$root.voucher.actionType != \'store\'\" href=\"/es/print/{{$root.voucher.selected.id}}\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir</a></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.voucher.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.voucher.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.voucher.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.voucher.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Monto</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root.voucher.selected.vouchertransaction\" class=\"{{$root.currentModule}}\"><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.amount}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{$root.transalatePayment(vt.payment_type)}}</a></td><td><a target=\"_blank\" href=\"/es/printtransaction/{{vt.id}}\">{{vt.created_at}}</a></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uifilters/templates/default.html","<div class=\"crud-grid-filters\"><div class=\"filters-box\"><div data-ng-repeat=\"(key, dato) in $root[modelName].filters.filters | orderBy:\'order\'\" data-ng-if=\"!$root[modelName].filters.filters[key].hide\"><form data-ng-submit=\"search()\"><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'search\'\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-model=\"$root[modelName].filters.filters[key].value\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fas fa-search\"></i></button></span></div></form><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'date\'\"><form data-ng-submit=\"search()\"><input type=\"date\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-model=\"$root[modelName].filters.filters[key].value\" data-ng-change=\"search()\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fas fa-search\"></i></button></span></form></div><div data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\" style=\"display: inline-block\"><mydatepicker ng-model=\"$root[modelName].filters.filters[key].from\" date-options=\"dateOptions\" opened=\"opened\" ng-submit=\"\'search\'\" pl=\"Desde\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\" style=\"display: inline-block\"><mydatepicker ng-model=\"$root[modelName].filters.filters[key].to\" date-options=\"dateOptions\" opened=\"opened\" ng-submit=\"\'search\'\" pl=\"Hasta\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\"></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'autocomplete\'\"><input type=\"text\" data-ng-init=\"$root[modelName].filters.filters[key][key+\'_open\'] = false\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-click=\"$root[modelName].filters.filters[key][key+\'_open\'] = true\" data-ng-model=\"$root[modelName].filters.filters[key].value\" data-ng-change=\"loadAcItems(modelName,key,dato.operator,dato.value)\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"pickItem(key, \'\');\" type=\"button\"><i data-ng-show=\"$root[modelName].filters.filters[key].value==\'\'\" class=\"fas fa-filter\"></i> <i data-ng-show=\"$root[modelName].filters.filters[key].value!=\'\'\" class=\"fas fa-times\"></i></button></span><ul class=\"form-ac\" data-ng-show=\"$root[modelName].filters.filters[key][key+\'_open\']\"><li data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pickItem(key, item[key]);\"><a href=\"\">{{item[key]}}</a></li></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'select\'\"><input type=\"text\" data-ng-init=\"$root[modelName].filters.filters[key][key+\'_open\'] = false\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-click=\"$root[modelName].filters.filters[key][key+\'_open\'] = true\" data-ng-model=\"$root[modelName].filters.filters[key].value\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"pickItem(key, \'\');\" type=\"button\"><i data-ng-show=\"$root[modelName].filters.filters[key].value==\'\'\" class=\"fas fa-filter\"></i> <i data-ng-show=\"$root[modelName].filters.filters[key].value!=\'\'\" class=\"fas fa-times\"></i></button></span><ul class=\"form-ac\" data-ng-show=\"$root[modelName].filters.filters[key][key+\'_open\']\"><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item,dato);\"><li style=\"width: 200px !important;\">{{item.name}}</li></ul></ul></div><div class=\"form-group input-group\" data-ng-if=\"($root[modelName].filters.filters[key].type == \'partner\' && $root.currentModule != \'inventory\') || ($root[modelName].filters.filters[key].type == \'partner\' && key == \'partner_related\')\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button data-ng-click=\"loadItems(key, dato.table, dato.field, dato.operator, dato.value2, dato.other)\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i> NIT/CI</li><li><i class=\"fas fa-search\"></i> Nombre</li><li>Teléfono</li></ul><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item, dato);\"><li>{{item.docid}}</li><li>{{item.name}}</li><li>{{item.phone}}</li></ul></li></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'product\'\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" data-ng-click=\"loadFilterList(key, dato.table, dato.field, dato.operator, dato.value2)\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i>Código</li><li><i class=\"fas fa-search\"></i>Código 2</li><li>Descripcion</li></ul><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item, dato);\"><li>{{item.code}}</li><li>{{item.code_secondary}}</li><li>{{item.description}}</li></ul></li></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'list\'\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" data-ng-if=\"!$root[modelName].filters.filters[key].value2 || $root[modelName].filters.filters[key].value2 == \'\'\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-click=\"loadFilterList(key, dato.table, dato.field, dato.operator, dato.value2)\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button> <button id=\"single-button\" data-ng-if=\"$root[modelName].filters.filters[key].value2 && $root[modelName].filters.filters[key].value2 != \'\'\" data-ng-click=\"$root[modelName].filters.filters[key].value2 = \'\'\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-times\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i>Name</li></ul><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item,dato);\"><li style=\"width: 200px !important;\">{{item.name}}</li></ul></li></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'selectlist\'\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\" style=\"width: calc(100% - 15px);padding: 5px;\"><li style=\"margin: 5px 0\" data-ng-click=\"pick(key, item,dato);\" data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\">{{item.name}}</li></ul></div><div data-ng-if=\"$root[modelName].filters.filters[key].type == \'group\'\"><div class=\"form-group input-group\" data-ng-repeat=\"sf in dato.subitems track by $index\" uib-dropdown=\"\" is-open=\"sf.isopen\"><input type=\"text\" placeholder=\"{{sf.label}}\" data-ng-model=\"sf.search\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" data-ng-click=\"loadData(sf)\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i>Name</li></ul><ul data-ng-repeat=\"item in sf.data\" data-ng-click=\"setFilter(sf, item, dato, key);\"><li style=\"width: 200px !important;\">{{item[sf.searchIn]}}</li></ul></li></ul></div></div></div><a style=\"float: left;margin-right: 15px;\" target=\"_blank\" data-ng-if=\"modelName==\'stock\'\" ng-href=\"{{$root.api+\'/print/stockreport\'+stockReport() }}\" tooltip=\"{{$root.switchText(\'Imprimir\', \'Print\')}}\" class=\"btn btn-default\" type=\"button\"><i class=\"fas fa-print\"></i></a> <button data-ng-click=\"resetFilters()\" data-ng-if=\"countItems($root[modelName].filters.filters)>0\" tooltip=\"{{$root.switchText(\'Resetear\', \'Reset\')}}\" class=\"btn btn-default\" type=\"button\"><i class=\"fas fa-retweet\"></i> <span>Reiniciar filtros</span></button></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/templates/inventory.html","<div class=\"forms expanded\"><div data-ng-if=\"$root.voucher.selected.vouchertype_id!=5\" class=\"grid-table-box {{$root.currentModule}} uistock\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th></th><th colspan=\"3\"><switch name=\"yesNo\" data-ng-if=\"$root.voucher.selected.vouchertype_id == 4\" data-ng-init=\"$root.voucher.selected.stockorder.type=true\" ng-model=\"$root.voucher.selected.stockorder.type\" on=\"Salida\" off=\"Ingreso\" class=\"wide\"></switch></th><th colspan=\"2\" style=\"background: #f0f0f0;text-align: center;\" data-ng-if=\"$root.voucher.selected.warehouse_id\"><a style=\"position: relative;height: 20px;display: inline-block;margin-bottom: 5px;\"><i class=\"fas fa-warehouse\"></i> <i class=\"fas fa-arrow-alt-circle-right\" style=\"position: absolute; top: 10px;left:8px;color: green;\"></i></a><br><strong>Stock {{$root.getWarehousename($root.voucher.selected.warehouse_id)}}</strong></th><th></th><th colspan=\"2\" style=\"background: #f0f0f0;text-align: center;\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"><a style=\"position: relative;height: 20px;display: inline-block;margin-bottom: 5px;\"><i class=\"fas fa-warehouse\"></i> <i class=\"fas fa-arrow-alt-circle-left\" style=\"position: absolute; top: 10px;left:8px;color: green;\"></i></a><br><strong>Stock {{$root.getWarehousename($root.voucher.selected.warehouse_id2)}}</strong></th></tr><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id\"><strong>Actual</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id\"><strong>Nuevo</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"><strong>Actual</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"><strong>Nuevo</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-repeat=\"register in $root.voucher.selected.voucherline\"><tr data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-init=\"register.value = $root.getUnitcost(register.product,$root.voucher.selected.warehouse_id)\" class=\"test {{$root.currentModule}}\"><td><a data-ng-click=\"remove($index)\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td data-ng-init=\"$root.calculateIssuedTotal(register)\">#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td><stockpicker register=\"register\" data-ng-if=\"$root.voucher.selected.vouchertype_id!=3\" new-stock=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\"></stockpicker><p data-ng-if=\"$root.voucher.selected.vouchertype_id==3 && $root.voucher.selected.status==0\">{{register.product.description}}</p><a data-ng-if=\"($root.voucher.selected.vouchertype_id==4 && $root.voucher.selected.stockorder.type==false) || $root.voucher.selected.vouchertype_id==3 && $root.voucher.selected.status==0\" data-ng-click=\"showPicker(false);$root.newStockBatch(register.product)\" style=\"padding: 4px; margin: auto auto 10px; min-width: 60px;\" class=\"btn btn-action\"><i class=\"fa fa-plus\"></i> Lote</a></td><td></td><td data-ng-if=\"$root.voucher.selected.warehouse_id\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id)}}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id) - (($root.voucher.selected.stockorder.type==false)?register.quantity_issued*-1:register.quantity_issued)}}</td><td data-ng-class=\"{\'danger\': register.quantity_expected != 0 , \'success\': register.quantity_expected == 0 }\">{{register.quantity_issued}}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id2\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id2)}}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id2\">{{$root.getCompleteStock(register.product,$root.voucher.selected.warehouse_id2) + (($root.voucher.selected.stockorder.type==false)?register.quantity_issued*-1:register.quantity_issued)}}</td></tr><tr style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in $root.getSubitems(register)\"><td></td><td></td><td></td><td data-ng-if=\"!st.isNew\" style=\"padding-left: 20px;\">Lote - {{(st.batchcode)?st.batchcode:\'No asignado\'}}</td><td data-ng-if=\"st.isNew\"><input class=\"grid-input form-control\" placeholder=\"Código de lote\" type=\"text\" data-ng-model=\"st.batchcode\"><mydatepicker ng-model=\"st.expire_at\" date-options=\"dateOptions\" opened=\"opened\" ng-required=\"false\" format=\"{{\'yyyy/MM/dd\'}}\"><input class=\"grid-input form-control\" placeholder=\"Estantería\" type=\"text\" data-ng-model=\"st.shelf\"></mydatepicker></td><td>{{st.shelf}}</td><td>{{ st.current_stock }}</td><td data-ng-if=\"$root.voucher.selected.warehouse_id\"></td><td data-ng-init=\"register.value = $root.getUnitcost(register.product,$root.voucher.selected.warehouse_id)\"><input class=\"grid-input form-control\" min=\"0\" data-ng-disabled=\"$root.voucher.selected.vouchertype_id == 6 && $root.voucher.selected.warehouse_id2==null\" data-ng-change=\"$root.fillVoucherline(register,st);\" type=\"number\" data-ng-model=\"st.quantity_issued\"></td><td colspan=\"2\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"></td></tr></tbody><tbody><tr class=\"{{$root.currentModule}}\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><td></td><td>#{{$root[modelName].selected.voucherline.length+1}}</td><td colspan=\"3\"><stockpicker data-ng-if=\"$root.voucher.selected.warehouse_id\" widget-type=\"\'searcher\'\" new-line=\"true\" new-stock=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\" register=\"{}\"></stockpicker><p data-ng-if=\"!$root.voucher.selected.warehouse_id\">Seleccione un almacen de origen</p></td><td></td><td colspan=\"2\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"></td><td colspan=\"2\"></td></tr><tr><td></td><td rowspan=\"2\" colspan=\"5\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n                </textarea></td><td colspan=\"2\" data-ng-if=\"$root.voucher.selected.warehouse_id2\"></td><td style=\"text-align: right\">Total Bs:</td><td style=\"text-align: right\">{{$root.othersTotal | number : 2}}</td></tr></tbody></table></div><div data-ng-if=\"$root.voucher.selected.vouchertype_id==5\" class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Marca</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" ng-repeat=\"register in $root[modelName].selected.voucherline\"><tr class=\"test {{$root.currentModule}}\"><td data-ng-init=\"$root.calculateTotal(\'quantity\',\'value\')\"><a data-ng-click=\"remove($index)\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td>#{{$index + 1}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.description}}</td><td>{{register.product.productbrand.name}}</td><td data-ng-init=\"register.value = $root.getUnitcost(register.product,$root.voucher.selected.warehouse_id)\"><input class=\"grid-input form-control\" data-ng-required=\"true\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" data-ng-disabled=\"$root[modelName].actionType!=\'store\' || $root.voucher.selected.vouchertype_id == 3\" min=\"1\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"></td></tr><tr data-ng-if=\"register.product.stock.length>1 && st.active\" style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in register.stockadjustment\"><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{(st.batchcode)?st.batchcode:\'No asignado\'}}</td><td></td><td><input class=\"grid-input form-control\" min=\"0\" step=\"0.01\" data-ng-change=\"$root.calculateSubTotal(register)\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" type=\"number\" data-ng-model=\"st.quantity\">(1)</td><td colspan=\"3\"></td></tr></tbody><tbody><tr class=\"{{$root.currentModule}}\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><td></td><td>#{{$root[modelName].selected.voucherline.length+1}}</td><td colspan=\"3\"><stockpicker data-ng-if=\"$root.voucher.selected.warehouse_id\" widget-type=\"\'searcher\'\" new-line=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\" register=\"{}\"></stockpicker><p data-ng-if=\"!$root.voucher.selected.warehouse_id\">Seleccione un almacen de origen</p></td><td colspan=\"3\"></td></tr><tr><td rowspan=\"2\" colspan=\"4\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n                </textarea></td><td style=\"text-align: right\">Total Bs:</td><td style=\"text-align: right\">{{$root.othersTotal | number : 2}}</td></tr><tr><td style=\"text-align: right;border-top: none;\"></td><td></td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/templates/inventorytable2.html","<div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\"><strong>Total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" ng-repeat=\"register in $root[modelName].selected.voucherline\"><tr class=\"test {{$root.currentModule}}\"><td data-ng-init=\"calculateTotal(\'quantity\',\'value\')\"><a data-ng-click=\"remove($index)\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{(register.product.stock.length==1)?register.product.stock[0].batchcode:\'\'}}</td><td><input class=\"grid-input form-control\" data-ng-change=\"calculateTotal(\'quantity\',\'value\')\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-if=\"register.product.stock.length==1\" min=\"1\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"></td><td>{{register.value * register.quantity}}</td></tr><tr data-ng-if=\"register.product.stock.length>1\" style=\"background: #F8F8F8;\" data-ng-repeat=\"st in register.product.stock\"><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{st.batchcode}}</td><td>{{st.batchcode}}</td><td><input class=\"grid-input form-control\" min=\"0\" step=\"0.01\" data-ng-change=\"calculateSubTotal(register.quantity, st )\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" type=\"number\" data-ng-model=\"st.quantity\"></td><td colspan=\"3\"></td></tr></tbody><tbody><tr class=\"{{$root.currentModule}}\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><td></td><td>#{{$root[modelName].selected.voucherline.length+1}}</td><td colspan=\"3\"><div class=\"grid-selector form-group input-group\" style=\"margin-bottom:0;width: 300px;\"><input data-ng-class=\"{\'focused\':products.length>0}\" class=\"grid-input form-control\" data-ng-change=\"loadProducts(\'code\', $root.searchCode)\" type=\"text\" data-ng-model=\"$root.searchCode\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" style=\"margin: 0 0 2px 0;\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div><ul data-ng-if=\"products.length>0 && $root.searchCode!=\'\'\" class=\"grid-selector-options {{$root.currentModule}}\"><li><ul><li><i class=\"fas fa-search\"></i> Cod 1</li><li><i class=\"fas fa-search\"></i> Cod 2</li><li><i class=\"fas fa-search\"></i> Producto</li><li>Stock</li></ul><ul data-ng-repeat=\"product in products track by $index\" data-ng-class=\"{\'text-danger\': (product.stock.length==0 || product.stock.current_stock <= 0)}\"><li data-ng-click=\"addProduct(product)\">{{product.code}}</li><li data-ng-click=\"addProduct(product)\">{{product.code_secondary}}</li><li data-ng-click=\"addProduct(product)\">{{product.description}}</li><li data-ng-click=\"addProduct(product)\">{{(product.stock.length==1)?product.stock[0].current_stock:\'\'}}</li><li data-ng-repeat=\"st in product.stock\" data-ng-if=\"product.stock.length>1 && st.current_stock > 0\" style=\"cursor: not-allowed;; width:100%;height: auto; max-height: inherit; overflow: visible; padding-left: 110px;background: #e4e4e4;\"><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px;float: left; font-weight: normal;color: inherit;width: 120px;\">Lote - {{st.batchcode}}</p><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px ;float: left; font-weight: normal;color:inherit\">{{st.current_stock - reserved_stock}}</p></li></ul></li></ul></td><td colspan=\"5\"></td></tr><tr><td rowspan=\"2\" colspan=\"7\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n                </textarea></td><td style=\"text-align: right\">Otros:</td><td style=\"text-align: right\">{{othersTotal}}</td></tr><tr><td style=\"text-align: right;border-top: none;\"><strong style=\"color: #02579B;\">Total:</strong></td><td style=\"background: #E1F5FE; color: #02579B; text-align: right;border-top: none;\"><strong style=\"font-size: 18px; coloe:#02579B;\">{{$root[modelName].selected.total}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/templates/purchases.html","<div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\"><strong>Costo</strong></th><th class=\"column-title\"><strong>Descuento</strong></th><th class=\"column-title\"><strong>Total</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].selected.voucherline\" class=\"test {{$root.currentModule}}\"><td data-ng-init=\"$root.calculateTotal(\'quantity\',\'value\')\"><a data-ng-click=\"remove($index)\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td>#{{$index + 1}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.description}}</td><td><input class=\"grid-input form-control\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" min=\"1\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"></td><td data-ng-init=\"register.value = $root.getUnitcost(register.product,$root.voucher.selected.warehouse_id2)\"><input class=\"grid-input form-control\" min=\"0\" step=\"0.01\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" type=\"number\" data-ng-model=\"register.value\"></td><td data-ng-init=\"starterValue(register, \'discount\', 0)\"><div class=\"grid-selector form-group input-group\"><input class=\"grid-input form-control\" type=\"text\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" data-ng-model=\"register.discount\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" style=\"margin: 0 0 2px 0;\" type=\"button\">%</button></span></div></td><td>{{register.sub | number : 2}}</td></tr><tr class=\"{{$root.currentModule}}\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><td></td><td>#{{$root[modelName].selected.voucherline.length+1}}</td><td colspan=\"3\"><stockpicker widget-type=\"\'searcher\'\" new-line=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\" register=\"{}\"></stockpicker></td><td></td><td></td><td></td></tr><tr><td rowspan=\"2\" colspan=\"6\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n                </textarea></td><td style=\"text-align: right\">Otros:</td><td style=\"text-align: right\">{{$root.othersTotal | number : 2}}</td></tr><tr><td style=\"text-align: right;border-top: none;\"><strong class=\"ui-total\" style=\"color: #02579B;\">Total:</strong></td><td style=\"background: #E1F5FE; color: #02579B; text-align: right;border-top: none;\"><strong class=\"ui-total\" style=\"font-size: 18px; coloe:#02579B;\">{{$root.voucher.selected.total | number : 2}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/templates/sales-mobile-point.html","<div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}} uiinv\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\"><strong>Precio</strong></th><th class=\"column-title\"><strong>Descuento</strong></th><th class=\"column-title\"><strong>Total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-init=\"$root.getSubitems(register)\" data-ng-repeat=\"register in $root[modelName].selected.voucherline\"><tr class=\"test {{$root.currentModule}}\"><td data-ng-init=\"$root.calculateTotal(\'quantity\',\'value\')\"><a data-ng-click=\"remove($index)\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td>#{{$index + 1}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.description}}</td><td><input class=\"grid-input form-control\" data-ng-required=\"true\" data-ng-if=\"$root.voucher.selected.vouchertype_id == 10\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\');\" min=\"0\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"> <input class=\"grid-input form-control\" data-ng-required=\"true\" data-ng-if=\"$root.voucher.selected.vouchertype_id != 10\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\');$root.controlDeliveryProg(register,checkGoodStock(register.product))\" min=\"0\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"> <small class=\"text-info\" data-ng-if=\"$root.voucher.selected.vouchertype_id != 10\">Stock disponible: {{checkGoodStock(register.product)}}</small></td><td><select data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" class=\"grid-input form-control\" data-ng-init=\"register.value=\'\'+register.product.sale_price1; $root.calculateTotal(\'quantity\',\'value\')\" data-ng-required=\"true\" style=\"min-width: 130px !important;\" data-ng-model=\"register.value\"><option data-ng-if=\"register.product.sale_price1 > 0\" value=\"{{register.product.sale_price1}}\">A - {{register.product.sale_price1}}</option><option data-ng-if=\"register.product.sale_price2 > 0\" value=\"{{register.product.sale_price2}}\">B - {{register.product.sale_price2}}</option><option data-ng-if=\"register.product.sale_price3 > 0\" value=\"{{register.product.sale_price3}}\">C - {{register.product.sale_price3}}</option><option data-ng-if=\"register.product.sale_price4 > 0\" value=\"{{register.product.sale_price4}}\">D - {{register.product.sale_price4}}</option><option data-ng-if=\"register.product.sale_price5 > 0 && $root.access([\'super-admin\']) || $root.currentUser.email == \'e.barron@guibdental.com\'\" value=\"{{register.product.sale_price5}}\">E - {{register.product.sale_price5}}</option></select></td><td>{{register.discount}} %</td><td>{{register.value * register.quantity | number : 2}}</td></tr><tr style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in $root.getSubitems(register)\"><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{(st.batchcode)?st.batchcode:\'No asignado\'}}</td><td>{{st.shelf}}</td><td><input class=\"grid-input form-control\" min=\"0\" data-ng-if=\"$root.voucher.actionType == \'store\' && $root.voucher.selected.vouchertype_id!=10\" data-ng-change=\"$root.calculateSubTotal(register);\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" type=\"number\" data-ng-model=\"st.quantity\"> <small class=\"text-warning\" data-ng-if=\"st.limitHelp\">*Stock lote {{st.limitHelp}}</small><input class=\"grid-input form-control\" min=\"0\" data-ng-if=\"$root.voucher.actionType != \'store\' && $root.voucher.selected.vouchertype_id==10\" data-ng-disabled=\"true\" type=\"number\" data-ng-model=\"st.quantity_issued\"></td><td colspan=\"3\"></td></tr></tbody><tbody><tr class=\"{{$root.currentModule}}\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><td></td><td>#{{$root[modelName].selected.voucherline.length+1}}</td><td colspan=\"3\"><stockpicker widget-type=\"\'searcher\'\" new-line=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\" register=\"{}\"></stockpicker></td><td colspan=\"5\"></td></tr><tr><td rowspan=\"2\" colspan=\"6\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n          </textarea></td><td style=\"text-align: right\"></td><td style=\"text-align: right\"></td></tr><tr><td style=\"text-align: right;border-top: none;\"><strong class=\"ui-total\" style=\"color: #02579B;\">Total:</strong></td><td style=\"background: #E1F5FE; color: #02579B; text-align: right;border-top: none;\"><strong class=\"ui-total\" style=\"font-size: 18px; coloe:#02579B;\">{{$root.voucher.selected.total | number : 2}}</strong></td></tr></tbody></table></div><div class=\"forms expanded\"><div class=\"pay-box\" style=\"margin-bottom: 20px;padding: 10px 15px 5px;background: #f8f8f8;border-radius: 5px;\"><div class=\"detail\" style=\"padding-left: 0\"><p class=\"detail-label\">Saldo de crédito:</p><p class=\"detail-item\" data-ng-class=\"{\'danger\':$root.voucher.selected.partnerrelated.creditavailable <= $root.voucher.selected.vouchertransaction[0].amount}\">{{$root.voucher.selected.partnerrelated.creditavailable - $root.voucher.selected.vouchertransaction[0].amount | number : 2}} Bs.</p></div><div class=\"detail\" style=\"padding-left: 0\"><p class=\"detail-label\">Crédito nuevo:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':$root.voucher.selected.partnerrelated.creditavailable > $root.voucher.selected.vouchertransaction[0].amount}\">{{$root.voucher.selected.vouchertransaction[0].amount | number : 2}} Bs.</p></div></div></div><div class=\"forms expanded\"><div class=\"col-xs-12\" style=\"padding: 0\"><div class=\"alert alert-info\" style=\"text-align: center\" role=\"alert\">ATENCIÓN, Esta operación generará un credito automático a nombre del vendedor</div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/templates/sales-mobile-request.html","<div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}} uiinv\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Vendido</strong></th><th class=\"column-title\"><strong>Entregado</strong></th><th class=\"column-title\" data-ng-if=\"$root.voucher.selected.vouchertypeSource!=10\"><strong>Nueva entrega</strong></th><th class=\"column-title\"><strong>Saldo</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-init=\"($root.voucher.selected.vouchertypeSource==10)?register.quantity=register.quantity_original: 0\" data-ng-repeat=\"register in $root[modelName].selected.voucherline\"><tr class=\"test {{$root.currentModule}}\" data-ng-class=\"{ \'success\': $root.voucher.selected.vouchertypeSource!=10 && (register.stockissued.balance - register.quantity) == 0, \'danger\' : $root.voucher.selected.vouchertypeSource!=10 && (register.stockissued.balance - register.quantity) != 0 }\"><td data-ng-init=\"$root.calculateTotal(\'quantity\',\'value\')\"></td><td>#{{$index + 1}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.description}} {{register.product.productcategory_id}}</td><td>{{register.stockissued.expected}}</td><td>{{register.stockissued.issued}}</td><td data-ng-if=\"$root.voucher.selected.vouchertypeSource!=10\"><input class=\"grid-input form-control\" data-ng-required=\"true\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" data-ng-disabled=\"register.stockissued.balance == 0 || $root.voucher.selected.vouchertypeSource==10\" min=\"0\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"></td><td>{{ register.stockissued.balance - register.quantity }}</td></tr><tr class=\"{{$root.currentModule}}\" data-ng-class=\"{ \'success\': cg.totalBalance == 0, \'danger\' : cg.totalBalance != 0 }\" data-ng-if=\"$root.voucher.selected.vouchertypeSource==10\" data-ng-repeat=\"cg in register.stockissued.groups\"><td></td><td></td><td></td><td><span style=\"padding-left: 15px\">Grupo: {{cg.name}} (min {{cg.min}})</span></td><td>{{cg.totalExpected}}</td><td>{{cg.totalIssued}}</td><td data-ng-if=\"$root.voucher.selected.vouchertypeSource!=10\"></td><td>{{cg.totalBalance}}</td></tr></tbody><tbody><tr><td rowspan=\"2\" colspan=\"7\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n          </textarea></td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/templates/sales.html","<div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}} uiinv\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>Marca</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\"><strong>Precio</strong></th><th class=\"column-title\"><strong>Descuento</strong></th><th class=\"column-title\"><strong>Total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-init=\"$root.getSubitems(register)\" data-ng-repeat=\"register in $root[modelName].selected.voucherline\"><tr class=\"test {{$root.currentModule}}\"><td data-ng-init=\"$root.calculateTotal(\'quantity\',\'value\')\"><a data-ng-click=\"remove($index)\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td>#{{$index + 1}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.code}} {{register.product.code_secondary}}</td><td><stockpicker register=\"register\" new-stock=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\"></stockpicker></td><td>{{(register.product.stock.length==1)?register.product.stock[0].batchcode:\'\'}}</td><td>{{register.product.productbrand.name}}</td><td><input class=\"grid-input form-control\" data-ng-required=\"true\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" data-ng-disabled=\"$root[modelName].selected.vouchertype_id == 7 || $root[modelName].selected.vouchertype_id == 9 || $root[modelName].selected.vouchertype_id == 11\" min=\"0\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"> <small data-ng-class=\"{ \'text-info\':register.quantity_original != register.quantity, \'text-success\':register.quantity_original == register.quantity }\" data-ng-if=\"register.note\">{{register.note}} <i class=\"fas fa-check-double\" data-ng-if=\"register.quantity_original == register.quantity\"></i></small></td><td><select data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-change=\"$root.calculateTotal(\'quantity\',\'value\')\" class=\"grid-input form-control\" data-ng-init=\"register.value=\'\'+register.product.sale_price1; $root.calculateTotal(\'quantity\',\'value\')\" data-ng-required=\"true\" style=\"min-width: 130px !important;\" data-ng-model=\"register.value\"><option data-ng-if=\"register.product.sale_price1 > 0\" value=\"{{register.product.sale_price1}}\">A - {{register.product.sale_price1}}</option><option data-ng-if=\"register.product.sale_price2 > 0\" value=\"{{register.product.sale_price2}}\">B - {{register.product.sale_price2}}</option><option data-ng-if=\"register.product.sale_price3 > 0\" value=\"{{register.product.sale_price3}}\">C - {{register.product.sale_price3}}</option><option data-ng-if=\"register.product.sale_price4 > 0\" value=\"{{register.product.sale_price4}}\">D - {{register.product.sale_price4}}</option><option data-ng-if=\"register.product.sale_price5 > 0 && $root.access([\'super-admin\']) || $root.currentUser.email == \'e.barron@guibdental.com\'\" value=\"{{register.product.sale_price5}}\">E - {{register.product.sale_price5}}</option></select></td><td>{{register.discount | number : 2 }} %</td><td>{{register.sub | number : 2}}</td></tr><tr style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in $root.getSubitems(register)\"><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{(st.batchcode)?st.batchcode:\'No asignado\'}}</td><td>{{st.shelf}}</td><td></td><td><input class=\"grid-input form-control\" min=\"0\" data-ng-if=\"$root.voucher.actionType == \'store\' && $root.voucher.selected.vouchertype_id!=10\" data-ng-change=\"$root.calculateSubTotal(register);\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" type=\"number\" data-ng-model=\"st.quantity\"> <small class=\"text-warning\" data-ng-if=\"st.limitHelp\">*Stock lote {{st.limitHelp}}</small></td><td colspan=\"3\"></td></tr></tbody><tbody><tr class=\"{{$root.currentModule}}\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><td></td><td>#{{$root[modelName].selected.voucherline.length+1}}</td><td colspan=\"3\"><stockpicker widget-type=\"\'searcher\'\" new-line=\"true\" new-stock=\"true\" warehouse-id=\"$root.voucher.selected.warehouse_id\" register=\"{}\"></stockpicker></td><td colspan=\"5\"></td></tr><tr><td rowspan=\"2\" colspan=\"8\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n          </textarea></td><td style=\"text-align: right\"></td><td style=\"text-align: right\"></td></tr><tr><td style=\"text-align: right;border-top: none;\"><strong class=\"ui-total\" style=\"color: #02579B;\">Total:</strong></td><td style=\"background: #E1F5FE; color: #02579B; text-align: right;border-top: none;\"><strong class=\"ui-total\" style=\"font-size: 18px; coloe:#02579B;\">{{$root.voucher.selected.total | number : 2}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/templates/salestable2.html","<div class=\"forms expanded\">{{$root[modelName].selected.vouchertype_id}}<div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\"><strong>Precio</strong></th><th class=\"column-title\"><strong>Descuento</strong></th><th class=\"column-title\"><strong>Total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" ng-repeat=\"register in $root[modelName].selected.voucherline\"><tr class=\"test {{$root.currentModule}}\"><td data-ng-init=\"calculateTotal(\'quantity\',\'value\')\"><a data-ng-click=\"remove($index)\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><i style=\"color: #d94a4a;\" class=\"fas fa-times-circle\"></i></a></td><td>#{{$index + 1}}</td><td data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.code}} {{register.product.code_secondary}}</td><td data-ng-init=\"register.batchPicker=false\" data-ng-click=\"$root.setPicked(register.product.id)\"><a style=\"width: 25px;float: left;padding: 0;margin-right: 5px;\" data-ng-if=\"register.product.stock.length>1\" data-ng-click=\"register.batchPicker=!register.batchPicker;loadProducts(\'\', register.product.description)\" class=\"btn btn-theme\"><i class=\"fa fa-plus\"></i></a> {{register.product.description}}<ul data-ng-if=\"products.length>0 && register.batchPicker\" class=\"grid-selector-options {{$root.currentModule}}\"><li><ul><li><i class=\"fas fa-search\"></i> Cod 1</li><li><i class=\"fas fa-search\"></i> Cod 2</li><li><i class=\"fas fa-search\"></i> Producto</li><li>Stock {{$root[modelName].selected.vouchertype_id}}</li></ul><ul data-ng-repeat=\"product in products track by $index\" data-ng-if=\"(product.productcategory_id == 4 && $root[modelName].selected.vouchertype_id == 10) || (product.productcategory_id != 4 && $root[modelName].selected.vouchertype_id != 10)\" data-ng-class=\"{\'text-danger\': (product.stock.length==0 || product.stock.current_stock <= 0)}\"><li>{{product.code}}</li><li>{{product.code_secondary}}</li><li>{{product.description}}</li><li>{{(product.stock.length==1)?product.stock[0].current_stock:\'\'}}</li><li data-ng-repeat=\"st in product.stock\" data-ng-if=\"product.stock.length>1 && st.current_stock > 0\" data-ng-click=\"register.batchPicker=false;addProduct(product, st)\" class=\"level2\"><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px;float: left; font-weight: normal;color: inherit;width: 120px;\">Lote - {{st.batchcode}}</p><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px ;float: left; font-weight: normal;color:inherit\">{{st.current_stock - reserved_stock}}</p></li></ul></li></ul></td><td>{{(register.product.stock.length==1)?register.product.stock[0].batchcode:\'\'}}</td><td><input class=\"grid-input form-control\" data-ng-required=\"true\" data-ng-change=\"calculateTotal(\'quantity\',\'value\')\" data-ng-disabled=\"$root[modelName].actionType!=\'store\' || register.product.stock.length>1\" min=\"1\" step=\"1\" title=\"Must be an integer number\" type=\"number\" data-ng-model=\"register.quantity\"></td><td><select data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-change=\"calculateTotal(\'quantity\',\'value\')\" class=\"grid-input form-control\" data-ng-init=\"register.value=\'\'+register.product.sale_price1; calculateTotal(\'quantity\',\'value\')\" data-ng-required=\"true\" data-ng-model=\"register.value\"><option value=\"{{register.product.sale_price1}}\">{{register.product.sale_price1}}</option><option value=\"{{register.product.sale_price2}}\">{{register.product.sale_price2}}</option><option value=\"{{register.product.sale_price3}}\">{{register.product.sale_price3}}</option><option value=\"{{register.product.sale_price4}}\">{{register.product.sale_price4}}</option></select></td><td>{{register.discount}} %</td><td>{{register.value * register.quantity}}</td></tr><tr data-ng-if=\"register.product.stock.length>1 && st.active\" style=\"background: #F8F8F8;\" data-ng-click=\"$root.setPicked(register.product.id)\" data-ng-repeat=\"st in register.stockadjustment\"><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{st.batchcode}}</td><td>{{st.batchcode}}</td><td><input class=\"grid-input form-control\" min=\"0\" step=\"0.01\" data-ng-change=\"calculateSubTotal(register)\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" type=\"number\" data-ng-model=\"st.quantity\"></td><td colspan=\"3\"></td></tr></tbody><tbody><tr class=\"{{$root.currentModule}}\" data-ng-hide=\"$root[modelName].actionType!=\'store\'\"><td></td><td>#{{$root[modelName].selected.voucherline.length+1}}</td><td colspan=\"3\"><div class=\"grid-selector form-group input-group\" style=\"margin-bottom:0;width: 300px;\"><input data-ng-class=\"{\'focused\':products.length>0}\" class=\"grid-input form-control\" data-ng-change=\"loadProducts(\'code\', $root.searchCode)\" type=\"text\" data-ng-model=\"$root.searchCode\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" style=\"margin: 0 0 2px 0;\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div><ul data-ng-if=\"products.length>0 && $root.searchCode!=\'\'\" class=\"grid-selector-options {{$root.currentModule}}\"><li><ul><li><i class=\"fas fa-search\"></i> Cod 1</li><li><i class=\"fas fa-search\"></i> Cod 2</li><li><i class=\"fas fa-search\"></i> Producto</li><li>Stock {{$root[modelName].selected.vouchertype_id}}</li></ul><ul data-ng-repeat=\"product in products track by $index\" data-ng-if=\"(product.productcategory_id == 4 && $root[modelName].selected.vouchertype_id == 10) || (product.productcategory_id != 4 && $root[modelName].selected.vouchertype_id != 10)\" data-ng-class=\"{\'text-danger\': (product.stock.length==0 || product.stock.current_stock <= 0)}\"><li data-ng-click=\"addProduct(product)\">{{product.code}}</li><li data-ng-click=\"addProduct(product)\">{{product.code_secondary}}</li><li data-ng-click=\"addProduct(product)\">{{product.description}}</li><li data-ng-click=\"addProduct(product)\">{{(product.stock.length==1)?product.stock[0].current_stock:\'\'}}</li><li data-ng-repeat=\"st in product.stock\" data-ng-if=\"product.stock.length>1 && st.current_stock > 0\" data-ng-click=\"addProduct(product, st)\" class=\"level2\"><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px;float: left; font-weight: normal;color: inherit;width: 120px;\">Lote - {{st.batchcode}}</p><p style=\"font-size: 12px; margin-bottom: 0;padding: 0 5px 0 5px ;float: left; font-weight: normal;color:inherit\">{{st.current_stock - reserved_stock}}</p></li></ul></li></ul></td><td colspan=\"5\"></td></tr><tr><td rowspan=\"2\" colspan=\"7\" style=\"padding: 8px 0 0 0;\"><textarea style=\"width: 300px;float: left;min-height: 56px;\" placeholder=\"Concepto\" data-ng-disabled=\"$root[modelName].actionType!=\'store\'\" data-ng-model=\"$root[modelName].selected.comments\" class=\"form-control\">\n                </textarea></td><td style=\"text-align: right\">Otros:</td><td style=\"text-align: right\">{{othersTotal}}</td></tr><tr><td style=\"text-align: right;border-top: none;\"><strong style=\"color: #02579B;\">Total:</strong></td><td style=\"background: #E1F5FE; color: #02579B; text-align: right;border-top: none;\"><strong style=\"font-size: 18px; coloe:#02579B;\">{{$root[modelName].selected.total}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/widgets/partnerpicker.html","<div class=\"picker\"><button style=\"padding: 6px 20px;margin-right: 20px; min-width: 185px;\" type=\"button\" data-ng-click=\"$root.newPartner()\" data-ng-if=\"!$root.voucher.selected[targetField] && targetField == \'partner_id\'\" class=\"btn btn-action success pull-left\">Crear {{partnerTypeLabel}}</button><button style=\"padding: 6px 20px;margin-right: 20px; min-width: 185px;\" type=\"button\" data-ng-click=\"$root.resetPartner(targetField)\" data-ng-if=\"$root.voucher.selected[targetField]\" class=\"btn btn-action danger pull-left\">Cambiar {{partnerTypeLabel}}</button><form class=\"form-group input-group\" data-ng-submit=\"$root.loadPartners($root.partnerSearch[targetField])\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"Buscar {{partnerTypeLabel}} {{ (targetField==\'partner_related\')?\'.\':\'\' }}\" data-ng-model=\"$root.partnerSearch[targetField]\" class=\"form-control search\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" data-ng-click=\"$root.loadPartners($root.partnerSearch[targetField],targetField)\" ng-disabled=\"disabled==true || $root.partnerSearch[targetField] == \'\'\"><i class=\"fas fa-search\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}} wow slideInLeft\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li class=\"hidden-sm hidden-lg hidden-md\"><a class=\"btn btn-default mobile-close {{$root.currentModule}}\">{{partnerTypeLabel}} <i class=\"far fa-times-circle\"></i></a></li><li><ul><li class=\"hidden-xs\"><i class=\"fas fa-search\"></i> NIT/CI</li><li><i class=\"fas fa-search\"></i> {{partnerTypeLabel}}</li><li class=\"hidden-xs\"><i class=\"fas fa-search\"></i> Teléfono</li></ul><ul data-ng-repeat=\"item in $root.partnersSet\" data-ng-click=\"$root.setPartner(item, targetField);setPartnerSearch(item.name);status.isopen=false\"><li><strong class=\"hidden-sm hidden-md hidden-lg\">Documento:</strong>{{item.docid}}</li><li><strong class=\"hidden-sm hidden-md hidden-lg\">Nombre:</strong>{{item.name}}</li><li><strong class=\"hidden-sm hidden-md hidden-lg\">Teléfono:</strong>{{item.phone}}</li></ul></li></ul></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/widgets/stockpicker.html","<div><form data-ng-submit=\"loadItems($root.searched)\"><div class=\"grid-selector form-group input-group\" data-ng-if=\"widgetType==\'searcher\'\" style=\"margin-bottom:0;width: 250px;\"><input data-ng-class=\"{\'focused\':productItem.length>0}\" class=\"grid-input form-control\" type=\"text\" data-ng-model=\"$root.searched\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-if=\"register.isOpen!=true\" style=\"margin: 0 0 2px 0;\" type=\"submit\"><i class=\"fas fa-search\"></i></button> <button class=\"btn btn-default\" data-ng-if=\"register.isOpen==true\" data-ng-click=\"showPicker();\" style=\"margin: 0 0 2px 0;\" type=\"button\"><i class=\"fas fa-times\"></i></button></span></div></form><div data-ng-if=\"widgetType !=\'searcher\' && register.product.productcategory_id !=4\" style=\"min-width: 15px; max-width: 15px; font-size: 8px;width: 15px;float: left;padding: 0;margin-right: 5px;\" data-ng-click=\"showPicker();loadItems(register.product.id, true)\" class=\"btn btn-theme\"><i class=\"fa fa-plus\"></i></div><p style=\"display: inline-block; width: calc(100% - 25px);\" data-ng-click=\"$root.setPicked(register.product.id)\">{{register.product.description}}</p><ul data-ng-if=\"register.isOpen==true\" class=\"grid-selector-options {{$root.currentModule}}\"><button class=\"btn btn-default hidden-lg hidden-md mobile-close {{$root.currentModule}}\" data-ng-if=\"register.isOpen==true\" data-ng-click=\"showPicker();\" style=\"margin: 0 0 2px 0;\" type=\"button\">Productos <i class=\"far fa-times-circle\"></i></button><li><ul><li class=\"hidden-xs\"><i class=\"fas fa-search\"></i> Código</li><li><i class=\"fas fa-search\"></i> Producto</li><li>Stock {{$root[modelName].selected.vouchertype_id}}</li></ul><ul data-ng-repeat=\"product in productItem track by $index | orderBy:[\'code\',\'code_secondary\',\'description\']\" data-ng-class=\"{\'text-danger\': ( $root.getCompleteStock(product, $root.voucher.selected.warehouse_id) == 0)}\"><li data-ng-click=\"addItem(product)\"><p>{{product.code}}</p><p>{{product.code_secondary}}</p></li><li data-ng-click=\"addItem(product)\">{{product.description}}</li><li>{{$root.getCompleteStock(product, $root.voucher.selected.warehouse_id)}}</li><li data-ng-repeat=\"st in product.stock\" data-ng-if=\"st.warehouse_id == warehouseId && newStock\" data-ng-click=\"addItem(product, st)\" class=\"level2\"><p class=\"batchcode\">Lote: {{(st.batchcode)?st.batchcode:\'No asignado\'}}</p><p class=\"stock\">{{st.current_stock - reserved_stock}}</p></li></ul></li></ul></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinventoryform/widgets/voucherpicker.html","<div><button style=\"padding: 6px 20px;margin-right: 20px; min-width: 185px;\" type=\"button\" data-ng-click=\"$root.refreshVoucher()\" data-ng-disabled=\"$root.voucher.selected.voucher_related==\'\'\" class=\"btn btn-action danger pull-left\">Cambiar</button><form class=\"form-group input-group\" data-ng-submit=\"$root.loadVoucherList($root.voucherSearch)\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"Buscar comprobante\" data-ng-model=\"$root.voucherSearch\" class=\"form-control search\"> <span class=\"input-group-btn\"><button type=\"submit\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" data-ng-click=\"$root.loadVoucherList($root.voucherSearch)\"><i class=\"fas fa-search\"></i></button></span><ul class=\"dropdown-menu grid-selector-options {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i> Comprobante</li><li><i class=\"fas fa-search\"></i> Total</li><li><i class=\"fas fa-search\"></i> Estado</li></ul><ul data-ng-repeat=\"item in $root.voucherList\" data-ng-click=\"$root.setVoucher(item);setVoucherSearch(item.code)\"><li>{{item.code}}</li><li>{{item.total}}</li><li>{{item.total}}</li></ul><ul data-ng-if=\"$root.voucherList.length==0\"><li style=\"width: 100%\">Sin resultados</li></ul></li></ul></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/templates/default.html","<div class=\"forms\" data-ng-if=\"$root[modelName].ready\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th></th><th data-ng-repeat=\"properties in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(properties.name)\" data-ng-class=\"{active: propertyName == properties.name}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName == properties && !reverse\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == properties.name && reverse\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th><th>Stock</th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-click=\"$root.addToList(itemsList , register, \'id\', true)\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td class=\"\"><button type=\"button\" style=\"font-size: 8px;width: 15px;height: 15px;padding: 0;min-width: inherit !important;min-height: inherit !important;\" class=\"btn btn-grid {{$root.currentModule}}\"><i data-ng-show=\"!$root.verifyInList(itemsList , register, \'id\')\" style=\"color:#1DA587\" class=\"fas fa-check\"></i></button></td><td data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[key])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td><td>{{$root.calculateStock(register.stock)}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/templates/default2.html","<div class=\"forms expanded\" data-ng-if=\"$root[modelName].ready\"><div class=\"col-xs-12\">Encontrados {{productItem.length}}</div><div class=\"crud-grid-pagination\"><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(pikerFilter.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(pikerFilter.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{productData.current_page}} {{$root.switchText(\'de\', \'from\')}} {{productData.last_page}}</span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(pikerFilter.page)>=productData.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage(productData.last_page)\" data-ng-disabled=\"(pikerFilter.page)>=productData.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Último\', \'Last\')}}</button></div><div class=\"pagination-records\" data-ng-class=\"$root.currentModule\"><div class=\"form-group flex\"><span class=\"filter-label\">Mostrar:</span><select data-ng-model=\"pikerFilter.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage(pikerFilter.per_page)\" class=\"form-control\"><option value=\"10\">10</option><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div></div><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><span class=\"result\">{{$root.switchText(\'Registros\', \'Records\')}}: {{productData.total}}</span></div></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th></th><th>Codigo1</th><th>Codigo2</th><th>Producto</th><th>Linea</th><th>Stock</th></tr></thead><tbody><tr ng-repeat=\"register in productItem\" class=\"test {{$root.currentModule}}\" data-ng-click=\"validateAddtolist(register)\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id ), \'danger\':( $root.getCompleteStock(register, $root.voucher.selected.warehouse_id) == 0 && modelName==\'voucher\')}\"><td class=\"\"><button type=\"button\" data-ng-disabled=\"($root.getCompleteStock(register, $root.voucher.selected.warehouse_id) == 0 && modelName==\'voucher\')\" style=\"font-size: 8px;width: 15px;height: 15px;padding: 0;min-width: inherit !important;min-height: inherit !important;\" class=\"btn btn-grid {{$root.currentModule}}\"><i data-ng-show=\"!$root.verifyInList(itemsList , register, \'id\')\" style=\"color:#1DA587\" class=\"fas fa-check\"></i></button></td><td>{{register.code}}</td><td>{{register.code_secondary}}</td><td>{{register.description}}</td><td>{{register.productline.name}}</td><td>{{$root.calculateStock(register.stock)}}</td></tr></tbody></table></div><div class=\"crud-grid-pagination\"><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(pikerFilter.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(pikerFilter.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{productData.current_page}} {{$root.switchText(\'de\', \'from\')}} {{productData.last_page}}</span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(pikerFilter.page)>=productData.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage(productData.last_page)\" data-ng-disabled=\"(pikerFilter.page)>=productData.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Último\', \'Last\')}}</button></div><div class=\"pagination-records\" data-ng-class=\"$root.currentModule\"><div class=\"form-group flex\"><span class=\"filter-label\">Mostrar:</span><select data-ng-model=\"pikerFilter.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage(pikerFilter.per_page)\" class=\"form-control\"><option value=\"10\">10</option><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div></div><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><span class=\"result\">{{$root.switchText(\'Registros\', \'Records\')}}: {{productData.total}}</span></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/templates/productcomboitem.html","<div class=\"forms\" data-ng-if=\"$root[modelName].ready\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th></th><th data-ng-repeat=\"properties in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(properties.name)\" data-ng-class=\"{active: propertyName == properties.name}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName == properties && !reverse\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == properties.name && reverse\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th><th data-ng-if=\"$root[modelName].childModel\">min</th><th data-ng-if=\"$root[modelName].childModel\">max</th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td class=\"\"><button type=\"button\" style=\"font-size: 8px;width: 15px;height: 15px;padding: 0;min-width: inherit !important;min-height: inherit !important;\" data-ng-click=\"$root.addToList(itemsList , register, \'id\', true)\" class=\"btn btn-grid {{$root.currentModule}}\"><i data-ng-show=\"!$root.verifyInList(itemsList , register, \'id\')\" style=\"color:#1DA587\" class=\"fas fa-check\"></i></button></td><td data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[key])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td><th data-ng-if=\"$root[modelName].childModel\"><input data-ng-required=\"!$root.verifyInList(itemsList , register, \'id\')\" data-ng-disabled=\"$root.verifyInList(itemsList , register, \'id\')\" data-ng-model=\"register.min\" type=\"number\" class=\"form-control\"></th><th data-ng-if=\"$root[modelName].childModel\"><input data-ng-required=\"!$root.verifyInList(itemsList , register, \'id\')\" data-ng-disabled=\"$root.verifyInList(itemsList , register, \'id\')\" data-ng-model=\"register.max\" type=\"number\" class=\"form-control\"></th></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/templates/productgroupitem.html","<div class=\"forms\" data-ng-if=\"$root[modelName].ready\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th></th><th data-ng-repeat=\"properties in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(properties.name)\" data-ng-class=\"{active: propertyName == properties.name}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName == properties && !reverse\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == properties.name && reverse\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th><th data-ng-if=\"$root[modelName].childModel\">min</th><th data-ng-if=\"$root[modelName].childModel\">max</th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td class=\"\"><button type=\"button\" style=\"font-size: 8px;width: 15px;height: 15px;padding: 0;min-width: inherit !important;min-height: inherit !important;\" data-ng-click=\"$root.addToList(itemsList , register, \'id\', true)\" class=\"btn btn-grid {{$root.currentModule}}\"><i data-ng-show=\"!$root.verifyInList(itemsList , register, \'id\')\" style=\"color:#1DA587\" class=\"fas fa-check\"></i></button></td><td data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[key])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td><th data-ng-if=\"$root[modelName].childModel\"><input data-ng-required=\"!$root.verifyInList(itemsList , register, \'id\')\" data-ng-disabled=\"$root.verifyInList(itemsList , register, \'id\')\" data-ng-model=\"register.min\" type=\"number\" class=\"form-control\"></th><th data-ng-if=\"$root[modelName].childModel\"><input data-ng-required=\"!$root.verifyInList(itemsList , register, \'id\')\" data-ng-disabled=\"$root.verifyInList(itemsList , register, \'id\')\" data-ng-model=\"register.max\" type=\"number\" class=\"form-control\"></th></tr></tbody></table></div></div>");}]);